var pw = Object.defineProperty;
var gw = (e, a, t) => a in e ? pw(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var Ee = (e, a, t) => (gw(e, typeof a != "symbol" ? a + "" : a, t), t);
import { openBlock as f, createElementBlock as y, defineComponent as We, normalizeClass as he, createBlock as ce, unref as b, createCommentVNode as Y, createElementVNode as X, computed as V, resolveDynamicComponent as Dt, withCtx as ue, renderSlot as fe, createTextVNode as $t, toDisplayString as we, mergeProps as Xt, Fragment as Qe, renderList as tt, withModifiers as _t, createVNode as Ce, ref as U, readonly as cv, getCurrentScope as fv, onScopeDispose as vv, isRef as Cr, toRef as zl, customRef as hw, onMounted as bt, nextTick as Bt, getCurrentInstance as pv, watch as st, reactive as Ja, watchEffect as ki, onUnmounted as al, Teleport as rl, Transition as Jn, normalizeStyle as Tt, withDirectives as cn, vModelText as ha, useSlots as mn, onBeforeUnmount as gv, vModelDynamic as mw, createSlots as Lt, toRaw as yw, toRefs as hv, useCssVars as yA, TransitionGroup as mv, normalizeProps as fn, guardReactiveProps as Xn, h as bw, render as Cf, useAttrs as ww, onBeforeUpdate as Cw, vShow as No, withKeys as aA } from "vue";
const Ne = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [r, i] of a)
    t[r] = i;
  return t;
}, Dw = {}, Bw = { class: "icon-app-gallery color-icon" };
function Tw(e, a) {
  return f(), y("span", Bw);
}
const xw = /* @__PURE__ */ Ne(Dw, [["render", Tw]]), Pw = {}, kw = { class: "icon-app-store color-icon" };
function Ow(e, a) {
  return f(), y("span", kw);
}
const Mw = /* @__PURE__ */ Ne(Pw, [["render", Ow]]), zw = {}, Iw = { class: "icon-google-play color-icon" };
function Ew(e, a) {
  return f(), y("span", Iw);
}
const Lw = /* @__PURE__ */ Ne(zw, [["render", Ew]]), Nw = {}, Yw = { class: "icon-ru-store color-icon" };
function Sw(e, a) {
  return f(), y("span", Yw);
}
const Vw = /* @__PURE__ */ Ne(Nw, [["render", Sw]]), Ww = {}, Xw = { class: "icon icon-arrow_left-regular" };
function Qw(e, a) {
  return f(), y("span", Xw);
}
const qo = /* @__PURE__ */ Ne(Ww, [["render", Qw]]), Hw = {}, Fw = { class: "icon icon-arrow_right-regular" };
function qw(e, a) {
  return f(), y("span", Fw);
}
const Uo = /* @__PURE__ */ Ne(Hw, [["render", qw]]), Uw = {}, Rw = { class: "icon icon-chevron_double_right-regular" };
function Zw(e, a) {
  return f(), y("span", Rw);
}
const Gw = /* @__PURE__ */ Ne(Uw, [["render", Zw]]), jw = {}, Kw = { class: "icon icon-chevron_down-regular" };
function Jw(e, a) {
  return f(), y("span", Kw);
}
const rs = /* @__PURE__ */ Ne(jw, [["render", Jw]]), _w = {}, $w = { class: "icon icon-chevron_left-regular" };
function e2(e, a) {
  return f(), y("span", $w);
}
const yv = /* @__PURE__ */ Ne(_w, [["render", e2]]), t2 = {}, n2 = { class: "icon icon-chevron_right-regular" };
function a2(e, a) {
  return f(), y("span", n2);
}
const bA = /* @__PURE__ */ Ne(t2, [["render", a2]]), r2 = {}, l2 = { class: "icon icon-refresh-regular" };
function i2(e, a) {
  return f(), y("span", l2);
}
const o2 = /* @__PURE__ */ Ne(r2, [["render", i2]]), s2 = {}, u2 = { class: "icon icon-reply-regular" };
function A2(e, a) {
  return f(), y("span", u2);
}
const bv = /* @__PURE__ */ Ne(s2, [["render", A2]]), d2 = {}, c2 = { class: "icon-empty-flag country-icon" };
function f2(e, a) {
  return f(), y("span", c2);
}
const v2 = /* @__PURE__ */ Ne(d2, [["render", f2]]), p2 = {}, g2 = { class: "icon-kz country-icon" };
function h2(e, a) {
  return f(), y("span", g2);
}
const m2 = /* @__PURE__ */ Ne(p2, [["render", h2]]), y2 = {}, b2 = { class: "icon-md country-icon" };
function w2(e, a) {
  return f(), y("span", b2);
}
const C2 = /* @__PURE__ */ Ne(y2, [["render", w2]]), D2 = {}, B2 = { class: "icon-ru country-icon" };
function T2(e, a) {
  return f(), y("span", B2);
}
const x2 = /* @__PURE__ */ Ne(D2, [["render", T2]]), P2 = {}, k2 = { class: "icon icon-calendar_today-regular" };
function O2(e, a) {
  return f(), y("span", k2);
}
const rA = /* @__PURE__ */ Ne(P2, [["render", O2]]), M2 = {}, z2 = { class: "icon icon-user-regular" };
function I2(e, a) {
  return f(), y("span", z2);
}
const E2 = /* @__PURE__ */ Ne(M2, [["render", I2]]), L2 = {}, N2 = { class: "icon icon-cloud_upload-fill" };
function Y2(e, a) {
  return f(), y("span", N2);
}
const S2 = /* @__PURE__ */ Ne(L2, [["render", Y2]]), V2 = {}, W2 = { class: "icon icon-file-regular" };
function X2(e, a) {
  return f(), y("span", W2);
}
const lA = /* @__PURE__ */ Ne(V2, [["render", X2]]), Q2 = {}, H2 = { class: "icon icon-file-thin" };
function F2(e, a) {
  return f(), y("span", H2);
}
const q2 = /* @__PURE__ */ Ne(Q2, [["render", F2]]), U2 = {}, R2 = { class: "icon icon-download-regular" };
function Z2(e, a) {
  return f(), y("span", R2);
}
const wv = /* @__PURE__ */ Ne(U2, [["render", Z2]]), G2 = {}, j2 = { class: "icon icon-upload-regular" };
function K2(e, a) {
  return f(), y("span", j2);
}
const J2 = /* @__PURE__ */ Ne(G2, [["render", K2]]), _2 = {}, $2 = { class: "icon icon-close-regular" };
function e3(e, a) {
  return f(), y("span", $2);
}
const tl = /* @__PURE__ */ Ne(_2, [["render", e3]]), t3 = {}, n3 = { class: "icon icon-circle_close-fill" };
function a3(e, a) {
  return f(), y("span", n3);
}
const Oi = /* @__PURE__ */ Ne(t3, [["render", a3]]), r3 = {}, l3 = { class: "icon icon-circle_info-fill" };
function i3(e, a) {
  return f(), y("span", l3);
}
const wa = /* @__PURE__ */ Ne(r3, [["render", i3]]), o3 = {}, s3 = { class: "icon icon-circle_info-regular" };
function u3(e, a) {
  return f(), y("span", s3);
}
const Df = /* @__PURE__ */ Ne(o3, [["render", u3]]), A3 = {}, d3 = { class: "icon icon-circle_info-thin" };
function c3(e, a) {
  return f(), y("span", d3);
}
const f3 = /* @__PURE__ */ Ne(A3, [["render", c3]]), v3 = {}, p3 = { class: "icon icon-circle_error-fill" };
function g3(e, a) {
  return f(), y("span", p3);
}
const Cv = /* @__PURE__ */ Ne(v3, [["render", g3]]), h3 = {}, m3 = { class: "icon icon-circle_done-fill" };
function y3(e, a) {
  return f(), y("span", m3);
}
const Dv = /* @__PURE__ */ Ne(h3, [["render", y3]]), b3 = {}, w3 = { class: "icon icon-done-regular" };
function C3(e, a) {
  return f(), y("span", w3);
}
const Il = /* @__PURE__ */ Ne(b3, [["render", C3]]), D3 = {}, B3 = { class: "icon icon-subtract-regular" };
function T3(e, a) {
  return f(), y("span", B3);
}
const Bv = /* @__PURE__ */ Ne(D3, [["render", T3]]), x3 = {}, P3 = { class: "icon icon-add-regular" };
function k3(e, a) {
  return f(), y("span", P3);
}
const O3 = /* @__PURE__ */ Ne(x3, [["render", k3]]), M3 = {}, z3 = { class: "icon icon-warning-fill" };
function I3(e, a) {
  return f(), y("span", z3);
}
const Tv = /* @__PURE__ */ Ne(M3, [["render", I3]]), E3 = {}, L3 = { class: "icon icon-hide_2-regular" };
function N3(e, a) {
  return f(), y("span", L3);
}
const Y3 = /* @__PURE__ */ Ne(E3, [["render", N3]]), S3 = {}, V3 = { class: "icon icon-search-regular" };
function W3(e, a) {
  return f(), y("span", V3);
}
const pi = /* @__PURE__ */ Ne(S3, [["render", W3]]), X3 = {}, Q3 = { class: "icon icon-show-regular" };
function H3(e, a) {
  return f(), y("span", Q3);
}
const F3 = /* @__PURE__ */ Ne(X3, [["render", H3]]), q3 = {}, U3 = { class: "icon icon-camera-fill" };
function R3(e, a) {
  return f(), y("span", U3);
}
const Z3 = /* @__PURE__ */ Ne(q3, [["render", R3]]), G3 = {}, j3 = { class: "type-file-icon icon-image-jpg-regular" };
function K3(e, a) {
  return f(), y("span", j3);
}
const J3 = /* @__PURE__ */ Ne(G3, [["render", K3]]), _3 = {}, $3 = { class: "type-file-icon icon-image-jpg-thin" };
function eC(e, a) {
  return f(), y("span", $3);
}
const tC = /* @__PURE__ */ Ne(_3, [["render", eC]]), nC = {}, aC = { class: "type-file-icon icon-archive-zip-regular" };
function rC(e, a) {
  return f(), y("span", aC);
}
const lC = /* @__PURE__ */ Ne(nC, [["render", rC]]), iC = {}, oC = { class: "type-file-icon icon-archive-zip-thin" };
function sC(e, a) {
  return f(), y("span", oC);
}
const uC = /* @__PURE__ */ Ne(iC, [["render", sC]]), AC = {}, dC = { class: "type-file-icon icon-archive-rar-regular" };
function cC(e, a) {
  return f(), y("span", dC);
}
const fC = /* @__PURE__ */ Ne(AC, [["render", cC]]), vC = {}, pC = { class: "type-file-icon icon-archive-rar-thin" };
function gC(e, a) {
  return f(), y("span", pC);
}
const hC = /* @__PURE__ */ Ne(vC, [["render", gC]]), mC = {}, yC = { class: "type-file-icon icon-image-png-regular" };
function bC(e, a) {
  return f(), y("span", yC);
}
const wC = /* @__PURE__ */ Ne(mC, [["render", bC]]), CC = {}, DC = { class: "type-file-icon icon-image-png-thin" };
function BC(e, a) {
  return f(), y("span", DC);
}
const TC = /* @__PURE__ */ Ne(CC, [["render", BC]]), xC = {}, PC = { class: "type-file-icon icon-image-gif-regular" };
function kC(e, a) {
  return f(), y("span", PC);
}
const OC = /* @__PURE__ */ Ne(xC, [["render", kC]]), MC = {}, zC = { class: "type-file-icon icon-image-gif-thin" };
function IC(e, a) {
  return f(), y("span", zC);
}
const EC = /* @__PURE__ */ Ne(MC, [["render", IC]]), LC = {}, NC = { class: "type-file-icon icon-image-svg-regular" };
function YC(e, a) {
  return f(), y("span", NC);
}
const SC = /* @__PURE__ */ Ne(LC, [["render", YC]]), VC = {}, WC = { class: "type-file-icon icon-image-svg-thin" };
function XC(e, a) {
  return f(), y("span", WC);
}
const QC = /* @__PURE__ */ Ne(VC, [["render", XC]]), HC = {}, FC = { class: "type-file-icon icon-image-img-regular" };
function qC(e, a) {
  return f(), y("span", FC);
}
const UC = /* @__PURE__ */ Ne(HC, [["render", qC]]), RC = {}, ZC = { class: "type-file-icon icon-image-img-thin" };
function GC(e, a) {
  return f(), y("span", ZC);
}
const jC = /* @__PURE__ */ Ne(RC, [["render", GC]]), KC = {}, JC = { class: "type-file-icon icon-media-avi-regular" };
function _C(e, a) {
  return f(), y("span", JC);
}
const $C = /* @__PURE__ */ Ne(KC, [["render", _C]]), e9 = {}, t9 = { class: "type-file-icon icon-media-wav-thin" };
function n9(e, a) {
  return f(), y("span", t9);
}
const a9 = /* @__PURE__ */ Ne(e9, [["render", n9]]), r9 = {}, l9 = { class: "type-file-icon icon-media-wav-regular" };
function i9(e, a) {
  return f(), y("span", l9);
}
const o9 = /* @__PURE__ */ Ne(r9, [["render", i9]]), s9 = {}, u9 = { class: "type-file-icon icon-media-wav-thin" };
function A9(e, a) {
  return f(), y("span", u9);
}
const d9 = /* @__PURE__ */ Ne(s9, [["render", A9]]), c9 = {}, f9 = { class: "type-file-icon icon-media-mp4-regular" };
function v9(e, a) {
  return f(), y("span", f9);
}
const p9 = /* @__PURE__ */ Ne(c9, [["render", v9]]), g9 = {}, h9 = { class: "type-file-icon icon-media-wav-thin" };
function m9(e, a) {
  return f(), y("span", h9);
}
const y9 = /* @__PURE__ */ Ne(g9, [["render", m9]]), b9 = {}, w9 = { class: "type-file-icon icon-media-mp3-regular" };
function C9(e, a) {
  return f(), y("span", w9);
}
const D9 = /* @__PURE__ */ Ne(b9, [["render", C9]]), B9 = {}, T9 = { class: "type-file-icon icon-media-wav-thin" };
function x9(e, a) {
  return f(), y("span", T9);
}
const P9 = /* @__PURE__ */ Ne(B9, [["render", x9]]), k9 = {}, O9 = { class: "type-file-icon icon-document-pptx-regular" };
function M9(e, a) {
  return f(), y("span", O9);
}
const z9 = /* @__PURE__ */ Ne(k9, [["render", M9]]), I9 = {}, E9 = { class: "type-file-icon icon-document-pptx-thin" };
function L9(e, a) {
  return f(), y("span", E9);
}
const N9 = /* @__PURE__ */ Ne(I9, [["render", L9]]), Y9 = {}, S9 = { class: "type-file-icon icon-document-ppt-regular" };
function V9(e, a) {
  return f(), y("span", S9);
}
const W9 = /* @__PURE__ */ Ne(Y9, [["render", V9]]), X9 = {}, Q9 = { class: "type-file-icon icon-document-ppt-thin" };
function H9(e, a) {
  return f(), y("span", Q9);
}
const F9 = /* @__PURE__ */ Ne(X9, [["render", H9]]), q9 = {}, U9 = { class: "type-file-icon icon-document-xlsx-regular" };
function R9(e, a) {
  return f(), y("span", U9);
}
const Z9 = /* @__PURE__ */ Ne(q9, [["render", R9]]), G9 = {}, j9 = { class: "type-file-icon icon-document-xlsx-thin" };
function K9(e, a) {
  return f(), y("span", j9);
}
const J9 = /* @__PURE__ */ Ne(G9, [["render", K9]]), _9 = {}, $9 = { class: "type-file-icon icon-document-xls-regular" };
function e7(e, a) {
  return f(), y("span", $9);
}
const t7 = /* @__PURE__ */ Ne(_9, [["render", e7]]), n7 = {}, a7 = { class: "type-file-icon icon-document-xls-thin" };
function r7(e, a) {
  return f(), y("span", a7);
}
const l7 = /* @__PURE__ */ Ne(n7, [["render", r7]]), i7 = {}, o7 = { class: "type-file-icon icon-document-csv-regular" };
function s7(e, a) {
  return f(), y("span", o7);
}
const u7 = /* @__PURE__ */ Ne(i7, [["render", s7]]), A7 = {}, d7 = { class: "type-file-icon icon-document-csv-thin" };
function c7(e, a) {
  return f(), y("span", d7);
}
const f7 = /* @__PURE__ */ Ne(A7, [["render", c7]]), v7 = {}, p7 = { class: "type-file-icon icon-document-txt-regular" };
function g7(e, a) {
  return f(), y("span", p7);
}
const h7 = /* @__PURE__ */ Ne(v7, [["render", g7]]), m7 = {}, y7 = { class: "type-file-icon icon-document-txt-thin" };
function b7(e, a) {
  return f(), y("span", y7);
}
const w7 = /* @__PURE__ */ Ne(m7, [["render", b7]]), C7 = {}, D7 = { class: "type-file-icon icon-document-docx-regular" };
function B7(e, a) {
  return f(), y("span", D7);
}
const T7 = /* @__PURE__ */ Ne(C7, [["render", B7]]), x7 = {}, P7 = { class: "type-file-icon icon-document-docx-thin" };
function k7(e, a) {
  return f(), y("span", P7);
}
const O7 = /* @__PURE__ */ Ne(x7, [["render", k7]]), M7 = {}, z7 = { class: "type-file-icon icon-document-doc-regular" };
function I7(e, a) {
  return f(), y("span", z7);
}
const E7 = /* @__PURE__ */ Ne(M7, [["render", I7]]), L7 = {}, N7 = { class: "type-file-icon icon-document-doc-thin" };
function Y7(e, a) {
  return f(), y("span", N7);
}
const S7 = /* @__PURE__ */ Ne(L7, [["render", Y7]]), V7 = {}, W7 = { class: "type-file-icon icon-document-pdf-regular" };
function X7(e, a) {
  return f(), y("span", W7);
}
const Q7 = /* @__PURE__ */ Ne(V7, [["render", X7]]), H7 = {}, F7 = { class: "type-file-icon icon-document-pdf-thin" };
function q7(e, a) {
  return f(), y("span", F7);
}
const U7 = /* @__PURE__ */ Ne(H7, [["render", q7]]), R7 = ["href"], Z7 = /* @__PURE__ */ We({
  name: "UiAppButton",
  __name: "UiAppButton",
  props: {
    color: {
      type: String,
      default: "light"
    },
    language: {
      type: String,
      default: "ru"
    },
    store: {
      type: String,
      default: "android"
    },
    size: {
      type: String,
      default: "large"
    },
    link: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (a, t) => (f(), y("a", {
      href: e.link,
      target: "_blank",
      class: he(["ui-app-button", [
        `ui-app-button_${e.color}
       ui-app-button_${e.size}`
      ]])
    }, [
      e.store === "android" ? (f(), ce(b(Lw), { key: 0 })) : Y("", !0),
      e.store === "ios" ? (f(), ce(b(Mw), { key: 1 })) : Y("", !0),
      e.store === "app-gallery" ? (f(), ce(b(xw), { key: 2 })) : Y("", !0),
      e.store === "ru-store" ? (f(), ce(b(Vw), { key: 3 })) : Y("", !0),
      X("span", {
        class: he(`icon_${e.store}_${e.language}_${e.color}`)
      }, null, 2)
    ], 10, R7));
  }
});
const je = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [r, i] of a)
    t[r] = i;
  return t;
}, KE = /* @__PURE__ */ je(Z7, [["__scopeId", "data-v-05fb4eb8"]]), G7 = /* @__PURE__ */ We({
  name: "UiBadge",
  __name: "UiBadge",
  props: {
    color: {
      type: String,
      default: "yellow"
    },
    type: {
      type: String,
      default: "yellow"
    },
    label: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "l"
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    to: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    const a = e, t = V(() => a.size === "xs"), r = V(() => {
      if (!t.value) {
        if (a.clickable)
          return "button";
        if (a.to)
          return "router-link";
      }
      return "span";
    });
    return (i, s) => (f(), ce(Dt(r.value), {
      type: "button",
      class: he(["ui-badge", [
        `ui-badge_${e.type}_${e.color}`,
        `ui-badge_size_${e.size}`,
        { "ui-badge_clickable": e.clickable }
      ]]),
      to: e.to
    }, {
      default: ue(() => [
        e.size !== "xs" ? fe(i.$slots, "default", { key: 0 }, void 0, !0) : Y("", !0),
        $t(" " + we(e.label) + " ", 1),
        e.clickable && !t.value ? (f(), ce(b(bA), {
          key: 1,
          class: "arrow"
        })) : Y("", !0)
      ]),
      _: 3
    }, 8, ["class", "to"]));
  }
});
const j7 = /* @__PURE__ */ je(G7, [["__scopeId", "data-v-a45da34a"]]), K7 = { class: "ui-button__label" }, J7 = {
  key: 0,
  class: "ui-button__icon-loading icon-loader"
}, nl = /* @__PURE__ */ We({
  name: "UiButton",
  __name: "UiButton",
  props: {
    color: {
      type: String,
      default: "accent"
    },
    label: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "l"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      required: !1
    },
    to: {
      type: Object,
      required: !1
    },
    target: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, t = V(() => a.href && !a.to ? "a" : !a.href && a.to ? "router-link" : "button"), r = V(() => ({
      ...t.value === "button" && {
        type: a.type,
        disabled: a.disabled || a.loading
      },
      ...t.value !== "button" && {
        target: a.target
      },
      ...t.value === "router-link" && {
        to: a.to
      },
      ...t.value === "a" && {
        href: a.href
      }
    }));
    return (i, s) => (f(), ce(Dt(t.value), Xt({
      class: ["ui-button", [
        `ui-button_color_${e.color}`,
        `ui-button_size_${e.size}`,
        {
          "ui-button_loading": e.loading
        },
        {
          "ui-button_full-width": e.fullWidth
        }
      ]]
    }, r.value), {
      default: ue(() => [
        fe(i.$slots, "default"),
        X("span", K7, we(e.label), 1),
        e.loading ? (f(), y("span", J7)) : Y("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
const _7 = { class: "ui-button-redirect__text" }, $7 = /* @__PURE__ */ We({
  name: "UiButtonRedirect",
  __name: "UiButtonRedirect",
  props: {
    text: {
      type: String,
      required: !0
    },
    arrowPosition: {
      type: String,
      default: "left"
    },
    href: {
      type: String,
      required: !1
    },
    to: {
      type: Object,
      required: !1
    },
    target: {
      type: String,
      default: "_blank"
    }
  },
  setup(e) {
    const a = e, t = V(() => a.href && !a.to ? "a" : !a.href && a.to ? "router-link" : "button");
    return (r, i) => (f(), ce(Dt(t.value), {
      href: e.href,
      class: he(["ui-button-redirect", [{ "ui-button-redirect_reversed": e.arrowPosition === "right" }]]),
      target: e.target
    }, {
      default: ue(() => [
        i[0] || (i[0] = X("svg", {
          class: "ui-button-redirect__icon",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          X("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3.99632 14.5206L1.60983 12.2521C1.46339 12.1128 1.46339 11.8871 1.60983 11.7479L3.99632 9.47941C4.14277 9.3402 4.3802 9.3402 4.52665 9.47941C4.6731 9.61861 4.6731 9.84432 4.52665 9.98352L2.78033 11.6435L22.1435 11.6435C22.3404 11.6435 22.5 11.8031 22.5 12V12C22.5 12.1969 22.3404 12.3565 22.1435 12.3565L2.78033 12.3565L4.52665 14.0165C4.6731 14.1557 4.6731 14.3814 4.52665 14.5206C4.3802 14.6598 4.14277 14.6598 3.99632 14.5206Z",
            fill: "#969696"
          })
        ], -1)),
        X("span", _7, we(e.text), 1)
      ]),
      _: 1
    }, 8, ["href", "class", "target"]));
  }
});
const JE = /* @__PURE__ */ je($7, [["__scopeId", "data-v-e47f7b57"]]), eD = ["checked", "disabled", "value"], tD = {
  key: 2,
  class: "label__counter"
}, nD = { class: "ui-checkbox__multiple multiple" }, aD = ["checked", "disabled", "onChange"], rD = {
  key: 0,
  class: "ui-checkbox__error-message"
}, lD = /* @__PURE__ */ We({
  name: "UiCheckbox",
  __name: "UiCheckbox",
  props: {
    label: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "l"
    },
    value: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Array, Boolean],
      default: ""
    },
    trueValue: {
      type: [String, Boolean, Number],
      default: !0
    },
    falseValue: {
      type: [String, Boolean, Number],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Number,
      required: !1
    },
    multipleCheckboxOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "update:modelValue",
    "update:multipleCheckboxOptions"
  ],
  setup(e, { emit: a }) {
    const t = e, r = a, i = V(() => t.multipleCheckboxOptions.length > 0), s = V(() => t.multipleCheckboxOptions.length === 0 ? t.modelValue instanceof Array ? t.modelValue.includes(t.value) : t.modelValue === t.trueValue : !t.multipleCheckboxOptions.find((p) => p.isChecked !== p.trueValue)), u = V(() => {
      const p = t.multipleCheckboxOptions.filter((v) => v.isChecked === v.trueValue);
      return p.length > 0 && p.length !== t.multipleCheckboxOptions.length;
    }), A = (p) => {
      const v = p.target;
      if (i.value) {
        const m = t.multipleCheckboxOptions.map((w) => ({
          ...w,
          isChecked: v.checked ? w.trueValue ?? !0 : w.falseValue ?? !1
        }));
        r("update:multipleCheckboxOptions", m);
      } else {
        const m = v.checked;
        if (t.modelValue instanceof Array) {
          const w = [...t.modelValue];
          m ? w.push(t.value) : w.splice(w.indexOf(t.value), 1), r("update:modelValue", w);
        } else
          r("update:modelValue", m ? t.trueValue : t.falseValue);
      }
    }, c = (p, v = !0) => v ? typeof (p == null ? void 0 : p.trueValue) > "u" ? p.isChecked : p.trueValue : typeof (p == null ? void 0 : p.falseValue) > "u" ? p.isChecked : p.falseValue, g = (p, v) => {
      const w = p.target.checked, B = t.multipleCheckboxOptions.find((L, E) => E === v), T = t.multipleCheckboxOptions.map((L, E) => (E === v && (L.isChecked = w ? c(B) : c(B, !1)), L));
      r("update:multipleCheckboxOptions", T);
    };
    return (p, v) => (f(), y("div", {
      class: he(["ui-checkbox", `ui-checkbox_size_${e.size}`])
    }, [
      X("label", {
        class: he(["ui-checkbox__label label", [
          {
            label_disabled: e.disabled,
            label_error: e.error || e.errorMessage,
            label_multiple: u.value
          }
        ]])
      }, [
        X("input", {
          type: "checkbox",
          checked: s.value,
          disabled: e.disabled,
          value: e.value,
          onChange: A
        }, null, 40, eD),
        v[0] || (v[0] = X("span", null, null, -1)),
        s.value ? (f(), ce(b(Il), {
          key: 0,
          class: "done"
        })) : Y("", !0),
        u.value ? (f(), ce(b(Bv), {
          key: 1,
          class: "done"
        })) : Y("", !0),
        $t(" " + we(e.label) + " ", 1),
        typeof e.counter == "number" ? (f(), y("span", tD, we(e.counter), 1)) : Y("", !0)
      ], 2),
      X("div", nD, [
        (f(!0), y(Qe, null, tt(e.multipleCheckboxOptions, (m, w) => (f(), y("label", {
          key: w,
          class: he(["ui-checkbox__label label", [
            {
              label_disabled: e.disabled,
              label_error: e.error || e.errorMessage
            }
          ]])
        }, [
          X("input", {
            type: "checkbox",
            checked: m.isChecked === m.trueValue,
            disabled: e.disabled,
            onChange: (B) => g(B, w)
          }, null, 40, aD),
          v[1] || (v[1] = X("span", null, null, -1)),
          m.isChecked === m.trueValue ? (f(), ce(b(Il), {
            key: 0,
            class: "done"
          })) : Y("", !0),
          $t(" " + we(m.label), 1)
        ], 2))), 128))
      ]),
      e.errorMessage ? (f(), y("p", rD, we(e.errorMessage), 1)) : Y("", !0)
    ], 2));
  }
});
const _E = /* @__PURE__ */ je(lD, [["__scopeId", "data-v-b831d12d"]]), iD = { class: "label" }, oD = /* @__PURE__ */ We({
  __name: "UiChip",
  props: {
    label: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    },
    isClosed: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: ["remove", "select"],
  setup(e, { emit: a }) {
    const t = a;
    return We({
      name: "UiChip"
    }), (r, i) => (f(), ce(Dt(e.isClosed ? "div" : "button"), {
      class: he(["ui-chip", [
        `ui-chip_${e.variant}`,
        `ui-chip_size_${e.size}`,
        {
          "ui-chip_closed": e.isClosed,
          "ui-chip_active": e.active
        }
      ]]),
      onClick: i[1] || (i[1] = (s) => t("select"))
    }, {
      default: ue(() => [
        fe(r.$slots, "default", {}, void 0, !0),
        X("span", iD, we(e.label), 1),
        e.active && e.isClosed ? (f(), y("button", {
          key: 0,
          type: "button",
          onClick: i[0] || (i[0] = _t((s) => t("remove"), ["stop"]))
        }, [
          Ce(b(Oi))
        ])) : Y("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
const xv = /* @__PURE__ */ je(oD, [["__scopeId", "data-v-428a3e61"]]);
function Br(e) {
  return fv() ? (vv(e), !0) : !1;
}
function Vt(e) {
  return typeof e == "function" ? e() : b(e);
}
const Mi = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const sD = Object.prototype.toString, Pv = (e) => sD.call(e) === "[object Object]", hn = () => {
}, El = /* @__PURE__ */ uD();
function uD() {
  var e, a;
  return Mi && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((a = window == null ? void 0 : window.navigator) == null ? void 0 : a.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function kv(e, a) {
  function t(...r) {
    return new Promise((i, s) => {
      Promise.resolve(e(() => a.apply(this, r), { fn: a, thisArg: this, args: r })).then(i).catch(s);
    });
  }
  return t;
}
function AD(e, a = {}) {
  let t, r, i = hn;
  const s = (A) => {
    clearTimeout(A), i(), i = hn;
  };
  return (A) => {
    const c = Vt(e), g = Vt(a.maxWait);
    return t && s(t), c <= 0 || g !== void 0 && g <= 0 ? (r && (s(r), r = null), Promise.resolve(A())) : new Promise((p, v) => {
      i = a.rejectOnCancel ? v : p, g && !r && (r = setTimeout(() => {
        t && s(t), r = null, p(A());
      }, g)), t = setTimeout(() => {
        r && s(r), r = null, p(A());
      }, c);
    });
  };
}
function dD(...e) {
  let a = 0, t, r = !0, i = hn, s, u, A, c, g;
  !Cr(e[0]) && typeof e[0] == "object" ? { delay: u, trailing: A = !0, leading: c = !0, rejectOnCancel: g = !1 } = e[0] : [u, A = !0, c = !0, g = !1] = e;
  const p = () => {
    t && (clearTimeout(t), t = void 0, i(), i = hn);
  };
  return (m) => {
    const w = Vt(u), B = Date.now() - a, T = () => s = m();
    return p(), w <= 0 ? (a = Date.now(), T()) : (B > w && (c || !r) ? (a = Date.now(), T()) : A && (s = new Promise((L, E) => {
      i = g ? E : L, t = setTimeout(() => {
        a = Date.now(), r = !0, L(T()), p();
      }, Math.max(0, w - B));
    })), !c && !t && (t = setTimeout(() => r = !0, w)), r = !1, s);
  };
}
const Bf = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function cD(e) {
  return e || pv();
}
function Ov(...e) {
  if (e.length !== 1)
    return zl(...e);
  const a = e[0];
  return typeof a == "function" ? cv(hw(() => ({ get: a, set: hn }))) : U(a);
}
function wA(e, a = 200, t = {}) {
  return kv(
    AD(a, t),
    e
  );
}
function Mv(e, a = 200, t = !1, r = !0, i = !1) {
  return kv(
    dD(a, t, r, i),
    e
  );
}
function CA(e, a = !0, t) {
  cD() ? bt(e, t) : a ? e() : Bt(e);
}
function fD(e, a, t = {}) {
  const {
    immediate: r = !0
  } = t, i = U(!1);
  let s = null;
  function u() {
    s && (clearTimeout(s), s = null);
  }
  function A() {
    i.value = !1, u();
  }
  function c(...g) {
    u(), i.value = !0, s = setTimeout(() => {
      i.value = !1, s = null, e(...g);
    }, Vt(a));
  }
  return r && (i.value = !0, Mi && c()), Br(A), {
    isPending: cv(i),
    start: c,
    stop: A
  };
}
function Ia(e) {
  var a;
  const t = Vt(e);
  return (a = t == null ? void 0 : t.$el) != null ? a : t;
}
const er = Mi ? window : void 0, vD = Mi ? window.document : void 0;
function Tn(...e) {
  let a, t, r, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, r, i] = e, a = er) : [a, t, r, i] = e, !a)
    return hn;
  Array.isArray(t) || (t = [t]), Array.isArray(r) || (r = [r]);
  const s = [], u = () => {
    s.forEach((p) => p()), s.length = 0;
  }, A = (p, v, m, w) => (p.addEventListener(v, m, w), () => p.removeEventListener(v, m, w)), c = st(
    () => [Ia(a), Vt(i)],
    ([p, v]) => {
      if (u(), !p)
        return;
      const m = Pv(v) ? { ...v } : v;
      s.push(
        ...t.flatMap((w) => r.map((B) => A(p, w, B, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), g = () => {
    c(), u();
  };
  return Br(g), g;
}
let Tf = !1;
function Ql(e, a, t = {}) {
  const { window: r = er, ignore: i = [], capture: s = !0, detectIframe: u = !1 } = t;
  if (!r)
    return hn;
  El && !Tf && (Tf = !0, Array.from(r.document.body.children).forEach((m) => m.addEventListener("click", hn)), r.document.documentElement.addEventListener("click", hn));
  let A = !0;
  const c = (m) => i.some((w) => {
    if (typeof w == "string")
      return Array.from(r.document.querySelectorAll(w)).some((B) => B === m.target || m.composedPath().includes(B));
    {
      const B = Ia(w);
      return B && (m.target === B || m.composedPath().includes(B));
    }
  }), p = [
    Tn(r, "click", (m) => {
      const w = Ia(e);
      if (!(!w || w === m.target || m.composedPath().includes(w))) {
        if (m.detail === 0 && (A = !c(m)), !A) {
          A = !0;
          return;
        }
        a(m);
      }
    }, { passive: !0, capture: s }),
    Tn(r, "pointerdown", (m) => {
      const w = Ia(e);
      A = !c(m) && !!(w && !m.composedPath().includes(w));
    }, { passive: !0 }),
    u && Tn(r, "blur", (m) => {
      setTimeout(() => {
        var w;
        const B = Ia(e);
        ((w = r.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(B != null && B.contains(r.document.activeElement)) && a(m);
      }, 0);
    })
  ].filter(Boolean);
  return () => p.forEach((m) => m());
}
function pD() {
  const e = U(!1), a = pv();
  return a && bt(() => {
    e.value = !0;
  }, a), e;
}
function zv(e) {
  const a = pD();
  return V(() => (a.value, !!e()));
}
function gD(e, a = {}) {
  const { window: t = er } = a, r = zv(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let i;
  const s = U(!1), u = (g) => {
    s.value = g.matches;
  }, A = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", u) : i.removeListener(u));
  }, c = ki(() => {
    r.value && (A(), i = t.matchMedia(Vt(e)), "addEventListener" in i ? i.addEventListener("change", u) : i.addListener(u), s.value = i.matches);
  });
  return Br(() => {
    c(), A(), i = void 0;
  }), s;
}
function hD(e, a, t = {}) {
  const { window: r = er, ...i } = t;
  let s;
  const u = zv(() => r && "ResizeObserver" in r), A = () => {
    s && (s.disconnect(), s = void 0);
  }, c = V(() => Array.isArray(e) ? e.map((v) => Ia(v)) : [Ia(e)]), g = st(
    c,
    (v) => {
      if (A(), u.value && r) {
        s = new ResizeObserver(a);
        for (const m of v)
          m && s.observe(m, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), p = () => {
    A(), g();
  };
  return Br(p), {
    isSupported: u,
    stop: p
  };
}
const xf = 1;
function mD(e, a = {}) {
  const {
    throttle: t = 0,
    idle: r = 200,
    onStop: i = hn,
    onScroll: s = hn,
    offset: u = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: A = {
      capture: !1,
      passive: !0
    },
    behavior: c = "auto",
    window: g = er,
    onError: p = (x) => {
      console.error(x);
    }
  } = a, v = U(0), m = U(0), w = V({
    get() {
      return v.value;
    },
    set(x) {
      T(x, void 0);
    }
  }), B = V({
    get() {
      return m.value;
    },
    set(x) {
      T(void 0, x);
    }
  });
  function T(x, W) {
    var z, q, J, le;
    if (!g)
      return;
    const ve = Vt(e);
    if (!ve)
      return;
    (J = ve instanceof Document ? g.document.body : ve) == null || J.scrollTo({
      top: (z = Vt(W)) != null ? z : B.value,
      left: (q = Vt(x)) != null ? q : w.value,
      behavior: Vt(c)
    });
    const R = ((le = ve == null ? void 0 : ve.document) == null ? void 0 : le.documentElement) || (ve == null ? void 0 : ve.documentElement) || ve;
    w != null && (v.value = R.scrollLeft), B != null && (m.value = R.scrollTop);
  }
  const L = U(!1), E = Ja({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), N = Ja({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), k = (x) => {
    L.value && (L.value = !1, N.left = !1, N.right = !1, N.top = !1, N.bottom = !1, i(x));
  }, F = wA(k, t + r), S = (x) => {
    var W;
    if (!g)
      return;
    const z = ((W = x == null ? void 0 : x.document) == null ? void 0 : W.documentElement) || (x == null ? void 0 : x.documentElement) || Ia(x), { display: q, flexDirection: J } = getComputedStyle(z), le = z.scrollLeft;
    N.left = le < v.value, N.right = le > v.value;
    const ve = Math.abs(le) <= (u.left || 0), R = Math.abs(le) + z.clientWidth >= z.scrollWidth - (u.right || 0) - xf;
    q === "flex" && J === "row-reverse" ? (E.left = R, E.right = ve) : (E.left = ve, E.right = R), v.value = le;
    let _ = z.scrollTop;
    x === g.document && !_ && (_ = g.document.body.scrollTop), N.top = _ < m.value, N.bottom = _ > m.value;
    const G = Math.abs(_) <= (u.top || 0), oe = Math.abs(_) + z.clientHeight >= z.scrollHeight - (u.bottom || 0) - xf;
    q === "flex" && J === "column-reverse" ? (E.top = oe, E.bottom = G) : (E.top = G, E.bottom = oe), m.value = _;
  }, Q = (x) => {
    var W;
    if (!g)
      return;
    const z = (W = x.target.documentElement) != null ? W : x.target;
    S(z), L.value = !0, F(x), s(x);
  };
  return Tn(
    e,
    "scroll",
    t ? Mv(Q, t, !0, !1) : Q,
    A
  ), CA(() => {
    try {
      const x = Vt(e);
      if (!x)
        return;
      S(x);
    } catch (x) {
      p(x);
    }
  }), Tn(
    e,
    "scrollend",
    k,
    A
  ), {
    x: w,
    y: B,
    isScrolling: L,
    arrivedState: E,
    directions: N,
    measure() {
      const x = Vt(e);
      g && x && S(x);
    }
  };
}
function Pu(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
const yD = {
  page: (e) => [e.pageX, e.pageY],
  client: (e) => [e.clientX, e.clientY],
  screen: (e) => [e.screenX, e.screenY],
  movement: (e) => e instanceof Touch ? null : [e.movementX, e.movementY]
};
function bD(e = {}) {
  const {
    type: a = "page",
    touch: t = !0,
    resetOnTouchEnds: r = !1,
    initialValue: i = { x: 0, y: 0 },
    window: s = er,
    target: u = s,
    scroll: A = !0,
    eventFilter: c
  } = e;
  let g = null;
  const p = U(i.x), v = U(i.y), m = U(null), w = typeof a == "function" ? a : yD[a], B = (S) => {
    const Q = w(S);
    g = S, Q && ([p.value, v.value] = Q, m.value = "mouse");
  }, T = (S) => {
    if (S.touches.length > 0) {
      const Q = w(S.touches[0]);
      Q && ([p.value, v.value] = Q, m.value = "touch");
    }
  }, L = () => {
    if (!g || !s)
      return;
    const S = w(g);
    g instanceof MouseEvent && S && (p.value = S[0] + s.scrollX, v.value = S[1] + s.scrollY);
  }, E = () => {
    p.value = i.x, v.value = i.y;
  }, N = c ? (S) => c(() => B(S), {}) : (S) => B(S), k = c ? (S) => c(() => T(S), {}) : (S) => T(S), F = c ? () => c(() => L(), {}) : () => L();
  if (u) {
    const S = { passive: !0 };
    Tn(u, ["mousemove", "dragover"], N, S), t && a !== "movement" && (Tn(u, ["touchstart", "touchmove"], k, S), r && Tn(u, "touchend", E, S)), A && a === "page" && Tn(s, "scroll", F, { passive: !0 });
  }
  return {
    x: p,
    y: v,
    sourceType: m
  };
}
function wD(e, a = {}) {
  const {
    handleOutside: t = !0,
    window: r = er
  } = a, i = a.type || "page", { x: s, y: u, sourceType: A } = bD(a), c = U(e ?? (r == null ? void 0 : r.document.body)), g = U(0), p = U(0), v = U(0), m = U(0), w = U(0), B = U(0), T = U(!0);
  let L = () => {
  };
  return r && (L = st(
    [c, s, u],
    () => {
      const E = Ia(c);
      if (!E)
        return;
      const {
        left: N,
        top: k,
        width: F,
        height: S
      } = E.getBoundingClientRect();
      v.value = N + (i === "page" ? r.pageXOffset : 0), m.value = k + (i === "page" ? r.pageYOffset : 0), w.value = S, B.value = F;
      const Q = s.value - v.value, x = u.value - m.value;
      T.value = F === 0 || S === 0 || Q < 0 || x < 0 || Q > F || x > S, (t || !T.value) && (g.value = Q, p.value = x);
    },
    { immediate: !0 }
  ), Tn(document, "mouseleave", () => {
    T.value = !0;
  })), {
    x: s,
    y: u,
    sourceType: A,
    elementX: g,
    elementY: p,
    elementPositionX: v,
    elementPositionY: m,
    elementHeight: w,
    elementWidth: B,
    isOutside: T,
    stop: L
  };
}
function Iv(e) {
  const a = window.getComputedStyle(e);
  if (a.overflowX === "scroll" || a.overflowY === "scroll" || a.overflowX === "auto" && e.clientWidth < e.scrollWidth || a.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !t || t.tagName === "BODY" ? !1 : Iv(t);
  }
}
function CD(e) {
  const a = e || window.event, t = a.target;
  return Iv(t) ? !1 : a.touches.length > 1 ? !0 : (a.preventDefault && a.preventDefault(), !1);
}
const ku = /* @__PURE__ */ new WeakMap();
function DA(e, a = !1) {
  const t = U(a);
  let r = null, i = "";
  st(Ov(e), (A) => {
    const c = Pu(Vt(A));
    if (c) {
      const g = c;
      if (ku.get(g) || ku.set(g, g.style.overflow), g.style.overflow !== "hidden" && (i = g.style.overflow), g.style.overflow === "hidden")
        return t.value = !0;
      if (t.value)
        return g.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const s = () => {
    const A = Pu(Vt(e));
    !A || t.value || (El && (r = Tn(
      A,
      "touchmove",
      (c) => {
        CD(c);
      },
      { passive: !1 }
    )), A.style.overflow = "hidden", t.value = !0);
  }, u = () => {
    const A = Pu(Vt(e));
    !A || !t.value || (El && (r == null || r()), A.style.overflow = i, ku.delete(A), t.value = !1);
  };
  return Br(u), V({
    get() {
      return t.value;
    },
    set(A) {
      A ? s() : u();
    }
  });
}
function DD(e, a = {}) {
  const {
    threshold: t = 50,
    onSwipe: r,
    onSwipeEnd: i,
    onSwipeStart: s,
    passive: u = !0,
    window: A = er
  } = a, c = Ja({ x: 0, y: 0 }), g = Ja({ x: 0, y: 0 }), p = V(() => c.x - g.x), v = V(() => c.y - g.y), { max: m, abs: w } = Math, B = V(() => m(w(p.value), w(v.value)) >= t), T = U(!1), L = V(() => B.value ? w(p.value) > w(v.value) ? p.value > 0 ? "left" : "right" : v.value > 0 ? "up" : "down" : "none"), E = (z) => [z.touches[0].clientX, z.touches[0].clientY], N = (z, q) => {
    c.x = z, c.y = q;
  }, k = (z, q) => {
    g.x = z, g.y = q;
  };
  let F;
  const S = BD(A == null ? void 0 : A.document);
  u ? F = S ? { passive: !0 } : { capture: !1 } : F = S ? { passive: !1, capture: !0 } : { capture: !0 };
  const Q = (z) => {
    T.value && (i == null || i(z, L.value)), T.value = !1;
  }, x = [
    Tn(e, "touchstart", (z) => {
      if (z.touches.length !== 1)
        return;
      F.capture && !F.passive && z.preventDefault();
      const [q, J] = E(z);
      N(q, J), k(q, J), s == null || s(z);
    }, F),
    Tn(e, "touchmove", (z) => {
      if (z.touches.length !== 1)
        return;
      const [q, J] = E(z);
      k(q, J), !T.value && B.value && (T.value = !0), T.value && (r == null || r(z));
    }, F),
    Tn(e, ["touchend", "touchcancel"], Q, F)
  ];
  return {
    isPassiveEventSupported: S,
    isSwiping: T,
    direction: L,
    coordsStart: c,
    coordsEnd: g,
    lengthX: p,
    lengthY: v,
    stop: () => x.forEach((z) => z())
  };
}
function BD(e) {
  if (!e)
    return !1;
  let a = !1;
  const t = {
    get passive() {
      return a = !0, !1;
    }
  };
  return e.addEventListener("x", hn, t), e.removeEventListener("x", hn), a;
}
function sa(e = {}) {
  const {
    window: a = er,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: i = !0,
    includeScrollbar: s = !0
  } = e, u = U(t), A = U(r), c = () => {
    a && (s ? (u.value = a.innerWidth, A.value = a.innerHeight) : (u.value = a.document.documentElement.clientWidth, A.value = a.document.documentElement.clientHeight));
  };
  if (c(), CA(c), Tn("resize", c, { passive: !0 }), i) {
    const g = gD("(orientation: portrait)");
    st(g, () => c());
  }
  return { width: u, height: A };
}
const TD = 10, xD = 24, PD = 12, kD = xD - PD + TD, BA = [
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "right",
  "right-start",
  "right-end",
  "left",
  "left-start",
  "left-end"
], OD = 16, Ev = (e) => {
  const {
    activatorPosition: a,
    dropPosition: t,
    ignorePosition: r,
    side: i,
    preferredPositions: s,
    windowSize: u,
    zIndex: A = 1e6,
    space: c = OD
  } = e, g = (a == null ? void 0 : a.top) || 0, p = (a == null ? void 0 : a.left) || 0, v = (a == null ? void 0 : a.right) || 0, m = (a == null ? void 0 : a.bottom) || 0, w = (a == null ? void 0 : a.width) || 0, B = (a == null ? void 0 : a.height) || 0, T = (t == null ? void 0 : t.width) || 0, L = (t == null ? void 0 : t.height) || 0, E = (x) => x > 0 ? `${x}px` : "initial", N = {
    top: () => ({
      top: E(g - L - c),
      left: E(v - (T / 2 + w / 2)),
      positionClass: "POSITION_TOP"
    }),
    "top-end": () => ({
      top: E(g - L - c),
      left: E(p - c / 2),
      positionClass: "POSITION_TOP_END"
    }),
    "right-start": () => ({
      top: E(g - L / 2),
      left: E(v + c),
      positionClass: "POSITION_RIGHT_START"
    }),
    right: () => ({
      top: E(m - L / 2 - B / 2),
      left: E(v + c),
      positionClass: "POSITION_RIGHT"
    }),
    "right-end": () => ({
      top: E(m - c - B / 2),
      left: E(v + c),
      positionClass: "POSITION_RIGHT_BOTTOM"
    }),
    "bottom-start": () => ({
      top: E(m + c),
      left: E(v - T + c / 2),
      positionClass: "POSITION_BOTTOM_START"
    }),
    bottom: () => ({
      top: E(m + c),
      left: E(v - (T / 2 + w / 2)),
      positionClass: "POSITION_BOTTOM"
    }),
    "bottom-end": () => ({
      top: E(m + c),
      left: E(p - c / 2),
      positionClass: "POSITION_BOTTOM_END"
    }),
    "left-end": () => ({
      top: E(m - c - B / 2),
      left: E(p - T - c),
      positionClass: "POSITION_LEFT_END"
    }),
    left: () => ({
      top: E(m - L / 2 - B / 2),
      left: E(p - T - c),
      positionClass: "POSITION_LEFT"
    }),
    "left-start": () => ({
      top: E(g - L / 2),
      left: E(p - T - c),
      positionClass: "POSITION_LEFT_START"
    }),
    "top-start": () => ({
      top: E(g - L - c),
      left: E(v - T + c / 2),
      positionClass: "POSITION_TOP_START"
    })
  }, k = (x) => {
    const W = N[x];
    if (!W)
      return !1;
    const { top: z, left: q } = W();
    return z !== "initial" && q !== "initial" && parseInt(z.replace("px", "")) + L < u.height && parseInt(q.replace("px", "")) + T < u.width;
  }, F = () => BA;
  let S = i;
  if (!k(S)) {
    if (s && s.length > 0) {
      const x = s.find(
        (W) => k(W)
      );
      x && (S = x);
    }
    if (!k(i)) {
      const x = F();
      for (let W = 0; W < x.length; W++)
        if (k(x[W])) {
          S = x[W];
          break;
        }
    }
  }
  const Q = N[S]();
  return r && (Q.positionClass = "POSITION_BOTTOM"), { ...Q, zIndex: A };
};
var li = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ro = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ro.exports;
(function(e, a) {
  (function() {
    var t, r = "4.17.21", i = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", A = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", g = 500, p = "__lodash_placeholder__", v = 1, m = 2, w = 4, B = 1, T = 2, L = 1, E = 2, N = 4, k = 8, F = 16, S = 32, Q = 64, x = 128, W = 256, z = 512, q = 30, J = "...", le = 800, ve = 16, R = 1, _ = 2, G = 3, oe = 1 / 0, Oe = 9007199254740991, pe = 17976931348623157e292, $ = 0 / 0, Me = 4294967295, me = Me - 1, te = Me >>> 1, P = [
      ["ary", x],
      ["bind", L],
      ["bindKey", E],
      ["curry", k],
      ["curryRight", F],
      ["flip", z],
      ["partial", S],
      ["partialRight", Q],
      ["rearg", W]
    ], Z = "[object Arguments]", ae = "[object Array]", O = "[object AsyncFunction]", ke = "[object Boolean]", Ue = "[object Date]", Qt = "[object DOMException]", ie = "[object Error]", Te = "[object Function]", M = "[object GeneratorFunction]", Ae = "[object Map]", xe = "[object Number]", de = "[object Null]", Re = "[object Object]", ne = "[object Promise]", Pe = "[object Proxy]", Ve = "[object RegExp]", Ze = "[object Set]", sn = "[object String]", Fe = "[object Symbol]", Ba = "[object Undefined]", yn = "[object WeakMap]", Pr = "[object WeakSet]", an = "[object ArrayBuffer]", _n = "[object DataView]", kr = "[object Float32Array]", ar = "[object Float64Array]", Or = "[object Int8Array]", Mr = "[object Int16Array]", zr = "[object Int32Array]", Ir = "[object Uint8Array]", Er = "[object Uint8ClampedArray]", Lr = "[object Uint16Array]", ee = "[object Uint32Array]", Ie = /\b__p \+= '';/g, se = /\b(__p \+=) '' \+/g, ze = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ye = /&(?:amp|lt|gt|quot|#39);/g, un = /[&<>"']/g, En = RegExp(Ye.source), Sa = RegExp(un.source), il = /<%-([\s\S]+?)%>/g, Nr = /<%([\s\S]+?)%>/g, ua = /<%=([\s\S]+?)%>/g, Fl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vs = /^\w*$/, Up = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ps = /[\\^$.*+?()[\]{}|]/g, Rp = RegExp(ps.source), gs = /^\s+/, Zp = /\s/, Gp = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, jp = /\{\n\/\* \[wrapped with (.+)\] \*/, Kp = /,? & /, Jp = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, _p = /[()=,{}\[\]\/\s]/, $p = /\\(\\)?/g, eg = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, jA = /\w*$/, tg = /^[-+]0x[0-9a-f]+$/i, ng = /^0b[01]+$/i, ag = /^\[object .+?Constructor\]$/, rg = /^0o[0-7]+$/i, lg = /^(?:0|[1-9]\d*)$/, ig = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Vi = /($^)/, og = /['\n\r\u2028\u2029\\]/g, Wi = "\\ud800-\\udfff", sg = "\\u0300-\\u036f", ug = "\\ufe20-\\ufe2f", Ag = "\\u20d0-\\u20ff", KA = sg + ug + Ag, JA = "\\u2700-\\u27bf", _A = "a-z\\xdf-\\xf6\\xf8-\\xff", dg = "\\xac\\xb1\\xd7\\xf7", cg = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", fg = "\\u2000-\\u206f", vg = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $A = "A-Z\\xc0-\\xd6\\xd8-\\xde", ed = "\\ufe0e\\ufe0f", td = dg + cg + fg + vg, hs = "['’]", pg = "[" + Wi + "]", nd = "[" + td + "]", Xi = "[" + KA + "]", ad = "\\d+", gg = "[" + JA + "]", rd = "[" + _A + "]", ld = "[^" + Wi + td + ad + JA + _A + $A + "]", ms = "\\ud83c[\\udffb-\\udfff]", hg = "(?:" + Xi + "|" + ms + ")", id = "[^" + Wi + "]", ys = "(?:\\ud83c[\\udde6-\\uddff]){2}", bs = "[\\ud800-\\udbff][\\udc00-\\udfff]", ol = "[" + $A + "]", od = "\\u200d", sd = "(?:" + rd + "|" + ld + ")", mg = "(?:" + ol + "|" + ld + ")", ud = "(?:" + hs + "(?:d|ll|m|re|s|t|ve))?", Ad = "(?:" + hs + "(?:D|LL|M|RE|S|T|VE))?", dd = hg + "?", cd = "[" + ed + "]?", yg = "(?:" + od + "(?:" + [id, ys, bs].join("|") + ")" + cd + dd + ")*", bg = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", wg = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", fd = cd + dd + yg, Cg = "(?:" + [gg, ys, bs].join("|") + ")" + fd, Dg = "(?:" + [id + Xi + "?", Xi, ys, bs, pg].join("|") + ")", Bg = RegExp(hs, "g"), Tg = RegExp(Xi, "g"), ws = RegExp(ms + "(?=" + ms + ")|" + Dg + fd, "g"), xg = RegExp([
      ol + "?" + rd + "+" + ud + "(?=" + [nd, ol, "$"].join("|") + ")",
      mg + "+" + Ad + "(?=" + [nd, ol + sd, "$"].join("|") + ")",
      ol + "?" + sd + "+" + ud,
      ol + "+" + Ad,
      wg,
      bg,
      ad,
      Cg
    ].join("|"), "g"), Pg = RegExp("[" + od + Wi + KA + ed + "]"), kg = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Og = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Mg = -1, Ot = {};
    Ot[kr] = Ot[ar] = Ot[Or] = Ot[Mr] = Ot[zr] = Ot[Ir] = Ot[Er] = Ot[Lr] = Ot[ee] = !0, Ot[Z] = Ot[ae] = Ot[an] = Ot[ke] = Ot[_n] = Ot[Ue] = Ot[ie] = Ot[Te] = Ot[Ae] = Ot[xe] = Ot[Re] = Ot[Ve] = Ot[Ze] = Ot[sn] = Ot[yn] = !1;
    var kt = {};
    kt[Z] = kt[ae] = kt[an] = kt[_n] = kt[ke] = kt[Ue] = kt[kr] = kt[ar] = kt[Or] = kt[Mr] = kt[zr] = kt[Ae] = kt[xe] = kt[Re] = kt[Ve] = kt[Ze] = kt[sn] = kt[Fe] = kt[Ir] = kt[Er] = kt[Lr] = kt[ee] = !0, kt[ie] = kt[Te] = kt[yn] = !1;
    var zg = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Ig = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Eg = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Lg = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Ng = parseFloat, Yg = parseInt, vd = typeof li == "object" && li && li.Object === Object && li, Sg = typeof self == "object" && self && self.Object === Object && self, vn = vd || Sg || Function("return this")(), Cs = a && !a.nodeType && a, Yr = Cs && !0 && e && !e.nodeType && e, pd = Yr && Yr.exports === Cs, Ds = pd && vd.process, $n = function() {
      try {
        var j = Yr && Yr.require && Yr.require("util").types;
        return j || Ds && Ds.binding && Ds.binding("util");
      } catch {
      }
    }(), gd = $n && $n.isArrayBuffer, hd = $n && $n.isDate, md = $n && $n.isMap, yd = $n && $n.isRegExp, bd = $n && $n.isSet, wd = $n && $n.isTypedArray;
    function Hn(j, ge, re) {
      switch (re.length) {
        case 0:
          return j.call(ge);
        case 1:
          return j.call(ge, re[0]);
        case 2:
          return j.call(ge, re[0], re[1]);
        case 3:
          return j.call(ge, re[0], re[1], re[2]);
      }
      return j.apply(ge, re);
    }
    function Vg(j, ge, re, Xe) {
      for (var nt = -1, gt = j == null ? 0 : j.length; ++nt < gt; ) {
        var rn = j[nt];
        ge(Xe, rn, re(rn), j);
      }
      return Xe;
    }
    function ea(j, ge) {
      for (var re = -1, Xe = j == null ? 0 : j.length; ++re < Xe && ge(j[re], re, j) !== !1; )
        ;
      return j;
    }
    function Wg(j, ge) {
      for (var re = j == null ? 0 : j.length; re-- && ge(j[re], re, j) !== !1; )
        ;
      return j;
    }
    function Cd(j, ge) {
      for (var re = -1, Xe = j == null ? 0 : j.length; ++re < Xe; )
        if (!ge(j[re], re, j))
          return !1;
      return !0;
    }
    function rr(j, ge) {
      for (var re = -1, Xe = j == null ? 0 : j.length, nt = 0, gt = []; ++re < Xe; ) {
        var rn = j[re];
        ge(rn, re, j) && (gt[nt++] = rn);
      }
      return gt;
    }
    function Qi(j, ge) {
      var re = j == null ? 0 : j.length;
      return !!re && sl(j, ge, 0) > -1;
    }
    function Bs(j, ge, re) {
      for (var Xe = -1, nt = j == null ? 0 : j.length; ++Xe < nt; )
        if (re(ge, j[Xe]))
          return !0;
      return !1;
    }
    function It(j, ge) {
      for (var re = -1, Xe = j == null ? 0 : j.length, nt = Array(Xe); ++re < Xe; )
        nt[re] = ge(j[re], re, j);
      return nt;
    }
    function lr(j, ge) {
      for (var re = -1, Xe = ge.length, nt = j.length; ++re < Xe; )
        j[nt + re] = ge[re];
      return j;
    }
    function Ts(j, ge, re, Xe) {
      var nt = -1, gt = j == null ? 0 : j.length;
      for (Xe && gt && (re = j[++nt]); ++nt < gt; )
        re = ge(re, j[nt], nt, j);
      return re;
    }
    function Xg(j, ge, re, Xe) {
      var nt = j == null ? 0 : j.length;
      for (Xe && nt && (re = j[--nt]); nt--; )
        re = ge(re, j[nt], nt, j);
      return re;
    }
    function xs(j, ge) {
      for (var re = -1, Xe = j == null ? 0 : j.length; ++re < Xe; )
        if (ge(j[re], re, j))
          return !0;
      return !1;
    }
    var Qg = Ps("length");
    function Hg(j) {
      return j.split("");
    }
    function Fg(j) {
      return j.match(Jp) || [];
    }
    function Dd(j, ge, re) {
      var Xe;
      return re(j, function(nt, gt, rn) {
        if (ge(nt, gt, rn))
          return Xe = gt, !1;
      }), Xe;
    }
    function Hi(j, ge, re, Xe) {
      for (var nt = j.length, gt = re + (Xe ? 1 : -1); Xe ? gt-- : ++gt < nt; )
        if (ge(j[gt], gt, j))
          return gt;
      return -1;
    }
    function sl(j, ge, re) {
      return ge === ge ? th(j, ge, re) : Hi(j, Bd, re);
    }
    function qg(j, ge, re, Xe) {
      for (var nt = re - 1, gt = j.length; ++nt < gt; )
        if (Xe(j[nt], ge))
          return nt;
      return -1;
    }
    function Bd(j) {
      return j !== j;
    }
    function Td(j, ge) {
      var re = j == null ? 0 : j.length;
      return re ? Os(j, ge) / re : $;
    }
    function Ps(j) {
      return function(ge) {
        return ge == null ? t : ge[j];
      };
    }
    function ks(j) {
      return function(ge) {
        return j == null ? t : j[ge];
      };
    }
    function xd(j, ge, re, Xe, nt) {
      return nt(j, function(gt, rn, xt) {
        re = Xe ? (Xe = !1, gt) : ge(re, gt, rn, xt);
      }), re;
    }
    function Ug(j, ge) {
      var re = j.length;
      for (j.sort(ge); re--; )
        j[re] = j[re].value;
      return j;
    }
    function Os(j, ge) {
      for (var re, Xe = -1, nt = j.length; ++Xe < nt; ) {
        var gt = ge(j[Xe]);
        gt !== t && (re = re === t ? gt : re + gt);
      }
      return re;
    }
    function Ms(j, ge) {
      for (var re = -1, Xe = Array(j); ++re < j; )
        Xe[re] = ge(re);
      return Xe;
    }
    function Rg(j, ge) {
      return It(ge, function(re) {
        return [re, j[re]];
      });
    }
    function Pd(j) {
      return j && j.slice(0, zd(j) + 1).replace(gs, "");
    }
    function Fn(j) {
      return function(ge) {
        return j(ge);
      };
    }
    function zs(j, ge) {
      return It(ge, function(re) {
        return j[re];
      });
    }
    function ql(j, ge) {
      return j.has(ge);
    }
    function kd(j, ge) {
      for (var re = -1, Xe = j.length; ++re < Xe && sl(ge, j[re], 0) > -1; )
        ;
      return re;
    }
    function Od(j, ge) {
      for (var re = j.length; re-- && sl(ge, j[re], 0) > -1; )
        ;
      return re;
    }
    function Zg(j, ge) {
      for (var re = j.length, Xe = 0; re--; )
        j[re] === ge && ++Xe;
      return Xe;
    }
    var Gg = ks(zg), jg = ks(Ig);
    function Kg(j) {
      return "\\" + Lg[j];
    }
    function Jg(j, ge) {
      return j == null ? t : j[ge];
    }
    function ul(j) {
      return Pg.test(j);
    }
    function _g(j) {
      return kg.test(j);
    }
    function $g(j) {
      for (var ge, re = []; !(ge = j.next()).done; )
        re.push(ge.value);
      return re;
    }
    function Is(j) {
      var ge = -1, re = Array(j.size);
      return j.forEach(function(Xe, nt) {
        re[++ge] = [nt, Xe];
      }), re;
    }
    function Md(j, ge) {
      return function(re) {
        return j(ge(re));
      };
    }
    function ir(j, ge) {
      for (var re = -1, Xe = j.length, nt = 0, gt = []; ++re < Xe; ) {
        var rn = j[re];
        (rn === ge || rn === p) && (j[re] = p, gt[nt++] = re);
      }
      return gt;
    }
    function Fi(j) {
      var ge = -1, re = Array(j.size);
      return j.forEach(function(Xe) {
        re[++ge] = Xe;
      }), re;
    }
    function eh(j) {
      var ge = -1, re = Array(j.size);
      return j.forEach(function(Xe) {
        re[++ge] = [Xe, Xe];
      }), re;
    }
    function th(j, ge, re) {
      for (var Xe = re - 1, nt = j.length; ++Xe < nt; )
        if (j[Xe] === ge)
          return Xe;
      return -1;
    }
    function nh(j, ge, re) {
      for (var Xe = re + 1; Xe--; )
        if (j[Xe] === ge)
          return Xe;
      return Xe;
    }
    function Al(j) {
      return ul(j) ? rh(j) : Qg(j);
    }
    function Aa(j) {
      return ul(j) ? lh(j) : Hg(j);
    }
    function zd(j) {
      for (var ge = j.length; ge-- && Zp.test(j.charAt(ge)); )
        ;
      return ge;
    }
    var ah = ks(Eg);
    function rh(j) {
      for (var ge = ws.lastIndex = 0; ws.test(j); )
        ++ge;
      return ge;
    }
    function lh(j) {
      return j.match(ws) || [];
    }
    function ih(j) {
      return j.match(xg) || [];
    }
    var oh = function j(ge) {
      ge = ge == null ? vn : dl.defaults(vn.Object(), ge, dl.pick(vn, Og));
      var re = ge.Array, Xe = ge.Date, nt = ge.Error, gt = ge.Function, rn = ge.Math, xt = ge.Object, Es = ge.RegExp, sh = ge.String, ta = ge.TypeError, qi = re.prototype, uh = gt.prototype, cl = xt.prototype, Ui = ge["__core-js_shared__"], Ri = uh.toString, wt = cl.hasOwnProperty, Ah = 0, Id = function() {
        var n = /[^.]+$/.exec(Ui && Ui.keys && Ui.keys.IE_PROTO || "");
        return n ? "Symbol(src)_1." + n : "";
      }(), Zi = cl.toString, dh = Ri.call(xt), ch = vn._, fh = Es(
        "^" + Ri.call(wt).replace(ps, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Gi = pd ? ge.Buffer : t, or = ge.Symbol, ji = ge.Uint8Array, Ed = Gi ? Gi.allocUnsafe : t, Ki = Md(xt.getPrototypeOf, xt), Ld = xt.create, Nd = cl.propertyIsEnumerable, Ji = qi.splice, Yd = or ? or.isConcatSpreadable : t, Ul = or ? or.iterator : t, Sr = or ? or.toStringTag : t, _i = function() {
        try {
          var n = Hr(xt, "defineProperty");
          return n({}, "", {}), n;
        } catch {
        }
      }(), vh = ge.clearTimeout !== vn.clearTimeout && ge.clearTimeout, ph = Xe && Xe.now !== vn.Date.now && Xe.now, gh = ge.setTimeout !== vn.setTimeout && ge.setTimeout, $i = rn.ceil, eo = rn.floor, Ls = xt.getOwnPropertySymbols, hh = Gi ? Gi.isBuffer : t, Sd = ge.isFinite, mh = qi.join, yh = Md(xt.keys, xt), ln = rn.max, bn = rn.min, bh = Xe.now, wh = ge.parseInt, Vd = rn.random, Ch = qi.reverse, Ns = Hr(ge, "DataView"), Rl = Hr(ge, "Map"), Ys = Hr(ge, "Promise"), fl = Hr(ge, "Set"), Zl = Hr(ge, "WeakMap"), Gl = Hr(xt, "create"), to = Zl && new Zl(), vl = {}, Dh = Fr(Ns), Bh = Fr(Rl), Th = Fr(Ys), xh = Fr(fl), Ph = Fr(Zl), no = or ? or.prototype : t, jl = no ? no.valueOf : t, Wd = no ? no.toString : t;
      function C(n) {
        if (Ht(n) && !rt(n) && !(n instanceof dt)) {
          if (n instanceof na)
            return n;
          if (wt.call(n, "__wrapped__"))
            return Xc(n);
        }
        return new na(n);
      }
      var pl = function() {
        function n() {
        }
        return function(l) {
          if (!Yt(l))
            return {};
          if (Ld)
            return Ld(l);
          n.prototype = l;
          var o = new n();
          return n.prototype = t, o;
        };
      }();
      function ao() {
      }
      function na(n, l) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!l, this.__index__ = 0, this.__values__ = t;
      }
      C.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: il,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Nr,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: ua,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: C
        }
      }, C.prototype = ao.prototype, C.prototype.constructor = C, na.prototype = pl(ao.prototype), na.prototype.constructor = na;
      function dt(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Me, this.__views__ = [];
      }
      function kh() {
        var n = new dt(this.__wrapped__);
        return n.__actions__ = Ln(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Ln(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Ln(this.__views__), n;
      }
      function Oh() {
        if (this.__filtered__) {
          var n = new dt(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else
          n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function Mh() {
        var n = this.__wrapped__.value(), l = this.__dir__, o = rt(n), d = l < 0, h = o ? n.length : 0, D = Hm(0, h, this.__views__), I = D.start, H = D.end, K = H - I, ye = d ? H : I - 1, be = this.__iteratees__, De = be.length, Se = 0, qe = bn(K, this.__takeCount__);
        if (!o || !d && h == K && qe == K)
          return uc(n, this.__actions__);
        var Ke = [];
        e:
          for (; K-- && Se < qe; ) {
            ye += l;
            for (var it = -1, Je = n[ye]; ++it < De; ) {
              var ut = be[it], vt = ut.iteratee, Rn = ut.type, kn = vt(Je);
              if (Rn == _)
                Je = kn;
              else if (!kn) {
                if (Rn == R)
                  continue e;
                break e;
              }
            }
            Ke[Se++] = Je;
          }
        return Ke;
      }
      dt.prototype = pl(ao.prototype), dt.prototype.constructor = dt;
      function Vr(n) {
        var l = -1, o = n == null ? 0 : n.length;
        for (this.clear(); ++l < o; ) {
          var d = n[l];
          this.set(d[0], d[1]);
        }
      }
      function zh() {
        this.__data__ = Gl ? Gl(null) : {}, this.size = 0;
      }
      function Ih(n) {
        var l = this.has(n) && delete this.__data__[n];
        return this.size -= l ? 1 : 0, l;
      }
      function Eh(n) {
        var l = this.__data__;
        if (Gl) {
          var o = l[n];
          return o === c ? t : o;
        }
        return wt.call(l, n) ? l[n] : t;
      }
      function Lh(n) {
        var l = this.__data__;
        return Gl ? l[n] !== t : wt.call(l, n);
      }
      function Nh(n, l) {
        var o = this.__data__;
        return this.size += this.has(n) ? 0 : 1, o[n] = Gl && l === t ? c : l, this;
      }
      Vr.prototype.clear = zh, Vr.prototype.delete = Ih, Vr.prototype.get = Eh, Vr.prototype.has = Lh, Vr.prototype.set = Nh;
      function Va(n) {
        var l = -1, o = n == null ? 0 : n.length;
        for (this.clear(); ++l < o; ) {
          var d = n[l];
          this.set(d[0], d[1]);
        }
      }
      function Yh() {
        this.__data__ = [], this.size = 0;
      }
      function Sh(n) {
        var l = this.__data__, o = ro(l, n);
        if (o < 0)
          return !1;
        var d = l.length - 1;
        return o == d ? l.pop() : Ji.call(l, o, 1), --this.size, !0;
      }
      function Vh(n) {
        var l = this.__data__, o = ro(l, n);
        return o < 0 ? t : l[o][1];
      }
      function Wh(n) {
        return ro(this.__data__, n) > -1;
      }
      function Xh(n, l) {
        var o = this.__data__, d = ro(o, n);
        return d < 0 ? (++this.size, o.push([n, l])) : o[d][1] = l, this;
      }
      Va.prototype.clear = Yh, Va.prototype.delete = Sh, Va.prototype.get = Vh, Va.prototype.has = Wh, Va.prototype.set = Xh;
      function Wa(n) {
        var l = -1, o = n == null ? 0 : n.length;
        for (this.clear(); ++l < o; ) {
          var d = n[l];
          this.set(d[0], d[1]);
        }
      }
      function Qh() {
        this.size = 0, this.__data__ = {
          hash: new Vr(),
          map: new (Rl || Va)(),
          string: new Vr()
        };
      }
      function Hh(n) {
        var l = ho(this, n).delete(n);
        return this.size -= l ? 1 : 0, l;
      }
      function Fh(n) {
        return ho(this, n).get(n);
      }
      function qh(n) {
        return ho(this, n).has(n);
      }
      function Uh(n, l) {
        var o = ho(this, n), d = o.size;
        return o.set(n, l), this.size += o.size == d ? 0 : 1, this;
      }
      Wa.prototype.clear = Qh, Wa.prototype.delete = Hh, Wa.prototype.get = Fh, Wa.prototype.has = qh, Wa.prototype.set = Uh;
      function Wr(n) {
        var l = -1, o = n == null ? 0 : n.length;
        for (this.__data__ = new Wa(); ++l < o; )
          this.add(n[l]);
      }
      function Rh(n) {
        return this.__data__.set(n, c), this;
      }
      function Zh(n) {
        return this.__data__.has(n);
      }
      Wr.prototype.add = Wr.prototype.push = Rh, Wr.prototype.has = Zh;
      function da(n) {
        var l = this.__data__ = new Va(n);
        this.size = l.size;
      }
      function Gh() {
        this.__data__ = new Va(), this.size = 0;
      }
      function jh(n) {
        var l = this.__data__, o = l.delete(n);
        return this.size = l.size, o;
      }
      function Kh(n) {
        return this.__data__.get(n);
      }
      function Jh(n) {
        return this.__data__.has(n);
      }
      function _h(n, l) {
        var o = this.__data__;
        if (o instanceof Va) {
          var d = o.__data__;
          if (!Rl || d.length < i - 1)
            return d.push([n, l]), this.size = ++o.size, this;
          o = this.__data__ = new Wa(d);
        }
        return o.set(n, l), this.size = o.size, this;
      }
      da.prototype.clear = Gh, da.prototype.delete = jh, da.prototype.get = Kh, da.prototype.has = Jh, da.prototype.set = _h;
      function Xd(n, l) {
        var o = rt(n), d = !o && qr(n), h = !o && !d && cr(n), D = !o && !d && !h && yl(n), I = o || d || h || D, H = I ? Ms(n.length, sh) : [], K = H.length;
        for (var ye in n)
          (l || wt.call(n, ye)) && !(I && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ye == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          h && (ye == "offset" || ye == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          D && (ye == "buffer" || ye == "byteLength" || ye == "byteOffset") || // Skip index properties.
          Fa(ye, K))) && H.push(ye);
        return H;
      }
      function Qd(n) {
        var l = n.length;
        return l ? n[Zs(0, l - 1)] : t;
      }
      function $h(n, l) {
        return mo(Ln(n), Xr(l, 0, n.length));
      }
      function em(n) {
        return mo(Ln(n));
      }
      function Ss(n, l, o) {
        (o !== t && !ca(n[l], o) || o === t && !(l in n)) && Xa(n, l, o);
      }
      function Kl(n, l, o) {
        var d = n[l];
        (!(wt.call(n, l) && ca(d, o)) || o === t && !(l in n)) && Xa(n, l, o);
      }
      function ro(n, l) {
        for (var o = n.length; o--; )
          if (ca(n[o][0], l))
            return o;
        return -1;
      }
      function tm(n, l, o, d) {
        return sr(n, function(h, D, I) {
          l(d, h, o(h), I);
        }), d;
      }
      function Hd(n, l) {
        return n && xa(l, An(l), n);
      }
      function nm(n, l) {
        return n && xa(l, Yn(l), n);
      }
      function Xa(n, l, o) {
        l == "__proto__" && _i ? _i(n, l, {
          configurable: !0,
          enumerable: !0,
          value: o,
          writable: !0
        }) : n[l] = o;
      }
      function Vs(n, l) {
        for (var o = -1, d = l.length, h = re(d), D = n == null; ++o < d; )
          h[o] = D ? t : mu(n, l[o]);
        return h;
      }
      function Xr(n, l, o) {
        return n === n && (o !== t && (n = n <= o ? n : o), l !== t && (n = n >= l ? n : l)), n;
      }
      function aa(n, l, o, d, h, D) {
        var I, H = l & v, K = l & m, ye = l & w;
        if (o && (I = h ? o(n, d, h, D) : o(n)), I !== t)
          return I;
        if (!Yt(n))
          return n;
        var be = rt(n);
        if (be) {
          if (I = qm(n), !H)
            return Ln(n, I);
        } else {
          var De = wn(n), Se = De == Te || De == M;
          if (cr(n))
            return cc(n, H);
          if (De == Re || De == Z || Se && !h) {
            if (I = K || Se ? {} : zc(n), !H)
              return K ? Em(n, nm(I, n)) : Im(n, Hd(I, n));
          } else {
            if (!kt[De])
              return h ? n : {};
            I = Um(n, De, H);
          }
        }
        D || (D = new da());
        var qe = D.get(n);
        if (qe)
          return qe;
        D.set(n, I), of(n) ? n.forEach(function(Je) {
          I.add(aa(Je, l, o, Je, n, D));
        }) : rf(n) && n.forEach(function(Je, ut) {
          I.set(ut, aa(Je, l, o, ut, n, D));
        });
        var Ke = ye ? K ? ru : au : K ? Yn : An, it = be ? t : Ke(n);
        return ea(it || n, function(Je, ut) {
          it && (ut = Je, Je = n[ut]), Kl(I, ut, aa(Je, l, o, ut, n, D));
        }), I;
      }
      function am(n) {
        var l = An(n);
        return function(o) {
          return Fd(o, n, l);
        };
      }
      function Fd(n, l, o) {
        var d = o.length;
        if (n == null)
          return !d;
        for (n = xt(n); d--; ) {
          var h = o[d], D = l[h], I = n[h];
          if (I === t && !(h in n) || !D(I))
            return !1;
        }
        return !0;
      }
      function qd(n, l, o) {
        if (typeof n != "function")
          throw new ta(u);
        return ai(function() {
          n.apply(t, o);
        }, l);
      }
      function Jl(n, l, o, d) {
        var h = -1, D = Qi, I = !0, H = n.length, K = [], ye = l.length;
        if (!H)
          return K;
        o && (l = It(l, Fn(o))), d ? (D = Bs, I = !1) : l.length >= i && (D = ql, I = !1, l = new Wr(l));
        e:
          for (; ++h < H; ) {
            var be = n[h], De = o == null ? be : o(be);
            if (be = d || be !== 0 ? be : 0, I && De === De) {
              for (var Se = ye; Se--; )
                if (l[Se] === De)
                  continue e;
              K.push(be);
            } else
              D(l, De, d) || K.push(be);
          }
        return K;
      }
      var sr = hc(Ta), Ud = hc(Xs, !0);
      function rm(n, l) {
        var o = !0;
        return sr(n, function(d, h, D) {
          return o = !!l(d, h, D), o;
        }), o;
      }
      function lo(n, l, o) {
        for (var d = -1, h = n.length; ++d < h; ) {
          var D = n[d], I = l(D);
          if (I != null && (H === t ? I === I && !Un(I) : o(I, H)))
            var H = I, K = D;
        }
        return K;
      }
      function lm(n, l, o, d) {
        var h = n.length;
        for (o = lt(o), o < 0 && (o = -o > h ? 0 : h + o), d = d === t || d > h ? h : lt(d), d < 0 && (d += h), d = o > d ? 0 : uf(d); o < d; )
          n[o++] = l;
        return n;
      }
      function Rd(n, l) {
        var o = [];
        return sr(n, function(d, h, D) {
          l(d, h, D) && o.push(d);
        }), o;
      }
      function pn(n, l, o, d, h) {
        var D = -1, I = n.length;
        for (o || (o = Zm), h || (h = []); ++D < I; ) {
          var H = n[D];
          l > 0 && o(H) ? l > 1 ? pn(H, l - 1, o, d, h) : lr(h, H) : d || (h[h.length] = H);
        }
        return h;
      }
      var Ws = mc(), Zd = mc(!0);
      function Ta(n, l) {
        return n && Ws(n, l, An);
      }
      function Xs(n, l) {
        return n && Zd(n, l, An);
      }
      function io(n, l) {
        return rr(l, function(o) {
          return qa(n[o]);
        });
      }
      function Qr(n, l) {
        l = Ar(l, n);
        for (var o = 0, d = l.length; n != null && o < d; )
          n = n[Pa(l[o++])];
        return o && o == d ? n : t;
      }
      function Gd(n, l, o) {
        var d = l(n);
        return rt(n) ? d : lr(d, o(n));
      }
      function xn(n) {
        return n == null ? n === t ? Ba : de : Sr && Sr in xt(n) ? Qm(n) : ey(n);
      }
      function Qs(n, l) {
        return n > l;
      }
      function im(n, l) {
        return n != null && wt.call(n, l);
      }
      function om(n, l) {
        return n != null && l in xt(n);
      }
      function sm(n, l, o) {
        return n >= bn(l, o) && n < ln(l, o);
      }
      function Hs(n, l, o) {
        for (var d = o ? Bs : Qi, h = n[0].length, D = n.length, I = D, H = re(D), K = 1 / 0, ye = []; I--; ) {
          var be = n[I];
          I && l && (be = It(be, Fn(l))), K = bn(be.length, K), H[I] = !o && (l || h >= 120 && be.length >= 120) ? new Wr(I && be) : t;
        }
        be = n[0];
        var De = -1, Se = H[0];
        e:
          for (; ++De < h && ye.length < K; ) {
            var qe = be[De], Ke = l ? l(qe) : qe;
            if (qe = o || qe !== 0 ? qe : 0, !(Se ? ql(Se, Ke) : d(ye, Ke, o))) {
              for (I = D; --I; ) {
                var it = H[I];
                if (!(it ? ql(it, Ke) : d(n[I], Ke, o)))
                  continue e;
              }
              Se && Se.push(Ke), ye.push(qe);
            }
          }
        return ye;
      }
      function um(n, l, o, d) {
        return Ta(n, function(h, D, I) {
          l(d, o(h), D, I);
        }), d;
      }
      function _l(n, l, o) {
        l = Ar(l, n), n = Nc(n, l);
        var d = n == null ? n : n[Pa(la(l))];
        return d == null ? t : Hn(d, n, o);
      }
      function jd(n) {
        return Ht(n) && xn(n) == Z;
      }
      function Am(n) {
        return Ht(n) && xn(n) == an;
      }
      function dm(n) {
        return Ht(n) && xn(n) == Ue;
      }
      function $l(n, l, o, d, h) {
        return n === l ? !0 : n == null || l == null || !Ht(n) && !Ht(l) ? n !== n && l !== l : cm(n, l, o, d, $l, h);
      }
      function cm(n, l, o, d, h, D) {
        var I = rt(n), H = rt(l), K = I ? ae : wn(n), ye = H ? ae : wn(l);
        K = K == Z ? Re : K, ye = ye == Z ? Re : ye;
        var be = K == Re, De = ye == Re, Se = K == ye;
        if (Se && cr(n)) {
          if (!cr(l))
            return !1;
          I = !0, be = !1;
        }
        if (Se && !be)
          return D || (D = new da()), I || yl(n) ? kc(n, l, o, d, h, D) : Wm(n, l, K, o, d, h, D);
        if (!(o & B)) {
          var qe = be && wt.call(n, "__wrapped__"), Ke = De && wt.call(l, "__wrapped__");
          if (qe || Ke) {
            var it = qe ? n.value() : n, Je = Ke ? l.value() : l;
            return D || (D = new da()), h(it, Je, o, d, D);
          }
        }
        return Se ? (D || (D = new da()), Xm(n, l, o, d, h, D)) : !1;
      }
      function fm(n) {
        return Ht(n) && wn(n) == Ae;
      }
      function Fs(n, l, o, d) {
        var h = o.length, D = h, I = !d;
        if (n == null)
          return !D;
        for (n = xt(n); h--; ) {
          var H = o[h];
          if (I && H[2] ? H[1] !== n[H[0]] : !(H[0] in n))
            return !1;
        }
        for (; ++h < D; ) {
          H = o[h];
          var K = H[0], ye = n[K], be = H[1];
          if (I && H[2]) {
            if (ye === t && !(K in n))
              return !1;
          } else {
            var De = new da();
            if (d)
              var Se = d(ye, be, K, n, l, De);
            if (!(Se === t ? $l(be, ye, B | T, d, De) : Se))
              return !1;
          }
        }
        return !0;
      }
      function Kd(n) {
        if (!Yt(n) || jm(n))
          return !1;
        var l = qa(n) ? fh : ag;
        return l.test(Fr(n));
      }
      function vm(n) {
        return Ht(n) && xn(n) == Ve;
      }
      function pm(n) {
        return Ht(n) && wn(n) == Ze;
      }
      function gm(n) {
        return Ht(n) && Bo(n.length) && !!Ot[xn(n)];
      }
      function Jd(n) {
        return typeof n == "function" ? n : n == null ? Sn : typeof n == "object" ? rt(n) ? ec(n[0], n[1]) : $d(n) : bf(n);
      }
      function qs(n) {
        if (!ni(n))
          return yh(n);
        var l = [];
        for (var o in xt(n))
          wt.call(n, o) && o != "constructor" && l.push(o);
        return l;
      }
      function hm(n) {
        if (!Yt(n))
          return $m(n);
        var l = ni(n), o = [];
        for (var d in n)
          d == "constructor" && (l || !wt.call(n, d)) || o.push(d);
        return o;
      }
      function Us(n, l) {
        return n < l;
      }
      function _d(n, l) {
        var o = -1, d = Nn(n) ? re(n.length) : [];
        return sr(n, function(h, D, I) {
          d[++o] = l(h, D, I);
        }), d;
      }
      function $d(n) {
        var l = iu(n);
        return l.length == 1 && l[0][2] ? Ec(l[0][0], l[0][1]) : function(o) {
          return o === n || Fs(o, n, l);
        };
      }
      function ec(n, l) {
        return su(n) && Ic(l) ? Ec(Pa(n), l) : function(o) {
          var d = mu(o, n);
          return d === t && d === l ? yu(o, n) : $l(l, d, B | T);
        };
      }
      function oo(n, l, o, d, h) {
        n !== l && Ws(l, function(D, I) {
          if (h || (h = new da()), Yt(D))
            mm(n, l, I, o, oo, d, h);
          else {
            var H = d ? d(Au(n, I), D, I + "", n, l, h) : t;
            H === t && (H = D), Ss(n, I, H);
          }
        }, Yn);
      }
      function mm(n, l, o, d, h, D, I) {
        var H = Au(n, o), K = Au(l, o), ye = I.get(K);
        if (ye) {
          Ss(n, o, ye);
          return;
        }
        var be = D ? D(H, K, o + "", n, l, I) : t, De = be === t;
        if (De) {
          var Se = rt(K), qe = !Se && cr(K), Ke = !Se && !qe && yl(K);
          be = K, Se || qe || Ke ? rt(H) ? be = H : Rt(H) ? be = Ln(H) : qe ? (De = !1, be = cc(K, !0)) : Ke ? (De = !1, be = fc(K, !0)) : be = [] : ri(K) || qr(K) ? (be = H, qr(H) ? be = Af(H) : (!Yt(H) || qa(H)) && (be = zc(K))) : De = !1;
        }
        De && (I.set(K, be), h(be, K, d, D, I), I.delete(K)), Ss(n, o, be);
      }
      function tc(n, l) {
        var o = n.length;
        if (o)
          return l += l < 0 ? o : 0, Fa(l, o) ? n[l] : t;
      }
      function nc(n, l, o) {
        l.length ? l = It(l, function(D) {
          return rt(D) ? function(I) {
            return Qr(I, D.length === 1 ? D[0] : D);
          } : D;
        }) : l = [Sn];
        var d = -1;
        l = It(l, Fn(Ge()));
        var h = _d(n, function(D, I, H) {
          var K = It(l, function(ye) {
            return ye(D);
          });
          return { criteria: K, index: ++d, value: D };
        });
        return Ug(h, function(D, I) {
          return zm(D, I, o);
        });
      }
      function ym(n, l) {
        return ac(n, l, function(o, d) {
          return yu(n, d);
        });
      }
      function ac(n, l, o) {
        for (var d = -1, h = l.length, D = {}; ++d < h; ) {
          var I = l[d], H = Qr(n, I);
          o(H, I) && ei(D, Ar(I, n), H);
        }
        return D;
      }
      function bm(n) {
        return function(l) {
          return Qr(l, n);
        };
      }
      function Rs(n, l, o, d) {
        var h = d ? qg : sl, D = -1, I = l.length, H = n;
        for (n === l && (l = Ln(l)), o && (H = It(n, Fn(o))); ++D < I; )
          for (var K = 0, ye = l[D], be = o ? o(ye) : ye; (K = h(H, be, K, d)) > -1; )
            H !== n && Ji.call(H, K, 1), Ji.call(n, K, 1);
        return n;
      }
      function rc(n, l) {
        for (var o = n ? l.length : 0, d = o - 1; o--; ) {
          var h = l[o];
          if (o == d || h !== D) {
            var D = h;
            Fa(h) ? Ji.call(n, h, 1) : Ks(n, h);
          }
        }
        return n;
      }
      function Zs(n, l) {
        return n + eo(Vd() * (l - n + 1));
      }
      function wm(n, l, o, d) {
        for (var h = -1, D = ln($i((l - n) / (o || 1)), 0), I = re(D); D--; )
          I[d ? D : ++h] = n, n += o;
        return I;
      }
      function Gs(n, l) {
        var o = "";
        if (!n || l < 1 || l > Oe)
          return o;
        do
          l % 2 && (o += n), l = eo(l / 2), l && (n += n);
        while (l);
        return o;
      }
      function ot(n, l) {
        return du(Lc(n, l, Sn), n + "");
      }
      function Cm(n) {
        return Qd(bl(n));
      }
      function Dm(n, l) {
        var o = bl(n);
        return mo(o, Xr(l, 0, o.length));
      }
      function ei(n, l, o, d) {
        if (!Yt(n))
          return n;
        l = Ar(l, n);
        for (var h = -1, D = l.length, I = D - 1, H = n; H != null && ++h < D; ) {
          var K = Pa(l[h]), ye = o;
          if (K === "__proto__" || K === "constructor" || K === "prototype")
            return n;
          if (h != I) {
            var be = H[K];
            ye = d ? d(be, K, H) : t, ye === t && (ye = Yt(be) ? be : Fa(l[h + 1]) ? [] : {});
          }
          Kl(H, K, ye), H = H[K];
        }
        return n;
      }
      var lc = to ? function(n, l) {
        return to.set(n, l), n;
      } : Sn, Bm = _i ? function(n, l) {
        return _i(n, "toString", {
          configurable: !0,
          enumerable: !1,
          value: wu(l),
          writable: !0
        });
      } : Sn;
      function Tm(n) {
        return mo(bl(n));
      }
      function ra(n, l, o) {
        var d = -1, h = n.length;
        l < 0 && (l = -l > h ? 0 : h + l), o = o > h ? h : o, o < 0 && (o += h), h = l > o ? 0 : o - l >>> 0, l >>>= 0;
        for (var D = re(h); ++d < h; )
          D[d] = n[d + l];
        return D;
      }
      function xm(n, l) {
        var o;
        return sr(n, function(d, h, D) {
          return o = l(d, h, D), !o;
        }), !!o;
      }
      function so(n, l, o) {
        var d = 0, h = n == null ? d : n.length;
        if (typeof l == "number" && l === l && h <= te) {
          for (; d < h; ) {
            var D = d + h >>> 1, I = n[D];
            I !== null && !Un(I) && (o ? I <= l : I < l) ? d = D + 1 : h = D;
          }
          return h;
        }
        return js(n, l, Sn, o);
      }
      function js(n, l, o, d) {
        var h = 0, D = n == null ? 0 : n.length;
        if (D === 0)
          return 0;
        l = o(l);
        for (var I = l !== l, H = l === null, K = Un(l), ye = l === t; h < D; ) {
          var be = eo((h + D) / 2), De = o(n[be]), Se = De !== t, qe = De === null, Ke = De === De, it = Un(De);
          if (I)
            var Je = d || Ke;
          else
            ye ? Je = Ke && (d || Se) : H ? Je = Ke && Se && (d || !qe) : K ? Je = Ke && Se && !qe && (d || !it) : qe || it ? Je = !1 : Je = d ? De <= l : De < l;
          Je ? h = be + 1 : D = be;
        }
        return bn(D, me);
      }
      function ic(n, l) {
        for (var o = -1, d = n.length, h = 0, D = []; ++o < d; ) {
          var I = n[o], H = l ? l(I) : I;
          if (!o || !ca(H, K)) {
            var K = H;
            D[h++] = I === 0 ? 0 : I;
          }
        }
        return D;
      }
      function oc(n) {
        return typeof n == "number" ? n : Un(n) ? $ : +n;
      }
      function qn(n) {
        if (typeof n == "string")
          return n;
        if (rt(n))
          return It(n, qn) + "";
        if (Un(n))
          return Wd ? Wd.call(n) : "";
        var l = n + "";
        return l == "0" && 1 / n == -oe ? "-0" : l;
      }
      function ur(n, l, o) {
        var d = -1, h = Qi, D = n.length, I = !0, H = [], K = H;
        if (o)
          I = !1, h = Bs;
        else if (D >= i) {
          var ye = l ? null : Sm(n);
          if (ye)
            return Fi(ye);
          I = !1, h = ql, K = new Wr();
        } else
          K = l ? [] : H;
        e:
          for (; ++d < D; ) {
            var be = n[d], De = l ? l(be) : be;
            if (be = o || be !== 0 ? be : 0, I && De === De) {
              for (var Se = K.length; Se--; )
                if (K[Se] === De)
                  continue e;
              l && K.push(De), H.push(be);
            } else
              h(K, De, o) || (K !== H && K.push(De), H.push(be));
          }
        return H;
      }
      function Ks(n, l) {
        return l = Ar(l, n), n = Nc(n, l), n == null || delete n[Pa(la(l))];
      }
      function sc(n, l, o, d) {
        return ei(n, l, o(Qr(n, l)), d);
      }
      function uo(n, l, o, d) {
        for (var h = n.length, D = d ? h : -1; (d ? D-- : ++D < h) && l(n[D], D, n); )
          ;
        return o ? ra(n, d ? 0 : D, d ? D + 1 : h) : ra(n, d ? D + 1 : 0, d ? h : D);
      }
      function uc(n, l) {
        var o = n;
        return o instanceof dt && (o = o.value()), Ts(l, function(d, h) {
          return h.func.apply(h.thisArg, lr([d], h.args));
        }, o);
      }
      function Js(n, l, o) {
        var d = n.length;
        if (d < 2)
          return d ? ur(n[0]) : [];
        for (var h = -1, D = re(d); ++h < d; )
          for (var I = n[h], H = -1; ++H < d; )
            H != h && (D[h] = Jl(D[h] || I, n[H], l, o));
        return ur(pn(D, 1), l, o);
      }
      function Ac(n, l, o) {
        for (var d = -1, h = n.length, D = l.length, I = {}; ++d < h; ) {
          var H = d < D ? l[d] : t;
          o(I, n[d], H);
        }
        return I;
      }
      function _s(n) {
        return Rt(n) ? n : [];
      }
      function $s(n) {
        return typeof n == "function" ? n : Sn;
      }
      function Ar(n, l) {
        return rt(n) ? n : su(n, l) ? [n] : Wc(yt(n));
      }
      var Pm = ot;
      function dr(n, l, o) {
        var d = n.length;
        return o = o === t ? d : o, !l && o >= d ? n : ra(n, l, o);
      }
      var dc = vh || function(n) {
        return vn.clearTimeout(n);
      };
      function cc(n, l) {
        if (l)
          return n.slice();
        var o = n.length, d = Ed ? Ed(o) : new n.constructor(o);
        return n.copy(d), d;
      }
      function eu(n) {
        var l = new n.constructor(n.byteLength);
        return new ji(l).set(new ji(n)), l;
      }
      function km(n, l) {
        var o = l ? eu(n.buffer) : n.buffer;
        return new n.constructor(o, n.byteOffset, n.byteLength);
      }
      function Om(n) {
        var l = new n.constructor(n.source, jA.exec(n));
        return l.lastIndex = n.lastIndex, l;
      }
      function Mm(n) {
        return jl ? xt(jl.call(n)) : {};
      }
      function fc(n, l) {
        var o = l ? eu(n.buffer) : n.buffer;
        return new n.constructor(o, n.byteOffset, n.length);
      }
      function vc(n, l) {
        if (n !== l) {
          var o = n !== t, d = n === null, h = n === n, D = Un(n), I = l !== t, H = l === null, K = l === l, ye = Un(l);
          if (!H && !ye && !D && n > l || D && I && K && !H && !ye || d && I && K || !o && K || !h)
            return 1;
          if (!d && !D && !ye && n < l || ye && o && h && !d && !D || H && o && h || !I && h || !K)
            return -1;
        }
        return 0;
      }
      function zm(n, l, o) {
        for (var d = -1, h = n.criteria, D = l.criteria, I = h.length, H = o.length; ++d < I; ) {
          var K = vc(h[d], D[d]);
          if (K) {
            if (d >= H)
              return K;
            var ye = o[d];
            return K * (ye == "desc" ? -1 : 1);
          }
        }
        return n.index - l.index;
      }
      function pc(n, l, o, d) {
        for (var h = -1, D = n.length, I = o.length, H = -1, K = l.length, ye = ln(D - I, 0), be = re(K + ye), De = !d; ++H < K; )
          be[H] = l[H];
        for (; ++h < I; )
          (De || h < D) && (be[o[h]] = n[h]);
        for (; ye--; )
          be[H++] = n[h++];
        return be;
      }
      function gc(n, l, o, d) {
        for (var h = -1, D = n.length, I = -1, H = o.length, K = -1, ye = l.length, be = ln(D - H, 0), De = re(be + ye), Se = !d; ++h < be; )
          De[h] = n[h];
        for (var qe = h; ++K < ye; )
          De[qe + K] = l[K];
        for (; ++I < H; )
          (Se || h < D) && (De[qe + o[I]] = n[h++]);
        return De;
      }
      function Ln(n, l) {
        var o = -1, d = n.length;
        for (l || (l = re(d)); ++o < d; )
          l[o] = n[o];
        return l;
      }
      function xa(n, l, o, d) {
        var h = !o;
        o || (o = {});
        for (var D = -1, I = l.length; ++D < I; ) {
          var H = l[D], K = d ? d(o[H], n[H], H, o, n) : t;
          K === t && (K = n[H]), h ? Xa(o, H, K) : Kl(o, H, K);
        }
        return o;
      }
      function Im(n, l) {
        return xa(n, ou(n), l);
      }
      function Em(n, l) {
        return xa(n, Oc(n), l);
      }
      function Ao(n, l) {
        return function(o, d) {
          var h = rt(o) ? Vg : tm, D = l ? l() : {};
          return h(o, n, Ge(d, 2), D);
        };
      }
      function gl(n) {
        return ot(function(l, o) {
          var d = -1, h = o.length, D = h > 1 ? o[h - 1] : t, I = h > 2 ? o[2] : t;
          for (D = n.length > 3 && typeof D == "function" ? (h--, D) : t, I && Pn(o[0], o[1], I) && (D = h < 3 ? t : D, h = 1), l = xt(l); ++d < h; ) {
            var H = o[d];
            H && n(l, H, d, D);
          }
          return l;
        });
      }
      function hc(n, l) {
        return function(o, d) {
          if (o == null)
            return o;
          if (!Nn(o))
            return n(o, d);
          for (var h = o.length, D = l ? h : -1, I = xt(o); (l ? D-- : ++D < h) && d(I[D], D, I) !== !1; )
            ;
          return o;
        };
      }
      function mc(n) {
        return function(l, o, d) {
          for (var h = -1, D = xt(l), I = d(l), H = I.length; H--; ) {
            var K = I[n ? H : ++h];
            if (o(D[K], K, D) === !1)
              break;
          }
          return l;
        };
      }
      function Lm(n, l, o) {
        var d = l & L, h = ti(n);
        function D() {
          var I = this && this !== vn && this instanceof D ? h : n;
          return I.apply(d ? o : this, arguments);
        }
        return D;
      }
      function yc(n) {
        return function(l) {
          l = yt(l);
          var o = ul(l) ? Aa(l) : t, d = o ? o[0] : l.charAt(0), h = o ? dr(o, 1).join("") : l.slice(1);
          return d[n]() + h;
        };
      }
      function hl(n) {
        return function(l) {
          return Ts(mf(hf(l).replace(Bg, "")), n, "");
        };
      }
      function ti(n) {
        return function() {
          var l = arguments;
          switch (l.length) {
            case 0:
              return new n();
            case 1:
              return new n(l[0]);
            case 2:
              return new n(l[0], l[1]);
            case 3:
              return new n(l[0], l[1], l[2]);
            case 4:
              return new n(l[0], l[1], l[2], l[3]);
            case 5:
              return new n(l[0], l[1], l[2], l[3], l[4]);
            case 6:
              return new n(l[0], l[1], l[2], l[3], l[4], l[5]);
            case 7:
              return new n(l[0], l[1], l[2], l[3], l[4], l[5], l[6]);
          }
          var o = pl(n.prototype), d = n.apply(o, l);
          return Yt(d) ? d : o;
        };
      }
      function Nm(n, l, o) {
        var d = ti(n);
        function h() {
          for (var D = arguments.length, I = re(D), H = D, K = ml(h); H--; )
            I[H] = arguments[H];
          var ye = D < 3 && I[0] !== K && I[D - 1] !== K ? [] : ir(I, K);
          if (D -= ye.length, D < o)
            return Bc(
              n,
              l,
              co,
              h.placeholder,
              t,
              I,
              ye,
              t,
              t,
              o - D
            );
          var be = this && this !== vn && this instanceof h ? d : n;
          return Hn(be, this, I);
        }
        return h;
      }
      function bc(n) {
        return function(l, o, d) {
          var h = xt(l);
          if (!Nn(l)) {
            var D = Ge(o, 3);
            l = An(l), o = function(H) {
              return D(h[H], H, h);
            };
          }
          var I = n(l, o, d);
          return I > -1 ? h[D ? l[I] : I] : t;
        };
      }
      function wc(n) {
        return Ha(function(l) {
          var o = l.length, d = o, h = na.prototype.thru;
          for (n && l.reverse(); d--; ) {
            var D = l[d];
            if (typeof D != "function")
              throw new ta(u);
            if (h && !I && go(D) == "wrapper")
              var I = new na([], !0);
          }
          for (d = I ? d : o; ++d < o; ) {
            D = l[d];
            var H = go(D), K = H == "wrapper" ? lu(D) : t;
            K && uu(K[0]) && K[1] == (x | k | S | W) && !K[4].length && K[9] == 1 ? I = I[go(K[0])].apply(I, K[3]) : I = D.length == 1 && uu(D) ? I[H]() : I.thru(D);
          }
          return function() {
            var ye = arguments, be = ye[0];
            if (I && ye.length == 1 && rt(be))
              return I.plant(be).value();
            for (var De = 0, Se = o ? l[De].apply(this, ye) : be; ++De < o; )
              Se = l[De].call(this, Se);
            return Se;
          };
        });
      }
      function co(n, l, o, d, h, D, I, H, K, ye) {
        var be = l & x, De = l & L, Se = l & E, qe = l & (k | F), Ke = l & z, it = Se ? t : ti(n);
        function Je() {
          for (var ut = arguments.length, vt = re(ut), Rn = ut; Rn--; )
            vt[Rn] = arguments[Rn];
          if (qe)
            var kn = ml(Je), Zn = Zg(vt, kn);
          if (d && (vt = pc(vt, d, h, qe)), D && (vt = gc(vt, D, I, qe)), ut -= Zn, qe && ut < ye) {
            var Zt = ir(vt, kn);
            return Bc(
              n,
              l,
              co,
              Je.placeholder,
              o,
              vt,
              Zt,
              H,
              K,
              ye - ut
            );
          }
          var fa = De ? o : this, Ra = Se ? fa[n] : n;
          return ut = vt.length, H ? vt = ty(vt, H) : Ke && ut > 1 && vt.reverse(), be && K < ut && (vt.length = K), this && this !== vn && this instanceof Je && (Ra = it || ti(Ra)), Ra.apply(fa, vt);
        }
        return Je;
      }
      function Cc(n, l) {
        return function(o, d) {
          return um(o, n, l(d), {});
        };
      }
      function fo(n, l) {
        return function(o, d) {
          var h;
          if (o === t && d === t)
            return l;
          if (o !== t && (h = o), d !== t) {
            if (h === t)
              return d;
            typeof o == "string" || typeof d == "string" ? (o = qn(o), d = qn(d)) : (o = oc(o), d = oc(d)), h = n(o, d);
          }
          return h;
        };
      }
      function tu(n) {
        return Ha(function(l) {
          return l = It(l, Fn(Ge())), ot(function(o) {
            var d = this;
            return n(l, function(h) {
              return Hn(h, d, o);
            });
          });
        });
      }
      function vo(n, l) {
        l = l === t ? " " : qn(l);
        var o = l.length;
        if (o < 2)
          return o ? Gs(l, n) : l;
        var d = Gs(l, $i(n / Al(l)));
        return ul(l) ? dr(Aa(d), 0, n).join("") : d.slice(0, n);
      }
      function Ym(n, l, o, d) {
        var h = l & L, D = ti(n);
        function I() {
          for (var H = -1, K = arguments.length, ye = -1, be = d.length, De = re(be + K), Se = this && this !== vn && this instanceof I ? D : n; ++ye < be; )
            De[ye] = d[ye];
          for (; K--; )
            De[ye++] = arguments[++H];
          return Hn(Se, h ? o : this, De);
        }
        return I;
      }
      function Dc(n) {
        return function(l, o, d) {
          return d && typeof d != "number" && Pn(l, o, d) && (o = d = t), l = Ua(l), o === t ? (o = l, l = 0) : o = Ua(o), d = d === t ? l < o ? 1 : -1 : Ua(d), wm(l, o, d, n);
        };
      }
      function po(n) {
        return function(l, o) {
          return typeof l == "string" && typeof o == "string" || (l = ia(l), o = ia(o)), n(l, o);
        };
      }
      function Bc(n, l, o, d, h, D, I, H, K, ye) {
        var be = l & k, De = be ? I : t, Se = be ? t : I, qe = be ? D : t, Ke = be ? t : D;
        l |= be ? S : Q, l &= ~(be ? Q : S), l & N || (l &= ~(L | E));
        var it = [
          n,
          l,
          h,
          qe,
          De,
          Ke,
          Se,
          H,
          K,
          ye
        ], Je = o.apply(t, it);
        return uu(n) && Yc(Je, it), Je.placeholder = d, Sc(Je, n, l);
      }
      function nu(n) {
        var l = rn[n];
        return function(o, d) {
          if (o = ia(o), d = d == null ? 0 : bn(lt(d), 292), d && Sd(o)) {
            var h = (yt(o) + "e").split("e"), D = l(h[0] + "e" + (+h[1] + d));
            return h = (yt(D) + "e").split("e"), +(h[0] + "e" + (+h[1] - d));
          }
          return l(o);
        };
      }
      var Sm = fl && 1 / Fi(new fl([, -0]))[1] == oe ? function(n) {
        return new fl(n);
      } : Bu;
      function Tc(n) {
        return function(l) {
          var o = wn(l);
          return o == Ae ? Is(l) : o == Ze ? eh(l) : Rg(l, n(l));
        };
      }
      function Qa(n, l, o, d, h, D, I, H) {
        var K = l & E;
        if (!K && typeof n != "function")
          throw new ta(u);
        var ye = d ? d.length : 0;
        if (ye || (l &= ~(S | Q), d = h = t), I = I === t ? I : ln(lt(I), 0), H = H === t ? H : lt(H), ye -= h ? h.length : 0, l & Q) {
          var be = d, De = h;
          d = h = t;
        }
        var Se = K ? t : lu(n), qe = [
          n,
          l,
          o,
          d,
          h,
          be,
          De,
          D,
          I,
          H
        ];
        if (Se && _m(qe, Se), n = qe[0], l = qe[1], o = qe[2], d = qe[3], h = qe[4], H = qe[9] = qe[9] === t ? K ? 0 : n.length : ln(qe[9] - ye, 0), !H && l & (k | F) && (l &= ~(k | F)), !l || l == L)
          var Ke = Lm(n, l, o);
        else
          l == k || l == F ? Ke = Nm(n, l, H) : (l == S || l == (L | S)) && !h.length ? Ke = Ym(n, l, o, d) : Ke = co.apply(t, qe);
        var it = Se ? lc : Yc;
        return Sc(it(Ke, qe), n, l);
      }
      function xc(n, l, o, d) {
        return n === t || ca(n, cl[o]) && !wt.call(d, o) ? l : n;
      }
      function Pc(n, l, o, d, h, D) {
        return Yt(n) && Yt(l) && (D.set(l, n), oo(n, l, t, Pc, D), D.delete(l)), n;
      }
      function Vm(n) {
        return ri(n) ? t : n;
      }
      function kc(n, l, o, d, h, D) {
        var I = o & B, H = n.length, K = l.length;
        if (H != K && !(I && K > H))
          return !1;
        var ye = D.get(n), be = D.get(l);
        if (ye && be)
          return ye == l && be == n;
        var De = -1, Se = !0, qe = o & T ? new Wr() : t;
        for (D.set(n, l), D.set(l, n); ++De < H; ) {
          var Ke = n[De], it = l[De];
          if (d)
            var Je = I ? d(it, Ke, De, l, n, D) : d(Ke, it, De, n, l, D);
          if (Je !== t) {
            if (Je)
              continue;
            Se = !1;
            break;
          }
          if (qe) {
            if (!xs(l, function(ut, vt) {
              if (!ql(qe, vt) && (Ke === ut || h(Ke, ut, o, d, D)))
                return qe.push(vt);
            })) {
              Se = !1;
              break;
            }
          } else if (!(Ke === it || h(Ke, it, o, d, D))) {
            Se = !1;
            break;
          }
        }
        return D.delete(n), D.delete(l), Se;
      }
      function Wm(n, l, o, d, h, D, I) {
        switch (o) {
          case _n:
            if (n.byteLength != l.byteLength || n.byteOffset != l.byteOffset)
              return !1;
            n = n.buffer, l = l.buffer;
          case an:
            return !(n.byteLength != l.byteLength || !D(new ji(n), new ji(l)));
          case ke:
          case Ue:
          case xe:
            return ca(+n, +l);
          case ie:
            return n.name == l.name && n.message == l.message;
          case Ve:
          case sn:
            return n == l + "";
          case Ae:
            var H = Is;
          case Ze:
            var K = d & B;
            if (H || (H = Fi), n.size != l.size && !K)
              return !1;
            var ye = I.get(n);
            if (ye)
              return ye == l;
            d |= T, I.set(n, l);
            var be = kc(H(n), H(l), d, h, D, I);
            return I.delete(n), be;
          case Fe:
            if (jl)
              return jl.call(n) == jl.call(l);
        }
        return !1;
      }
      function Xm(n, l, o, d, h, D) {
        var I = o & B, H = au(n), K = H.length, ye = au(l), be = ye.length;
        if (K != be && !I)
          return !1;
        for (var De = K; De--; ) {
          var Se = H[De];
          if (!(I ? Se in l : wt.call(l, Se)))
            return !1;
        }
        var qe = D.get(n), Ke = D.get(l);
        if (qe && Ke)
          return qe == l && Ke == n;
        var it = !0;
        D.set(n, l), D.set(l, n);
        for (var Je = I; ++De < K; ) {
          Se = H[De];
          var ut = n[Se], vt = l[Se];
          if (d)
            var Rn = I ? d(vt, ut, Se, l, n, D) : d(ut, vt, Se, n, l, D);
          if (!(Rn === t ? ut === vt || h(ut, vt, o, d, D) : Rn)) {
            it = !1;
            break;
          }
          Je || (Je = Se == "constructor");
        }
        if (it && !Je) {
          var kn = n.constructor, Zn = l.constructor;
          kn != Zn && "constructor" in n && "constructor" in l && !(typeof kn == "function" && kn instanceof kn && typeof Zn == "function" && Zn instanceof Zn) && (it = !1);
        }
        return D.delete(n), D.delete(l), it;
      }
      function Ha(n) {
        return du(Lc(n, t, Fc), n + "");
      }
      function au(n) {
        return Gd(n, An, ou);
      }
      function ru(n) {
        return Gd(n, Yn, Oc);
      }
      var lu = to ? function(n) {
        return to.get(n);
      } : Bu;
      function go(n) {
        for (var l = n.name + "", o = vl[l], d = wt.call(vl, l) ? o.length : 0; d--; ) {
          var h = o[d], D = h.func;
          if (D == null || D == n)
            return h.name;
        }
        return l;
      }
      function ml(n) {
        var l = wt.call(C, "placeholder") ? C : n;
        return l.placeholder;
      }
      function Ge() {
        var n = C.iteratee || Cu;
        return n = n === Cu ? Jd : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function ho(n, l) {
        var o = n.__data__;
        return Gm(l) ? o[typeof l == "string" ? "string" : "hash"] : o.map;
      }
      function iu(n) {
        for (var l = An(n), o = l.length; o--; ) {
          var d = l[o], h = n[d];
          l[o] = [d, h, Ic(h)];
        }
        return l;
      }
      function Hr(n, l) {
        var o = Jg(n, l);
        return Kd(o) ? o : t;
      }
      function Qm(n) {
        var l = wt.call(n, Sr), o = n[Sr];
        try {
          n[Sr] = t;
          var d = !0;
        } catch {
        }
        var h = Zi.call(n);
        return d && (l ? n[Sr] = o : delete n[Sr]), h;
      }
      var ou = Ls ? function(n) {
        return n == null ? [] : (n = xt(n), rr(Ls(n), function(l) {
          return Nd.call(n, l);
        }));
      } : Tu, Oc = Ls ? function(n) {
        for (var l = []; n; )
          lr(l, ou(n)), n = Ki(n);
        return l;
      } : Tu, wn = xn;
      (Ns && wn(new Ns(new ArrayBuffer(1))) != _n || Rl && wn(new Rl()) != Ae || Ys && wn(Ys.resolve()) != ne || fl && wn(new fl()) != Ze || Zl && wn(new Zl()) != yn) && (wn = function(n) {
        var l = xn(n), o = l == Re ? n.constructor : t, d = o ? Fr(o) : "";
        if (d)
          switch (d) {
            case Dh:
              return _n;
            case Bh:
              return Ae;
            case Th:
              return ne;
            case xh:
              return Ze;
            case Ph:
              return yn;
          }
        return l;
      });
      function Hm(n, l, o) {
        for (var d = -1, h = o.length; ++d < h; ) {
          var D = o[d], I = D.size;
          switch (D.type) {
            case "drop":
              n += I;
              break;
            case "dropRight":
              l -= I;
              break;
            case "take":
              l = bn(l, n + I);
              break;
            case "takeRight":
              n = ln(n, l - I);
              break;
          }
        }
        return { start: n, end: l };
      }
      function Fm(n) {
        var l = n.match(jp);
        return l ? l[1].split(Kp) : [];
      }
      function Mc(n, l, o) {
        l = Ar(l, n);
        for (var d = -1, h = l.length, D = !1; ++d < h; ) {
          var I = Pa(l[d]);
          if (!(D = n != null && o(n, I)))
            break;
          n = n[I];
        }
        return D || ++d != h ? D : (h = n == null ? 0 : n.length, !!h && Bo(h) && Fa(I, h) && (rt(n) || qr(n)));
      }
      function qm(n) {
        var l = n.length, o = new n.constructor(l);
        return l && typeof n[0] == "string" && wt.call(n, "index") && (o.index = n.index, o.input = n.input), o;
      }
      function zc(n) {
        return typeof n.constructor == "function" && !ni(n) ? pl(Ki(n)) : {};
      }
      function Um(n, l, o) {
        var d = n.constructor;
        switch (l) {
          case an:
            return eu(n);
          case ke:
          case Ue:
            return new d(+n);
          case _n:
            return km(n, o);
          case kr:
          case ar:
          case Or:
          case Mr:
          case zr:
          case Ir:
          case Er:
          case Lr:
          case ee:
            return fc(n, o);
          case Ae:
            return new d();
          case xe:
          case sn:
            return new d(n);
          case Ve:
            return Om(n);
          case Ze:
            return new d();
          case Fe:
            return Mm(n);
        }
      }
      function Rm(n, l) {
        var o = l.length;
        if (!o)
          return n;
        var d = o - 1;
        return l[d] = (o > 1 ? "& " : "") + l[d], l = l.join(o > 2 ? ", " : " "), n.replace(Gp, `{
/* [wrapped with ` + l + `] */
`);
      }
      function Zm(n) {
        return rt(n) || qr(n) || !!(Yd && n && n[Yd]);
      }
      function Fa(n, l) {
        var o = typeof n;
        return l = l ?? Oe, !!l && (o == "number" || o != "symbol" && lg.test(n)) && n > -1 && n % 1 == 0 && n < l;
      }
      function Pn(n, l, o) {
        if (!Yt(o))
          return !1;
        var d = typeof l;
        return (d == "number" ? Nn(o) && Fa(l, o.length) : d == "string" && l in o) ? ca(o[l], n) : !1;
      }
      function su(n, l) {
        if (rt(n))
          return !1;
        var o = typeof n;
        return o == "number" || o == "symbol" || o == "boolean" || n == null || Un(n) ? !0 : vs.test(n) || !Fl.test(n) || l != null && n in xt(l);
      }
      function Gm(n) {
        var l = typeof n;
        return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? n !== "__proto__" : n === null;
      }
      function uu(n) {
        var l = go(n), o = C[l];
        if (typeof o != "function" || !(l in dt.prototype))
          return !1;
        if (n === o)
          return !0;
        var d = lu(o);
        return !!d && n === d[0];
      }
      function jm(n) {
        return !!Id && Id in n;
      }
      var Km = Ui ? qa : xu;
      function ni(n) {
        var l = n && n.constructor, o = typeof l == "function" && l.prototype || cl;
        return n === o;
      }
      function Ic(n) {
        return n === n && !Yt(n);
      }
      function Ec(n, l) {
        return function(o) {
          return o == null ? !1 : o[n] === l && (l !== t || n in xt(o));
        };
      }
      function Jm(n) {
        var l = Co(n, function(d) {
          return o.size === g && o.clear(), d;
        }), o = l.cache;
        return l;
      }
      function _m(n, l) {
        var o = n[1], d = l[1], h = o | d, D = h < (L | E | x), I = d == x && o == k || d == x && o == W && n[7].length <= l[8] || d == (x | W) && l[7].length <= l[8] && o == k;
        if (!(D || I))
          return n;
        d & L && (n[2] = l[2], h |= o & L ? 0 : N);
        var H = l[3];
        if (H) {
          var K = n[3];
          n[3] = K ? pc(K, H, l[4]) : H, n[4] = K ? ir(n[3], p) : l[4];
        }
        return H = l[5], H && (K = n[5], n[5] = K ? gc(K, H, l[6]) : H, n[6] = K ? ir(n[5], p) : l[6]), H = l[7], H && (n[7] = H), d & x && (n[8] = n[8] == null ? l[8] : bn(n[8], l[8])), n[9] == null && (n[9] = l[9]), n[0] = l[0], n[1] = h, n;
      }
      function $m(n) {
        var l = [];
        if (n != null)
          for (var o in xt(n))
            l.push(o);
        return l;
      }
      function ey(n) {
        return Zi.call(n);
      }
      function Lc(n, l, o) {
        return l = ln(l === t ? n.length - 1 : l, 0), function() {
          for (var d = arguments, h = -1, D = ln(d.length - l, 0), I = re(D); ++h < D; )
            I[h] = d[l + h];
          h = -1;
          for (var H = re(l + 1); ++h < l; )
            H[h] = d[h];
          return H[l] = o(I), Hn(n, this, H);
        };
      }
      function Nc(n, l) {
        return l.length < 2 ? n : Qr(n, ra(l, 0, -1));
      }
      function ty(n, l) {
        for (var o = n.length, d = bn(l.length, o), h = Ln(n); d--; ) {
          var D = l[d];
          n[d] = Fa(D, o) ? h[D] : t;
        }
        return n;
      }
      function Au(n, l) {
        if (!(l === "constructor" && typeof n[l] == "function") && l != "__proto__")
          return n[l];
      }
      var Yc = Vc(lc), ai = gh || function(n, l) {
        return vn.setTimeout(n, l);
      }, du = Vc(Bm);
      function Sc(n, l, o) {
        var d = l + "";
        return du(n, Rm(d, ny(Fm(d), o)));
      }
      function Vc(n) {
        var l = 0, o = 0;
        return function() {
          var d = bh(), h = ve - (d - o);
          if (o = d, h > 0) {
            if (++l >= le)
              return arguments[0];
          } else
            l = 0;
          return n.apply(t, arguments);
        };
      }
      function mo(n, l) {
        var o = -1, d = n.length, h = d - 1;
        for (l = l === t ? d : l; ++o < l; ) {
          var D = Zs(o, h), I = n[D];
          n[D] = n[o], n[o] = I;
        }
        return n.length = l, n;
      }
      var Wc = Jm(function(n) {
        var l = [];
        return n.charCodeAt(0) === 46 && l.push(""), n.replace(Up, function(o, d, h, D) {
          l.push(h ? D.replace($p, "$1") : d || o);
        }), l;
      });
      function Pa(n) {
        if (typeof n == "string" || Un(n))
          return n;
        var l = n + "";
        return l == "0" && 1 / n == -oe ? "-0" : l;
      }
      function Fr(n) {
        if (n != null) {
          try {
            return Ri.call(n);
          } catch {
          }
          try {
            return n + "";
          } catch {
          }
        }
        return "";
      }
      function ny(n, l) {
        return ea(P, function(o) {
          var d = "_." + o[0];
          l & o[1] && !Qi(n, d) && n.push(d);
        }), n.sort();
      }
      function Xc(n) {
        if (n instanceof dt)
          return n.clone();
        var l = new na(n.__wrapped__, n.__chain__);
        return l.__actions__ = Ln(n.__actions__), l.__index__ = n.__index__, l.__values__ = n.__values__, l;
      }
      function ay(n, l, o) {
        (o ? Pn(n, l, o) : l === t) ? l = 1 : l = ln(lt(l), 0);
        var d = n == null ? 0 : n.length;
        if (!d || l < 1)
          return [];
        for (var h = 0, D = 0, I = re($i(d / l)); h < d; )
          I[D++] = ra(n, h, h += l);
        return I;
      }
      function ry(n) {
        for (var l = -1, o = n == null ? 0 : n.length, d = 0, h = []; ++l < o; ) {
          var D = n[l];
          D && (h[d++] = D);
        }
        return h;
      }
      function ly() {
        var n = arguments.length;
        if (!n)
          return [];
        for (var l = re(n - 1), o = arguments[0], d = n; d--; )
          l[d - 1] = arguments[d];
        return lr(rt(o) ? Ln(o) : [o], pn(l, 1));
      }
      var iy = ot(function(n, l) {
        return Rt(n) ? Jl(n, pn(l, 1, Rt, !0)) : [];
      }), oy = ot(function(n, l) {
        var o = la(l);
        return Rt(o) && (o = t), Rt(n) ? Jl(n, pn(l, 1, Rt, !0), Ge(o, 2)) : [];
      }), sy = ot(function(n, l) {
        var o = la(l);
        return Rt(o) && (o = t), Rt(n) ? Jl(n, pn(l, 1, Rt, !0), t, o) : [];
      });
      function uy(n, l, o) {
        var d = n == null ? 0 : n.length;
        return d ? (l = o || l === t ? 1 : lt(l), ra(n, l < 0 ? 0 : l, d)) : [];
      }
      function Ay(n, l, o) {
        var d = n == null ? 0 : n.length;
        return d ? (l = o || l === t ? 1 : lt(l), l = d - l, ra(n, 0, l < 0 ? 0 : l)) : [];
      }
      function dy(n, l) {
        return n && n.length ? uo(n, Ge(l, 3), !0, !0) : [];
      }
      function cy(n, l) {
        return n && n.length ? uo(n, Ge(l, 3), !0) : [];
      }
      function fy(n, l, o, d) {
        var h = n == null ? 0 : n.length;
        return h ? (o && typeof o != "number" && Pn(n, l, o) && (o = 0, d = h), lm(n, l, o, d)) : [];
      }
      function Qc(n, l, o) {
        var d = n == null ? 0 : n.length;
        if (!d)
          return -1;
        var h = o == null ? 0 : lt(o);
        return h < 0 && (h = ln(d + h, 0)), Hi(n, Ge(l, 3), h);
      }
      function Hc(n, l, o) {
        var d = n == null ? 0 : n.length;
        if (!d)
          return -1;
        var h = d - 1;
        return o !== t && (h = lt(o), h = o < 0 ? ln(d + h, 0) : bn(h, d - 1)), Hi(n, Ge(l, 3), h, !0);
      }
      function Fc(n) {
        var l = n == null ? 0 : n.length;
        return l ? pn(n, 1) : [];
      }
      function vy(n) {
        var l = n == null ? 0 : n.length;
        return l ? pn(n, oe) : [];
      }
      function py(n, l) {
        var o = n == null ? 0 : n.length;
        return o ? (l = l === t ? 1 : lt(l), pn(n, l)) : [];
      }
      function gy(n) {
        for (var l = -1, o = n == null ? 0 : n.length, d = {}; ++l < o; ) {
          var h = n[l];
          d[h[0]] = h[1];
        }
        return d;
      }
      function qc(n) {
        return n && n.length ? n[0] : t;
      }
      function hy(n, l, o) {
        var d = n == null ? 0 : n.length;
        if (!d)
          return -1;
        var h = o == null ? 0 : lt(o);
        return h < 0 && (h = ln(d + h, 0)), sl(n, l, h);
      }
      function my(n) {
        var l = n == null ? 0 : n.length;
        return l ? ra(n, 0, -1) : [];
      }
      var yy = ot(function(n) {
        var l = It(n, _s);
        return l.length && l[0] === n[0] ? Hs(l) : [];
      }), by = ot(function(n) {
        var l = la(n), o = It(n, _s);
        return l === la(o) ? l = t : o.pop(), o.length && o[0] === n[0] ? Hs(o, Ge(l, 2)) : [];
      }), wy = ot(function(n) {
        var l = la(n), o = It(n, _s);
        return l = typeof l == "function" ? l : t, l && o.pop(), o.length && o[0] === n[0] ? Hs(o, t, l) : [];
      });
      function Cy(n, l) {
        return n == null ? "" : mh.call(n, l);
      }
      function la(n) {
        var l = n == null ? 0 : n.length;
        return l ? n[l - 1] : t;
      }
      function Dy(n, l, o) {
        var d = n == null ? 0 : n.length;
        if (!d)
          return -1;
        var h = d;
        return o !== t && (h = lt(o), h = h < 0 ? ln(d + h, 0) : bn(h, d - 1)), l === l ? nh(n, l, h) : Hi(n, Bd, h, !0);
      }
      function By(n, l) {
        return n && n.length ? tc(n, lt(l)) : t;
      }
      var Ty = ot(Uc);
      function Uc(n, l) {
        return n && n.length && l && l.length ? Rs(n, l) : n;
      }
      function xy(n, l, o) {
        return n && n.length && l && l.length ? Rs(n, l, Ge(o, 2)) : n;
      }
      function Py(n, l, o) {
        return n && n.length && l && l.length ? Rs(n, l, t, o) : n;
      }
      var ky = Ha(function(n, l) {
        var o = n == null ? 0 : n.length, d = Vs(n, l);
        return rc(n, It(l, function(h) {
          return Fa(h, o) ? +h : h;
        }).sort(vc)), d;
      });
      function Oy(n, l) {
        var o = [];
        if (!(n && n.length))
          return o;
        var d = -1, h = [], D = n.length;
        for (l = Ge(l, 3); ++d < D; ) {
          var I = n[d];
          l(I, d, n) && (o.push(I), h.push(d));
        }
        return rc(n, h), o;
      }
      function cu(n) {
        return n == null ? n : Ch.call(n);
      }
      function My(n, l, o) {
        var d = n == null ? 0 : n.length;
        return d ? (o && typeof o != "number" && Pn(n, l, o) ? (l = 0, o = d) : (l = l == null ? 0 : lt(l), o = o === t ? d : lt(o)), ra(n, l, o)) : [];
      }
      function zy(n, l) {
        return so(n, l);
      }
      function Iy(n, l, o) {
        return js(n, l, Ge(o, 2));
      }
      function Ey(n, l) {
        var o = n == null ? 0 : n.length;
        if (o) {
          var d = so(n, l);
          if (d < o && ca(n[d], l))
            return d;
        }
        return -1;
      }
      function Ly(n, l) {
        return so(n, l, !0);
      }
      function Ny(n, l, o) {
        return js(n, l, Ge(o, 2), !0);
      }
      function Yy(n, l) {
        var o = n == null ? 0 : n.length;
        if (o) {
          var d = so(n, l, !0) - 1;
          if (ca(n[d], l))
            return d;
        }
        return -1;
      }
      function Sy(n) {
        return n && n.length ? ic(n) : [];
      }
      function Vy(n, l) {
        return n && n.length ? ic(n, Ge(l, 2)) : [];
      }
      function Wy(n) {
        var l = n == null ? 0 : n.length;
        return l ? ra(n, 1, l) : [];
      }
      function Xy(n, l, o) {
        return n && n.length ? (l = o || l === t ? 1 : lt(l), ra(n, 0, l < 0 ? 0 : l)) : [];
      }
      function Qy(n, l, o) {
        var d = n == null ? 0 : n.length;
        return d ? (l = o || l === t ? 1 : lt(l), l = d - l, ra(n, l < 0 ? 0 : l, d)) : [];
      }
      function Hy(n, l) {
        return n && n.length ? uo(n, Ge(l, 3), !1, !0) : [];
      }
      function Fy(n, l) {
        return n && n.length ? uo(n, Ge(l, 3)) : [];
      }
      var qy = ot(function(n) {
        return ur(pn(n, 1, Rt, !0));
      }), Uy = ot(function(n) {
        var l = la(n);
        return Rt(l) && (l = t), ur(pn(n, 1, Rt, !0), Ge(l, 2));
      }), Ry = ot(function(n) {
        var l = la(n);
        return l = typeof l == "function" ? l : t, ur(pn(n, 1, Rt, !0), t, l);
      });
      function Zy(n) {
        return n && n.length ? ur(n) : [];
      }
      function Gy(n, l) {
        return n && n.length ? ur(n, Ge(l, 2)) : [];
      }
      function jy(n, l) {
        return l = typeof l == "function" ? l : t, n && n.length ? ur(n, t, l) : [];
      }
      function fu(n) {
        if (!(n && n.length))
          return [];
        var l = 0;
        return n = rr(n, function(o) {
          if (Rt(o))
            return l = ln(o.length, l), !0;
        }), Ms(l, function(o) {
          return It(n, Ps(o));
        });
      }
      function Rc(n, l) {
        if (!(n && n.length))
          return [];
        var o = fu(n);
        return l == null ? o : It(o, function(d) {
          return Hn(l, t, d);
        });
      }
      var Ky = ot(function(n, l) {
        return Rt(n) ? Jl(n, l) : [];
      }), Jy = ot(function(n) {
        return Js(rr(n, Rt));
      }), _y = ot(function(n) {
        var l = la(n);
        return Rt(l) && (l = t), Js(rr(n, Rt), Ge(l, 2));
      }), $y = ot(function(n) {
        var l = la(n);
        return l = typeof l == "function" ? l : t, Js(rr(n, Rt), t, l);
      }), eb = ot(fu);
      function tb(n, l) {
        return Ac(n || [], l || [], Kl);
      }
      function nb(n, l) {
        return Ac(n || [], l || [], ei);
      }
      var ab = ot(function(n) {
        var l = n.length, o = l > 1 ? n[l - 1] : t;
        return o = typeof o == "function" ? (n.pop(), o) : t, Rc(n, o);
      });
      function Zc(n) {
        var l = C(n);
        return l.__chain__ = !0, l;
      }
      function rb(n, l) {
        return l(n), n;
      }
      function yo(n, l) {
        return l(n);
      }
      var lb = Ha(function(n) {
        var l = n.length, o = l ? n[0] : 0, d = this.__wrapped__, h = function(D) {
          return Vs(D, n);
        };
        return l > 1 || this.__actions__.length || !(d instanceof dt) || !Fa(o) ? this.thru(h) : (d = d.slice(o, +o + (l ? 1 : 0)), d.__actions__.push({
          func: yo,
          args: [h],
          thisArg: t
        }), new na(d, this.__chain__).thru(function(D) {
          return l && !D.length && D.push(t), D;
        }));
      });
      function ib() {
        return Zc(this);
      }
      function ob() {
        return new na(this.value(), this.__chain__);
      }
      function sb() {
        this.__values__ === t && (this.__values__ = sf(this.value()));
        var n = this.__index__ >= this.__values__.length, l = n ? t : this.__values__[this.__index__++];
        return { done: n, value: l };
      }
      function ub() {
        return this;
      }
      function Ab(n) {
        for (var l, o = this; o instanceof ao; ) {
          var d = Xc(o);
          d.__index__ = 0, d.__values__ = t, l ? h.__wrapped__ = d : l = d;
          var h = d;
          o = o.__wrapped__;
        }
        return h.__wrapped__ = n, l;
      }
      function db() {
        var n = this.__wrapped__;
        if (n instanceof dt) {
          var l = n;
          return this.__actions__.length && (l = new dt(this)), l = l.reverse(), l.__actions__.push({
            func: yo,
            args: [cu],
            thisArg: t
          }), new na(l, this.__chain__);
        }
        return this.thru(cu);
      }
      function cb() {
        return uc(this.__wrapped__, this.__actions__);
      }
      var fb = Ao(function(n, l, o) {
        wt.call(n, o) ? ++n[o] : Xa(n, o, 1);
      });
      function vb(n, l, o) {
        var d = rt(n) ? Cd : rm;
        return o && Pn(n, l, o) && (l = t), d(n, Ge(l, 3));
      }
      function pb(n, l) {
        var o = rt(n) ? rr : Rd;
        return o(n, Ge(l, 3));
      }
      var gb = bc(Qc), hb = bc(Hc);
      function mb(n, l) {
        return pn(bo(n, l), 1);
      }
      function yb(n, l) {
        return pn(bo(n, l), oe);
      }
      function bb(n, l, o) {
        return o = o === t ? 1 : lt(o), pn(bo(n, l), o);
      }
      function Gc(n, l) {
        var o = rt(n) ? ea : sr;
        return o(n, Ge(l, 3));
      }
      function jc(n, l) {
        var o = rt(n) ? Wg : Ud;
        return o(n, Ge(l, 3));
      }
      var wb = Ao(function(n, l, o) {
        wt.call(n, o) ? n[o].push(l) : Xa(n, o, [l]);
      });
      function Cb(n, l, o, d) {
        n = Nn(n) ? n : bl(n), o = o && !d ? lt(o) : 0;
        var h = n.length;
        return o < 0 && (o = ln(h + o, 0)), To(n) ? o <= h && n.indexOf(l, o) > -1 : !!h && sl(n, l, o) > -1;
      }
      var Db = ot(function(n, l, o) {
        var d = -1, h = typeof l == "function", D = Nn(n) ? re(n.length) : [];
        return sr(n, function(I) {
          D[++d] = h ? Hn(l, I, o) : _l(I, l, o);
        }), D;
      }), Bb = Ao(function(n, l, o) {
        Xa(n, o, l);
      });
      function bo(n, l) {
        var o = rt(n) ? It : _d;
        return o(n, Ge(l, 3));
      }
      function Tb(n, l, o, d) {
        return n == null ? [] : (rt(l) || (l = l == null ? [] : [l]), o = d ? t : o, rt(o) || (o = o == null ? [] : [o]), nc(n, l, o));
      }
      var xb = Ao(function(n, l, o) {
        n[o ? 0 : 1].push(l);
      }, function() {
        return [[], []];
      });
      function Pb(n, l, o) {
        var d = rt(n) ? Ts : xd, h = arguments.length < 3;
        return d(n, Ge(l, 4), o, h, sr);
      }
      function kb(n, l, o) {
        var d = rt(n) ? Xg : xd, h = arguments.length < 3;
        return d(n, Ge(l, 4), o, h, Ud);
      }
      function Ob(n, l) {
        var o = rt(n) ? rr : Rd;
        return o(n, Do(Ge(l, 3)));
      }
      function Mb(n) {
        var l = rt(n) ? Qd : Cm;
        return l(n);
      }
      function zb(n, l, o) {
        (o ? Pn(n, l, o) : l === t) ? l = 1 : l = lt(l);
        var d = rt(n) ? $h : Dm;
        return d(n, l);
      }
      function Ib(n) {
        var l = rt(n) ? em : Tm;
        return l(n);
      }
      function Eb(n) {
        if (n == null)
          return 0;
        if (Nn(n))
          return To(n) ? Al(n) : n.length;
        var l = wn(n);
        return l == Ae || l == Ze ? n.size : qs(n).length;
      }
      function Lb(n, l, o) {
        var d = rt(n) ? xs : xm;
        return o && Pn(n, l, o) && (l = t), d(n, Ge(l, 3));
      }
      var Nb = ot(function(n, l) {
        if (n == null)
          return [];
        var o = l.length;
        return o > 1 && Pn(n, l[0], l[1]) ? l = [] : o > 2 && Pn(l[0], l[1], l[2]) && (l = [l[0]]), nc(n, pn(l, 1), []);
      }), wo = ph || function() {
        return vn.Date.now();
      };
      function Yb(n, l) {
        if (typeof l != "function")
          throw new ta(u);
        return n = lt(n), function() {
          if (--n < 1)
            return l.apply(this, arguments);
        };
      }
      function Kc(n, l, o) {
        return l = o ? t : l, l = n && l == null ? n.length : l, Qa(n, x, t, t, t, t, l);
      }
      function Jc(n, l) {
        var o;
        if (typeof l != "function")
          throw new ta(u);
        return n = lt(n), function() {
          return --n > 0 && (o = l.apply(this, arguments)), n <= 1 && (l = t), o;
        };
      }
      var vu = ot(function(n, l, o) {
        var d = L;
        if (o.length) {
          var h = ir(o, ml(vu));
          d |= S;
        }
        return Qa(n, d, l, o, h);
      }), _c = ot(function(n, l, o) {
        var d = L | E;
        if (o.length) {
          var h = ir(o, ml(_c));
          d |= S;
        }
        return Qa(l, d, n, o, h);
      });
      function $c(n, l, o) {
        l = o ? t : l;
        var d = Qa(n, k, t, t, t, t, t, l);
        return d.placeholder = $c.placeholder, d;
      }
      function ef(n, l, o) {
        l = o ? t : l;
        var d = Qa(n, F, t, t, t, t, t, l);
        return d.placeholder = ef.placeholder, d;
      }
      function tf(n, l, o) {
        var d, h, D, I, H, K, ye = 0, be = !1, De = !1, Se = !0;
        if (typeof n != "function")
          throw new ta(u);
        l = ia(l) || 0, Yt(o) && (be = !!o.leading, De = "maxWait" in o, D = De ? ln(ia(o.maxWait) || 0, l) : D, Se = "trailing" in o ? !!o.trailing : Se);
        function qe(Zt) {
          var fa = d, Ra = h;
          return d = h = t, ye = Zt, I = n.apply(Ra, fa), I;
        }
        function Ke(Zt) {
          return ye = Zt, H = ai(ut, l), be ? qe(Zt) : I;
        }
        function it(Zt) {
          var fa = Zt - K, Ra = Zt - ye, wf = l - fa;
          return De ? bn(wf, D - Ra) : wf;
        }
        function Je(Zt) {
          var fa = Zt - K, Ra = Zt - ye;
          return K === t || fa >= l || fa < 0 || De && Ra >= D;
        }
        function ut() {
          var Zt = wo();
          if (Je(Zt))
            return vt(Zt);
          H = ai(ut, it(Zt));
        }
        function vt(Zt) {
          return H = t, Se && d ? qe(Zt) : (d = h = t, I);
        }
        function Rn() {
          H !== t && dc(H), ye = 0, d = K = h = H = t;
        }
        function kn() {
          return H === t ? I : vt(wo());
        }
        function Zn() {
          var Zt = wo(), fa = Je(Zt);
          if (d = arguments, h = this, K = Zt, fa) {
            if (H === t)
              return Ke(K);
            if (De)
              return dc(H), H = ai(ut, l), qe(K);
          }
          return H === t && (H = ai(ut, l)), I;
        }
        return Zn.cancel = Rn, Zn.flush = kn, Zn;
      }
      var Sb = ot(function(n, l) {
        return qd(n, 1, l);
      }), Vb = ot(function(n, l, o) {
        return qd(n, ia(l) || 0, o);
      });
      function Wb(n) {
        return Qa(n, z);
      }
      function Co(n, l) {
        if (typeof n != "function" || l != null && typeof l != "function")
          throw new ta(u);
        var o = function() {
          var d = arguments, h = l ? l.apply(this, d) : d[0], D = o.cache;
          if (D.has(h))
            return D.get(h);
          var I = n.apply(this, d);
          return o.cache = D.set(h, I) || D, I;
        };
        return o.cache = new (Co.Cache || Wa)(), o;
      }
      Co.Cache = Wa;
      function Do(n) {
        if (typeof n != "function")
          throw new ta(u);
        return function() {
          var l = arguments;
          switch (l.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, l[0]);
            case 2:
              return !n.call(this, l[0], l[1]);
            case 3:
              return !n.call(this, l[0], l[1], l[2]);
          }
          return !n.apply(this, l);
        };
      }
      function Xb(n) {
        return Jc(2, n);
      }
      var Qb = Pm(function(n, l) {
        l = l.length == 1 && rt(l[0]) ? It(l[0], Fn(Ge())) : It(pn(l, 1), Fn(Ge()));
        var o = l.length;
        return ot(function(d) {
          for (var h = -1, D = bn(d.length, o); ++h < D; )
            d[h] = l[h].call(this, d[h]);
          return Hn(n, this, d);
        });
      }), pu = ot(function(n, l) {
        var o = ir(l, ml(pu));
        return Qa(n, S, t, l, o);
      }), nf = ot(function(n, l) {
        var o = ir(l, ml(nf));
        return Qa(n, Q, t, l, o);
      }), Hb = Ha(function(n, l) {
        return Qa(n, W, t, t, t, l);
      });
      function Fb(n, l) {
        if (typeof n != "function")
          throw new ta(u);
        return l = l === t ? l : lt(l), ot(n, l);
      }
      function qb(n, l) {
        if (typeof n != "function")
          throw new ta(u);
        return l = l == null ? 0 : ln(lt(l), 0), ot(function(o) {
          var d = o[l], h = dr(o, 0, l);
          return d && lr(h, d), Hn(n, this, h);
        });
      }
      function Ub(n, l, o) {
        var d = !0, h = !0;
        if (typeof n != "function")
          throw new ta(u);
        return Yt(o) && (d = "leading" in o ? !!o.leading : d, h = "trailing" in o ? !!o.trailing : h), tf(n, l, {
          leading: d,
          maxWait: l,
          trailing: h
        });
      }
      function Rb(n) {
        return Kc(n, 1);
      }
      function Zb(n, l) {
        return pu($s(l), n);
      }
      function Gb() {
        if (!arguments.length)
          return [];
        var n = arguments[0];
        return rt(n) ? n : [n];
      }
      function jb(n) {
        return aa(n, w);
      }
      function Kb(n, l) {
        return l = typeof l == "function" ? l : t, aa(n, w, l);
      }
      function Jb(n) {
        return aa(n, v | w);
      }
      function _b(n, l) {
        return l = typeof l == "function" ? l : t, aa(n, v | w, l);
      }
      function $b(n, l) {
        return l == null || Fd(n, l, An(l));
      }
      function ca(n, l) {
        return n === l || n !== n && l !== l;
      }
      var e0 = po(Qs), t0 = po(function(n, l) {
        return n >= l;
      }), qr = jd(function() {
        return arguments;
      }()) ? jd : function(n) {
        return Ht(n) && wt.call(n, "callee") && !Nd.call(n, "callee");
      }, rt = re.isArray, n0 = gd ? Fn(gd) : Am;
      function Nn(n) {
        return n != null && Bo(n.length) && !qa(n);
      }
      function Rt(n) {
        return Ht(n) && Nn(n);
      }
      function a0(n) {
        return n === !0 || n === !1 || Ht(n) && xn(n) == ke;
      }
      var cr = hh || xu, r0 = hd ? Fn(hd) : dm;
      function l0(n) {
        return Ht(n) && n.nodeType === 1 && !ri(n);
      }
      function i0(n) {
        if (n == null)
          return !0;
        if (Nn(n) && (rt(n) || typeof n == "string" || typeof n.splice == "function" || cr(n) || yl(n) || qr(n)))
          return !n.length;
        var l = wn(n);
        if (l == Ae || l == Ze)
          return !n.size;
        if (ni(n))
          return !qs(n).length;
        for (var o in n)
          if (wt.call(n, o))
            return !1;
        return !0;
      }
      function o0(n, l) {
        return $l(n, l);
      }
      function s0(n, l, o) {
        o = typeof o == "function" ? o : t;
        var d = o ? o(n, l) : t;
        return d === t ? $l(n, l, t, o) : !!d;
      }
      function gu(n) {
        if (!Ht(n))
          return !1;
        var l = xn(n);
        return l == ie || l == Qt || typeof n.message == "string" && typeof n.name == "string" && !ri(n);
      }
      function u0(n) {
        return typeof n == "number" && Sd(n);
      }
      function qa(n) {
        if (!Yt(n))
          return !1;
        var l = xn(n);
        return l == Te || l == M || l == O || l == Pe;
      }
      function af(n) {
        return typeof n == "number" && n == lt(n);
      }
      function Bo(n) {
        return typeof n == "number" && n > -1 && n % 1 == 0 && n <= Oe;
      }
      function Yt(n) {
        var l = typeof n;
        return n != null && (l == "object" || l == "function");
      }
      function Ht(n) {
        return n != null && typeof n == "object";
      }
      var rf = md ? Fn(md) : fm;
      function A0(n, l) {
        return n === l || Fs(n, l, iu(l));
      }
      function d0(n, l, o) {
        return o = typeof o == "function" ? o : t, Fs(n, l, iu(l), o);
      }
      function c0(n) {
        return lf(n) && n != +n;
      }
      function f0(n) {
        if (Km(n))
          throw new nt(s);
        return Kd(n);
      }
      function v0(n) {
        return n === null;
      }
      function p0(n) {
        return n == null;
      }
      function lf(n) {
        return typeof n == "number" || Ht(n) && xn(n) == xe;
      }
      function ri(n) {
        if (!Ht(n) || xn(n) != Re)
          return !1;
        var l = Ki(n);
        if (l === null)
          return !0;
        var o = wt.call(l, "constructor") && l.constructor;
        return typeof o == "function" && o instanceof o && Ri.call(o) == dh;
      }
      var hu = yd ? Fn(yd) : vm;
      function g0(n) {
        return af(n) && n >= -Oe && n <= Oe;
      }
      var of = bd ? Fn(bd) : pm;
      function To(n) {
        return typeof n == "string" || !rt(n) && Ht(n) && xn(n) == sn;
      }
      function Un(n) {
        return typeof n == "symbol" || Ht(n) && xn(n) == Fe;
      }
      var yl = wd ? Fn(wd) : gm;
      function h0(n) {
        return n === t;
      }
      function m0(n) {
        return Ht(n) && wn(n) == yn;
      }
      function y0(n) {
        return Ht(n) && xn(n) == Pr;
      }
      var b0 = po(Us), w0 = po(function(n, l) {
        return n <= l;
      });
      function sf(n) {
        if (!n)
          return [];
        if (Nn(n))
          return To(n) ? Aa(n) : Ln(n);
        if (Ul && n[Ul])
          return $g(n[Ul]());
        var l = wn(n), o = l == Ae ? Is : l == Ze ? Fi : bl;
        return o(n);
      }
      function Ua(n) {
        if (!n)
          return n === 0 ? n : 0;
        if (n = ia(n), n === oe || n === -oe) {
          var l = n < 0 ? -1 : 1;
          return l * pe;
        }
        return n === n ? n : 0;
      }
      function lt(n) {
        var l = Ua(n), o = l % 1;
        return l === l ? o ? l - o : l : 0;
      }
      function uf(n) {
        return n ? Xr(lt(n), 0, Me) : 0;
      }
      function ia(n) {
        if (typeof n == "number")
          return n;
        if (Un(n))
          return $;
        if (Yt(n)) {
          var l = typeof n.valueOf == "function" ? n.valueOf() : n;
          n = Yt(l) ? l + "" : l;
        }
        if (typeof n != "string")
          return n === 0 ? n : +n;
        n = Pd(n);
        var o = ng.test(n);
        return o || rg.test(n) ? Yg(n.slice(2), o ? 2 : 8) : tg.test(n) ? $ : +n;
      }
      function Af(n) {
        return xa(n, Yn(n));
      }
      function C0(n) {
        return n ? Xr(lt(n), -Oe, Oe) : n === 0 ? n : 0;
      }
      function yt(n) {
        return n == null ? "" : qn(n);
      }
      var D0 = gl(function(n, l) {
        if (ni(l) || Nn(l)) {
          xa(l, An(l), n);
          return;
        }
        for (var o in l)
          wt.call(l, o) && Kl(n, o, l[o]);
      }), df = gl(function(n, l) {
        xa(l, Yn(l), n);
      }), xo = gl(function(n, l, o, d) {
        xa(l, Yn(l), n, d);
      }), B0 = gl(function(n, l, o, d) {
        xa(l, An(l), n, d);
      }), T0 = Ha(Vs);
      function x0(n, l) {
        var o = pl(n);
        return l == null ? o : Hd(o, l);
      }
      var P0 = ot(function(n, l) {
        n = xt(n);
        var o = -1, d = l.length, h = d > 2 ? l[2] : t;
        for (h && Pn(l[0], l[1], h) && (d = 1); ++o < d; )
          for (var D = l[o], I = Yn(D), H = -1, K = I.length; ++H < K; ) {
            var ye = I[H], be = n[ye];
            (be === t || ca(be, cl[ye]) && !wt.call(n, ye)) && (n[ye] = D[ye]);
          }
        return n;
      }), k0 = ot(function(n) {
        return n.push(t, Pc), Hn(cf, t, n);
      });
      function O0(n, l) {
        return Dd(n, Ge(l, 3), Ta);
      }
      function M0(n, l) {
        return Dd(n, Ge(l, 3), Xs);
      }
      function z0(n, l) {
        return n == null ? n : Ws(n, Ge(l, 3), Yn);
      }
      function I0(n, l) {
        return n == null ? n : Zd(n, Ge(l, 3), Yn);
      }
      function E0(n, l) {
        return n && Ta(n, Ge(l, 3));
      }
      function L0(n, l) {
        return n && Xs(n, Ge(l, 3));
      }
      function N0(n) {
        return n == null ? [] : io(n, An(n));
      }
      function Y0(n) {
        return n == null ? [] : io(n, Yn(n));
      }
      function mu(n, l, o) {
        var d = n == null ? t : Qr(n, l);
        return d === t ? o : d;
      }
      function S0(n, l) {
        return n != null && Mc(n, l, im);
      }
      function yu(n, l) {
        return n != null && Mc(n, l, om);
      }
      var V0 = Cc(function(n, l, o) {
        l != null && typeof l.toString != "function" && (l = Zi.call(l)), n[l] = o;
      }, wu(Sn)), W0 = Cc(function(n, l, o) {
        l != null && typeof l.toString != "function" && (l = Zi.call(l)), wt.call(n, l) ? n[l].push(o) : n[l] = [o];
      }, Ge), X0 = ot(_l);
      function An(n) {
        return Nn(n) ? Xd(n) : qs(n);
      }
      function Yn(n) {
        return Nn(n) ? Xd(n, !0) : hm(n);
      }
      function Q0(n, l) {
        var o = {};
        return l = Ge(l, 3), Ta(n, function(d, h, D) {
          Xa(o, l(d, h, D), d);
        }), o;
      }
      function H0(n, l) {
        var o = {};
        return l = Ge(l, 3), Ta(n, function(d, h, D) {
          Xa(o, h, l(d, h, D));
        }), o;
      }
      var F0 = gl(function(n, l, o) {
        oo(n, l, o);
      }), cf = gl(function(n, l, o, d) {
        oo(n, l, o, d);
      }), q0 = Ha(function(n, l) {
        var o = {};
        if (n == null)
          return o;
        var d = !1;
        l = It(l, function(D) {
          return D = Ar(D, n), d || (d = D.length > 1), D;
        }), xa(n, ru(n), o), d && (o = aa(o, v | m | w, Vm));
        for (var h = l.length; h--; )
          Ks(o, l[h]);
        return o;
      });
      function U0(n, l) {
        return ff(n, Do(Ge(l)));
      }
      var R0 = Ha(function(n, l) {
        return n == null ? {} : ym(n, l);
      });
      function ff(n, l) {
        if (n == null)
          return {};
        var o = It(ru(n), function(d) {
          return [d];
        });
        return l = Ge(l), ac(n, o, function(d, h) {
          return l(d, h[0]);
        });
      }
      function Z0(n, l, o) {
        l = Ar(l, n);
        var d = -1, h = l.length;
        for (h || (h = 1, n = t); ++d < h; ) {
          var D = n == null ? t : n[Pa(l[d])];
          D === t && (d = h, D = o), n = qa(D) ? D.call(n) : D;
        }
        return n;
      }
      function G0(n, l, o) {
        return n == null ? n : ei(n, l, o);
      }
      function j0(n, l, o, d) {
        return d = typeof d == "function" ? d : t, n == null ? n : ei(n, l, o, d);
      }
      var vf = Tc(An), pf = Tc(Yn);
      function K0(n, l, o) {
        var d = rt(n), h = d || cr(n) || yl(n);
        if (l = Ge(l, 4), o == null) {
          var D = n && n.constructor;
          h ? o = d ? new D() : [] : Yt(n) ? o = qa(D) ? pl(Ki(n)) : {} : o = {};
        }
        return (h ? ea : Ta)(n, function(I, H, K) {
          return l(o, I, H, K);
        }), o;
      }
      function J0(n, l) {
        return n == null ? !0 : Ks(n, l);
      }
      function _0(n, l, o) {
        return n == null ? n : sc(n, l, $s(o));
      }
      function $0(n, l, o, d) {
        return d = typeof d == "function" ? d : t, n == null ? n : sc(n, l, $s(o), d);
      }
      function bl(n) {
        return n == null ? [] : zs(n, An(n));
      }
      function e1(n) {
        return n == null ? [] : zs(n, Yn(n));
      }
      function t1(n, l, o) {
        return o === t && (o = l, l = t), o !== t && (o = ia(o), o = o === o ? o : 0), l !== t && (l = ia(l), l = l === l ? l : 0), Xr(ia(n), l, o);
      }
      function n1(n, l, o) {
        return l = Ua(l), o === t ? (o = l, l = 0) : o = Ua(o), n = ia(n), sm(n, l, o);
      }
      function a1(n, l, o) {
        if (o && typeof o != "boolean" && Pn(n, l, o) && (l = o = t), o === t && (typeof l == "boolean" ? (o = l, l = t) : typeof n == "boolean" && (o = n, n = t)), n === t && l === t ? (n = 0, l = 1) : (n = Ua(n), l === t ? (l = n, n = 0) : l = Ua(l)), n > l) {
          var d = n;
          n = l, l = d;
        }
        if (o || n % 1 || l % 1) {
          var h = Vd();
          return bn(n + h * (l - n + Ng("1e-" + ((h + "").length - 1))), l);
        }
        return Zs(n, l);
      }
      var r1 = hl(function(n, l, o) {
        return l = l.toLowerCase(), n + (o ? gf(l) : l);
      });
      function gf(n) {
        return bu(yt(n).toLowerCase());
      }
      function hf(n) {
        return n = yt(n), n && n.replace(ig, Gg).replace(Tg, "");
      }
      function l1(n, l, o) {
        n = yt(n), l = qn(l);
        var d = n.length;
        o = o === t ? d : Xr(lt(o), 0, d);
        var h = o;
        return o -= l.length, o >= 0 && n.slice(o, h) == l;
      }
      function i1(n) {
        return n = yt(n), n && Sa.test(n) ? n.replace(un, jg) : n;
      }
      function o1(n) {
        return n = yt(n), n && Rp.test(n) ? n.replace(ps, "\\$&") : n;
      }
      var s1 = hl(function(n, l, o) {
        return n + (o ? "-" : "") + l.toLowerCase();
      }), u1 = hl(function(n, l, o) {
        return n + (o ? " " : "") + l.toLowerCase();
      }), A1 = yc("toLowerCase");
      function d1(n, l, o) {
        n = yt(n), l = lt(l);
        var d = l ? Al(n) : 0;
        if (!l || d >= l)
          return n;
        var h = (l - d) / 2;
        return vo(eo(h), o) + n + vo($i(h), o);
      }
      function c1(n, l, o) {
        n = yt(n), l = lt(l);
        var d = l ? Al(n) : 0;
        return l && d < l ? n + vo(l - d, o) : n;
      }
      function f1(n, l, o) {
        n = yt(n), l = lt(l);
        var d = l ? Al(n) : 0;
        return l && d < l ? vo(l - d, o) + n : n;
      }
      function v1(n, l, o) {
        return o || l == null ? l = 0 : l && (l = +l), wh(yt(n).replace(gs, ""), l || 0);
      }
      function p1(n, l, o) {
        return (o ? Pn(n, l, o) : l === t) ? l = 1 : l = lt(l), Gs(yt(n), l);
      }
      function g1() {
        var n = arguments, l = yt(n[0]);
        return n.length < 3 ? l : l.replace(n[1], n[2]);
      }
      var h1 = hl(function(n, l, o) {
        return n + (o ? "_" : "") + l.toLowerCase();
      });
      function m1(n, l, o) {
        return o && typeof o != "number" && Pn(n, l, o) && (l = o = t), o = o === t ? Me : o >>> 0, o ? (n = yt(n), n && (typeof l == "string" || l != null && !hu(l)) && (l = qn(l), !l && ul(n)) ? dr(Aa(n), 0, o) : n.split(l, o)) : [];
      }
      var y1 = hl(function(n, l, o) {
        return n + (o ? " " : "") + bu(l);
      });
      function b1(n, l, o) {
        return n = yt(n), o = o == null ? 0 : Xr(lt(o), 0, n.length), l = qn(l), n.slice(o, o + l.length) == l;
      }
      function w1(n, l, o) {
        var d = C.templateSettings;
        o && Pn(n, l, o) && (l = t), n = yt(n), l = xo({}, l, d, xc);
        var h = xo({}, l.imports, d.imports, xc), D = An(h), I = zs(h, D), H, K, ye = 0, be = l.interpolate || Vi, De = "__p += '", Se = Es(
          (l.escape || Vi).source + "|" + be.source + "|" + (be === ua ? eg : Vi).source + "|" + (l.evaluate || Vi).source + "|$",
          "g"
        ), qe = "//# sourceURL=" + (wt.call(l, "sourceURL") ? (l.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Mg + "]") + `
`;
        n.replace(Se, function(Je, ut, vt, Rn, kn, Zn) {
          return vt || (vt = Rn), De += n.slice(ye, Zn).replace(og, Kg), ut && (H = !0, De += `' +
__e(` + ut + `) +
'`), kn && (K = !0, De += `';
` + kn + `;
__p += '`), vt && (De += `' +
((__t = (` + vt + `)) == null ? '' : __t) +
'`), ye = Zn + Je.length, Je;
        }), De += `';
`;
        var Ke = wt.call(l, "variable") && l.variable;
        if (!Ke)
          De = `with (obj) {
` + De + `
}
`;
        else if (_p.test(Ke))
          throw new nt(A);
        De = (K ? De.replace(Ie, "") : De).replace(se, "$1").replace(ze, "$1;"), De = "function(" + (Ke || "obj") + `) {
` + (Ke ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (H ? ", __e = _.escape" : "") + (K ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + De + `return __p
}`;
        var it = yf(function() {
          return gt(D, qe + "return " + De).apply(t, I);
        });
        if (it.source = De, gu(it))
          throw it;
        return it;
      }
      function C1(n) {
        return yt(n).toLowerCase();
      }
      function D1(n) {
        return yt(n).toUpperCase();
      }
      function B1(n, l, o) {
        if (n = yt(n), n && (o || l === t))
          return Pd(n);
        if (!n || !(l = qn(l)))
          return n;
        var d = Aa(n), h = Aa(l), D = kd(d, h), I = Od(d, h) + 1;
        return dr(d, D, I).join("");
      }
      function T1(n, l, o) {
        if (n = yt(n), n && (o || l === t))
          return n.slice(0, zd(n) + 1);
        if (!n || !(l = qn(l)))
          return n;
        var d = Aa(n), h = Od(d, Aa(l)) + 1;
        return dr(d, 0, h).join("");
      }
      function x1(n, l, o) {
        if (n = yt(n), n && (o || l === t))
          return n.replace(gs, "");
        if (!n || !(l = qn(l)))
          return n;
        var d = Aa(n), h = kd(d, Aa(l));
        return dr(d, h).join("");
      }
      function P1(n, l) {
        var o = q, d = J;
        if (Yt(l)) {
          var h = "separator" in l ? l.separator : h;
          o = "length" in l ? lt(l.length) : o, d = "omission" in l ? qn(l.omission) : d;
        }
        n = yt(n);
        var D = n.length;
        if (ul(n)) {
          var I = Aa(n);
          D = I.length;
        }
        if (o >= D)
          return n;
        var H = o - Al(d);
        if (H < 1)
          return d;
        var K = I ? dr(I, 0, H).join("") : n.slice(0, H);
        if (h === t)
          return K + d;
        if (I && (H += K.length - H), hu(h)) {
          if (n.slice(H).search(h)) {
            var ye, be = K;
            for (h.global || (h = Es(h.source, yt(jA.exec(h)) + "g")), h.lastIndex = 0; ye = h.exec(be); )
              var De = ye.index;
            K = K.slice(0, De === t ? H : De);
          }
        } else if (n.indexOf(qn(h), H) != H) {
          var Se = K.lastIndexOf(h);
          Se > -1 && (K = K.slice(0, Se));
        }
        return K + d;
      }
      function k1(n) {
        return n = yt(n), n && En.test(n) ? n.replace(Ye, ah) : n;
      }
      var O1 = hl(function(n, l, o) {
        return n + (o ? " " : "") + l.toUpperCase();
      }), bu = yc("toUpperCase");
      function mf(n, l, o) {
        return n = yt(n), l = o ? t : l, l === t ? _g(n) ? ih(n) : Fg(n) : n.match(l) || [];
      }
      var yf = ot(function(n, l) {
        try {
          return Hn(n, t, l);
        } catch (o) {
          return gu(o) ? o : new nt(o);
        }
      }), M1 = Ha(function(n, l) {
        return ea(l, function(o) {
          o = Pa(o), Xa(n, o, vu(n[o], n));
        }), n;
      });
      function z1(n) {
        var l = n == null ? 0 : n.length, o = Ge();
        return n = l ? It(n, function(d) {
          if (typeof d[1] != "function")
            throw new ta(u);
          return [o(d[0]), d[1]];
        }) : [], ot(function(d) {
          for (var h = -1; ++h < l; ) {
            var D = n[h];
            if (Hn(D[0], this, d))
              return Hn(D[1], this, d);
          }
        });
      }
      function I1(n) {
        return am(aa(n, v));
      }
      function wu(n) {
        return function() {
          return n;
        };
      }
      function E1(n, l) {
        return n == null || n !== n ? l : n;
      }
      var L1 = wc(), N1 = wc(!0);
      function Sn(n) {
        return n;
      }
      function Cu(n) {
        return Jd(typeof n == "function" ? n : aa(n, v));
      }
      function Y1(n) {
        return $d(aa(n, v));
      }
      function S1(n, l) {
        return ec(n, aa(l, v));
      }
      var V1 = ot(function(n, l) {
        return function(o) {
          return _l(o, n, l);
        };
      }), W1 = ot(function(n, l) {
        return function(o) {
          return _l(n, o, l);
        };
      });
      function Du(n, l, o) {
        var d = An(l), h = io(l, d);
        o == null && !(Yt(l) && (h.length || !d.length)) && (o = l, l = n, n = this, h = io(l, An(l)));
        var D = !(Yt(o) && "chain" in o) || !!o.chain, I = qa(n);
        return ea(h, function(H) {
          var K = l[H];
          n[H] = K, I && (n.prototype[H] = function() {
            var ye = this.__chain__;
            if (D || ye) {
              var be = n(this.__wrapped__), De = be.__actions__ = Ln(this.__actions__);
              return De.push({ func: K, args: arguments, thisArg: n }), be.__chain__ = ye, be;
            }
            return K.apply(n, lr([this.value()], arguments));
          });
        }), n;
      }
      function X1() {
        return vn._ === this && (vn._ = ch), this;
      }
      function Bu() {
      }
      function Q1(n) {
        return n = lt(n), ot(function(l) {
          return tc(l, n);
        });
      }
      var H1 = tu(It), F1 = tu(Cd), q1 = tu(xs);
      function bf(n) {
        return su(n) ? Ps(Pa(n)) : bm(n);
      }
      function U1(n) {
        return function(l) {
          return n == null ? t : Qr(n, l);
        };
      }
      var R1 = Dc(), Z1 = Dc(!0);
      function Tu() {
        return [];
      }
      function xu() {
        return !1;
      }
      function G1() {
        return {};
      }
      function j1() {
        return "";
      }
      function K1() {
        return !0;
      }
      function J1(n, l) {
        if (n = lt(n), n < 1 || n > Oe)
          return [];
        var o = Me, d = bn(n, Me);
        l = Ge(l), n -= Me;
        for (var h = Ms(d, l); ++o < n; )
          l(o);
        return h;
      }
      function _1(n) {
        return rt(n) ? It(n, Pa) : Un(n) ? [n] : Ln(Wc(yt(n)));
      }
      function $1(n) {
        var l = ++Ah;
        return yt(n) + l;
      }
      var ew = fo(function(n, l) {
        return n + l;
      }, 0), tw = nu("ceil"), nw = fo(function(n, l) {
        return n / l;
      }, 1), aw = nu("floor");
      function rw(n) {
        return n && n.length ? lo(n, Sn, Qs) : t;
      }
      function lw(n, l) {
        return n && n.length ? lo(n, Ge(l, 2), Qs) : t;
      }
      function iw(n) {
        return Td(n, Sn);
      }
      function ow(n, l) {
        return Td(n, Ge(l, 2));
      }
      function sw(n) {
        return n && n.length ? lo(n, Sn, Us) : t;
      }
      function uw(n, l) {
        return n && n.length ? lo(n, Ge(l, 2), Us) : t;
      }
      var Aw = fo(function(n, l) {
        return n * l;
      }, 1), dw = nu("round"), cw = fo(function(n, l) {
        return n - l;
      }, 0);
      function fw(n) {
        return n && n.length ? Os(n, Sn) : 0;
      }
      function vw(n, l) {
        return n && n.length ? Os(n, Ge(l, 2)) : 0;
      }
      return C.after = Yb, C.ary = Kc, C.assign = D0, C.assignIn = df, C.assignInWith = xo, C.assignWith = B0, C.at = T0, C.before = Jc, C.bind = vu, C.bindAll = M1, C.bindKey = _c, C.castArray = Gb, C.chain = Zc, C.chunk = ay, C.compact = ry, C.concat = ly, C.cond = z1, C.conforms = I1, C.constant = wu, C.countBy = fb, C.create = x0, C.curry = $c, C.curryRight = ef, C.debounce = tf, C.defaults = P0, C.defaultsDeep = k0, C.defer = Sb, C.delay = Vb, C.difference = iy, C.differenceBy = oy, C.differenceWith = sy, C.drop = uy, C.dropRight = Ay, C.dropRightWhile = dy, C.dropWhile = cy, C.fill = fy, C.filter = pb, C.flatMap = mb, C.flatMapDeep = yb, C.flatMapDepth = bb, C.flatten = Fc, C.flattenDeep = vy, C.flattenDepth = py, C.flip = Wb, C.flow = L1, C.flowRight = N1, C.fromPairs = gy, C.functions = N0, C.functionsIn = Y0, C.groupBy = wb, C.initial = my, C.intersection = yy, C.intersectionBy = by, C.intersectionWith = wy, C.invert = V0, C.invertBy = W0, C.invokeMap = Db, C.iteratee = Cu, C.keyBy = Bb, C.keys = An, C.keysIn = Yn, C.map = bo, C.mapKeys = Q0, C.mapValues = H0, C.matches = Y1, C.matchesProperty = S1, C.memoize = Co, C.merge = F0, C.mergeWith = cf, C.method = V1, C.methodOf = W1, C.mixin = Du, C.negate = Do, C.nthArg = Q1, C.omit = q0, C.omitBy = U0, C.once = Xb, C.orderBy = Tb, C.over = H1, C.overArgs = Qb, C.overEvery = F1, C.overSome = q1, C.partial = pu, C.partialRight = nf, C.partition = xb, C.pick = R0, C.pickBy = ff, C.property = bf, C.propertyOf = U1, C.pull = Ty, C.pullAll = Uc, C.pullAllBy = xy, C.pullAllWith = Py, C.pullAt = ky, C.range = R1, C.rangeRight = Z1, C.rearg = Hb, C.reject = Ob, C.remove = Oy, C.rest = Fb, C.reverse = cu, C.sampleSize = zb, C.set = G0, C.setWith = j0, C.shuffle = Ib, C.slice = My, C.sortBy = Nb, C.sortedUniq = Sy, C.sortedUniqBy = Vy, C.split = m1, C.spread = qb, C.tail = Wy, C.take = Xy, C.takeRight = Qy, C.takeRightWhile = Hy, C.takeWhile = Fy, C.tap = rb, C.throttle = Ub, C.thru = yo, C.toArray = sf, C.toPairs = vf, C.toPairsIn = pf, C.toPath = _1, C.toPlainObject = Af, C.transform = K0, C.unary = Rb, C.union = qy, C.unionBy = Uy, C.unionWith = Ry, C.uniq = Zy, C.uniqBy = Gy, C.uniqWith = jy, C.unset = J0, C.unzip = fu, C.unzipWith = Rc, C.update = _0, C.updateWith = $0, C.values = bl, C.valuesIn = e1, C.without = Ky, C.words = mf, C.wrap = Zb, C.xor = Jy, C.xorBy = _y, C.xorWith = $y, C.zip = eb, C.zipObject = tb, C.zipObjectDeep = nb, C.zipWith = ab, C.entries = vf, C.entriesIn = pf, C.extend = df, C.extendWith = xo, Du(C, C), C.add = ew, C.attempt = yf, C.camelCase = r1, C.capitalize = gf, C.ceil = tw, C.clamp = t1, C.clone = jb, C.cloneDeep = Jb, C.cloneDeepWith = _b, C.cloneWith = Kb, C.conformsTo = $b, C.deburr = hf, C.defaultTo = E1, C.divide = nw, C.endsWith = l1, C.eq = ca, C.escape = i1, C.escapeRegExp = o1, C.every = vb, C.find = gb, C.findIndex = Qc, C.findKey = O0, C.findLast = hb, C.findLastIndex = Hc, C.findLastKey = M0, C.floor = aw, C.forEach = Gc, C.forEachRight = jc, C.forIn = z0, C.forInRight = I0, C.forOwn = E0, C.forOwnRight = L0, C.get = mu, C.gt = e0, C.gte = t0, C.has = S0, C.hasIn = yu, C.head = qc, C.identity = Sn, C.includes = Cb, C.indexOf = hy, C.inRange = n1, C.invoke = X0, C.isArguments = qr, C.isArray = rt, C.isArrayBuffer = n0, C.isArrayLike = Nn, C.isArrayLikeObject = Rt, C.isBoolean = a0, C.isBuffer = cr, C.isDate = r0, C.isElement = l0, C.isEmpty = i0, C.isEqual = o0, C.isEqualWith = s0, C.isError = gu, C.isFinite = u0, C.isFunction = qa, C.isInteger = af, C.isLength = Bo, C.isMap = rf, C.isMatch = A0, C.isMatchWith = d0, C.isNaN = c0, C.isNative = f0, C.isNil = p0, C.isNull = v0, C.isNumber = lf, C.isObject = Yt, C.isObjectLike = Ht, C.isPlainObject = ri, C.isRegExp = hu, C.isSafeInteger = g0, C.isSet = of, C.isString = To, C.isSymbol = Un, C.isTypedArray = yl, C.isUndefined = h0, C.isWeakMap = m0, C.isWeakSet = y0, C.join = Cy, C.kebabCase = s1, C.last = la, C.lastIndexOf = Dy, C.lowerCase = u1, C.lowerFirst = A1, C.lt = b0, C.lte = w0, C.max = rw, C.maxBy = lw, C.mean = iw, C.meanBy = ow, C.min = sw, C.minBy = uw, C.stubArray = Tu, C.stubFalse = xu, C.stubObject = G1, C.stubString = j1, C.stubTrue = K1, C.multiply = Aw, C.nth = By, C.noConflict = X1, C.noop = Bu, C.now = wo, C.pad = d1, C.padEnd = c1, C.padStart = f1, C.parseInt = v1, C.random = a1, C.reduce = Pb, C.reduceRight = kb, C.repeat = p1, C.replace = g1, C.result = Z0, C.round = dw, C.runInContext = j, C.sample = Mb, C.size = Eb, C.snakeCase = h1, C.some = Lb, C.sortedIndex = zy, C.sortedIndexBy = Iy, C.sortedIndexOf = Ey, C.sortedLastIndex = Ly, C.sortedLastIndexBy = Ny, C.sortedLastIndexOf = Yy, C.startCase = y1, C.startsWith = b1, C.subtract = cw, C.sum = fw, C.sumBy = vw, C.template = w1, C.times = J1, C.toFinite = Ua, C.toInteger = lt, C.toLength = uf, C.toLower = C1, C.toNumber = ia, C.toSafeInteger = C0, C.toString = yt, C.toUpper = D1, C.trim = B1, C.trimEnd = T1, C.trimStart = x1, C.truncate = P1, C.unescape = k1, C.uniqueId = $1, C.upperCase = O1, C.upperFirst = bu, C.each = Gc, C.eachRight = jc, C.first = qc, Du(C, function() {
        var n = {};
        return Ta(C, function(l, o) {
          wt.call(C.prototype, o) || (n[o] = l);
        }), n;
      }(), { chain: !1 }), C.VERSION = r, ea(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
        C[n].placeholder = C;
      }), ea(["drop", "take"], function(n, l) {
        dt.prototype[n] = function(o) {
          o = o === t ? 1 : ln(lt(o), 0);
          var d = this.__filtered__ && !l ? new dt(this) : this.clone();
          return d.__filtered__ ? d.__takeCount__ = bn(o, d.__takeCount__) : d.__views__.push({
            size: bn(o, Me),
            type: n + (d.__dir__ < 0 ? "Right" : "")
          }), d;
        }, dt.prototype[n + "Right"] = function(o) {
          return this.reverse()[n](o).reverse();
        };
      }), ea(["filter", "map", "takeWhile"], function(n, l) {
        var o = l + 1, d = o == R || o == G;
        dt.prototype[n] = function(h) {
          var D = this.clone();
          return D.__iteratees__.push({
            iteratee: Ge(h, 3),
            type: o
          }), D.__filtered__ = D.__filtered__ || d, D;
        };
      }), ea(["head", "last"], function(n, l) {
        var o = "take" + (l ? "Right" : "");
        dt.prototype[n] = function() {
          return this[o](1).value()[0];
        };
      }), ea(["initial", "tail"], function(n, l) {
        var o = "drop" + (l ? "" : "Right");
        dt.prototype[n] = function() {
          return this.__filtered__ ? new dt(this) : this[o](1);
        };
      }), dt.prototype.compact = function() {
        return this.filter(Sn);
      }, dt.prototype.find = function(n) {
        return this.filter(n).head();
      }, dt.prototype.findLast = function(n) {
        return this.reverse().find(n);
      }, dt.prototype.invokeMap = ot(function(n, l) {
        return typeof n == "function" ? new dt(this) : this.map(function(o) {
          return _l(o, n, l);
        });
      }), dt.prototype.reject = function(n) {
        return this.filter(Do(Ge(n)));
      }, dt.prototype.slice = function(n, l) {
        n = lt(n);
        var o = this;
        return o.__filtered__ && (n > 0 || l < 0) ? new dt(o) : (n < 0 ? o = o.takeRight(-n) : n && (o = o.drop(n)), l !== t && (l = lt(l), o = l < 0 ? o.dropRight(-l) : o.take(l - n)), o);
      }, dt.prototype.takeRightWhile = function(n) {
        return this.reverse().takeWhile(n).reverse();
      }, dt.prototype.toArray = function() {
        return this.take(Me);
      }, Ta(dt.prototype, function(n, l) {
        var o = /^(?:filter|find|map|reject)|While$/.test(l), d = /^(?:head|last)$/.test(l), h = C[d ? "take" + (l == "last" ? "Right" : "") : l], D = d || /^find/.test(l);
        h && (C.prototype[l] = function() {
          var I = this.__wrapped__, H = d ? [1] : arguments, K = I instanceof dt, ye = H[0], be = K || rt(I), De = function(ut) {
            var vt = h.apply(C, lr([ut], H));
            return d && Se ? vt[0] : vt;
          };
          be && o && typeof ye == "function" && ye.length != 1 && (K = be = !1);
          var Se = this.__chain__, qe = !!this.__actions__.length, Ke = D && !Se, it = K && !qe;
          if (!D && be) {
            I = it ? I : new dt(this);
            var Je = n.apply(I, H);
            return Je.__actions__.push({ func: yo, args: [De], thisArg: t }), new na(Je, Se);
          }
          return Ke && it ? n.apply(this, H) : (Je = this.thru(De), Ke ? d ? Je.value()[0] : Je.value() : Je);
        });
      }), ea(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
        var l = qi[n], o = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", d = /^(?:pop|shift)$/.test(n);
        C.prototype[n] = function() {
          var h = arguments;
          if (d && !this.__chain__) {
            var D = this.value();
            return l.apply(rt(D) ? D : [], h);
          }
          return this[o](function(I) {
            return l.apply(rt(I) ? I : [], h);
          });
        };
      }), Ta(dt.prototype, function(n, l) {
        var o = C[l];
        if (o) {
          var d = o.name + "";
          wt.call(vl, d) || (vl[d] = []), vl[d].push({ name: l, func: o });
        }
      }), vl[co(t, E).name] = [{
        name: "wrapper",
        func: t
      }], dt.prototype.clone = kh, dt.prototype.reverse = Oh, dt.prototype.value = Mh, C.prototype.at = lb, C.prototype.chain = ib, C.prototype.commit = ob, C.prototype.next = sb, C.prototype.plant = Ab, C.prototype.reverse = db, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = cb, C.prototype.first = C.prototype.head, Ul && (C.prototype[Ul] = ub), C;
    }, dl = oh();
    Yr ? ((Yr.exports = dl)._ = dl, Cs._ = dl) : vn._ = dl;
  }).call(li);
})(Ro, Ro.exports);
var Lv = Ro.exports;
const MD = ["id"], zD = /* @__PURE__ */ We({
  name: "UiTooltip",
  __name: "UiTooltip",
  props: {
    size: {
      type: String,
      default: "l"
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    label: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "top"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 1e6
    },
    customMobileTooltip: {
      type: Boolean,
      default: !1
    },
    customMobileTooltipWidth: {
      type: Number,
      default: 1023
    }
  },
  emits: ["update:modelValue", "click"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = sa(), s = U(!1), u = U(null), A = U(null), c = U({
      top: "",
      left: "",
      positionClass: ""
    }), g = Lv.debounce((B) => {
      s.value = B && !t.disabled, s.value && Bt(p);
    }, 200), p = () => {
      var T, L;
      const B = {
        activatorPosition: (T = u.value) == null ? void 0 : T.getBoundingClientRect(),
        dropPosition: (L = A.value) == null ? void 0 : L.getBoundingClientRect(),
        ignorePosition: !1,
        preferredPositions: BA,
        side: t.position,
        windowSize: {
          width: i.width.value,
          height: i.height.value
        },
        space: kD,
        zIndex: t.zIndex
      };
      c.value = Ev(B);
    }, v = () => {
      g(!1);
    }, m = () => {
      if (t.customMobileTooltip && i.width.value <= t.customMobileTooltipWidth) {
        r("click");
        return;
      }
      g(!0);
    }, w = () => {
      s.value && Bt(() => {
        p();
      });
    };
    return bt(() => {
      w(), Bt(() => {
        window.addEventListener("resize", w);
      });
    }), al(() => {
      Bt(() => {
        window.removeEventListener("resize", w);
      });
    }), Ql(u, () => v()), (B, T) => (f(), y("div", {
      id: e.id,
      class: "ui-tooltip"
    }, [
      X("button", {
        ref_key: "activator",
        ref: u,
        type: "button",
        class: he(["ui-tooltip__button tooltip-button", `tooltip-button_size_${e.size}`]),
        onClick: m
      }, [
        fe(B.$slots, "icon", {}, () => [
          Ce(b(wa), { class: "tooltip-button__icon" })
        ], !0)
      ], 2),
      (f(), ce(rl, { to: "body" }, [
        Ce(Jn, {
          name: "tooltip-fade",
          mode: "out-in"
        }, {
          default: ue(() => [
            s.value ? (f(), y("div", {
              key: 0,
              ref_key: "drop",
              ref: A,
              style: Tt(c.value),
              class: he(["tooltip__container__tooltip tooltip elevation-shadow-high", c.value.positionClass])
            }, [
              fe(B.$slots, "default", {}, () => [
                X("span", null, we(e.label), 1)
              ], !0),
              T[0] || (T[0] = X("div", { class: "tooltip_triangle_start" }, null, -1))
            ], 6)) : Y("", !0)
          ]),
          _: 3
        })
      ]))
    ], 8, MD));
  }
});
const zi = /* @__PURE__ */ je(zD, [["__scopeId", "data-v-d7106bf3"]]), ID = {
  key: 0,
  class: "ui-counter__hint hint"
}, ED = {
  key: 0,
  class: "ui-counter__label"
}, LD = ["disabled"], ND = { class: "ui-counter__container container" }, YD = ["min", "max"], SD = ["disabled"], VD = {
  key: 1,
  class: "ui-counter__hint-message"
}, WD = /* @__PURE__ */ We({
  name: "UiCounter",
  __name: "UiCounter",
  props: {
    size: {
      type: String,
      default: "l"
    },
    fill: {
      type: Boolean,
      default: !1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    label: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Number,
      required: !0
    },
    labelTooltip: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "increment",
    "decrement",
    "update"
  ],
  setup(e, { emit: a }) {
    const t = e, r = a, { width: i } = sa(), s = U(0), u = V(() => s.value <= t.min), A = V(() => s.value >= t.max), c = V(() => t.label || t.labelTooltip), g = V(() => i.value >= 1023 ? "m" : "s");
    st(
      () => s.value,
      (w) => {
        const B = Math.max(t.min, Math.min(t.max, w));
        s.value !== B && (s.value = B, r("update:modelValue", B), r("update", B));
      }
    );
    const p = () => {
      s.value < t.max && s.value++, r("increment");
    }, v = () => {
      s.value > t.min && s.value--, r("decrement");
    }, m = (w) => {
      const B = w.target;
      B.value = B.value.replace(/^0+/, "") || "0", s.value = +B.value, r("update:modelValue", s.value), r("update", s.value);
    };
    return ki(() => {
      t.modelValue && (s.value = t.modelValue);
    }), (w, B) => (f(), y("div", {
      class: he(`ui-counter__wrapper_size_${e.size}`)
    }, [
      c.value ? (f(), y("span", ID, [
        e.label ? (f(), y("span", ED, we(e.label), 1)) : Y("", !0),
        e.labelTooltip ? (f(), ce(zi, {
          key: 1,
          class: "ui-counter-tooltip",
          size: g.value,
          label: e.labelTooltip
        }, {
          icon: ue(() => [
            fe(w.$slots, "tooltip-icon", {}, () => [
              Ce(b(wa), { class: "ui-counter-tooltip__icon" })
            ], !0)
          ]),
          _: 3
        }, 8, ["size", "label"])) : Y("", !0)
      ])) : Y("", !0),
      X("div", {
        class: he(["ui-counter", { "ui-counter_fill": e.fill }])
      }, [
        X("button", {
          type: "button",
          disabled: u.value,
          class: he([{ "ui-counter-button_disabled": u.value }, "ui-counter-button"]),
          onClick: v
        }, [
          Ce(b(Bv), { class: "ui-counter-button__icon" })
        ], 10, LD),
        X("label", ND, [
          cn(X("input", {
            "onUpdate:modelValue": B[0] || (B[0] = (T) => s.value = T),
            type: "number",
            class: "container__input",
            inputmode: "numeric",
            min: e.min,
            max: e.max,
            onChange: m
          }, null, 40, YD), [
            [
              ha,
              s.value,
              void 0,
              { number: !0 }
            ]
          ])
        ]),
        X("button", {
          type: "button",
          class: he(["ui-counter-button", { "ui-counter-button_disabled": A.value }]),
          disabled: A.value,
          onClick: p
        }, [
          Ce(b(O3), { class: "ui-counter-button__icon" })
        ], 10, SD)
      ], 2),
      e.hintMessage ? (f(), y("p", VD, we(e.hintMessage), 1)) : Y("", !0)
    ], 2));
  }
});
const $E = /* @__PURE__ */ je(WD, [["__scopeId", "data-v-f57a8477"]]);
var Nv = { exports: {} }, en = Nv.exports = {}, ka, Oa;
function iA() {
  throw new Error("setTimeout has not been defined");
}
function oA() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? ka = setTimeout : ka = iA;
  } catch {
    ka = iA;
  }
  try {
    typeof clearTimeout == "function" ? Oa = clearTimeout : Oa = oA;
  } catch {
    Oa = oA;
  }
})();
function Yv(e) {
  if (ka === setTimeout)
    return setTimeout(e, 0);
  if ((ka === iA || !ka) && setTimeout)
    return ka = setTimeout, setTimeout(e, 0);
  try {
    return ka(e, 0);
  } catch {
    try {
      return ka.call(null, e, 0);
    } catch {
      return ka.call(this, e, 0);
    }
  }
}
function XD(e) {
  if (Oa === clearTimeout)
    return clearTimeout(e);
  if ((Oa === oA || !Oa) && clearTimeout)
    return Oa = clearTimeout, clearTimeout(e);
  try {
    return Oa(e);
  } catch {
    try {
      return Oa.call(null, e);
    } catch {
      return Oa.call(this, e);
    }
  }
}
var Ga = [], Ol = !1, Jr, Yo = -1;
function QD() {
  !Ol || !Jr || (Ol = !1, Jr.length ? Ga = Jr.concat(Ga) : Yo = -1, Ga.length && Sv());
}
function Sv() {
  if (!Ol) {
    var e = Yv(QD);
    Ol = !0;
    for (var a = Ga.length; a; ) {
      for (Jr = Ga, Ga = []; ++Yo < a; )
        Jr && Jr[Yo].run();
      Yo = -1, a = Ga.length;
    }
    Jr = null, Ol = !1, XD(e);
  }
}
en.nextTick = function(e) {
  var a = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      a[t - 1] = arguments[t];
  Ga.push(new Vv(e, a)), Ga.length === 1 && !Ol && Yv(Sv);
};
function Vv(e, a) {
  this.fun = e, this.array = a;
}
Vv.prototype.run = function() {
  this.fun.apply(null, this.array);
};
en.title = "browser";
en.browser = !0;
en.env = {};
en.argv = [];
en.version = "";
en.versions = {};
function tr() {
}
en.on = tr;
en.addListener = tr;
en.once = tr;
en.off = tr;
en.removeListener = tr;
en.removeAllListeners = tr;
en.emit = tr;
en.prependListener = tr;
en.prependOnceListener = tr;
en.listeners = function(e) {
  return [];
};
en.binding = function(e) {
  throw new Error("process.binding is not supported");
};
en.cwd = function() {
  return "/";
};
en.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
en.umask = function() {
  return 0;
};
var HD = Nv.exports;
const FD = { class: "ui-hint" }, qD = 16, UD = /* @__PURE__ */ We({
  name: "UiHint",
  __name: "UiHint",
  props: {
    hintContent: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top"
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    asTooltip: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 1e6
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const a = e, t = U(!1), r = U({
      top: "",
      left: "",
      positionClass: ""
    }), i = sa(), s = U(null), u = U(null), A = Lv.debounce((v) => {
      a.asTooltip || (t.value = v && !a.disabled, t.value && HD.nextTick(p));
    }, 200), c = () => {
      A(!1);
    }, g = () => {
      A(!0);
    }, p = () => {
      var m, w;
      const v = {
        activatorPosition: (m = s.value) == null ? void 0 : m.getBoundingClientRect(),
        dropPosition: (w = u.value) == null ? void 0 : w.getBoundingClientRect(),
        ignorePosition: !1,
        preferredPositions: BA,
        side: a.position,
        windowSize: {
          width: i.width.value,
          height: i.height.value
        },
        space: qD,
        zIndex: a.zIndex
      };
      r.value = Ev(v);
    };
    return (v, m) => (f(), y("div", FD, [
      X("div", {
        ref_key: "activator",
        ref: s,
        class: he(["ui-hint__label-text", { "ui-hint__label-text_disabled": a.disabled }]),
        onMouseenter: g,
        onMouseleave: c
      }, [
        fe(v.$slots, "default", {}, () => [
          Ce(b(f3), { class: "icon" })
        ], !0)
      ], 34),
      (f(), ce(rl, { to: "body" }, [
        Ce(Jn, {
          name: "hint-fade",
          mode: "out-in"
        }, {
          default: ue(() => [
            t.value && !a.disabled ? (f(), y("div", {
              key: 0,
              ref_key: "drop",
              ref: u,
              style: Tt(r.value),
              class: he(["hint__container__hint hint", r.value.positionClass]),
              onMouseenter: g,
              onMouseleave: c
            }, [
              X("span", null, we(e.hintContent), 1),
              m[0] || (m[0] = X("div", { class: "hint_triangle_start" }, null, -1))
            ], 38)) : Y("", !0)
          ]),
          _: 1
        })
      ]))
    ]));
  }
});
const ls = /* @__PURE__ */ je(UD, [["__scopeId", "data-v-20be1d42"]]), RD = /* @__PURE__ */ We({
  name: "UiIconButton",
  __name: "UiIconButton",
  props: {
    color: {
      type: String,
      default: "accent"
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "l"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      required: !1
    },
    to: {
      type: Object,
      required: !1
    },
    target: {
      type: String,
      default: ""
    },
    ariaLabel: {
      type: String,
      default: "icon-button"
    }
  },
  setup(e) {
    const a = e, t = V(() => a.href && !a.to && !a.disabled ? "a" : !a.href && a.to && !a.disabled ? "router-link" : "button");
    return (r, i) => (f(), ce(Dt(t.value), {
      class: he(["ui-icon-button", [
        `ui-icon-button_color_${e.color}`,
        `ui-icon-button_size_${e.size}`,
        {
          "ui-icon-button_loading": e.loading
        }
      ]]),
      href: e.href,
      to: e.to,
      target: e.target,
      type: e.type,
      disabled: e.disabled || e.loading,
      "aria-label": e.ariaLabel
    }, {
      default: ue(() => [
        fe(r.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "href", "to", "target", "type", "disabled", "aria-label"]));
  }
});
const Pf = /* @__PURE__ */ je(RD, [["__scopeId", "data-v-9b8e8814"]]);
/*! maska v2.1.11 | (c) Alexander Shabunevich | Released under the MIT license */
var ZD = Object.defineProperty, GD = (e, a, t) => a in e ? ZD(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, gi = (e, a, t) => (GD(e, typeof a != "symbol" ? a + "" : a, t), t);
const kf = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
};
class Of {
  constructor(a = {}) {
    gi(this, "opts", {}), gi(this, "memo", /* @__PURE__ */ new Map());
    const t = { ...a };
    if (t.tokens != null) {
      t.tokens = t.tokensReplace ? { ...t.tokens } : { ...kf, ...t.tokens };
      for (const r of Object.values(t.tokens))
        typeof r.pattern == "string" && (r.pattern = new RegExp(r.pattern));
    } else
      t.tokens = kf;
    Array.isArray(t.mask) && (t.mask.length > 1 ? t.mask = [...t.mask].sort((r, i) => r.length - i.length) : t.mask = t.mask[0] ?? ""), t.mask === "" && (t.mask = null), this.opts = t;
  }
  masked(a) {
    return this.process(a, this.findMask(a));
  }
  unmasked(a) {
    return this.process(a, this.findMask(a), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(a) {
    const t = this.findMask(a);
    if (this.opts.mask == null || t == null)
      return !1;
    const r = this.process(a, t).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : typeof this.opts.mask == "function" ? r >= t.length : this.opts.mask.filter((i) => r >= i.length).length === this.opts.mask.length;
  }
  findMask(a) {
    const t = this.opts.mask;
    if (t == null)
      return null;
    if (typeof t == "string")
      return t;
    if (typeof t == "function")
      return t(a);
    const r = this.process(a, t.slice(-1).pop() ?? "", !1);
    return t.find((i) => this.process(a, i, !1).length >= r.length) ?? "";
  }
  escapeMask(a) {
    const t = [], r = [];
    return a.split("").forEach((i, s) => {
      i === "!" && a[s - 1] !== "!" ? r.push(s - r.length) : t.push(i);
    }), { mask: t.join(""), escaped: r };
  }
  process(a, t, r = !0) {
    if (t == null)
      return a;
    const i = `value=${a},mask=${t},masked=${r ? 1 : 0}`;
    if (this.memo.has(i))
      return this.memo.get(i);
    const { mask: s, escaped: u } = this.escapeMask(t), A = [], c = this.opts.tokens != null ? this.opts.tokens : {}, g = this.isReversed() ? -1 : 1, p = this.isReversed() ? "unshift" : "push", v = this.isReversed() ? 0 : s.length - 1, m = this.isReversed() ? () => L > -1 && E > -1 : () => L < s.length && E < a.length, w = (k) => !this.isReversed() && k <= v || this.isReversed() && k >= v;
    let B, T = -1, L = this.isReversed() ? s.length - 1 : 0, E = this.isReversed() ? a.length - 1 : 0, N = !1;
    for (; m(); ) {
      const k = s.charAt(L), F = c[k], S = (F == null ? void 0 : F.transform) != null ? F.transform(a.charAt(E)) : a.charAt(E);
      if (!u.includes(L) && F != null ? (S.match(F.pattern) != null ? (A[p](S), F.repeated ? (T === -1 ? T = L : L === v && L !== T && (L = T - g), v === T && (L -= g)) : F.multiple && (N = !0, L -= g), L += g) : F.multiple ? N && (L += g, E -= g, N = !1) : S === B ? B = void 0 : F.optional && (L += g, E -= g), E += g) : (r && !this.isEager() && A[p](k), S === k && !this.isEager() ? E += g : B = k, this.isEager() || (L += g)), this.isEager())
        for (; w(L) && (c[s.charAt(L)] == null || u.includes(L)); )
          r ? A[p](s.charAt(L)) : s.charAt(L) === a.charAt(E) && (E += g), L += g;
    }
    return this.memo.set(i, A.join("")), this.memo.get(i);
  }
}
const Wv = (e) => JSON.parse(e.replaceAll("'", '"')), Mf = (e, a = {}) => {
  const t = { ...a };
  return e.dataset.maska != null && e.dataset.maska !== "" && (t.mask = jD(e.dataset.maska)), e.dataset.maskaEager != null && (t.eager = Ou(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (t.reversed = Ou(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (t.tokensReplace = Ou(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (t.tokens = KD(e.dataset.maskaTokens)), t;
}, Ou = (e) => e !== "" ? !!JSON.parse(e) : !0, jD = (e) => e.startsWith("[") && e.endsWith("]") ? Wv(e) : e, KD = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Wv(e);
  const a = {};
  return e.split("|").forEach((t) => {
    const r = t.split(":");
    a[r[0]] = {
      pattern: new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), a;
};
class JD {
  constructor(a, t = {}) {
    gi(this, "items", /* @__PURE__ */ new Map()), gi(this, "beforeinputEvent", (r) => {
      const i = r.target, s = this.items.get(i);
      s.isEager() && "inputType" in r && r.inputType.startsWith("delete") && s.unmasked(i.value).length <= 1 && this.setMaskedValue(i, "");
    }), gi(this, "inputEvent", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && r.detail != null && typeof r.detail == "object" && "masked" in r.detail)
        return;
      const i = r.target, s = this.items.get(i), u = i.value, A = i.selectionStart, c = i.selectionEnd;
      let g = u;
      if (s.isEager()) {
        const p = s.masked(u), v = s.unmasked(u);
        v === "" && "data" in r && r.data != null ? g = r.data : v !== s.unmasked(p) && (g = v);
      }
      if (this.setMaskedValue(i, g), "inputType" in r && (r.inputType.startsWith("delete") || A != null && A < u.length))
        try {
          i.setSelectionRange(A, c);
        } catch {
        }
    }), this.options = t, typeof a == "string" ? this.init(
      Array.from(document.querySelectorAll(a)),
      this.getMaskOpts(t)
    ) : this.init(
      "length" in a ? Array.from(a) : [a],
      this.getMaskOpts(t)
    );
  }
  destroy() {
    for (const a of this.items.keys())
      a.removeEventListener("input", this.inputEvent), a.removeEventListener("beforeinput", this.beforeinputEvent);
    this.items.clear();
  }
  needUpdateOptions(a, t) {
    const r = this.items.get(a), i = new Of(Mf(a, this.getMaskOpts(t)));
    return JSON.stringify(r.opts) !== JSON.stringify(i.opts);
  }
  needUpdateValue(a) {
    const t = a.dataset.maskaValue;
    return t == null && a.value !== "" || t != null && t !== a.value;
  }
  getMaskOpts(a) {
    const { onMaska: t, preProcess: r, postProcess: i, ...s } = a;
    return s;
  }
  init(a, t) {
    for (const r of a) {
      const i = new Of(Mf(r, t));
      this.items.set(r, i), r.value !== "" && this.setMaskedValue(r, r.value), r.addEventListener("input", this.inputEvent), r.addEventListener("beforeinput", this.beforeinputEvent);
    }
  }
  setMaskedValue(a, t) {
    const r = this.items.get(a);
    this.options.preProcess != null && (t = this.options.preProcess(t));
    const i = r.masked(t), s = r.unmasked(r.isEager() ? i : t), u = r.completed(t), A = { masked: i, unmasked: s, completed: u };
    t = i, this.options.postProcess != null && (t = this.options.postProcess(t)), a.value = t, a.dataset.maskaValue = t, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((c) => c(A)) : this.options.onMaska(A)), a.dispatchEvent(new CustomEvent("maska", { detail: A })), a.dispatchEvent(new CustomEvent("input", { detail: A }));
  }
}
const sA = /* @__PURE__ */ new WeakMap(), _D = (e) => {
  setTimeout(() => {
    var a;
    ((a = sA.get(e)) == null ? void 0 : a.needUpdateValue(e)) === !0 && e.dispatchEvent(new CustomEvent("input"));
  });
}, hi = (e, a) => {
  const t = e instanceof HTMLInputElement ? e : e.querySelector("input"), r = { ...a.arg };
  if (t == null || (t == null ? void 0 : t.type) === "file")
    return;
  _D(t);
  const i = sA.get(t);
  if (i != null) {
    if (!i.needUpdateOptions(t, r))
      return;
    i.destroy();
  }
  if (a.value != null) {
    const s = a.value, u = (A) => {
      s.masked = A.masked, s.unmasked = A.unmasked, s.completed = A.completed;
    };
    r.onMaska = r.onMaska == null ? u : Array.isArray(r.onMaska) ? [...r.onMaska, u] : [r.onMaska, u];
  }
  sA.set(t, new JD(t, r));
}, $D = ["for"], eB = {
  key: 0,
  class: "container__hint hint"
}, tB = {
  key: 0,
  class: "hint__label"
}, nB = {
  key: 2,
  class: "hint__icon-required icon-required"
}, aB = {
  key: 3,
  class: "hint__counter"
}, rB = {
  key: 0,
  class: "input-block__icon-left"
}, lB = ["id", "data-maska", "data-maska-tokens", "data-maska-reversed", "type", "placeholder", "disabled", "maxlength", "enterkeyhint", "inputmode", "name", "readonly"], iB = {
  key: 0,
  class: "input-block__unit"
}, oB = {
  key: 1,
  class: "input-block__wrapper"
}, sB = {
  key: 2,
  class: "input-block__wrapper"
}, uB = {
  key: 0,
  class: "ui-input__error-message"
}, AB = {
  key: 1,
  class: "ui-input__hint-message"
}, dB = /* @__PURE__ */ We({
  name: "UiInput",
  __name: "UiInput",
  props: {
    size: {
      type: String,
      default: "m"
    },
    modelValue: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    resetButton: {
      type: Boolean,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    unit: {
      type: String,
      default: "",
      validator: (e) => e.length >= 1 && e.length <= 10
    },
    labelTooltip: {
      type: String,
      required: !1
    },
    mask: {
      type: [String, Array, Object, null, Array, void 0],
      required: !1
    },
    maskTokens: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    dataMaskaReversed: {
      type: Boolean,
      default: !1
    },
    maskaOptions: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    enterKeyHint: {
      type: String,
      default: "enter"
    },
    inputMode: {
      type: String,
      default: "text"
    },
    name: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    variant: {
      type: String,
      default: "stroke"
    },
    customMobileTooltip: {
      type: Boolean,
      default: !1
    },
    customMobileTooltipWidth: {
      type: Number,
      default: 1023
    }
  },
  emits: [
    "update:modelValue",
    "blur",
    "input",
    "focus",
    "tooltipClick"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = e, i = t, s = mn(), { width: u } = sa(), A = U(0), c = U(null), g = U(null), p = U(null), v = U(!1), m = {
      s: 14,
      m: 16,
      l: 18
    }, w = V(() => `${u.value <= 1023 ? m[r.size] - 2 : m[r.size]}px`), B = V(() => r.resetButton && r.modelValue.trim() !== ""), T = V(() => r.unit && N.value), L = V(() => (r.error || r.errorMessage.length > 0) && !r.disabled), E = V(() => B.value && r.modelValue !== ""), N = V({
      get() {
        return r.modelValue;
      },
      set(le) {
        i("update:modelValue", le);
      }
    }), k = V(() => N.value && r.unit ? { maxWidth: A.value } : { maxWidth: "100%" }), F = V(
      () => `${N.value.length}/${r.maxLength}`
    ), S = (le) => {
      const ve = le.target;
      i("input", ve.value);
    }, Q = () => {
      document.getElementById(r.inputId).focus();
    }, x = V(() => r.label || r.labelTooltip || r.required || r.counter), W = V(() => r.type === "password" ? v.value ? "text" : "password" : r.type), z = V(
      () => v.value ? F3 : Y3
    ), q = () => {
      if (r.unit && p.value) {
        const le = getComputedStyle(p.value), ve = document.createElement("span");
        ve.style.position = "absolute", ve.style.visibility = "hidden", ve.style.whiteSpace = "pre", ve.style.font = `${le.fontSize} ${le.fontFamily}`, ve.style.fontSize = w.value, ve.textContent = N.value || " ", document.body.appendChild(ve), A.value = `${ve.offsetWidth + 1}px`, document.body.removeChild(ve);
      }
    }, J = () => {
      r.type === "password" && (v.value = !v.value);
    };
    return st([N, () => r.unit], q), gv(() => {
      g.value && document.body.removeChild(g.value);
    }), a({
      focus: Q
    }), (le, ve) => (f(), y("div", {
      class: he(["ui-input", [
        `ui-input_size_${e.size}`,
        { "ui-input_disabled": e.disabled },
        { "ui-input_readonly": e.readonly },
        { "ui-input_error": L.value }
      ]])
    }, [
      X("label", {
        class: "ui-input__container",
        for: e.inputId
      }, [
        x.value ? (f(), y("span", eB, [
          e.label ? (f(), y("span", tB, we(e.label), 1)) : Y("", !0),
          e.labelTooltip ? (f(), ce(zi, {
            key: 1,
            class: "ui-tooltip",
            size: "m",
            label: e.labelTooltip,
            "custom-mobile-tooltip": e.customMobileTooltip,
            "custom-mobile-tooltip-width": e.customMobileTooltipWidth,
            onClick: ve[0] || (ve[0] = (R) => i("tooltipClick"))
          }, {
            icon: ue(() => [
              fe(le.$slots, "tooltip-icon", {}, () => [
                Ce(b(wa))
              ], !0)
            ]),
            _: 3
          }, 8, ["label", "custom-mobile-tooltip", "custom-mobile-tooltip-width"])) : Y("", !0),
          e.required ? (f(), y("span", nB)) : Y("", !0),
          e.counter ? (f(), y("span", aB, we(F.value), 1)) : Y("", !0)
        ])) : Y("", !0),
        X("span", {
          ref_key: "textArea",
          ref: c,
          class: he(["ui-input__input-block input-block", `input-block_${e.variant}`])
        }, [
          b(s).hasOwnProperty("icon-left") ? (f(), y("span", rB, [
            fe(le.$slots, "icon-left", {}, void 0, !0)
          ])) : Y("", !0),
          X("span", {
            ref_key: "textArea",
            ref: c,
            class: "ui-input__input-wrapper input-wrapper"
          }, [
            cn(X("input", {
              id: e.inputId,
              ref_key: "inputElement",
              ref: p,
              "onUpdate:modelValue": ve[1] || (ve[1] = (R) => N.value = R),
              class: "input-block__input input",
              "data-maska": e.mask,
              "data-maska-tokens": e.maskTokens,
              "data-maska-reversed": e.dataMaskaReversed,
              type: W.value,
              placeholder: e.placeholder,
              disabled: e.disabled,
              maxlength: e.maxLength,
              style: Tt(k.value),
              enterkeyhint: e.enterKeyHint,
              inputmode: e.inputMode,
              name: e.name,
              readonly: e.readonly,
              onBlur: ve[2] || (ve[2] = (R) => i("blur")),
              onInput: S
            }, null, 44, lB), [
              [mw, N.value],
              [b(hi), void 0, e.maskaOptions]
            ]),
            T.value ? (f(), y("span", iB, we(e.unit), 1)) : Y("", !0)
          ], 512),
          e.type === "password" ? (f(), y("span", oB, [
            X("button", {
              type: "button",
              class: "input-block__button button",
              onClick: J
            }, [
              (f(), ce(Dt(z.value), { class: "button__show" }))
            ])
          ])) : (f(), y("span", sB, [
            E.value ? (f(), y("button", {
              key: 0,
              type: "button",
              class: "input-block__button button",
              onClick: ve[3] || (ve[3] = (R) => N.value = "")
            }, [
              Ce(b(Oi), { class: "button__icon" })
            ])) : Y("", !0)
          ]))
        ], 2)
      ], 8, $D),
      L.value ? (f(), y("p", uB, we(e.errorMessage), 1)) : Y("", !0),
      e.hintMessage && !L.value ? (f(), y("p", AB, we(e.hintMessage), 1)) : Y("", !0)
    ], 2));
  }
});
const yr = /* @__PURE__ */ je(dB, [["__scopeId", "data-v-a4dbdca5"]]), cB = ["target", "href"], fB = /* @__PURE__ */ We({
  __name: "UiLink",
  props: {
    link: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    target: {
      type: String,
      default: "_blank"
    }
  },
  setup(e) {
    return (a, t) => (f(), y("a", {
      class: "ui-link",
      target: e.target,
      href: e.link
    }, we(e.label), 9, cB));
  }
});
const e6 = /* @__PURE__ */ je(fB, [["__scopeId", "data-v-afee7b27"]]), vB = ["id"], pB = { class: "ui-notification__info" }, gB = { key: 0 }, hB = { key: 1 }, mB = /* @__PURE__ */ We({
  name: "UiNotification",
  __name: "UiNotification",
  props: {
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    size: {
      type: String,
      default: "m"
    },
    type: {
      type: String,
      default: "neutral"
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  setup(e) {
    const a = e, t = {
      neutral: wa,
      info: wa,
      warning: Tv,
      success: Dv,
      error: Cv
    }, r = V(() => t[a.type]);
    return (i, s) => (f(), y("div", {
      id: e.id,
      class: he(["ui-notification", [`ui-notification_${e.type}`, `ui-notification_size_${e.size}`]])
    }, [
      (f(), ce(Dt(r.value))),
      X("div", pB, [
        e.title ? (f(), y("h5", gB, we(e.title), 1)) : Y("", !0),
        e.text ? (f(), y("p", hB, we(e.text), 1)) : Y("", !0),
        fe(i.$slots, "default", {}, void 0, !0)
      ]),
      e.showClose ? (f(), y("button", {
        key: 0,
        type: "button",
        "aria-label": "close",
        onClick: s[0] || (s[0] = (u) => i.$emit("close"))
      }, [
        Ce(b(tl))
      ])) : Y("", !0)
    ], 10, vB));
  }
});
const t6 = /* @__PURE__ */ je(mB, [["__scopeId", "data-v-d50a6714"]]), yB = ["name", "value", "checked", "disabled"], bB = {
  key: 0,
  class: "ui-radio__error-message"
}, wB = /* @__PURE__ */ We({
  name: "UiRadioButton",
  __name: "UiRadioButton",
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    resizeTextType: {
      type: String,
      default: "hug"
    },
    name: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = (s) => {
      if (s && "target" in s) {
        const u = s.target;
        r("update:modelValue", t.value ? u.value : t.label);
      } else
        console.error("Event или event.target равны null или undefined");
    };
    return (s, u) => (f(), y(Qe, null, [
      X("div", {
        class: he(["ui-radio", `ui-radio_size_${e.size}`])
      }, [
        X("label", {
          class: he(["ui-radio__label label", [
            {
              label_disabled: e.disabled,
              label_error: e.error || e.errorMessage
            }
          ]])
        }, [
          X("input", {
            type: "radio",
            name: e.name,
            value: e.value,
            checked: e.modelValue === e.value,
            disabled: e.disabled,
            onChange: i
          }, null, 40, yB),
          u[0] || (u[0] = X("span", { class: "label__checkmark" }, null, -1)),
          e.label ? (f(), y("span", {
            key: 0,
            class: he([`label__resize-text_${e.resizeTextType}`, "label__text"])
          }, we(e.label), 3)) : Y("", !0)
        ], 2)
      ], 2),
      e.errorMessage ? (f(), y("p", bB, we(e.errorMessage), 1)) : Y("", !0)
    ], 64));
  }
});
const n6 = /* @__PURE__ */ je(wB, [["__scopeId", "data-v-71a7046c"]]), CB = {
  key: 0,
  class: "ui-segments__header header"
}, DB = {
  key: 0,
  class: "header__label"
}, BB = { class: "ui-segments__segments segments" }, TB = ["onClick"], xB = { class: "segment__title" }, PB = /* @__PURE__ */ We({
  name: "UiSegmentedControl",
  __name: "UiSegmentedControl",
  props: {
    segments: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "m"
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = (u) => {
      r("update:modelValue", u);
    }, s = V(() => t.label !== "" || t.hint !== "");
    return (u, A) => (f(), y("div", {
      class: he(["ui-segments", `ui-segments__size_${t.size}`])
    }, [
      s.value ? (f(), y("div", CB, [
        e.label ? (f(), y("span", DB, we(e.label), 1)) : Y("", !0),
        e.hint ? (f(), ce(ls, {
          key: 1,
          class: "header__hint",
          "hint-content": e.hint
        }, {
          default: ue(() => [
            Ce(b(wa), {
              size: e.size,
              class: "info"
            }, null, 8, ["size"])
          ]),
          _: 1
        }, 8, ["hint-content"])) : Y("", !0)
      ])) : Y("", !0),
      X("div", BB, [
        (f(!0), y(Qe, null, tt(e.segments, (c) => (f(), y("button", {
          key: c.id,
          type: "button",
          class: he(["segments__segment segment", {
            segment_selected: c.id === e.modelValue
          }]),
          onClick: (g) => i(c.id)
        }, [
          c.icon ? (f(), ce(Dt(c.icon), { key: 0 })) : Y("", !0),
          X("span", xB, we(c.title), 1)
        ], 10, TB))), 128))
      ])
    ], 2));
  }
});
const a6 = /* @__PURE__ */ je(PB, [["__scopeId", "data-v-f7519607"]]), kB = {}, OB = { class: "options-search__icon-container icon-container" };
function MB(e, a) {
  return f(), y("div", OB, a[0] || (a[0] = [
    X("span", { class: "icon-container__icon-loading icon-loader" }, null, -1)
  ]));
}
const zf = /* @__PURE__ */ je(kB, [["render", MB]]), zB = {
  key: 0,
  class: "ui-dropdown__input"
}, IB = {
  key: 0,
  class: "options__list"
}, EB = {
  key: 1,
  class: "ui-dropdown-options-loading options-search"
}, LB = {
  key: 2,
  class: "ui-dropdown__empty"
}, NB = /* @__PURE__ */ We({
  __name: "DropdownOptions",
  props: {
    dropdownOptions: {
      type: Array,
      default: () => []
    },
    showInput: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["selectItem"],
  setup(e) {
    const a = e, t = V(() => a.dropdownOptions.some((r) => r == null ? void 0 : r.title) ? "ui-dropdown-options_labels" : "ui-dropdown-options");
    return (r, i) => (f(), y("div", {
      id: "ui-dropdown-options",
      class: he(["options ui-dropdown-options_input", t.value])
    }, [
      e.showInput ? (f(), y("div", zB, [
        fe(r.$slots, "input", {}, void 0, !0)
      ])) : Y("", !0),
      e.dropdownOptions.length ? (f(), y(Qe, { key: 1 }, [
        a.loading ? e.loading ? (f(), y("div", EB, [
          fe(r.$slots, "loading", {}, void 0, !0)
        ])) : Y("", !0) : (f(), y("div", IB, [
          fe(r.$slots, "header-list", {}, void 0, !0),
          fe(r.$slots, "list", {}, void 0, !0)
        ]))
      ], 64)) : (f(), y("p", LB, [
        fe(r.$slots, "error", {}, void 0, !0)
      ]))
    ], 2));
  }
});
const Mu = /* @__PURE__ */ je(NB, [["__scopeId", "data-v-154aa817"]]), YB = {}, SB = { class: "dropdown-options-empty" };
function VB(e, a) {
  return f(), y("div", SB, [
    fe(e.$slots, "empty-list")
  ]);
}
const zu = /* @__PURE__ */ je(YB, [["render", VB]]), WB = { class: "ui-dropdown__options-search options-search" }, XB = {
  key: 0,
  class: "options__list"
}, QB = {
  key: 0,
  class: "search-result__item-notification"
}, HB = /* @__PURE__ */ We({
  __name: "DropdownOptionsSearch",
  props: {
    searchOptions: {
      type: Array,
      default: () => []
    },
    showInput: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number],
      default: ""
    },
    error: {
      type: Boolean,
      required: !1
    }
  },
  emits: ["selectItem"],
  setup(e) {
    const a = e, t = V(
      () => a.searchOptions.length === 0 || a.error
    );
    return (r, i) => (f(), y("div", WB, [
      fe(r.$slots, "loading"),
      a.loading ? Y("", !0) : (f(), y("div", XB, [
        fe(r.$slots, "header-list"),
        fe(r.$slots, "search-list"),
        t.value ? (f(), y("div", QB, [
          fe(r.$slots, "error")
        ])) : Y("", !0)
      ]))
    ]));
  }
});
function Ai(e) {
  var a;
  const t = Vt(e);
  return (a = t == null ? void 0 : t.$el) != null ? a : t;
}
const Xv = Mi ? window : void 0;
function So(...e) {
  let a, t, r, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, r, i] = e, a = Xv) : [a, t, r, i] = e, !a)
    return hn;
  Array.isArray(t) || (t = [t]), Array.isArray(r) || (r = [r]);
  const s = [], u = () => {
    s.forEach((p) => p()), s.length = 0;
  }, A = (p, v, m, w) => (p.addEventListener(v, m, w), () => p.removeEventListener(v, m, w)), c = st(
    () => [Ai(a), Vt(i)],
    ([p, v]) => {
      if (u(), !p)
        return;
      const m = Pv(v) ? { ...v } : v;
      s.push(
        ...t.flatMap((w) => r.map((B) => A(p, w, B, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), g = () => {
    c(), u();
  };
  return Br(g), g;
}
let If = !1;
function Ef(e, a, t = {}) {
  const { window: r = Xv, ignore: i = [], capture: s = !0, detectIframe: u = !1 } = t;
  if (!r)
    return hn;
  El && !If && (If = !0, Array.from(r.document.body.children).forEach((m) => m.addEventListener("click", hn)), r.document.documentElement.addEventListener("click", hn));
  let A = !0;
  const c = (m) => i.some((w) => {
    if (typeof w == "string")
      return Array.from(r.document.querySelectorAll(w)).some((B) => B === m.target || m.composedPath().includes(B));
    {
      const B = Ai(w);
      return B && (m.target === B || m.composedPath().includes(B));
    }
  }), p = [
    So(r, "click", (m) => {
      const w = Ai(e);
      if (!(!w || w === m.target || m.composedPath().includes(w))) {
        if (m.detail === 0 && (A = !c(m)), !A) {
          A = !0;
          return;
        }
        a(m);
      }
    }, { passive: !0, capture: s }),
    So(r, "pointerdown", (m) => {
      const w = Ai(e);
      A = !c(m) && !!(w && !m.composedPath().includes(w));
    }, { passive: !0 }),
    u && So(r, "blur", (m) => {
      setTimeout(() => {
        var w;
        const B = Ai(e);
        ((w = r.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(B != null && B.contains(r.document.activeElement)) && a(m);
      }, 0);
    })
  ].filter(Boolean);
  return () => p.forEach((m) => m());
}
const Lf = {
  [Bf.mounted](e, a) {
    const t = !a.modifiers.bubble;
    if (typeof a.value == "function")
      e.__onClickOutside_stop = Ef(e, a.value, { capture: t });
    else {
      const [r, i] = a.value;
      e.__onClickOutside_stop = Ef(e, r, Object.assign({ capture: t }, i));
    }
  },
  [Bf.unmounted](e) {
    e.__onClickOutside_stop();
  }
};
function Iu(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function Qv(e) {
  const a = window.getComputedStyle(e);
  if (a.overflowX === "scroll" || a.overflowY === "scroll" || a.overflowX === "auto" && e.clientWidth < e.scrollWidth || a.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !t || t.tagName === "BODY" ? !1 : Qv(t);
  }
}
function FB(e) {
  const a = e || window.event, t = a.target;
  return Qv(t) ? !1 : a.touches.length > 1 ? !0 : (a.preventDefault && a.preventDefault(), !1);
}
const Eu = /* @__PURE__ */ new WeakMap();
function qB(e, a = !1) {
  const t = U(a);
  let r = null, i = "";
  st(Ov(e), (A) => {
    const c = Iu(Vt(A));
    if (c) {
      const g = c;
      if (Eu.get(g) || Eu.set(g, g.style.overflow), g.style.overflow !== "hidden" && (i = g.style.overflow), g.style.overflow === "hidden")
        return t.value = !0;
      if (t.value)
        return g.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const s = () => {
    const A = Iu(Vt(e));
    !A || t.value || (El && (r = So(
      A,
      "touchmove",
      (c) => {
        FB(c);
      },
      { passive: !1 }
    )), A.style.overflow = "hidden", t.value = !0);
  }, u = () => {
    const A = Iu(Vt(e));
    !A || !t.value || (El && (r == null || r()), A.style.overflow = i, Eu.delete(A), t.value = !1);
  };
  return Br(u), V({
    get() {
      return t.value;
    },
    set(A) {
      A ? s() : u();
    }
  });
}
function UB() {
  let e = !1;
  const a = U(!1);
  return (t, r) => {
    if (a.value = r.value, e)
      return;
    e = !0;
    const i = qB(t, r.value);
    st(a, (s) => i.value = s);
  };
}
UB();
const RB = ["id"], ZB = {
  key: 0,
  class: "ui-bottom-sheet__custom-header custom-header"
}, GB = { class: "custom-header__info" }, jB = { key: 0 }, KB = { key: 1 }, JB = {
  key: 0,
  class: "custom-header__action"
}, _B = {
  key: 1,
  class: "ui-bottom-sheet__header"
}, $B = { key: 0 }, eT = { key: 1 }, tT = {
  key: 2,
  class: "content-header"
}, nT = {
  key: 4,
  class: "ui-bottom-sheet__footer"
}, aT = /* @__PURE__ */ We({
  name: "UiBottomSheet",
  __name: "UiBottomSheet",
  props: {
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    maxHeight: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    actionHeader: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close", "initRef"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = U(!1), s = U(null), u = U(null), A = U("0"), c = U(1), g = document.body, p = DA(g), { height: v } = sa(), { isScrolling: m } = mD(u), { lengthY: w, direction: B } = DD(s, {
      passive: !0,
      onSwipe() {
        if (B.value === "down" && !m.value) {
          const N = Math.abs(w.value);
          A.value = `-${N}px`, c.value = 1.25 - N / v.value;
        } else
          A.value = "0", c.value = 1;
      },
      onSwipeEnd() {
        w.value < 0 && v.value && Math.abs(w.value) / v.value >= 0.5 ? (A.value = "0", c.value = 1, L()) : (A.value = "0", c.value = 1);
      }
    }), T = mn(), L = () => {
      i.value = !1, Bt(() => r("close", !1));
    }, E = V(() => `height: ${t.maxHeight ? "calc(100vh - 200px)" : "auto"}`);
    return bt(() => {
      p.value = !0, i.value = !0;
    }), (N, k) => (f(), ce(rl, { to: "body" }, [
      Ce(Jn, {
        appear: "",
        name: "bottom-sheet"
      }, {
        default: ue(() => [
          i.value ? (f(), y("div", {
            key: 0,
            id: e.id,
            ref: (F) => {
              N.$emit("initRef", F);
            },
            class: "ui-bottom-sheet",
            onClick: _t(L, ["prevent"])
          }, [
            X("div", {
              ref_key: "container",
              ref: s,
              style: Tt({
                bottom: A.value,
                opacity: c.value
              }),
              class: he({ custom: e.actionHeader }),
              onClick: k[0] || (k[0] = _t(() => {
              }, ["stop"]))
            }, [
              e.actionHeader ? Y("", !0) : (f(), y("button", {
                key: 0,
                type: "button",
                class: "close-button close-button_fixed",
                onClick: L
              }, [
                Ce(b(tl))
              ])),
              e.hideHeader ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                e.actionHeader ? (f(), y("div", ZB, [
                  X("button", {
                    type: "button",
                    class: "close-button",
                    onClick: L
                  }, [
                    Ce(b(tl))
                  ]),
                  X("div", GB, [
                    e.title ? (f(), y("h5", jB, we(e.title), 1)) : Y("", !0),
                    e.subtitle ? (f(), y("p", KB, we(e.subtitle), 1)) : Y("", !0)
                  ]),
                  T.hasOwnProperty("header-action") ? (f(), y("div", JB, [
                    fe(N.$slots, "header-action", {}, void 0, !0)
                  ])) : Y("", !0)
                ])) : (f(), y("div", _B, [
                  e.title ? (f(), y("h5", $B, we(e.title), 1)) : Y("", !0),
                  e.subtitle ? (f(), y("p", eT, we(e.subtitle), 1)) : Y("", !0)
                ]))
              ], 64)),
              T.hasOwnProperty("content-header") ? (f(), y("div", tT, [
                fe(N.$slots, "content-header", {}, void 0, !0)
              ])) : Y("", !0),
              T.hasOwnProperty("content") ? (f(), y("div", {
                key: 3,
                ref_key: "content",
                ref: u,
                style: Tt(E.value),
                class: "ui-bottom-sheet__content"
              }, [
                fe(N.$slots, "content", {}, void 0, !0)
              ], 4)) : Y("", !0),
              T.hasOwnProperty("footer") ? (f(), y("div", nT, [
                fe(N.$slots, "footer", {}, void 0, !0)
              ])) : Y("", !0)
            ], 6)
          ], 8, RB)) : Y("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
const is = /* @__PURE__ */ je(aT, [["__scopeId", "data-v-08448eed"]]), rT = {
  key: 0,
  class: "label__checkbox"
}, lT = ["checked"], iT = { class: "label__content" }, oT = {
  key: 1,
  class: "label__selected"
}, sT = /* @__PURE__ */ We({
  name: "UiDropdownItem",
  __name: "UiDropdownItem",
  props: {
    type: {
      type: String,
      default: "default"
    },
    icon: {
      type: Object,
      default: null
    },
    selected: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const a = e, t = V(() => a.icon && a.type === "default"), r = V(() => a.selected && (a.type === "default" || a.type === "search")), i = V(() => a.type === "multiple" || a.type === "color");
    return (s, u) => (f(), y("div", {
      class: he(["ui-dropdown-item", { "ui-dropdown-item_active": e.selected }])
    }, [
      X("label", {
        class: he(["ui-dropdown-item__label label", `label__type_${a.type}`])
      }, [
        i.value ? (f(), y("span", rT, [
          X("input", {
            type: "checkbox",
            checked: e.selected
          }, null, 8, lT),
          e.selected ? (f(), ce(b(Il), {
            key: 0,
            class: "done"
          })) : Y("", !0)
        ])) : Y("", !0),
        X("span", iT, [
          t.value ? (f(), ce(Dt(e.icon), {
            key: 0,
            class: "label__icon"
          })) : Y("", !0),
          a.type === "color" ? (f(), y("span", {
            key: 1,
            style: Tt({ background: e.color }),
            class: "label__color"
          }, null, 4)) : Y("", !0),
          $t(" " + we(e.title), 1)
        ]),
        r.value ? (f(), y("span", oT, [
          Ce(b(Il), { class: "done" })
        ])) : Y("", !0)
      ], 2)
    ], 2));
  }
});
const Lu = /* @__PURE__ */ je(sT, [["__scopeId", "data-v-d29e4858"]]);
var Vo = /* @__PURE__ */ ((e) => (e.TOP = "top", e.TOP_START = "top-start", e.TOP_END = "top-end", e.BOTTOM = "bottom", e.BOTTOM_START = "bottom-start", e.BOTTOM_END = "bottom-end", e.RIGHT = "right", e.RIGHT_START = "right-start", e.RIGHT_END = "right-end", e.LEFT = "left", e.LEFT_START = "left-start", e.LEFT_END = "left-end", e))(Vo || {});
const uT = () => {
  const a = sa();
  return {
    HELPER_SIZE: 16,
    WINDOWS_SIZE: a,
    CLASSES: [
      "POSITION_TOP-CENTER",
      "POSITION_TOP-RIGHT",
      "POSITION_RIGHT-TOP",
      "POSITION_RIGHT-CENTER",
      "POSITION_RIGHT-BOTTOM",
      "POSITION_BOTTOM-RIGHT",
      "POSITION_BOTTOM-CENTER",
      "POSITION_BOTTOM-LEFT",
      "POSITION_LEFT-BOTTOM",
      "POSITION_LEFT-CENTER",
      "POSITION_LEFT-TOP",
      "POSITION_TOP-LEFT"
    ],
    POSITION: Vo,
    setPosition: (i) => {
      const {
        activatorPosition: s,
        dropPosition: u,
        ignorePosition: A = !1,
        side: c = "top",
        preferredPositions: g = Object.values(Vo),
        zIndex: p = 1e6,
        space: v = 16,
        preferredPositionsOnly: m = void 0
      } = i, w = (s == null ? void 0 : s.top) || 0, B = (s == null ? void 0 : s.left) || 0, T = (s == null ? void 0 : s.right) || 0, L = (s == null ? void 0 : s.bottom) || 0, E = (s == null ? void 0 : s.width) || 0, N = (s == null ? void 0 : s.height) || 0, k = (u == null ? void 0 : u.width) || 0, F = (u == null ? void 0 : u.height) || 0, S = (J) => J > 0 ? `${J}px` : "initial", Q = {
        top: () => ({
          top: S(w - F - v),
          left: S(T - (k / 2 + E / 2)),
          positionClass: "POSITION_TOP"
        }),
        "top-end": () => ({
          top: S(w - F - v),
          left: S(B - v / 2),
          positionClass: "POSITION_TOP_END"
        }),
        "right-start": () => ({
          top: S(w - F / 2),
          left: S(T + v),
          positionClass: "POSITION_RIGHT_START"
        }),
        right: () => ({
          top: S(L - F / 2 - N / 2),
          left: S(T + v),
          positionClass: "POSITION_RIGHT"
        }),
        "right-end": () => ({
          top: S(L - v - N / 2),
          left: S(T + v),
          positionClass: "POSITION_RIGHT_BOTTOM"
        }),
        "bottom-start": () => ({
          top: S(L + v),
          left: S(T - k + v / 2),
          positionClass: "POSITION_BOTTOM_START"
        }),
        bottom: () => ({
          top: S(L + v),
          left: S(T - (k / 2 + E / 2)),
          positionClass: "POSITION_BOTTOM"
        }),
        "bottom-end": () => ({
          top: S(L + v),
          left: S(B - v / 2),
          positionClass: "POSITION_BOTTOM_END"
        }),
        "left-end": () => ({
          top: S(L - v - N / 2),
          left: S(B - k - v),
          positionClass: "POSITION_LEFT_END"
        }),
        left: () => ({
          top: S(L - F / 2 - N / 2),
          left: S(B - k - v),
          positionClass: "POSITION_LEFT"
        }),
        "left-start": () => ({
          top: S(w - F / 2),
          left: S(B - k - v),
          positionClass: "POSITION_LEFT_START"
        }),
        "top-start": () => ({
          top: S(w - F - v),
          left: S(T - k + v / 2),
          positionClass: "POSITION_TOP_START"
        })
      }, x = (J) => {
        if (!J)
          return !1;
        const le = Q[J], { top: ve, left: R } = le();
        return ve !== "initial" && R !== "initial" && parseInt(ve.replace("px", "")) + F < a.height.value && parseInt(R.replace("px", "")) + k < a.width.value;
      }, W = () => Object.values(Vo);
      let z = c;
      if (!x(z)) {
        if (g && g.length > 0) {
          const J = g.find(
            (le) => x(le)
          );
          J && (z = J);
        }
        if (!x(z))
          if (m)
            z = m;
          else {
            const J = W();
            for (let le = 0; le < J.length; le++)
              if (x(J[le])) {
                z = J[le];
                break;
              }
          }
      }
      const q = Q[z]();
      return A && (q.positionClass = "POSITION_BOTTOM"), { ...q, zIndex: p };
    }
  };
}, AT = {
  key: 0,
  class: "item__title"
}, dT = ["onClick"], cT = {
  key: 0,
  class: "ui-dropdown__input"
}, fT = { key: 0 }, vT = {
  key: 0,
  class: "item__title"
}, pT = /* @__PURE__ */ We({
  name: "UiDropdown",
  __name: "UiDropdown",
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: ""
    },
    mobileTitle: {
      type: String,
      default: null
    },
    mobileMaxHeight: {
      type: Boolean,
      default: !1
    },
    mobileSubtitle: {
      type: String,
      default: null
    },
    mobileHeaderAction: {
      type: Boolean,
      default: !1
    },
    hideMobileHeader: {
      type: Boolean,
      default: !1
    },
    parentId: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "l"
    },
    dropdownOptions: {
      type: Array,
      default: () => []
    },
    showInput: {
      type: Boolean,
      default: !1
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    dropdownType: {
      type: String,
      default: "default"
    },
    error: {
      type: Boolean,
      required: !1
    },
    placeholder: {
      type: String,
      default: "Поиск..."
    },
    loading: {
      type: Boolean,
      required: !1
    },
    scrollContainerId: {
      type: String,
      default: ""
    },
    isOpenUp: {
      type: Boolean,
      default: !1
    },
    isOutsideClose: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "controlOptions",
    "hideOptions",
    "initRef",
    "selectItem"
  ],
  setup(e, { emit: a }) {
    const t = e, r = a, i = V(
      () => document.getElementById(t.parentId) || null
    ), s = U(null), { WINDOWS_SIZE: u, POSITION: A, setPosition: c } = uT(), g = U({
      zIndex: 0,
      top: "0px",
      left: "0px",
      positionClass: ""
    }), p = () => {
      var x, W;
      if (!s.value || !i.value)
        return;
      const Q = {
        activatorPosition: (x = i.value) == null ? void 0 : x.getBoundingClientRect(),
        dropPosition: (W = s.value) == null ? void 0 : W.getBoundingClientRect(),
        preferredPositions: [A.TOP, A.BOTTOM],
        side: A.BOTTOM,
        zIndex: 1e3
      };
      g.value = c(Q);
    }, v = mn(), m = U(!1), w = U(window.innerHeight), B = U(""), T = V(() => u.width.value > 768 || t.dropdownType === "search"), L = V(() => t.error ? "Что-то пошло не так..." : "Ничего не найдено"), E = V(() => (Q) => Array.isArray(t.modelValue) ? t.modelValue.includes(Q) : Q === t.modelValue);
    st(w, () => {
      r("hideOptions");
    }), st(B, (Q) => {
      S(Q);
    }), st(
      () => t.isActive,
      () => {
        T.value && Bt(p);
      }
    );
    const N = (Q) => {
      const { dropdownType: x, modelValue: W } = t;
      if ((x === "multiple" || x === "color") && Array.isArray(W)) {
        const z = W.includes(Q) ? W.filter((q) => q !== Q) : [...W, Q];
        r("update:modelValue", z);
        return;
      }
      r("update:modelValue", Q), r("selectItem", Q), t.isActive && (m.value = !0, r("hideOptions"));
    }, k = V(() => ({
      empty: zu,
      default: Mu,
      multiple: Mu,
      color: Mu,
      error: zu,
      search: HB
    })[t.dropdownType] || zu), F = () => {
      t.isOutsideClose && t.isActive && (m.value = !0, r("hideOptions"));
    }, S = wA((Q) => {
      r("update:modelValue", Q);
    }, 300);
    return (Q, x) => T.value ? (f(), ce(rl, {
      key: 0,
      to: "body"
    }, [
      Ce(Jn, {
        name: "dropdown-fade",
        mode: "out-in"
      }, {
        default: ue(() => [
          T.value && e.isActive && i.value ? (f(), y("div", {
            key: 0,
            ref_key: "drop",
            ref: s,
            class: "ui-dropdown elevation-shadow-high",
            style: Tt(g.value)
          }, [
            cn((f(), ce(Dt(k.value), {
              "show-input": e.showInput,
              "model-value": e.modelValue,
              loading: e.loading,
              "dropdown-options": e.dropdownOptions,
              "search-options": e.searchOptions,
              error: e.error,
              onSelectItem: x[1] || (x[1] = (W) => N(W))
            }, Lt({
              list: ue(() => [
                (f(!0), y(Qe, null, tt(e.dropdownOptions, (W, z) => (f(), y("div", {
                  key: z,
                  class: "options__item item"
                }, [
                  W.title ? (f(), y("span", AT, we(W.title), 1)) : Y("", !0),
                  (f(!0), y(Qe, null, tt(W.options, (q, J) => (f(), y("div", { key: J }, [
                    Ce(Lu, {
                      id: q.optionId,
                      title: q.label,
                      selected: E.value(q.optionId),
                      type: e.dropdownType,
                      color: q.color,
                      onClick: _t((le) => N(q.optionId), ["prevent"])
                    }, null, 8, ["id", "title", "selected", "type", "color", "onClick"])
                  ]))), 128))
                ]))), 128))
              ]),
              "search-list": ue(() => [
                (f(!0), y(Qe, null, tt(e.searchOptions, (W) => (f(), y("div", {
                  key: W.id,
                  class: "options__item item",
                  onClick: _t((z) => N(W.id), ["stop"])
                }, [
                  Ce(Lu, Xt({ ref_for: !0 }, W, {
                    id: W.id,
                    title: W.option,
                    selected: W.option === e.modelValue
                  }), null, 16, ["id", "title", "selected"])
                ], 8, dT))), 128))
              ]),
              input: ue(() => [
                Ce(yr, {
                  modelValue: B.value,
                  "onUpdate:modelValue": x[0] || (x[0] = (W) => B.value = W),
                  "reset-button": "",
                  type: "text",
                  placeholder: "Поиск..."
                }, {
                  "icon-left": ue(() => [
                    Ce(b(pi))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              error: ue(() => [
                $t(we(L.value), 1)
              ]),
              _: 2
            }, [
              e.loading ? {
                name: "loading",
                fn: ue(() => [
                  Ce(b(zf))
                ]),
                key: "0"
              } : void 0,
              b(v).default ? {
                name: "empty-list",
                fn: ue(() => [
                  fe(Q.$slots, "default", {}, void 0, !0)
                ]),
                key: "1"
              } : void 0
            ]), 1064, ["show-input", "model-value", "loading", "dropdown-options", "search-options", "error"])), [
              [
                b(Lf),
                F,
                void 0,
                { bubble: !0 }
              ]
            ])
          ], 4)) : Y("", !0)
        ]),
        _: 3
      })
    ])) : e.isActive ? (f(), ce(is, {
      key: 1,
      title: e.mobileTitle,
      subtitle: e.mobileSubtitle,
      "action-header": e.mobileHeaderAction,
      "max-height": e.mobileMaxHeight,
      "hide-header": e.hideMobileHeader,
      onInitRef: x[5] || (x[5] = (W) => r("initRef", W)),
      onClose: x[6] || (x[6] = (W) => r("hideOptions"))
    }, Lt({
      "content-header": ue(() => [
        e.showInput ? (f(), y("div", cT, [
          Ce(yr, {
            modelValue: B.value,
            "onUpdate:modelValue": x[2] || (x[2] = (W) => B.value = W),
            "reset-button": "",
            size: "s",
            type: "text",
            placeholder: "Поиск..."
          }, {
            "icon-left": ue(() => [
              Ce(b(pi))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])) : fe(Q.$slots, "content-header", { key: 1 }, void 0, !0)
      ]),
      content: ue(() => [
        e.isActive ? (f(), y("div", fT, [
          cn((f(), ce(Dt(k.value), {
            "model-value": e.modelValue,
            loading: e.loading,
            "dropdown-options": e.dropdownOptions,
            "search-options": e.searchOptions,
            error: e.error,
            class: "asd",
            onSelectItem: x[4] || (x[4] = (W) => N(W))
          }, Lt({
            input: ue(() => [
              Ce(yr, {
                modelValue: B.value,
                "onUpdate:modelValue": x[3] || (x[3] = (W) => B.value = W),
                "reset-button": "",
                type: "text",
                placeholder: "Поиск..."
              }, {
                "icon-left": ue(() => [
                  Ce(b(pi))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            list: ue(() => [
              (f(!0), y(Qe, null, tt(e.dropdownOptions, (W, z) => (f(), y("div", {
                key: z,
                class: "options__item item"
              }, [
                W.title ? (f(), y("span", vT, we(W.title), 1)) : Y("", !0),
                (f(!0), y(Qe, null, tt(W.options, (q, J) => (f(), y("div", { key: J }, [
                  Ce(Lu, {
                    id: q.optionId,
                    title: q.label,
                    selected: E.value(q.optionId),
                    type: e.dropdownType,
                    color: q.color,
                    onClick: _t((le) => N(q.optionId), ["prevent"])
                  }, null, 8, ["id", "title", "selected", "type", "color", "onClick"])
                ]))), 128))
              ]))), 128))
            ]),
            error: ue(() => [
              $t(we(L.value), 1)
            ]),
            _: 2
          }, [
            b(v)["header-list"] ? {
              name: "header-list",
              fn: ue(() => [
                fe(Q.$slots, "header-list", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0,
            e.loading ? {
              name: "loading",
              fn: ue(() => [
                Ce(b(zf))
              ]),
              key: "1"
            } : void 0,
            b(v).default ? {
              name: "empty-list",
              fn: ue(() => [
                fe(Q.$slots, "default", {}, void 0, !0)
              ]),
              key: "2"
            } : void 0
          ]), 1064, ["model-value", "loading", "dropdown-options", "search-options", "error"])), [
            [
              b(Lf),
              F,
              void 0,
              { bubble: !0 }
            ]
          ])
        ])) : Y("", !0)
      ]),
      _: 2
    }, [
      b(v)["header-action"] ? {
        name: "header-action",
        fn: ue(() => [
          fe(Q.$slots, "header-action", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0,
      b(v).actions ? {
        name: "footer",
        fn: ue(() => [
          fe(Q.$slots, "actions", {}, void 0, !0)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["title", "subtitle", "action-header", "max-height", "hide-header"])) : Y("", !0);
  }
});
const Ii = /* @__PURE__ */ je(pT, [["__scopeId", "data-v-e4ec89ba"]]), gT = ["id"], hT = ["for"], mT = ["id", "placeholder", "disabled", "readonly"], yT = { class: "ui-select__bottom-sheet-input" }, bT = {
  key: 0,
  class: "ui-select__bottom-sheet-list"
}, wT = ["onClick"], CT = {
  key: 1,
  class: "ui-select__dropdown-empty-content",
  style: { padding: "14px 16px" }
}, DT = {
  key: 1,
  class: "ui-select__caption"
}, BT = /* @__PURE__ */ We({
  name: "UiSelect",
  __name: "UiSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    placeholder: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    scrollContainerId: {
      type: String,
      default: ""
    },
    isSearch: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: ["update:modelValue", "initRef"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = U(null), s = U(null), u = U(null), A = U(!1), c = U(""), g = U(null), p = U(""), v = U(""), m = U(1920), w = V(() => {
      if (p.value === g.value || p.value.length === 0 && v.value.length === 0)
        return t.options;
      const J = structuredClone(yw(t.options));
      return J.forEach((le) => {
        le.options = le.options.filter((ve) => ve.label.toLowerCase().includes(
          p.value.toLowerCase().length > 0 ? p.value.toLowerCase() : v.value.toLowerCase()
        ));
      }), J.filter((le) => le.options.length > 0);
    }), B = V(() => w.value.length > 0 ? "default" : "empty"), T = V(() => g.value === null ? t.placeholder : g.value.toString()), L = V(() => p.value !== "" && g.value === null), E = V(() => {
      let J = 0;
      return t.options.forEach((le) => {
        J += le.options.length;
      }), J < 15 || m.value < 769;
    });
    Ql(i, () => k(), {
      ignore: [s, u]
    }), st(A, () => {
      A.value ? x() : (v.value = "", Q());
    }), st(c, () => {
      const J = N(c.value);
      J && (p.value = J.label, g.value = J.label, r("update:modelValue", J.optionId), A.value = !1);
    }), ki(() => {
      var J;
      c.value === "" && ((J = t.modelValue) != null && J.toString()) && (c.value = t.modelValue);
    });
    function N(J) {
      let le = null;
      return t.options.find((ve) => {
        const R = ve.options.find((_) => _.optionId === J);
        R && (le = R);
      }), le;
    }
    function k() {
      A.value = !1;
    }
    function F() {
      t.disabled || (A.value = !A.value);
    }
    function S() {
      A.value === !1 && (A.value = !0);
    }
    function Q() {
      if (g.value === null) {
        p.value = "";
        return;
      }
      t.modelValue === c.value && (p.value = g.value.toString());
    }
    function x() {
      g.value !== null && !E.value && (p.value = "");
    }
    function W() {
      m.value = window.innerWidth;
    }
    function z(J) {
      s.value = J, r("initRef", J);
    }
    function q(J) {
      u.value = J, r("initRef", J);
    }
    return bt(() => {
      W(), Bt().then(() => {
        window.addEventListener("resize", W);
      });
    }), al(() => {
      Bt().then(() => {
        window.removeEventListener("resize", W);
      });
    }), (J, le) => (f(), y("div", {
      id: e.id,
      ref_key: "select",
      ref: i,
      class: he(["ui-select", [
        { "ui-select_disabled": e.disabled },
        { "ui-select_error": e.error },
        `ui-select_size_${e.size}`,
        `ui-select_${e.variant}`
      ]])
    }, [
      e.label ? (f(), y("label", {
        key: 0,
        for: e.inputId,
        class: "ui-select__label"
      }, we(e.label), 9, hT)) : Y("", !0),
      X("div", {
        class: "ui-select__content",
        onClick: F
      }, [
        cn(X("input", {
          id: e.inputId,
          "onUpdate:modelValue": le[0] || (le[0] = (ve) => p.value = ve),
          class: "ui-select__input",
          placeholder: T.value,
          disabled: e.disabled,
          readonly: E.value,
          onInput: S
        }, null, 40, mT), [
          [
            ha,
            p.value,
            void 0,
            { trim: !0 }
          ]
        ]),
        L.value ? (f(), y("button", {
          key: 1,
          class: "ui-select__button-clear",
          type: "button",
          onClick: le[1] || (le[1] = _t((ve) => p.value = "", ["stop"]))
        }, [
          Ce(b(Oi), { class: "ui-select__icon-close" })
        ])) : (f(), ce(b(rs), {
          key: 0,
          class: he(["ui-select__icon-chevron-down", { "ui-select__icon-chevron-down_rotated": A.value }])
        }, null, 8, ["class"])),
        m.value > 768 ? (f(), ce(Ii, {
          key: 2,
          modelValue: c.value,
          "onUpdate:modelValue": le[2] || (le[2] = (ve) => c.value = ve),
          "parent-id": e.inputId,
          "is-active": A.value,
          "scroll-container-id": e.scrollContainerId,
          "dropdown-options": w.value,
          "dropdown-type": B.value,
          size: e.size,
          onInitRef: q
        }, {
          default: ue(() => le[5] || (le[5] = [
            X("div", { class: "ui-select__dropdown-empty-content" }, [
              X("p", null, "Ничего не найдено")
            ], -1)
          ])),
          _: 1
        }, 8, ["modelValue", "parent-id", "is-active", "scroll-container-id", "dropdown-options", "dropdown-type", "size"])) : A.value ? (f(), ce(is, {
          key: 3,
          title: e.placeholder,
          "is-search": e.isSearch,
          onInitRef: z,
          onClose: le[4] || (le[4] = (ve) => A.value = !1)
        }, Lt({
          content: ue(() => [
            w.value.length > 0 ? (f(), y("div", bT, [
              (f(!0), y(Qe, null, tt(w.value, (ve) => (f(), y("div", {
                key: ve.id,
                class: "ui-select__bottom-sheet-item"
              }, [
                (f(!0), y(Qe, null, tt(ve.options, (R) => (f(), y("button", {
                  key: R.optionId,
                  type: "button",
                  onClick: (_) => c.value = R.optionId
                }, we(R.label), 9, wT))), 128))
              ]))), 128))
            ])) : (f(), y("div", CT, le[6] || (le[6] = [
              X("p", null, "Ничего не найдено", -1)
            ])))
          ]),
          _: 2
        }, [
          e.isSearch ? {
            name: "content-header",
            fn: ue(() => [
              X("div", yT, [
                Ce(yr, {
                  modelValue: v.value,
                  "onUpdate:modelValue": le[3] || (le[3] = (ve) => v.value = ve),
                  placeholder: "Поиск",
                  size: "m",
                  "reset-button": !!v.value.length
                }, {
                  "icon-left": ue(() => [
                    Ce(b(pi))
                  ]),
                  _: 1
                }, 8, ["modelValue", "reset-button"])
              ])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["title", "is-search"])) : Y("", !0)
      ]),
      e.caption ? (f(), y("div", DT, [
        X("p", null, we(e.caption), 1)
      ])) : Y("", !0)
    ], 10, gT));
  }
});
const r6 = /* @__PURE__ */ je(BT, [["__scopeId", "data-v-c504d2b5"]]), TT = { class: "ui-text-button__label label" }, xT = /* @__PURE__ */ We({
  name: "UiTextButton",
  __name: "UiTextButton",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "l"
    },
    href: {
      type: String,
      required: !1
    },
    to: {
      type: Object,
      required: !1
    },
    target: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    download: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, t = V(() => a.href && !a.to ? "a" : !a.href && a.to ? "router-link" : "button");
    return (r, i) => (f(), ce(Dt(t.value), {
      href: e.href,
      download: e.download && e.href,
      disabled: e.disabled,
      to: e.to,
      target: e.target,
      class: he(["ui-text-button", [`ui-text-button_color_${e.color}`, `ui-text-button_size_${e.size}`]]),
      type: e.type
    }, {
      default: ue(() => [
        fe(r.$slots, "left", {}, void 0, !0),
        fe(r.$slots, "default", {}, () => [
          X("span", TT, we(e.label), 1)
        ], !0),
        fe(r.$slots, "right", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["href", "download", "disabled", "to", "target", "class", "type"]));
  }
});
const Zo = /* @__PURE__ */ je(xT, [["__scopeId", "data-v-895a32b9"]]), PT = /* @__PURE__ */ We({
  __name: "SelectChip",
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: !0
    },
    showIcon: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: ["remove"],
  setup(e, { emit: a }) {
    const t = e, r = a;
    return (i, s) => (f(), y("div", {
      class: he(["select-chip", [
        {
          "select-chip_disabled": t.disabled,
          "select-chip_small": t.small
        },
        `select-chip_${e.variant}`
      ]])
    }, [
      X("span", {
        class: "select-chip__text",
        style: Tt({ paddingRight: t.showIcon ? "3px" : "7px" })
      }, we(t.label), 5),
      e.showIcon ? (f(), y("div", {
        key: 0,
        class: "select-chip__button",
        onClick: s[0] || (s[0] = _t((u) => r("remove", e.id), ["stop"]))
      }, [
        Ce(b(tl), { class: "select-chip__icon" })
      ])) : Y("", !0)
    ], 2));
  }
});
const Po = /* @__PURE__ */ je(PT, [["__scopeId", "data-v-54ecbab4"]]), kT = ["id"], OT = ["for"], MT = {
  key: 1,
  class: "tooltip__icon-required icon-required"
}, zT = ["id"], IT = { class: "ui-multiple-select__content content" }, ET = { class: "content__chips_temp" }, LT = ["placeholder"], NT = { class: "ui-multiple-select__buttons" }, YT = { class: "ui-multiple-select__content content__chips_mobile" }, ST = { class: "ui-multiple-select__input" }, VT = {
  key: 1,
  class: "ui-multiple-select__caption"
}, WT = 30, XT = 0.95, QT = 10, HT = /* @__PURE__ */ We({
  name: "UiMultipleSelect",
  __name: "UiMultipleSelect",
  props: {
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    labelTooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    type: {
      type: String,
      default: "multiple"
    },
    placeholder: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    scrollContainerId: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: ["update:modelValue", "initRef", "hideOptions"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = mn(), { width: s } = sa(), u = U(null), A = U(null), c = U(!1), g = U(null), p = U(""), v = U(0), m = U(0), w = U(0), B = U(0), T = U([]), L = U([]), E = U(null), N = V(() => t.options.flatMap((Z) => Z.options)), k = V(() => {
      const ae = (p.value.length > 0 ? p.value : "").toLowerCase();
      return t.options.map((O) => ({
        ...O,
        options: O.options.filter(
          (ke) => ke.label.toLowerCase().includes(ae)
        )
      })).filter((O) => O.options.length > 0);
    }), F = V(() => `flex-wrap: ${c.value ? "wrap" : "nowrap"}`), S = V(() => le.value > 0 && !c.value && m.value > v.value), Q = V(() => T.value.length > 0 ? "" : g.value === null ? t.placeholder : g.value.toString()), x = V(
      () => (c.value || t.modelValue.length === 0) && s.value >= 768
    ), W = V(() => p.value !== "" && T.value.length > 0 && !t.disabled), z = V(() => `ui-multiple-select__wrapper${c.value ? "_active" : ""} ui-multiple-select__wrapper_${t.variant}`), q = V(() => {
      const Z = new Map(
        N.value.map((O) => [O.optionId, O])
      ), ae = t.modelValue.map((O) => Z.get(O)).filter((O) => O !== void 0);
      return !c.value && m.value > v.value ? ae.slice(0, B.value) : ae;
    }), J = V(() => {
      const Z = new Map(
        N.value.map((ae) => [ae.optionId, ae])
      );
      return t.modelValue.map((ae) => Z.get(ae)).filter((ae) => ae !== void 0);
    }), le = V(() => T.value.length - B.value), ve = V(() => {
      const ae = T.value.length === 0, O = ae ? "100%" : `${Math.min(w.value + 1, v.value)}px`, ke = c.value || ae ? "100%" : "0";
      return {
        width: O,
        maxHeight: ke
      };
    }), R = (Z) => {
      A.value = Z, r("initRef", Z);
    }, _ = () => {
      if (!p.value && T.value.length === 0) {
        w.value = v.value;
        return;
      }
      const Z = document.createElement("span"), ae = E.value;
      if (ae) {
        const O = getComputedStyle(ae);
        Z.style.visibility = "hidden", Z.style.whiteSpace = "pre", Z.style.position = "absolute", Z.style.font = `${O.fontSize} ${O.fontFamily}`;
      }
      Z.textContent = p.value || " ", document.body.appendChild(Z), w.value = Math.min(
        Z.offsetWidth + 1,
        v.value
      ), document.body.removeChild(Z);
    }, G = () => {
      var O;
      const Z = ((O = u.value) == null ? void 0 : O.querySelectorAll(".content__chips_temp > *")) || [];
      let ae = 0;
      B.value = 0, Array.from(Z).forEach((ke) => {
        const Ue = ke.offsetWidth;
        ae += Ue + QT, ae + WT + w.value <= v.value * XT && B.value++;
      }), m.value = ae;
    }, oe = (Z) => {
      r(
        "update:modelValue",
        t.modelValue.filter((ae) => ae !== Z)
      ), Bt(() => {
        G();
      });
    }, Oe = () => {
      pe(), Bt(() => {
        E.value && E.value.focus();
      });
    }, pe = () => {
      p.value = "", c.value = !0, r("hideOptions", c.value);
    }, $ = () => {
      c.value = !1, r("hideOptions", c.value);
    }, Me = () => {
      c.value = !c.value, r("hideOptions", c.value);
    }, me = () => {
      p.value = "", m.value = 0, T.value = [], G();
    }, te = () => {
      r("update:modelValue", L.value), c.value = !1, r("hideOptions", c.value);
    }, P = (Z) => {
      for (const ae of Z)
        v.value = ae.contentRect.width;
    };
    return st(
      () => t.isActive,
      (Z) => {
        Z || (p.value = "", L.value = t.modelValue), c.value = Z, r("hideOptions", c.value), Bt(() => {
          G(), _();
        });
      }
    ), st(p, () => {
      _();
    }), st(s, () => {
      G();
    }), st(T, () => {
      r("update:modelValue", T), G(), p.value = "";
    }), Ql(u, () => $(), {
      ignore: [A]
    }), hD(u, (Z) => {
      P(Z), _();
    }), bt(() => {
      c.value = t.isActive, L.value = t.modelValue, T.value = t.modelValue, s.value, Bt(() => {
        G(), _();
      });
    }), (Z, ae) => (f(), y("div", {
      id: e.id,
      class: he(["ui-multiple-select", [
        { "ui-multiple-select_disabled": t.disabled },
        { "ui-multiple-select_error": t.error },
        `ui-multiple-select_size_${t.size}`
      ]])
    }, [
      e.label ? (f(), y("label", {
        key: 0,
        for: e.inputId,
        class: "ui-multiple-select__label"
      }, [
        $t(we(e.label) + " ", 1),
        e.labelTooltip ? (f(), ce(zi, {
          key: 0,
          class: "ui-multiple-select__tooltip tooltip",
          size: "m",
          label: e.labelTooltip
        }, {
          icon: ue(() => [
            fe(Z.$slots, "tooltip-icon", {}, () => [
              Ce(b(wa), { class: "tooltip__icon" })
            ], !0)
          ]),
          _: 3
        }, 8, ["label"])) : Y("", !0),
        e.required ? (f(), y("span", MT)) : Y("", !0)
      ], 8, OT)) : Y("", !0),
      X("div", {
        id: e.inputId,
        ref_key: "multipleSelect",
        ref: u,
        class: he(z.value),
        onClick: Oe
      }, [
        X("span", IT, [
          X("span", {
            class: "content__chips",
            style: Tt(F.value)
          }, [
            X("span", ET, [
              (f(!0), y(Qe, null, tt(J.value, (O) => (f(), ce(b(Po), {
                id: O.optionId,
                key: O.optionId,
                small: e.size === "s",
                variant: e.variant,
                disabled: e.disabled,
                label: O.label,
                onRemove: ae[0] || (ae[0] = (ke) => oe(ke))
              }, null, 8, ["id", "small", "variant", "disabled", "label"]))), 128))
            ]),
            (f(!0), y(Qe, null, tt(q.value, (O) => (f(), ce(b(Po), {
              id: O.optionId,
              key: O.optionId,
              small: e.size === "s",
              variant: e.variant,
              disabled: e.disabled,
              label: O.label,
              onRemove: ae[1] || (ae[1] = (ke) => oe(ke))
            }, null, 8, ["id", "small", "variant", "disabled", "label"]))), 128)),
            S.value ? (f(), ce(b(Po), {
              key: 0,
              small: e.size === "s",
              variant: e.variant,
              disabled: e.disabled,
              "show-icon": !1,
              label: `+${le.value}`
            }, null, 8, ["small", "variant", "disabled", "label"])) : Y("", !0),
            x.value ? cn((f(), y("input", {
              key: 1,
              ref_key: "inputRef",
              ref: E,
              "onUpdate:modelValue": ae[2] || (ae[2] = (O) => p.value = O),
              class: "ui-multiple-select__input",
              style: Tt(ve.value),
              placeholder: Q.value
            }, null, 12, LT)), [
              [
                ha,
                p.value,
                void 0,
                { trim: !0 }
              ]
            ]) : Y("", !0)
          ], 4)
        ]),
        X("div", NT, [
          W.value ? (f(), y("button", {
            key: 0,
            type: "button",
            class: "ui-multiple-select__button button",
            onClick: _t(me, ["self"])
          }, [
            Ce(b(Oi), { class: "ui-multiple-select__icon-close" })
          ])) : Y("", !0),
          X("button", {
            type: "button",
            class: "ui-multiple-select__button button",
            onClick: _t(Me, ["stop"])
          }, [
            Ce(b(rs), {
              class: he(["ui-multiple-select__icon-chevron-down", {
                "ui-multiple-select__icon-chevron-down_rotated": c.value
              }])
            }, null, 8, ["class"])
          ])
        ]),
        Ce(Ii, {
          modelValue: T.value,
          "onUpdate:modelValue": ae[5] || (ae[5] = (O) => T.value = O),
          "parent-id": e.inputId,
          "is-active": c.value,
          "scroll-container-id": e.scrollContainerId,
          "dropdown-options": k.value,
          "dropdown-type": e.type,
          "mobile-title": e.label,
          "mobile-header-action": "",
          "mobile-max-height": "",
          size: e.size,
          onHideOptions: te,
          onInitRef: R
        }, Lt({
          "header-list": ue(() => [
            X("span", YT, [
              (f(!0), y(Qe, null, tt(q.value, (O) => (f(), ce(b(Po), {
                id: O.optionId,
                key: O.optionId,
                small: e.size === "s",
                disabled: e.disabled,
                label: O.label,
                onRemove: ae[3] || (ae[3] = (ke) => oe(ke))
              }, null, 8, ["id", "small", "disabled", "label"]))), 128))
            ])
          ]),
          "content-header": ue(() => [
            X("div", ST, [
              Ce(yr, {
                modelValue: p.value,
                "onUpdate:modelValue": ae[4] || (ae[4] = (O) => p.value = O),
                variant: e.variant,
                placeholder: Q.value,
                size: "s",
                "reset-button": !!p.value.length
              }, {
                "icon-left": ue(() => [
                  Ce(b(pi))
                ]),
                _: 1
              }, 8, ["modelValue", "variant", "placeholder", "reset-button"])
            ])
          ]),
          "header-action": ue(() => [
            e.modelValue.length > 0 ? (f(), ce(Zo, {
              key: 0,
              label: "Сбросить",
              size: "m",
              onClick: me
            })) : Y("", !0)
          ]),
          default: ue(() => [
            ae[6] || (ae[6] = X("div", { class: "ui-multiple-select__dropdown-empty-content" }, [
              X("p", null, "Ничего не найдено")
            ], -1))
          ]),
          _: 2
        }, [
          b(i).actions ? {
            name: "actions",
            fn: ue(() => [
              fe(Z.$slots, "actions", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "parent-id", "is-active", "scroll-container-id", "dropdown-options", "dropdown-type", "mobile-title", "size"])
      ], 10, zT),
      e.caption ? (f(), y("div", VT, [
        X("p", null, we(e.caption), 1)
      ])) : Y("", !0)
    ], 10, kT));
  }
});
const l6 = /* @__PURE__ */ je(HT, [["__scopeId", "data-v-8ebfe360"]]), FT = ["checked", "disabled", "value"], qT = /* @__PURE__ */ We({
  name: "UiSwitch",
  __name: "UiSwitch",
  props: {
    label: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "l"
    },
    value: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [Array, String, Number, Boolean],
      default: ""
    },
    trueValue: {
      type: [String, Boolean, Number],
      default: !0
    },
    falseValue: {
      type: [String, Boolean, Number],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    textPosition: {
      type: String,
      default: "left"
    },
    resizeTextType: {
      type: String,
      default: "hug"
    }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = V(() => Array.isArray(t.modelValue) ? t.modelValue.includes(t.value) : t.modelValue === t.trueValue), s = (u) => {
      const A = u.target.checked;
      if (Array.isArray(t.modelValue)) {
        const c = [...t.modelValue];
        A ? c.push(t.value) : c.splice(c.indexOf(t.value), 1), r("update:modelValue", c);
      } else
        r("update:modelValue", A ? t.trueValue : t.falseValue);
      r("change", A ? t.trueValue : t.falseValue);
    };
    return (u, A) => (f(), y("div", {
      class: he(["ui-switch", `ui-switch_size_${e.size}`])
    }, [
      X("label", {
        class: he(["ui-switch__label label", [
          {
            label_disabled: e.disabled
          },
          `label_text-position_${e.textPosition}`
        ]])
      }, [
        X("input", {
          type: "checkbox",
          checked: i.value,
          disabled: e.disabled,
          value: e.value,
          onChange: s
        }, null, 40, FT),
        A[0] || (A[0] = X("span", { class: "ui-switch__switch switch" }, [
          X("span", { class: "switch__circle circle" })
        ], -1)),
        X("span", {
          class: he(`ui-switch__text ui-switch__text_${e.resizeTextType}`)
        }, we(e.label), 3)
      ], 2)
    ], 2));
  }
});
const i6 = /* @__PURE__ */ je(qT, [["__scopeId", "data-v-961949db"]]), UT = /* @__PURE__ */ We({
  name: "UiTabs",
  __name: "UiTab",
  props: {
    label: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = a;
    return (r, i) => (f(), y("button", {
      type: "button",
      class: he(["ui-tab", [
        `ui-tab_${e.size}`,
        {
          "ui-tab_selected": e.selected
        }
      ]]),
      onClick: i[0] || (i[0] = (s) => t("select"))
    }, [
      fe(r.$slots, "default", {}, void 0, !0),
      X("p", null, we(e.label), 1)
    ], 2));
  }
});
const RT = /* @__PURE__ */ je(UT, [["__scopeId", "data-v-b808b963"]]), ZT = 6, GT = 0.5, jT = ["id"], KT = /* @__PURE__ */ We({
  __name: "UiTabs",
  props: {
    isScrollable: {
      type: Boolean,
      default: !1
    },
    labelSelector: {
      type: String,
      default: "Ещё"
    },
    tabs: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "m"
    },
    selectorId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, { width: i } = sa(), { tabs: s, size: u } = hv(t), A = U(!1), c = U(!1), g = U(!1), p = U(!1), v = U(null), m = U(null), w = U(""), B = V(
      () => t.isScrollable ? t.tabs.length : Math.min(t.tabs.length, ZT)
    ), T = V(() => t.tabs.slice(0, B.value)), L = V(() => {
      if (t.tabs.length <= B.value)
        return [];
      const z = t.tabs.slice(B.value).map((q) => ({
        optionId: q.id,
        label: q.title,
        icon: q.icon
      }));
      return [
        {
          id: performance.now(),
          options: z
        }
      ];
    }), E = V(
      () => t.tabs.length > B.value && !t.isScrollable
    ), N = V(
      () => {
        var z;
        return (z = L.value[0]) == null ? void 0 : z.options.some(
          (q) => q.optionId === t.modelValue
        );
      }
    ), k = (z) => z * GT, F = Mv(() => {
      const z = v.value;
      if (!z)
        return;
      const J = z.scrollWidth > z.clientWidth && i.value >= 768;
      A.value = J;
      const { scrollLeft: le, scrollWidth: ve, clientWidth: R } = z;
      c.value = J && le < ve - R, g.value = J && le > 0;
    }, 100), S = (z) => {
      const q = v.value;
      if (!q)
        return;
      const { clientWidth: J, scrollLeft: le, scrollWidth: ve } = q, R = k(J) * (z === "left" ? -1 : 1), _ = ve - J, G = le + R;
      g.value = G > 0, c.value = G < _, q.scrollBy({
        left: R,
        behavior: "smooth"
      });
    }, Q = () => {
      p.value = !p.value;
    }, x = (z, q = !1) => {
      r("update:modelValue", z), q ? p.value && Q() : w.value = "";
    }, W = () => {
      p.value = !1;
    };
    return st([s, u], F, { deep: !0 }), st(w, (z) => x(z, !0)), bt(() => {
      F(), Tn(window, "resize", F);
    }), Ql(m, W), (z, q) => (f(), y("div", {
      ref_key: "wrapperRef",
      ref: m,
      class: he(["ui-tabs__wrapper", `ui-tabs__wrapper_${b(u)}`])
    }, [
      g.value ? (f(), y("button", {
        key: 0,
        type: "button",
        class: "ui-tabs-arrow",
        onClick: q[0] || (q[0] = (J) => S("left"))
      }, [
        Ce(b(yv), { class: "ui-tabs-arrow__icon" })
      ])) : Y("", !0),
      X("div", {
        ref_key: "tabsRef",
        ref: v,
        class: he(["ui-tabs", [`ui-tabs_size_${b(u)}`, { "ui-tabs_scroll": e.isScrollable }]])
      }, [
        (f(!0), y(Qe, null, tt(T.value, (J) => (f(), ce(RT, {
          key: J.id,
          label: J.title,
          size: b(u),
          selected: J.id === e.modelValue,
          onSelect: (le) => x(J.id)
        }, {
          default: ue(() => [
            J.icon ? (f(), ce(Dt(J.icon), { key: 0 })) : Y("", !0)
          ]),
          _: 2
        }, 1032, ["label", "size", "selected", "onSelect"]))), 128)),
        X("div", {
          id: e.selectorId,
          class: "ui-tabs__selector selector"
        }, [
          E.value ? (f(), y("button", {
            key: 0,
            type: "button",
            class: he(["selector__label label", { label_selected: N.value }]),
            onClick: Q
          }, [
            $t(we(e.labelSelector) + " ", 1),
            X("span", {
              class: he(["label__icon icon-arrow-up", { label__icon_rotated: p.value }])
            }, null, 2)
          ], 2)) : Y("", !0),
          Ce(Ii, {
            modelValue: w.value,
            "onUpdate:modelValue": q[1] || (q[1] = (J) => w.value = J),
            "dropdown-type": "default",
            "dropdown-options": L.value,
            "is-active": p.value,
            "parent-id": e.selectorId,
            onHideOptions: q[2] || (q[2] = (J) => p.value = !1),
            onControlOptions: Q
          }, null, 8, ["modelValue", "dropdown-options", "is-active", "parent-id"])
        ], 8, jT)
      ], 2),
      c.value ? (f(), y("button", {
        key: 1,
        type: "button",
        class: "ui-tabs-arrow",
        onClick: q[3] || (q[3] = (J) => S("right"))
      }, [
        Ce(b(bA), { class: "ui-tabs-arrow__icon" })
      ])) : Y("", !0)
    ], 2));
  }
});
const o6 = /* @__PURE__ */ je(KT, [["__scopeId", "data-v-a90294d1"]]), JT = ["for"], _T = { class: "container__hint hint" }, $T = {
  key: 0,
  class: "hint__label"
}, ex = {
  key: 2,
  class: "hint__icon-required icon-required"
}, tx = {
  key: 3,
  class: "hint__counter"
}, nx = ["id", "placeholder", "disabled", "rows", "required", "maxlength", "minlength"], ax = {
  key: 0,
  class: "ui-textarea__error-message"
}, rx = {
  key: 1,
  class: "ui-textarea__hint-message"
}, lx = /* @__PURE__ */ We({
  name: "UiTextarea",
  __name: "UiTextarea",
  props: {
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    minLength: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 3
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    textareaId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    labelTooltip: {
      type: String,
      required: !1
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = V(() => t.error && !t.disabled), s = V({
      get() {
        return t.modelValue;
      },
      set(c) {
        r("update:modelValue", c);
      }
    }), u = V(() => `${s.value.length}/${t.maxLength}`);
    function A(c) {
      const g = c.target;
      g.style.height = "auto", g.style.height = `${g.scrollHeight + 4}px`;
    }
    return bt(() => {
      const c = document.getElementById(t.textareaId);
      t.modelValue !== "" && (c.style.overflow = "auto");
    }), (c, g) => (f(), y("div", {
      class: he(["ui-textarea", [
        `ui-textarea_size_${e.size}`,
        { "ui-textarea_disabled": e.disabled },
        { "ui-textarea_error": i.value }
      ]])
    }, [
      X("label", {
        for: e.textareaId,
        class: he(["ui-textarea__container", `ui-textarea__container_${e.variant}`])
      }, [
        X("span", _T, [
          e.label ? (f(), y("span", $T, we(e.label), 1)) : Y("", !0),
          e.labelTooltip ? (f(), ce(zi, {
            key: 1,
            class: "ui-tooltip",
            size: "m",
            label: e.labelTooltip
          }, null, 8, ["label"])) : Y("", !0),
          e.required ? (f(), y("span", ex)) : Y("", !0),
          e.counter ? (f(), y("span", tx, we(u.value), 1)) : Y("", !0)
        ]),
        cn(X("textarea", {
          id: e.textareaId,
          "onUpdate:modelValue": g[0] || (g[0] = (p) => s.value = p),
          placeholder: e.placeholder,
          disabled: e.disabled,
          rows: e.rows,
          required: e.required,
          maxlength: e.maxLength,
          minlength: e.minLength,
          onInput: g[1] || (g[1] = (p) => A(p))
        }, null, 40, nx), [
          [ha, s.value]
        ])
      ], 10, JT),
      i.value ? (f(), y("p", ax, we(e.errorMessage), 1)) : Y("", !0),
      e.hintMessage && !i.value ? (f(), y("p", rx, we(e.hintMessage), 1)) : Y("", !0)
    ], 2));
  }
});
const s6 = /* @__PURE__ */ je(lx, [["__scopeId", "data-v-b63ab978"]]), ix = ["for"], ox = {
  key: 1,
  class: "ui-slider__single-slider single-slider"
}, sx = {
  key: 0,
  class: "single-slider__input-number input-number"
}, ux = ["id", "data-maska", "min", "max"], Ax = { class: "single-slider__input-range input-range" }, dx = {
  key: 0,
  class: "input-range__ui-hint ui-hint"
}, cx = {
  key: 0,
  class: "ui-hint__container container"
}, fx = { class: "container__hint" }, vx = ["min", "max", "step"], px = {
  key: 2,
  class: "ui-slider__double-slider double-slider"
}, gx = { class: "double-slider__input-number input-number" }, hx = ["id", "data-maska", "min", "max"], mx = ["data-maska", "min", "max"], yx = { class: "double-slider__input-range input-range" }, bx = ["min", "max", "step"], wx = ["min", "max", "step"], ko = 256, Cx = /* @__PURE__ */ We({
  name: "UiSlider",
  __name: "UiSlider",
  props: {
    size: {
      type: String,
      default: "l"
    },
    maxValue: {
      type: Number,
      default: 100
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    type: {
      type: String,
      default: "single"
    },
    label: {
      type: String,
      required: !1
    },
    minValue: {
      type: Number,
      default: 0
    },
    stepNumber: {
      type: Number,
      default: 5
    },
    minCurrentValue: {
      type: Number,
      default: 10
    },
    maxCurrentValue: {
      type: Number,
      default: 50
    },
    singleCurrentValue: {
      type: Number,
      default: 50
    },
    zIndex: {
      type: Number,
      default: 1
    }
  },
  emits: [
    "update:minCurrentValue",
    "update:maxCurrentValue",
    "update:singleCurrentValue"
  ],
  setup(e, { emit: a }) {
    yA((x) => ({
      "1e838156": E.value,
      "6b9c8e21": L.value,
      "12fcfe35": w.value,
      "7bbf82dc": N.value,
      "34c3c1ec": k.value,
      "12fc6479": m.value
    }));
    const t = e, r = a, i = U(0), s = U(0), u = U(0), A = U(!1), c = U(0), g = U(0), p = U(0), v = V(() => t.type !== "volume"), m = V(() => t.zIndex - 1), w = V(() => t.zIndex + 1), B = V(() => t.maxValue.toString().length), T = V(() => "#".repeat(B.value)), L = V(() => `${(ko - 20) / (t.maxValue - t.minValue) * (p.value - t.minValue)}px`), E = V(() => `${ko / (t.maxValue - t.minValue) * (t.maxValue - p.value)}px`), N = V(() => `${ko / (t.maxValue - t.minValue) * (c.value - t.minValue)}px`), k = V(() => `${ko / (t.maxValue - t.minValue) * (t.maxValue - g.value)}px`);
    st(u, (x) => {
      if (x === "") {
        p.value = t.minValue, u.value = t.minValue;
        return;
      }
      x > t.maxValue ? u.value = t.maxValue : x < t.minValue ? u.value = t.minValue : u.value = x, p.value = +x;
    }), st(i, (x) => {
      if (x === "") {
        g.value = t.maxValue, i.value = t.maxValue, x = +x;
        return;
      }
      x > t.maxValue ? i.value = t.maxValue : x < t.minValue ? (i.value = t.minValue, g.value = t.minValue) : i.value = x, r("update:maxCurrentValue", i.value), !(typeof i.value == "string" || typeof s.value == "string") && (i.value > s.value ? (g.value = x, c.value = s.value) : s.value > i.value ? (g.value = s.value, c.value = i.value) : (g.value = i.value, c.value = s.value));
    }), st(s, (x) => {
      const z = x.toString().replace(/(^|\s)0/g, "$1"), q = isNaN(parseInt(z)) ? t.minValue : parseInt(z);
      if (x === "") {
        c.value = t.minValue, s.value = t.minValue;
        return;
      }
      x > t.maxValue ? s.value = t.maxValue : x < t.minValue ? (c.value = t.minValue, s.value = t.minValue) : s.value = q, r("update:minCurrentValue", s.value), typeof i.value != "string" && (c.value = x, s.value > i.value ? (g.value = s.value, c.value = i.value) : (g.value = i.value, c.value = s.value));
    });
    const F = () => {
      if (s.value > i.value) {
        const x = i.value;
        i.value = s.value, s.value = x;
      }
    }, S = () => {
      A.value = !0;
    }, Q = () => {
      A.value = !1;
    };
    return bt(() => {
      i.value = t.maxCurrentValue, s.value = t.minCurrentValue, g.value = i.value, u.value = t.singleCurrentValue, c.value = t.singleCurrentValue, p.value = u.value;
    }), (x, W) => (f(), y("div", {
      class: he(["ui-slider", `ui-slider_size_${e.size}`])
    }, [
      v.value ? (f(), y("label", {
        key: 0,
        for: e.inputId,
        class: "ui-slider__label"
      }, we(e.label), 9, ix)) : Y("", !0),
      e.type !== "double" ? (f(), y("div", ox, [
        v.value ? (f(), y("span", sx, [
          cn(X("input", {
            id: e.inputId,
            "onUpdate:modelValue": W[0] || (W[0] = (z) => u.value = z),
            "data-maska": T.value,
            min: e.minValue,
            max: e.maxValue,
            type: "number"
          }, null, 8, ux), [
            [
              ha,
              u.value,
              void 0,
              { number: !0 }
            ],
            [b(hi)]
          ])
        ])) : Y("", !0),
        X("div", Ax, [
          W[7] || (W[7] = X("span", { class: "input-range__value" }, null, -1)),
          e.type === "volume" ? (f(), y("div", dx, [
            Ce(Jn, {
              name: "hint-fade",
              mode: "out-in"
            }, {
              default: ue(() => [
                A.value ? (f(), y("div", cx, [
                  X("div", fx, [
                    X("span", null, we(u.value), 1)
                  ]),
                  W[6] || (W[6] = X("span", { class: "container__triangle" }, null, -1))
                ])) : Y("", !0)
              ]),
              _: 1
            })
          ])) : Y("", !0),
          cn(X("input", {
            "onUpdate:modelValue": W[1] || (W[1] = (z) => u.value = z),
            min: e.minValue,
            max: e.maxValue,
            step: e.stepNumber,
            type: "range",
            onMousedown: S,
            onMouseup: Q
          }, null, 40, vx), [
            [ha, u.value]
          ])
        ])
      ])) : (f(), y("div", px, [
        X("span", gx, [
          cn(X("input", {
            id: e.inputId,
            "onUpdate:modelValue": W[2] || (W[2] = (z) => s.value = z),
            "data-maska": T.value,
            min: e.minValue,
            max: e.maxValue,
            type: "number",
            onChange: F
          }, null, 40, hx), [
            [ha, s.value],
            [b(hi)]
          ]),
          W[8] || (W[8] = X("span", { class: "input-number__divider" }, null, -1)),
          cn(X("input", {
            "onUpdate:modelValue": W[3] || (W[3] = (z) => i.value = z),
            "data-maska": T.value,
            min: e.minValue,
            max: e.maxValue,
            type: "number"
          }, null, 8, mx), [
            [ha, i.value],
            [b(hi)]
          ])
        ]),
        X("span", yx, [
          W[9] || (W[9] = X("span", { class: "input-range__value-min" }, null, -1)),
          W[10] || (W[10] = X("span", { class: "input-range__line" }, null, -1)),
          W[11] || (W[11] = X("span", { class: "input-range__value-max" }, null, -1)),
          cn(X("input", {
            "onUpdate:modelValue": W[4] || (W[4] = (z) => s.value = z),
            min: e.minValue,
            max: e.maxValue,
            step: e.stepNumber,
            type: "range",
            onChange: F
          }, null, 40, bx), [
            [ha, s.value]
          ]),
          cn(X("input", {
            "onUpdate:modelValue": W[5] || (W[5] = (z) => i.value = z),
            min: e.minValue,
            max: e.maxValue,
            step: e.stepNumber,
            type: "range",
            onChange: F
          }, null, 40, wx), [
            [
              ha,
              i.value,
              void 0,
              { number: !0 }
            ]
          ])
        ])
      ]))
    ], 2));
  }
});
const u6 = /* @__PURE__ */ je(Cx, [["__scopeId", "data-v-70a9d74b"]]), Dx = {
  key: 0,
  class: "ui-avatar__online-circle online-circle"
}, Bx = { class: "avatar-letters__title" }, Tx = { class: "counter__text" }, xx = /* @__PURE__ */ We({
  name: "UiAvatar",
  __name: "UiAvatar",
  props: {
    size: {
      type: String,
      default: "xs"
    },
    borderAvatar: {
      type: Boolean,
      default: !1
    },
    isOnline: {
      type: Boolean,
      default: !1
    },
    avatarList: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const a = e, t = V(() => {
      var s;
      return `+${((s = a.avatarList) == null ? void 0 : s.length) - 3}`;
    }), r = V(() => {
      var s;
      return ((s = a.avatarList) == null ? void 0 : s.length) <= 4 ? a.avatarList : a.avatarList.slice(0, 3);
    }), i = (s) => {
      if (typeof s < "u") {
        if (s.length > 2)
          return s == null ? void 0 : s.slice(0, 2);
      } else
        return "";
    };
    return (s, u) => (f(), y("div", {
      class: he(["ui-avatar-group", `ui-avatar-group_size_${e.size}`])
    }, [
      (f(!0), y(Qe, null, tt(r.value, (A, c) => (f(), y("div", {
        key: c,
        class: he(["ui-avatar-group__ui-avatar ui-avatar", [
          `ui-avatar_avatar-${c}`,
          {
            "ui-avatar_yellow": (A == null ? void 0 : A.colorIcon) === "yellow" && (A == null ? void 0 : A.backgroundColor) === "yellow",
            "ui-avatar_orange": (A == null ? void 0 : A.colorIcon) === "orange" && (A == null ? void 0 : A.backgroundColor) === "orange",
            "ui-avatar_pink": (A == null ? void 0 : A.colorIcon) === "pink" && (A == null ? void 0 : A.backgroundColor) === "pink",
            "ui-avatar_teal": (A == null ? void 0 : A.colorIcon) === "teal" && (A == null ? void 0 : A.backgroundColor) === "teal"
          }
        ]])
      }, [
        e.isOnline ? (f(), y("span", Dx)) : Y("", !0),
        A != null && A.link ? (f(), y("div", {
          key: 1,
          class: he([{ avatar_border: e.borderAvatar }, "ui-avatar__avatar avatar"]),
          style: Tt({
            backgroundImage: `url(${A.link})`
          })
        }, null, 6)) : !(A != null && A.link) && typeof A.lettersInitials < "u" ? (f(), y("div", {
          key: 2,
          class: he([{ "avatar-letters_border": e.borderAvatar }, "ui-avatar__avatar-letters avatar-letters"])
        }, [
          X("span", Bx, we(i(A.lettersInitials)), 1)
        ], 2)) : (f(), y("div", {
          key: 3,
          class: he([{ "avatar-icon_border": e.borderAvatar }, "ui-avatar__avatar-icon avatar-icon"])
        }, [
          Ce(b(E2), { class: "avatar-icon__icon icon" })
        ], 2))
      ], 2))), 128)),
      e.avatarList.length > 4 ? (f(), y("div", {
        key: 0,
        class: he(["ui-avatar-group__counter counter", { counter_border: e.borderAvatar }])
      }, [
        X("span", Tx, we(t.value), 1)
      ], 2)) : Y("", !0)
    ], 2));
  }
});
const A6 = /* @__PURE__ */ je(xx, [["__scopeId", "data-v-b6112b43"]]), Px = { class: "ui-input-phone__container container" }, kx = ["for"], Ox = {
  key: 0,
  class: "hint__label"
}, Mx = {
  key: 1,
  class: "hint__icon-required icon-required"
}, zx = ["id"], Ix = ["disabled"], Ex = ["id", "data-maska", "placeholder", "disabled", "maxlength"], Lx = {
  key: 0,
  class: "ui-input-phone__error-message"
}, Nx = /* @__PURE__ */ We({
  name: "UiInputPhone",
  __name: "UiInputPhone",
  props: {
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    mask: {
      type: [String, Array, Object],
      required: !1
    },
    showCountry: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: ["update:modelValue", "hideOptions", "blur"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = U(null), s = U(null), u = U(!1), A = U("ru"), c = [
      {
        id: "ru",
        title: "Россия (+7)"
      },
      {
        id: "kz",
        title: "Казахстан (+7)"
      },
      {
        id: "md",
        title: "Молдова (+373)"
      }
    ];
    Ql(i, () => u.value = !1, {
      ignore: [s]
    });
    const g = V(() => (t.error || t.errorMessage) && !t.disabled), p = V(() => ({
      "grid-template-columns": "fit-content(20px) 1fr"
    })), v = V({
      get() {
        return t.modelValue;
      },
      set(E) {
        r("update:modelValue", E);
      }
    }), m = V(() => [
      {
        id: Date.now().toString(),
        options: c.map((E) => ({
          optionId: E.id,
          label: E.title
        }))
      }
    ]), w = V(() => {
      switch (A.value) {
        case "ru":
          return x2;
        case "kz":
          return m2;
        case "md":
          return C2;
        default:
          return v2;
      }
    }), B = V(() => {
      if (t.showCountry)
        switch (A.value) {
          case "ru":
            return "+7 (999) 000-00-00";
          case "kz":
            return "+7 (999) 000-00-00";
          case "md":
            return "+(373) 000-00-00";
          default:
            return "+0 (999) 000-00-00";
        }
      else
        return "+7 (999) 000-00-00";
    }), T = V(() => {
      if (t.showCountry)
        switch (A.value) {
          case "ru":
            return "+7 (###) ###-##-##";
          case "kz":
            return "+7 (###) ###-##-##";
          case "md":
            return "+(373) ###-##-##";
          default:
            return "";
        }
      else
        return "+7 (###) ###-##-##";
    }), L = () => {
      u.value = !u.value;
    };
    return (E, N) => (f(), y(Qe, null, [
      X("div", {
        class: he(["ui-input-phone", [
          `ui-input-phone_size_${e.size}`,
          { "ui-input-phone_disabled": e.disabled },
          { "ui-input-phone_error": g.value }
        ]])
      }, [
        X("div", Px, [
          X("label", {
            for: `label-${e.inputId}`,
            class: "container__hint hint"
          }, [
            e.label ? (f(), y("span", Ox, we(e.label), 1)) : Y("", !0),
            e.required ? (f(), y("span", Mx)) : Y("", !0)
          ], 8, kx),
          X("span", {
            id: e.inputId,
            class: he(["ui-input-phone__input-block input-block", [
              { "input-block_without-country": !e.showCountry },
              `input-block_${e.variant}`
            ]]),
            style: Tt(p.value)
          }, [
            e.showCountry ? (f(), y("button", {
              key: 0,
              ref_key: "countryButton",
              ref: s,
              type: "button",
              class: "ui-input-phone__button-country button-country",
              disabled: e.disabled,
              onClick: L
            }, [
              (f(), ce(Dt(w.value), { class: "button-country__icon-country" })),
              Ce(b(rs), {
                class: he(["button-country__chevron", { "button-country__chevron_rotated": u.value }])
              }, null, 8, ["class"])
            ], 8, Ix)) : Y("", !0),
            cn(X("input", {
              id: `label-${e.inputId}`,
              "onUpdate:modelValue": N[0] || (N[0] = (k) => v.value = k),
              class: "input-block__input input",
              "data-maska": T.value,
              type: "tel",
              placeholder: B.value,
              disabled: e.disabled,
              maxlength: e.maxLength,
              name: "phone",
              onBlur: N[1] || (N[1] = (k) => r("blur"))
            }, null, 40, Ex), [
              [ha, v.value],
              [b(hi)]
            ])
          ], 14, zx)
        ]),
        e.errorMessage ? (f(), y("p", Lx, we(e.errorMessage), 1)) : Y("", !0)
      ], 2),
      Ce(Ii, {
        ref_key: "target",
        ref: i,
        modelValue: A.value,
        "onUpdate:modelValue": N[2] || (N[2] = (k) => A.value = k),
        "dropdown-type": "default",
        "dropdown-options": m.value,
        size: e.size,
        "parent-id": e.inputId,
        "is-active": u.value,
        onHideOptions: N[3] || (N[3] = (k) => r("hideOptions"))
      }, null, 8, ["modelValue", "dropdown-options", "size", "parent-id", "is-active"])
    ], 64));
  }
});
const d6 = /* @__PURE__ */ je(Nx, [["__scopeId", "data-v-5b13de5d"]]), Yx = ["id"], Sx = /* @__PURE__ */ We({
  name: "UiInputSearch",
  __name: "UiInputSearch",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    selectedItem: {
      type: String,
      default: ""
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    isDropdownOpen: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      required: !1
    },
    size: {
      type: String,
      default: "l"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    required: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    inputSearchId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    unit: {
      type: String,
      default: ""
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    mask: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    maskTokens: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    dataMaskaReversed: {
      type: Boolean,
      default: !1
    },
    maskaOptions: {
      type: Object,
      default: null
    },
    enterKeyHint: {
      type: String,
      default: "enter"
    },
    inputMode: {
      type: String,
      default: "text"
    },
    variant: {
      type: String,
      default: "stroke"
    }
  },
  emits: [
    "update:modelValue",
    "update:selectedItem",
    "hideOptions",
    "blur",
    "input",
    "selectItem"
  ],
  setup(e, { emit: a }) {
    const t = e, r = a, i = mn(), s = V({
      get() {
        return t.selectedItem;
      },
      set(m) {
        r("update:selectedItem", m);
      }
    }), u = V({
      get() {
        return t.modelValue;
      },
      set(m) {
        r("update:modelValue", m);
      }
    }), A = (m) => {
      m !== t.selectedItem && (r("input", m), m.trim() === "" && r("hideOptions"));
    }, c = (m) => {
      r("selectItem", m);
    }, g = V(
      () => Object.prototype.hasOwnProperty.call(i, "icon-left")
    ), p = V(
      () => Object.prototype.hasOwnProperty.call(i, "tooltip-icon")
    ), v = U(null);
    return Ql(v, () => r("hideOptions")), (m, w) => (f(), y("div", {
      id: e.inputSearchId,
      ref_key: "uiInputSearchRef",
      ref: v,
      class: "ui-input-search"
    }, [
      Ce(yr, {
        modelValue: u.value,
        "onUpdate:modelValue": w[0] || (w[0] = (B) => u.value = B),
        "input-id": e.inputId,
        "maska-options": e.maskaOptions,
        "data-maska": e.mask,
        "data-maska-tokens": e.maskTokens,
        counter: e.counter,
        "label-tooltip": e.labelTooltip,
        "data-maska-reversed": e.dataMaskaReversed,
        type: e.type,
        unit: e.unit,
        variant: e.variant,
        required: e.required,
        error: e.error,
        "hint-message": e.hintMessage,
        "error-message": e.errorMessage,
        placeholder: e.placeholder,
        size: e.size,
        disabled: e.disabled,
        "reset-button": "",
        label: e.label,
        maxlength: e.maxLength,
        enterkeyhint: e.enterKeyHint,
        inputmode: e.inputMode,
        onBlur: w[1] || (w[1] = (B) => r("blur")),
        onInput: A
      }, Lt({ _: 2 }, [
        p.value ? {
          name: "tooltip-icon",
          fn: ue(() => [
            fe(m.$slots, "tooltip-icon", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        g.value ? {
          name: "icon-left",
          fn: ue(() => [
            fe(m.$slots, "icon-left", {}, void 0, !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "input-id", "maska-options", "data-maska", "data-maska-tokens", "counter", "label-tooltip", "data-maska-reversed", "type", "unit", "variant", "required", "error", "hint-message", "error-message", "placeholder", "size", "disabled", "label", "maxlength", "enterkeyhint", "inputmode"]),
      Ce(Ii, {
        modelValue: s.value,
        "onUpdate:modelValue": w[2] || (w[2] = (B) => s.value = B),
        "dropdown-type": "search",
        "search-options": e.searchOptions,
        size: e.size,
        "parent-id": e.inputSearchId,
        "is-active": e.isDropdownOpen,
        error: e.error,
        loading: e.loading,
        onHideOptions: w[3] || (w[3] = (B) => r("hideOptions")),
        onSelectItem: c
      }, null, 8, ["modelValue", "search-options", "size", "parent-id", "is-active", "error", "loading"])
    ], 8, Yx));
  }
});
const c6 = /* @__PURE__ */ je(Sx, [["__scopeId", "data-v-09f0f433"]]), Vx = { class: "ui-pagination" }, Wx = ["disabled"], Xx = { class: "ui-pagination__items" }, Qx = ["onClick"], Hx = { key: 1 }, Fx = ["disabled"], qx = /* @__PURE__ */ We({
  name: "UiPagination",
  __name: "UiPagination",
  props: {
    totalPages: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !0
    }
  },
  emits: ["select", "prev", "next"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = V(() => {
      const c = [];
      for (let g = 1; g <= t.totalPages; g++)
        g === 1 || t.currentPage - 1 <= g && t.currentPage + 1 >= g || g === t.currentPage || g === t.totalPages ? c.push(g) : (g === t.currentPage - (1 + 1) || g === t.currentPage + (1 + 1)) && c.push("...");
      return c;
    }), s = () => {
      t.currentPage !== 1 && r("prev");
    }, u = () => {
      t.totalPages !== t.currentPage && r("next");
    }, A = (c) => {
      r("select", c);
    };
    return (c, g) => (f(), y("div", Vx, [
      X("button", {
        type: "button",
        disabled: e.currentPage === 1,
        "aria-label": "prev",
        onClick: s
      }, [
        Ce(b(yv))
      ], 8, Wx),
      X("div", Xx, [
        (f(!0), y(Qe, null, tt(i.value, (p) => (f(), y(Qe, { key: p }, [
          Number.isInteger(p) ? (f(), y("button", {
            key: 0,
            type: "button",
            class: he([{ "ui-pagination__item_active": t.currentPage === p }, "ui-pagination__item"]),
            onClick: (v) => A(p)
          }, we(p), 11, Qx)) : (f(), y("span", Hx, we(p), 1))
        ], 64))), 128))
      ]),
      X("button", {
        type: "button",
        disabled: e.currentPage === t.totalPages,
        "aria-label": "next",
        onClick: u
      }, [
        Ce(b(bA))
      ], 8, Fx)
    ]));
  }
});
const f6 = /* @__PURE__ */ je(qx, [["__scopeId", "data-v-ec86d1d6"]]), Ux = {
  left: "top: 16px; left: 16px;",
  right: "top: 16px; right: 16px;",
  top: "top: 16px; right: 30%;",
  bottom: "bottom: 16px; right: 30%;"
}, Rx = {
  info: wa,
  success: Dv,
  error: Cv,
  warning: Tv
}, Zx = ["id"], Gx = { class: "ui-snackbar__info" }, jx = { key: 0 }, Kx = { key: 1 }, Jx = /* @__PURE__ */ We({
  name: "UiSnackbar",
  __name: "UiSnackbar",
  props: {
    type: {
      type: String,
      default: "info"
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: !0
    },
    zIndex: {
      type: String,
      default: "10000000"
    },
    position: {
      type: String,
      default: "fixed"
    },
    duration: {
      type: Number,
      default: 4500
    }
  },
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = e, r = a, { duration: i } = hv(t), s = U(null), { isOutside: u } = wD(s), { start: A, stop: c } = fD(() => {
      r("close");
    }, i), g = V(() => Rx[t.type] || wa);
    return ki(() => {
      if (!u.value) {
        c();
        return;
      }
      A();
    }), (p, v) => (f(), y("div", {
      id: e.id,
      ref_key: "snackbarRef",
      ref: s,
      class: "ui-snackbar elevation-shadow-high",
      style: Tt({ zIndex: e.zIndex, position: e.position })
    }, [
      X("div", {
        class: he(["ui-snackbar__icon", `ui-snackbar__icon_${e.type}`])
      }, [
        (f(), ce(Dt(g.value)))
      ], 2),
      X("div", Gx, [
        e.title ? (f(), y("h5", jx, we(e.title), 1)) : Y("", !0),
        e.text ? (f(), y("p", Kx, we(e.text), 1)) : Y("", !0),
        fe(p.$slots, "default", {}, void 0, !0)
      ]),
      e.showClose ? (f(), y("button", {
        key: 0,
        type: "button",
        "aria-label": "close",
        onClick: v[0] || (v[0] = (m) => p.$emit("close"))
      }, [
        Ce(b(tl))
      ])) : Y("", !0)
    ], 12, Zx));
  }
});
const _x = /* @__PURE__ */ je(Jx, [["__scopeId", "data-v-d149e518"]]), $x = ["data-position"], eP = /* @__PURE__ */ We({
  name: "UiSnackbarGroup",
  __name: "UiSnackbarGroup",
  props: {
    position: {
      type: String,
      default: "right"
    },
    modelValue: {
      type: Array,
      required: !0
    },
    duration: {
      type: Number,
      default: 4500
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = mn(), s = V(() => Ux[t.position]), u = (A) => {
      r(
        "update:modelValue",
        t.modelValue.filter((c) => c.id !== A)
      );
    };
    return (A, c) => (f(), y("div", {
      class: "ui-snackbar-group",
      style: Tt(s.value)
    }, [
      Ce(mv, {
        appear: "",
        name: `ui-snackbar-animate-${e.position}`,
        tag: "ul",
        class: "ui-snackbar-group-list"
      }, {
        default: ue(() => [
          (f(!0), y(Qe, null, tt(e.modelValue, (g) => (f(), y("li", {
            key: g.id,
            class: "ui-snackbar-group-list__item",
            "data-position": e.position
          }, [
            Ce(_x, {
              class: "elevation-shadow-high",
              position: "static",
              "z-index": "0",
              type: g.type,
              title: g.title,
              text: g.text,
              label: g.label,
              "show-close": g == null ? void 0 : g.showClose,
              onClose: (p) => u(g.id)
            }, {
              default: ue(() => [
                b(i).default ? fe(A.$slots, "default", { key: 0 }, void 0, !0) : Y("", !0)
              ]),
              _: 2
            }, 1032, ["type", "title", "text", "label", "show-close", "onClose"])
          ], 8, $x))), 128))
        ]),
        _: 3
      }, 8, ["name"])
    ], 4));
  }
});
const v6 = /* @__PURE__ */ je(eP, [["__scopeId", "data-v-91fbec46"]]), tP = /* @__PURE__ */ We({
  name: "UiProgressBar",
  __name: "UiProgressBar",
  props: {
    value: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: "m"
    }
  },
  setup(e) {
    return (a, t) => (f(), y("div", {
      class: he(["ui-progress-bar", [`ui-progress-bar_size_${e.size}`]])
    }, [
      X("span", {
        style: Tt({ width: `${e.value}%` })
      }, null, 4)
    ], 2));
  }
});
const nP = /* @__PURE__ */ je(tP, [["__scopeId", "data-v-fe39d904"]]), aP = { class: "ui-file-card__info" }, rP = { key: 0 }, lP = { key: 0 }, iP = { key: 1 }, oP = { key: 2 }, sP = /* @__PURE__ */ We({
  name: "UiFileCard",
  __name: "UiFileCard",
  props: {
    color: {
      type: String,
      default: "outline"
    },
    title: { type: String, required: !0 },
    fileSize: { type: String, default: "" },
    format: { type: String, default: "" },
    date: { type: String, default: "" },
    author: { type: String, default: "" },
    link: { type: String, default: "" },
    downloadButton: { type: Boolean, default: !1 }
  },
  emits: ["download"],
  setup(e) {
    const a = e, t = V(() => a.link ? "a" : "div");
    return (r, i) => (f(), ce(Dt(t.value), {
      class: he(["ui-file-card", [`ui-file-card_color_${e.color}`]]),
      download: e.link,
      href: e.link
    }, {
      default: ue(() => [
        e.format === "pdf" ? (f(), ce(b(U7), { key: 0 })) : e.format === "doc" ? (f(), ce(b(S7), { key: 1 })) : e.format === "docx" ? (f(), ce(b(O7), { key: 2 })) : e.format === "txt" ? (f(), ce(b(w7), { key: 3 })) : e.format === "csv" ? (f(), ce(b(f7), { key: 4 })) : e.format === "xls" ? (f(), ce(b(l7), { key: 5 })) : e.format === "xlsx" ? (f(), ce(b(J9), { key: 6 })) : e.format === "ppt" ? (f(), ce(b(F9), { key: 7 })) : e.format === "pptx" ? (f(), ce(b(N9), { key: 8 })) : e.format === "zip" ? (f(), ce(b(uC), { key: 9 })) : e.format === "rar" ? (f(), ce(b(hC), { key: 10 })) : e.format === "mp3" ? (f(), ce(b(P9), { key: 11 })) : e.format === "wav" ? (f(), ce(b(d9), { key: 12 })) : e.format === "mp4" ? (f(), ce(b(y9), { key: 13 })) : e.format === "avi" ? (f(), ce(b(a9), { key: 14 })) : e.format === "img" ? (f(), ce(b(jC), { key: 15 })) : e.format === "jpg" || e.format === "jpeg" ? (f(), ce(b(tC), { key: 16 })) : e.format === "png" ? (f(), ce(b(TC), { key: 17 })) : e.format === "gif" ? (f(), ce(b(EC), { key: 18 })) : e.format === "svg" ? (f(), ce(b(QC), { key: 19 })) : (f(), ce(b(q2), { key: 20 })),
        X("div", aP, [
          X("h6", null, we(e.title), 1),
          e.fileSize || e.date || e.author ? (f(), y("p", rP, [
            e.fileSize ? (f(), y("span", lP, we(e.fileSize), 1)) : Y("", !0),
            e.date ? (f(), y("span", iP, "Дата публикации: " + we(e.date), 1)) : Y("", !0),
            e.author ? (f(), y("span", oP, "Автор: " + we(e.author), 1)) : Y("", !0)
          ])) : Y("", !0)
        ]),
        e.downloadButton ? (f(), y("button", {
          key: 21,
          type: "button",
          onClick: i[0] || (i[0] = (s) => r.$emit("download"))
        }, [
          Ce(b(wv))
        ])) : Y("", !0)
      ]),
      _: 1
    }, 8, ["class", "download", "href"]));
  }
});
const p6 = /* @__PURE__ */ je(sP, [["__scopeId", "data-v-45c9eb6d"]]), uP = /* @__PURE__ */ We({
  name: "UiSkeleton",
  __name: "UiSkeleton",
  props: {
    type: {
      type: String,
      default: "text"
    }
  },
  setup(e) {
    return (a, t) => (f(), y("span", {
      class: he(["ui-skeleton", [`ui-skeleton_type_${e.type}`]])
    }, null, 2));
  }
});
const g6 = /* @__PURE__ */ je(uP, [["__scopeId", "data-v-173c981e"]]), AP = ["id"], dP = {
  key: 1,
  class: "ui-modal__header"
}, cP = { key: 0 }, fP = { key: 1 }, vP = { class: "ui-modal__content" }, pP = { class: "ui-modal__footer" }, gP = /* @__PURE__ */ We({
  name: "UiModal",
  __name: "UiModal",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "s"
    },
    title: {
      type: String,
      required: !1
    },
    subTitle: {
      type: String,
      default: ""
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    hideClose: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    }
  },
  emits: ["close", "initRef"],
  setup(e, { emit: a }) {
    const t = a, r = mn(), i = document.body, s = DA(i), { width: u } = sa(), A = U(!1), c = () => {
      A.value = !1, s.value = !1, Bt(() => t("close", !1));
    };
    return bt(() => {
      s.value = !0, A.value = !0;
    }), (g, p) => b(u) > 768 ? (f(), ce(rl, {
      key: 0,
      to: "body"
    }, [
      Ce(Jn, { name: "modal" }, {
        default: ue(() => [
          A.value ? (f(), y("div", {
            key: 0,
            id: e.id,
            ref: (v) => {
              g.$emit("initRef", v);
            },
            class: "ui-modal elevation-shadow-low",
            onClick: c
          }, [
            X("div", {
              class: he(["ui-modal__container", [`ui-modal_size_${e.size}`]]),
              onClick: p[0] || (p[0] = _t(() => {
              }, ["stop"]))
            }, [
              e.hideClose ? Y("", !0) : (f(), y("button", {
                key: 0,
                type: "button",
                onClick: c
              }, [
                Ce(b(tl))
              ])),
              e.hideHeader ? Y("", !0) : (f(), y("div", dP, [
                e.title ? (f(), y("h4", cP, we(e.title), 1)) : Y("", !0),
                e.subTitle ? (f(), y("p", fP, we(e.subTitle), 1)) : Y("", !0),
                fe(g.$slots, "content-header", {}, void 0, !0)
              ])),
              X("div", vP, [
                fe(g.$slots, "default", {}, void 0, !0)
              ]),
              X("div", pP, [
                fe(g.$slots, "actions", {}, void 0, !0)
              ])
            ], 2)
          ], 8, AP)) : Y("", !0)
        ]),
        _: 3
      })
    ])) : (f(), ce(is, {
      key: 1,
      id: e.id,
      "hide-header": e.hideHeader,
      title: e.title,
      subtitle: e.subTitle,
      onClose: c,
      onInitRef: p[1] || (p[1] = (v) => t("initRef", v))
    }, Lt({ _: 2 }, [
      b(r)["header-action"] ? {
        name: "header-action",
        fn: ue(() => [
          fe(g.$slots, "header-action", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0,
      b(r)["content-header"] ? {
        name: "content-header",
        fn: ue(() => [
          fe(g.$slots, "content-header", {}, void 0, !0)
        ]),
        key: "1"
      } : void 0,
      b(r).default ? {
        name: "content",
        fn: ue(() => [
          fe(g.$slots, "default", {}, void 0, !0)
        ]),
        key: "2"
      } : void 0,
      b(r).actions ? {
        name: "footer",
        fn: ue(() => [
          fe(g.$slots, "actions", {}, void 0, !0)
        ]),
        key: "3"
      } : void 0
    ]), 1032, ["id", "hide-header", "title", "subtitle"]));
  }
});
const h6 = /* @__PURE__ */ je(gP, [["__scopeId", "data-v-c488280b"]]), hP = {
  key: 0,
  class: "ui-stepper"
}, mP = { key: 0 }, yP = { class: "ui-stepper__horizontally" }, bP = { key: 3 }, wP = { key: 0 }, CP = {
  key: 1,
  class: "ui-stepper__content"
}, DP = {
  key: 1,
  class: "ui-stepper"
}, BP = { key: 3 }, TP = { class: "step-vertically__info" }, xP = { class: "step-description" }, PP = { key: 0 }, kP = {
  key: 0,
  class: "ui-stepper__content_vertically"
}, OP = /* @__PURE__ */ We({
  name: "UiStepper",
  __name: "UiStepper",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "horizontally"
    },
    activeStep: {
      type: Number,
      default: 0
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, r = a, { width: i } = sa(), s = mn(), u = V(() => t.steps[t.activeStep]), A = V(() => t.clickable ? "button" : "div"), c = (g, p) => {
      t.clickable && g.status !== "waiting" && r("select", p);
    };
    return (g, p) => e.type === "horizontally" ? (f(), y("div", hP, [
      b(i) < 1024 ? (f(), y("div", {
        key: 0,
        class: he(["step-description", [`step-description_${e.type}`]])
      }, [
        X("h5", null, we(u.value.title), 1),
        u.value.subTitle ? (f(), y("p", mP, we(u.value.subTitle), 1)) : Y("", !0)
      ], 2)) : Y("", !0),
      X("div", yP, [
        (f(!0), y(Qe, null, tt(e.steps, (v, m) => (f(), y("div", {
          key: m,
          class: he(["step_horizontally", [`step_${v.status}`]])
        }, [
          (f(), ce(Dt(A.value), {
            class: he(["step-status", [
              `step-status_${e.type}`,
              `${v.status ? `step-status_${v.status}` : ""}`,
              { clickable: e.clickable }
            ]]),
            disabled: e.clickable && v.status === "waiting",
            onClick: (w) => c(v, m)
          }, {
            default: ue(() => [
              v.status === "finished" ? (f(), ce(b(Il), { key: 0 })) : v.status === "error" ? (f(), ce(b(Df), { key: 1 })) : v.icon ? (f(), ce(Dt(v.icon), { key: 2 })) : (f(), y("p", bP, we(m + 1), 1))
            ]),
            _: 2
          }, 1032, ["disabled", "class", "onClick"])),
          b(i) > 1023 ? (f(), y("div", {
            key: 0,
            class: he(["step-description", [`step-description_${e.type}`]])
          }, [
            X("h5", null, we(v.title), 1),
            v.subTitle ? (f(), y("p", wP, we(v.subTitle), 1)) : Y("", !0)
          ], 2)) : Y("", !0)
        ], 2))), 128))
      ]),
      b(s).content ? (f(), y("div", CP, [
        fe(g.$slots, "content", {}, void 0, !0)
      ])) : Y("", !0)
    ])) : (f(), y("div", DP, [
      (f(!0), y(Qe, null, tt(e.steps, (v, m) => (f(), y("div", {
        key: m,
        class: "ui-stepper__vertically"
      }, [
        (f(), ce(Dt(A.value), {
          class: he(["step-status", [
            `step-status_${e.type}`,
            `${v.status ? `step-status_${v.status}` : ""}`,
            { clickable: e.clickable }
          ]]),
          disabled: e.clickable && v.status === "waiting",
          onClick: (w) => c(v, m)
        }, {
          default: ue(() => [
            v.status === "finished" ? (f(), ce(b(Il), { key: 0 })) : v.status === "error" ? (f(), ce(b(Df), { key: 1 })) : v.icon ? (f(), ce(Dt(v.icon), { key: 2 })) : (f(), y("p", BP, we(m + 1), 1))
          ]),
          _: 2
        }, 1032, ["disabled", "class", "onClick"])),
        X("div", TP, [
          X("div", xP, [
            X("h5", null, we(v.title), 1),
            v.subTitle ? (f(), y("p", PP, we(v.subTitle), 1)) : Y("", !0)
          ]),
          e.activeStep === m && b(s).content ? (f(), y("div", kP, [
            fe(g.$slots, "content", {}, void 0, !0)
          ])) : Y("", !0)
        ])
      ]))), 128))
    ]));
  }
});
const m6 = /* @__PURE__ */ je(OP, [["__scopeId", "data-v-0f2ad864"]]), Nf = "data:image/png;base64,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", MP = "data:image/png;base64,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", zP = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoAAAAHgCAYAAAA10dzkAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAFZPSURBVHgB7d1LrCRXft/5Hyn2S6NuXkoYt7rbAx4CGnlkQGJRAqyFB2Bw4YUBaXi57JlFBTeaJYtu7Su4b6Eul92bCm5ayypK2s2iksDMYgC1q6jFDCwZqCDgB2TAXcXulg3IQl/n/544jLh545nxyIjM7wcI5L2ZkY97Mx7/+J9z/kcCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAYb0gAACq3coXk+W3T7bLcwEAAOCouO3yYLtcbpen22WTL8/y+x5tlzhfDwAAACt3Rz7Quy8f5D3eedzl92/kg8NYAAAAWCUnn9mzoC4q3f9s5/eyOH/8jgAAALAqd+Wbdi+2y9nOYxf5UieSDwKdAAAAsHg2wMOaeHezfmVR/niTVM1BIgAAABYgZP2SlvXO8vXOGtaJ1B4kAgAA4EAi+azfRkWJlzZtTbwhSAQAAMCCWJB2Tz5Q6ztoI1N9E3HQliUEsCAvCQBw7CL5si5WwPkN+WLOY3L5LQWiAQAADqyc9RsySKNLH8DHAgAAwEFF8gMzmkb4dmH9BJ+1rGPB5X0BAADgIHazfkP75Vl/wYct61iQeS4AAADMLpIPxixjN1ZA1hbc3RIlYAAAAGZXzvptNN6sHLG6FYGm+RcAAGBGkXyQtk95lyZn+evGDeu4/H2dAAAAMIswm4cFal2LOndlGcW2zF4qsn8AAACzCHP4WvCXavwCzBZYWlDpGtZxIvsHAAAwC2vmfZYvYzb5BrfVPvWbeaD2eYQBAAAwgNsuj1Q0+TqNzzJ/Fvy1NSfH+Wdg6jcAAICJhKzfWLX9qlifvy59CZ3aB4cAAABgTxbohazfVE2+Tr4/4WN1yyqmYuAHAADAJCIVWb+pm3y7zhN8Z8LPAgAAcLLKRZ2nGuUbyQdyj9V9nmAnHyx2XR8AAAAdRCqKOo9d2Dm8vjUp921ODkWhEwEAAGA0FpCFwO9pvtzTOCIVgV+i/hlF+xwbAQAAYBROxUAPW57IB39RfrtvFtCCvNDHb9/AT+pWFBoAAAAdhaLLYbBHkt9vtxZ0natfvzsL8CxgDAHlRsP67EXqVhQaAAAALcJAjzAQoyrIS1T0u2sKwuz+3aDvjoYPHHEaloEEAABAzgoth8Cvrf7eRb5uqmLmDVs3lq/FZ/dZcLjROEFf4MSgDwAAgFGEGT1C8JaqPWizdR6rGB0cAr5EPms4domYs/z9utYGBAAAQAUn30RrQZwFVn3LsKTqNk3bGCw4fSwAAADsLVIx20aq/YopW7D4UNMLI36nmGsYAADgJNhAj5Dtswxg1/l2d11o+iZZyr0AAAAM4FQM8IjUvb9fHQsepxyNS/AHAAAwQKjtZxm7UMcv0TChMPQUQrFoJwAAAPQSavuFPn4hsDrXME5+9O8UQrA6x+ASAACAo+Lks3Qb+WAqlHlxGi7WNPPwEvwBAADsKdT2S1T0/dtovJG0qcYvyGzBn2UVCf4AAAB6KE/nFqmY4WPs0bpj1/8LwV8sAAAAdOZUNPnaz6E5deyRuuf5+4yF4A8AAGAPIdhL8t/DYI9I40s1XvNv+NyxAAAA0Fl5lK8Zc7DHLiefrXMajgEfAAAAPTkVhZ1dxe9TSOUDzKHCIBWCPwAAgI4iFYWdjdPwmT3aOI2T/QvN0wR/AAAAHYUAKs5/jzTOzB5tUg3P/oXp3Qj+AAAAOrDMns2/W+7fZ02pc4ygjTS8XyFz+wIAAPQQ6vmlKpp452pKdfl7DyknE2oTOgEAAKBVGDBRDsCmHOm7K9Wwpt85PysAAMCq7c7qEe6beqRv2ZBm29Bk/VjTDUwBAAA4Gk7F/L2udN/UI33LhgZ/Y88/DAAAcLQi3Zy/N/QBtKbgu5rekODPqQhUAQAA0KKqv1+kosyLkw+upgoCLVs3pM+e083gFQAAABXKgVd5VG8ICJ+qGIjhdn4fS5S/7kb7Ndu6/PmJAAAA0Mipur9cucyLrVPO/IXnPNDwPnaR/GCN3cxjH7c0TzFqAACA1YtU3WRaVTfP6XoQWB4R3DcItPUt2AuBX6L9A8nbuj4zCQAAAGpU9fcLTcF1ZV7svt0+gGl+XywfUEb5emGx7Nx5/j4X+Wtfymcc72hYBjH8DbEAAADQKGT4yv39upZOcSqCwHLfQXvek+2SyQd4Ycny+x/KB4DnGqc0S7mJGgAAADWcqgs52899SqeE9S0A22j+WnvM6wsAANBBqOVnWbhywOa03+jZWD74mxtTuwEAAHQQBkrsjrIdMno21rwBYHlqNycAAADUCn3lop3764LCrhKNXwuwjhNTuwEAALRqmlVjjNIpqeapu+fE1G4AAACtnOozZmONnrXm2HNNy4nZPQAAAFqVB3vsGnP07NQlWJjdAwAAoIOmfn1Vs3vsy4KzS02H2T0AAAA6CE27Vc2yY5dOsffYaBp1g1YAAABQUpfdK5dOGXP0bKrqJuahQhM1s3sAAADUaKqNF6Z2Gzv4MxakRRrXmE3UAAAAR8mpKI9yVvHYY01TOiUMMhmLffYHosAzAABAoxCEJRWPOU1bNy/VeAWgnSjwDAAA0KpppK/T9HXzxmr+daLAMwAAQKumEbJO0wd/scZp/m3KYAIAACAXBklUjZB1miegsgEnsYaJRIFnAACARk1z+pq5ZsyI8s8wpK+eNV9bAelYAAAAqOTUPEhizunSHg98n7HmIAYAADhaTs2DJELwF2t6sYb1/RtzDmIAAICj1DZIYs6mVJd/llj7GXsaOgAAgKMTqb7Mi5m7H12q/er+Nc1SAgAAgFyo8Re3PH6ueVgQuk/2zokCz4Flc2P5bO790mK/2/foBAAATlbbIInbmncQhb3Ppfq/n9NpF3h28oGzZT+f5ctD+f9HUlou5APky3xdBscAAHBi2gZJHCL4a2qGruN0mgWeLctp32EI+jby/zvX4bm2TiL/f7snAABwEtoGSVhgYVmiuZp99y0tc4qze0TyQZ99Pxv5pt59m7ydfLP5Y9FsDgDA0eoySCI0C6eaZyStZa32GWAyZz3CJYhVZPsSjRew2es8zl8bAAAcGaf2QRK7fQITTRcE2mcIU81F6qdt4MqxCM289rfad3dH02TqQhBIczAAAEfEqX2QRAg0LBtX7oeXaPwg8E7+Xg/UP6A5handyoHfRv0D5H04zTvaGwAATMipvZ9cOfMX+tXdLT2eaHgQaEFNKPGyT9bPhMxfpOMVy/9/Npr/77Tgz/6/9AcEAGDFugySqCoF43RzhGii/kGgBRKx/KCTkM3aN8M096jkuUUaFhyPxfoCJgIAAKvUZZBEVfAXOBUjRF1+n9WRCwGlZfPineVOvs6DfL0wUtXWj7S/Yw7+Ivmga8jUd2OKRBYQAIBVCk15ccM6TcFfWQj6YhVNk3Zfmv8clof5ffaYBYKRxgkijjX4c5pmVO8Y7HP1rccIAAAOqMsgia7BX3ChwwwQCDODHNPAhDDAw/6uCy0z0xZmFQEAACsQRtdGDev0Df6kon/anJyOr9RL+H42WvZ8vE7+cwIAgIXrEtjt25waad4A0Om4ZviI5P+ex1rPCGbbTpwAAMBihXl9pwj+TKR5A0ALlC60fk5FP7+19anLRE1AAAAWKwR/rmGdoQMpIs0XAIa/Z83CLCfWzy/ROkfUWuAaCwAALE7X4M8CkSGjaCPNE5RFWn/T41r6+bUhAAQAYIG6BH/WhDfGtGn2OhtNz/6etZYfibS+fn5NLACkCRgAgAWx5sW24C8Ugo41nAVlG00r1jqbfu3/vNZ+fk2OJZAFAOAo3Ne8wZ9JNP2gjLU1OYZ+fkss5DyGod0GAADASPoEf2Nmox5q2uyWBU8WcDgtXyjkbP9j+z6cjk/YhgAAwIFZsGHNck2ZJqdp6ufZ+07ZH8xp+QFHOfDb6LibR2PN0+cTAAA0OGTwZ6ZuDnT5eyy1GTVWMQ9ypOOX6jjqMAIAsFqHDv7mag7MtLzgKpb/v9oS6XSc2t8LAMCiHDr4M9b376GmZ+/T1r9xDmelz2JLrNMSaf2FuAEAWK0lBH9m6gEgZdbseKgg8JT6+DVJ5bc9AAAwsy7B31m+TqppDZlCbh+J5s28RfKB56kHfkHbnNIAAGACSwr+bOTvIZoDY03bBBuaeUMBZwsAIyGW364AAMCMugR/5kHH9YZKddjRoLGuB4JD/t6z/DVC0LeRDwKXOvL4EE6xzyMAAAfVNfjrut5QTsspzhxvlycqii9Hav/7nXwG0wJYC/rsb9nINzE7YVcsBn8AADCrMMNHW1BzV/MNkphj/t++rG9aKh8MWkBngfCjncX+P8/yx209CwBjkelrQ/YPAIAZ2XyyXYK6OYM/afm14Cygi+SzfHFpsd+d0Ecssn8AAMyma1A3d/Bn77cRTgXZPwAAZtI1qLOm2GeaL/hzM78fDisW2T8AAGbRNfiz5sy56/ClohDwqXAi+wcAwCy6Bn9hDt5Y81nKdGyYh/U/JdgHAGBiXYM/l6831xRsxgLOSzELxKlwWk6ZHwAAjlaYZ9a1rGePW/D3WPNl45ymn1MYy8L3DQDAxG6rW18+p6KOnf2caPq5WZ0IBk5NyEQDAICJWPDXpWm1PL9voiL7dyd//hTNwZF8sJkIp8KJUd4AAEyqz0AOm993U/o9UREERvnPdzUOCzbvaf5BJji8RyLgBwBgMn2CvzAbyO50ZYmKINDlP9/TsGnNovx1NiILdGpo+gUAYEJO3fvVtY0MTlT0A7R1HueLU3cWMFoTcpgrNxZOjROjfgEAmIzTeMFfkOj6IJKLlueFeXJD0GfP3YjA75Qx0AcAgIk4dT/R9p3lI87Xf5Qvlzu/2xJKx9hj2XZ5KB8EDmkyxvrR9Ass1AsCsHYWZFkQ9onaR+zeytd9Vz5I68rWfZa/R5Xn8oFflv8MRPIDjN6Q3y4AAMCILKB70GE9p/2b41LRjIfunOafUQYAgJNxX775ta2p1WlYX6xEBIDoLhVz/QIAMImuAzlCoecL7S8RJ3R0E7ZL+n8CADCyrsGf2S30vI9EZADRzomSLwAATML6VXWdUmusbEwqAkA0c6LkCwAAk7ASLl3m9zV9soRtQlkXoE4qugkAADA6p+5TvN1W9yxhFzbS+FxAtTEvNgAAQM6pe/NamAt4zIDNXi8ScJMT/f4AABidU/fgr8+6XVn/wUsxqhM3OdHvDwCASVgJl7TDehagTXEyjvLPAOxKRb8/AABGFwo9d9F1RpC+bPBHn2njcBro9wcAwAT6nGDvabriuxZYxgIKTvT7AwBgdH2Cv6kzMZzoUTZVVwMAAE6ajd61Ubddav2FdZ2mYa9P/z+UpaLfHwAAo3LqXusvrDtlfT4KQKPMtgX6/QEAMCKnw5Z7qXoPmn8ROHWfhQYAAHQQ+lVdjLzuEDawhKY+BPT7AwBgZFa+ZdNx3Xs91t2Xkz/hRwLm2eYAADgpSxrxW34fav/BxKLfHwAAo+rTqX6uDvhO9P2D5+S3uVgAAGAU1pm+a6d6Jz/iN9L0rPDz1P0LsQ6p6AcKAMBonHxmpUuJlbBuoumFJuYpZhTBusSi6RcAgNH0nUlhjhG/JmQknXDqnPx2N2WNSQAATsqDfOnCRl/OMROHU/eMJI5fKpp+AQAYTZ8m1rlG/DpR4w0FywTT9AsAwEj6jOKdeo7fwIngD9exPQAAMBKn7qN4w7pT978KmZ5EgBfLbxMAAGAgp2XN8WssG3kp+vzhOmr+AQAwEhvE0XUU74N8/anKsDj5On92ou9SfxCnwzLOZP8AABiBjeLtelINgz4eavxMzFn++pb1uxB1/nCTXRjEAgAAg/QZ9BHvrBt+v69hA0FC4Gd9CjdiZCeqOVEDEgCAwfaZ5m0362f3p/nr3FV3FvRF8hkde+5G80whh/VKRd0/AAAGcdpvmrdY1Vm/sE7TzAwufz8L+iyYfJy/Jk296MK2rUgAAGBvfQd9lDMvTj4bU9UHMFYRIN7J3yMEfKGJ945oxkM/kRj8AQDAIGEgR591q7J0sW5mA+3WgksL9lL5ADAWAR+GSUXzLwAAexsy6KOKPZbm61mw90yM4MX4aP4FAGBPTtPN9BGKNjsB47JBSs8EAAB6c+o+e8dZj3XL5pgXGKcnlu87CgAAetodyNEkzdfvy/r+xQLGlYq5oIGT9JIADGEDOawZ7Y2O6765Xd5Sf5+Kvn8Y3+vyM88AAICOInVvmu2zbpVEjNTE+LoWKwcAANqv2HOXdevEoq8WxuXkA0AAANBRn2LPfdatE4livRhXJLYpAAA626fY81BOlOvAuKwM0UYAAKCVnTTHLPbclRPNdRhXLAJAAABaOVXP0Vu3bp9iz21sBDABIMZkfVIZWAScqBcFoKtH2+Uj+dppTc7ydT/UeCU2nue3TsA4KCsEAECLPn357mmapjWmg8OYYpEBBACgVqzuffnuaLx+f7sIADGmWPQBBACgklO/fn9TFtalDyDGFAY0AQCAHV1r+Fl/KjuZJpqGEwEgxuVEaSEAAG7o0+8v3S4PNB3LKnKyxtjoVgAAQEmk7nP3TtnvT6XP81jAuGybGqtUEQAAq+bUb57fKfv9BbHosI/xXWj4NIUAABwFa8rtUh5j6n5/ZZyoMYVIDAQBAOCLfn9diuSmmrbfX5kVlu6SkQT6sq4OkQAAOFFO3TvFz9Hvr4yTNKaSiILQAIAT1ac518kHZFP3+wsYAYwpOTEaGABworpO3zZnv78gFgNAMK1UZAEBACcmVvfm3Knm+W1i/f9iAdOxCxu6GQAAToZT96neYs3b70+ieQ7zmbtfKwAAB2PZtS7lVZy6B4pjspPyQwHzsH2h6yh4AABWqU/Jl7n7/ZXfd67BJoBJRSYQAHCknLo3rfaZE3hMZP9wKCETGAkAgCPSNaMXqfucwGNyIvuHw7ILENv2bXSwE4Cj8oKA02MZvXi7vNaynpPvI/ih5p+GLZXPUL4rBGeib9rcnPz+Eslvkx9tl0z7se/ulorv0Zbn+WNZaQHqZMJoCABxaiL56dveUPvBJN0ub26XtzTvgScEqPYZn+u0ue1yW/57s8X+H58Lh/Ky9g/C27673dfmu0bZq/LH4Y38hchGANCRk29W7TKnbiiJkWre0b+h2c3pdEUq+l3a/2Ij//9/LOohLoFl8Ww7taz4Zrs80fUMXpbfn8p3s4jVfXt2Kgqf2/d/V4CXyW93qfy2YYt1T4gEAC1SdZvtwOl6UVy7tYPNI00bmN3VvFPMLYVlfSL5gOJZvlzk95UzQhTEPi2RfNDPYBSYTNe3A/s5FcEggBaxupe2CAeTcud3C0RCgNIlg9iHvfY9ndagD/ubY/n/sf1PMxVBXx0CwNMUsuJkA09bpvrjg92fimAQwA6n7s24oenRnpNWPC+81lh10mIVzZxOx82CPjuZWyAX/uZE3Q/UBICny4km4VOXqduxwtZJRTAIQN2bfiPd7H8XqziIOBUS+VG6+5yQnIrm3mNv3nLyf6sFb/b/2sgHgfsMJCAAPG1OBIGnLFP/Y2UkgkHgZMXqlq1zqh8gYo+las4G2vOifLmVP+by3+P88fu6PrAh0nGKVBQStr/1ofz/YGgJFwJAOHUfyIXjkmnYMTMSwSBwMpy6N/2mas8SxioOHBbkhSzeRj7IsdusYnmSv34IEocGQkvTdRDHUASAMJEYKX+KMo0XsEUiGASOWqpuBZxjde/T51QUabagL9Jp2mcQx1AEgAhsW3sknJJM0xxfIp1oMEghaBwry7a9p/Ziyk7+RPKB/EGgKwt6rED0E52WWEVhZmP/2080z//hdv4+nwrwGfh0u3wmnAI7nttF95TfdyRf/N9k8q067+tIC/ITAOIYOfn6Ye+ovVq8BX8WUPTtUxSafLtkGI9JyLpw0sWhWRb67e3ysZgxB9Ow7avLeQTAQliQ0iUwCyVf9umnFgZ1nBqaYbEktj0mAqZh21ckAKsQpnBrC+qcfD8+p/2cy2cZTw0BIJYkku+OAUyBABBYCafrU7g1sSAx0f6cTvPEQwCIpTn2Wpo4nKMOAF8UcDysSfYjtffXCIVkE+0vk88yOgE4JNvnKQ4NACcq1jxNv2WZTmfu3oAMIJbG9vlLHV99TRweGUBg4Zx8BuBdtY8GDCVfMo2Dkw5wWLbPb+T75QLoiAAQxyCRPwFsWtYbo+m3rGvxaADTslqUbwpAZwSAWLtY/sD/Qct61lRrI4TfEoBjsxEZQKAXAkCsmZPP6rU16Voz7QON2/QLYDk2+a0TgE4IALFmifyBP21Zz4JEm7ni1GbtAE6JTRMYCUAnLwlYp1i+6betSTfK131D08gEYAlsSsdTG5UP7I0AEGvk1L3p976ma/p9TafpVZFpwTK9LrZNjOeoqzwQAGKNEi2j6dcCoUynxbIsb6nIvNoJ1/7HbeV3xvB6/j6fCahmrQIvCMdojmPNy/IJhk/z3z/XPMc2AB1E8lOwuZHW25eTLz576jLNl3GhCDWaUBD6uGWa/lgTqb2c2NFgEAjWpkuT7tRNv8bJdzoHsAzP84UAEOiAABBrEgo5tzXpzjHqNxJNkcDSWJOdE4BW9AHEWjj5vn9tAy9sFGCs6Ub9BtbX6CMBWBJm5wE6IgOIteg6h+9cBZ8jnVBfEWAlLCtPE/DyRPIX8E5YDAJArMGd/DZpWc+afq0P0NQFn23KqUzUAASWiABwOaxFxi7e7cL8zfxnLAQBIJbObZf3tsu7HdZLtss7mp4FgDT/AstDyY7lsAv3x9vlk+3yivwxk37TC0IfQCxdIt/UumlZr2sT8VBuu9zW6RaBBpaMUcDLYK0xsXxf7FAtwY6bqbAYBIBYsljdpnsLo4MTTS+RP4hlArBELwuHFII/O25npfsjtbfkYEYEgFgqu4rvMt2bU7fRwWNwIvsHAHUi+aZfy/xlpfudfHY2ExaDPoBYKuv3Z/1F0pb15mr6NYnI/gFL97lwCE71BfjtMfpnLgwZQCyRU7esXtfRwWOI1a05GsDhWMsBgcZhJPJ9taeuwoCREABiibpk9Zx8E/Eco36dujVHAzgsAsDDsHIvTRfIfCcLRBMwlibOb5OW9ezxh5q+GLOTD0ithEEqAMCue/LHyKzmcQsAnbAoZACxJE4+0/Z+y3qx5mmOdfLB38eap5kZwDCvihl65mbZP6fmEb4hA0iGdkHIAGJJEvmD98OGdZx8kPihpm2OdfLBnxUxvSMAa0GAMS87Pm7UfDx+Lmo0Lg4BIJYiks/qfdCyXpLfWpODjThzGp/N9GEV7K1JIxaAtbCBYwSA83pb/oK8TSafLcRCEABiKSyYa8vqOfmDjTX92oH+he3yVOMFgk5+zkp7PRtckgjAmlgTcCbMJZIPuJ90WPdT0Q9wUQgAsQRhJo+28gHWJJvKH+BtiVUEgo/y13HqLxSdtqzfZ/lrbgRgTULzYibMxVpLNh3XzbbL6wKAnNsul2oP3CxAe5avW5Xxs9838hnBWN1E8gHls/y5kdBXpvn+bxbkxwKqRfL7P+bTZ58MXWv2lWn6Y02kE7r4JwOIQ0vUPruGy9ez6YXqmn7t+ZH8SLT3VB0Iuvw+yzRa0Pcgf94bOrEdHzhClgH8TJiT9enLOq5rzcROACAfjFmg5lrWS3Wzedjl99dlBOP8tW2xQC9kDzf5a0XCGDKRAcQyJGIWirnZMbXPyF47DjvtJxMZwFGRAcQhdZldI5YfHbx7YM90vQ/gbkYwVVG42er42cCRV1RMVr4RgGPSJxuF4Vx+22fUtWUBI2ERKASNQ7Hgzw4cacM6YXBGU5Bo98fyV/+2PM1f017b+py8JU4KwCmwEcBdRqPicGwkMKVggBPm1G3gh9X6e6j+r512fH0Ml4kmYCxD3+ZIXGf/u1j+wrkLJ/8/72PIQJBMNAEDq5eqva+O0/5B3Jk4GcwlEwEgDi8SI4CHsKxcqIYQ+k63HT+d+geAQ47NmQgAR0UfQMwtVnWfvl12sm/rH1iHaYeA02IBzKfCPpyK420k36/apsC83/K88vy+XdlzbKQ2zcALQACIuXUd+GES7e9z0QQMnIpINN3ty4I/m4WpfFFuA+UiNWfc9r3Q3oiBIItAAIg5dRn44VQEiUNYcwYZQOA02AwTDADpL85vk5377ThtQeHdludn6p/N28i3AuHACAAxFyd/kHmnZT1bZ6PmILELa2YgAASOnwUgtq9vhD6cmi+2Q73UpuPop+qfzduo+M5wQASAmEsif0WZNazjtsttDc/+GfoAAqeB/n/7sRmTNqq/2H6ePx6rnmVd+87vm8l30aEf4IERAGIOsaYf+FGFABA4flZa5KHQh5Pv59d2sf3Rdnm74fGN9gvkNqIf4MFRCBpzmGvgR1kmAkC0C7XP7CTn8iVT0cHdMktPSssh7H5G8zz/PDbLzakHP3ZxeUfoI5If6Zu1rGfblo0Gtm3wecXjT/LHnPpduG/kW3twQGQAMbXQiThtWMdpnIEfu14WUC+Sr3dmGSQLpKx/qpXAeHe7vJ/fZ2L54rW2rmWxneZzK3/v8BnfzRfbV6wZ7V7+uWKdJvu/WGCSCX1Y82/aYb0uZVueqH8W0ALLSFykA0fLqVsx51TtNaf6SiZ4TdyUaZ2FoC1wuOz5epGKWWbaRkeOwcmPZm/LbsUqivc6nZZU7V1LcF3fYswXav4fp9ovA5up37EjE4WggdVI1R6EOU0zbdsdEQDOIdP6AkAnHyzt22zo8udbZm7KDIa9R9JjfVvX9qVTag61AHmfPminLFK/WVNi+X2vTluAONbzMhW1CRNNc7ETiZlAgMEsw2J9c9qadR9o3IEfwXMB1SL5Zq19M0eZfFOx3T7QNELNzKTHc2zdN+Sb9+bIUB5arKIvJKbT1sSbab/uNtYM/HbP59h2/UBF1wgAC9SlX1Ks6ebvjEUGcA6Z1pcBDP3+hrLsn2WgIo3v6YDXdfnzjz0IHLNLwClx8tttH02tNLH2C8bC/uM6rp/pejeHKeZ7j0QTMDCINUF1Ceym7LweiwBwDpnWFQA69Z/Avkmi5uaxfVhwOvTCyMmfXMcIdJfIaZquI6ei74VLpvptKdL+26vtO126LDhd/75DP8axRaIJGNibk2+Capvxo8u0cMDYrOnoE40n1fh90MKI3yEy+dHCdhHkdHwS+f99JuyjyzRvZRvVb0eZ9mfbedRhPduOy12FnOjmMxgBIMaWyB8smvrlOHWbFm4IJ+AmC9bGPHFk8tmIMZuirO/sQw1nr2GFfI8tE+7k+46NXTbqlFj/V9sXoo7r2z7jGh5veqzJRu3zAt/KXz/deb9MGIQAEGNy6nZgTsTVOw7DArUlDxoIRXU3Gkeifif6NYjkC3Rnwr4soOuTBbR9xml8YV+MGtaxJuKNrn/fTn4gFwYgAMSYrD9H23y/kbqNDh7D5wKuG7vTuMtvx8oqWrA2ZoAaTvTH1BfQgpZUGCoUNe/SBy9T/Zy/Q7d9y1I3bZ+WVPhw575IjP4ejAAQY4nz26RlPWuOagsSx+BEHxFMz2ncE5EFgGNnNjY6nmm3QqCQCkPZ8dH6iVpA3XZhlKk+Azj0OGv7T10zcJjpZXcfe1kEgIMRAGIMTt2mcovz233rr/VRN3clkGk8doIa80TkNP7F0Sa/HXuwypxsf7ZjjF1ADh0gg8JGfvttywJm+a3T+B7Kb5tVQWjdgKhbogvAYASAGION+t3oMPP91rErRAJA7HpV47LmqTEDEjsJZhpfpvUOjIq2y+OvfOWrydkrv2r/n77Fg9HMsoB2DG/LAn5Ws47TMCHDV9UMXDUgymn5fXlXgQAQQzn5q8e2wM6aoKzjdqp5THUixbqNmTmI8tuHGo8FqFNcuDzXOi+I7r7w4ouPfvXX/kf3zV//ln7lV76u7e9OjPIfUyZ/EdOWBexTtLmvTyteO2QFNzv323oEfyMgAMRQ99Q+lZuT7xvYdoAZ09jlPrB+oQl0o3HEmqZobKbxrXF/uPtLL72UfOtb39kGfr9ydceLL76oL730kv245ubsJUrVngX8TNPNfZ3pZnbevuNPK9a1+xngNwICQAwRy++MFy3rJZq37Es4SHGViDK7ABkrW+c0TS261zS+WOubM/cq+PvmN7+ll3zA94Vf8r9PFYicqo3a+wLW1QKcqr91pOoLLJp/R0IAiCFCn76mnd8CxLnKvpTfkwMEypz8dviRxtGl5NEShMETc+5/Q7ntUhn8mRdfeDGsg3HZNtLUv9KO81WB91QBoJWd2VTczwCQkRAAYl+hgGjast4D+ZNupvlMUUoD6xbJbxMbDRe2/UTLZidm66JhJ+dU6/Ho7JVfrQz+MKlQ7Dmqedy2o5drHhv7eGvbbt2FvH2GTBiMABD7cPInv7da1ovz20TzIgOIXRa0JRrOmshitW/7Q4yRTbF9wLKU1qQ85WcdW7xt4nXf+MbLtSv8wz/8g91kwthsu2uamzerud9pfOEYXrUvTJVxPDkEgNhHom59+g7V9FTXdIDTFGuc7N+5/DZtc1hnms7Qk5t9xscqTuZrOlnefeWVX2tc4fLyF3aTCVOwPrJNzcBVfVTHCsjKAzuaWnFeEQHgKMixo69Ivi9VW1YhdCZONS8nMoBrZieTSEU/n42Gn+xtdOOHGsY+jxUhfl/L3bac/Ge0/+EbWt8+cJX9++Vf/uXaFX7xi1/o7//+7+1H9u9pbOS77VQFdXVB1xglt9zOa0Sq/46nKpV0csgAoq8uU7k5+ZPuu5pftF0+EQeINXLymask/zneLk/ltzmn/YS+RA+1Pyd/UrRsdqr92AVRova/Y99C1ZH8/87KZtjF2RoDpPNvfP0bjSuUgj/272mE0eJRzWNV26fT8O9jN+B8VQT5kyMARB9xfnvRsl4ifyW50fwijVuYF/Nw8n3WbMCQBWyx/HdpTU4vyAc3t9RfU1+irsLnatvu69hAjNv5Z7GANmpZv+9nteDSAtT385/XGhy9+ZWvfq1xhb/7u5/ZzSfClOz/G/VY34K1TMPsDuxgpO8MaAJGV06+b9H7Hdazk90U9cza2FWk9V9JhLU5l79gSHbuz1QEg5YJfF39OA0rGhvnt4n2E8n/bZaVy+QDNAsI36hY1+W3fQK4u/lrrjXrF9x68cUXz7785S/XrmCDP/7u5z+3H/cNxNGNbUe3K+6fsgn4tdLr3yp9DkyIDCC6SuRP0A87rJfqMFdv5/n7ZsLatM2pu5EPcsJAjLnYew3pyhAC2yz/3YIXp+oMi1O/bTfScQR/5lZT8Gd+7oO/VOzfU7NtqSrbXlcH0Gl41rmcRaTQ80zIAKILp25Zva7rTWVtBW9ROOuwTiYf7FiTrGX1umSC7Dn79qs7z2832p9lLHcDW2tiu1XxuvY/6FNPzTKitr0fw8ny/Ctf+Wrtg5b9++nnNhUt+/cMMvltsWogyFnF70MzgK70vqZpBLBE/8/RkAFEF3bCbZvv19zvuN4U4vw2FdbIBi906eOXyZdhsWA/6ri+035Th0Vqzkp2UZXNsN+rmrJvqXswF8ufJI+lOfT1r361PgD8T3/7H+3mUMeWU2MBlm1brsO6Ll9/SFDmdH273/19l1387bM/YwcBINrE+W3Ssp5lS5wOE4A5kf1bu1Ttk9EHdnKwvqg28MG1rJvJn8y6BJe7xqgn6XTz5JjVrNun47tt78cS/Dlb6gaAPH/+3DKAmejbOydLt3bZZ8bo/+d0vZ/u6y2v+UxMBTgKAkA0ceoeWN3T4a7QE/kTdSqs1UY+sOvavy+VH5l7v8O6D1U05/ZR7pi+r6pmtPDau7qWvriVv25bf9y1uFWX/fu7n//Mmn4zrWs2k2PQtSuCbYtDBlkZp+vbfVtQ+akIAEdBAIgmlpGxnS1tWS/Ob9vWm4IFDFaYmuzf+tlgiz6DPBL5E8GdlvUsUHpb+5mrv1GoV9glAIx0XKVQzr9UMQDE+v09e/YT+9GyvZkwJ9vuXYf1xhiwsZv5btsPun42tCAARB0nf2JtO7maQzW/WtYxVlFiA+uWyX+Xts11CQLtRPBuvm5T0/GT/HGnZajKCoaTXpeAM9JxTXX4+le+crP51/r9/eIXv7DjyrFkOo+RbbdjjAB+Uno9tbxmXR9a9EQAiDpdm3Tj/DbVeJx8/6ZH+RLr+sk7ki8MbLcEf8clk6+RF6tbELjJl6Z17WRiJ41I/Z1pfPaaz3buaxv5WGYZ76FZl6W4ynzuNgFb5m+bAbS/MREOIeu4nhVwHiMDGAK+LhnFjfbr04sdBIAoc/KBl3Wuv6VunczHzv6dywd3dmCxPl4f5/c9yj/P0/zz2f0WKGTCscnkA/tY/vt2LeuHGTCa1us6qrGsy3vvw+lmsGdN1Bu1Cye+LuuuQWTNvy++WJyKfvrTn+pnP/08kx/tjcNwFfdV9c0b2k82bM9PSu/b1qcwy28jYRACQAROPsiywOvz/Pd7aj4BWvBnJ7JU430Ge087ob+bv64FfRYAWjAY5he2g04iHLNM/nu2790Csbst637QYZ2+9QD3CRq7qBrsUVUXsIqt96mOR/TlLxX9/0r1/mw/z4QlqcqGD50Gbjfj5+T39zahliYGIABEkMifgOzAG6uYgzU0we5y+f2JxmOBXt2gk0TFlWbVFWfIWCaig/Aa1R3ME/lt0TKCdmKIVf39XjQ8ZrLt8or6ybR/EekmVZ3eTZemtEjH1Sfu9a/98v9w9cMvfvGLcr+/jXBIVdk+83xnHWlYABjpejbcqVtXCPoBjoAAECbWzZG0WX6/ZeMss2In3/PS47dV9L8aS9vor4/zdZx8k1+c/2zL43wd+9k+630RCK6FXWTY91dX0iWTP1GEUcK2vttZx05Mli2MVa9vf75Mw2e12T2ZVQV7kbqN6rXPb03FxxQARmEKuM8/v6r3Z/+HRDg0awnavdC27a/cPOs0fADIbua7a0axyzpoQQAIp6IfX1bxuJ1sXssft+ZZO0lH8gfpDzQuO5g0naRDNuZR/hni/GfrE5iqCApD9pJAcPksoHPy/TkjNQdwGxXdAex7391WUnUvJt2FbY8vazhX+rmqCbdrUBcy5JmOQ/RLL72kl7ZLqd9fLCzBbpbaON3MAI45Aji8ZtbtqQebchQ4Gqm6FdM1Ll//Uv4EPLZIfnTkWc17X1a8tz3nqYrmwd3npPlzutaWQz+ZhnXGvlCR8bEAx77HLgHcI1Vniuz+OxX3h8FFfUTq1h+pSabr/5/dLhX2t9r26dSuahtfs+RrX/vly29/538K+zV9upYhbJO7El0/V0Qa3gJ0qev7e9d9IVH381Yfkeh+gBMRa7+Rji5/3h2NLzQHutJ9Uf5+iYrPvNsMGO6vCwTD8zGuTMMCwFTXt6O6wG5XpOrg7I6qL05uqX8wF2ncALAq2IvVLTCNR/gsh2B/c22w/sorv3q5zQBein1zSSJVb5Oprn9PsYYFS5Gul0OqCzyrWMZ8ivNPJAJAnACnYRmFSDdrmY3BTtQhI2AHoaf5+5R3djtQJPn9u028saoDQfv5mPpOLUWmYQHgbsAWqT4LXBZOFmcd73fqfnIpf5aNhslU/H/sdjeIS9V+InO62Qd3DZz8505V/X0++/KXv2zfyQNhSRJVZ9d2s9f280b7u7PzfDv2dzmnOHXPFPYViQAQJyDVsBS6U/8Tahep/OeyE0akYt7Tus+Q5p+jLhAM/QUfi/5FU8g0LAAMRZGj0n0WENzr8Ny6k8DuiSroO4l8rHEDwHjn9bo2/6aaprlravY9pDWPhQu9fVogMK26/ScU3w9snY32l+p6RjHq+Hp3Nd3+EIkAEEcu1vADb6z+faraRNq/STpVdbN0kt8/1RXjqcs0vCBrIr8thUDfyQdrtxueY+vUXYBYv8IuGYwun2voiSZT8f9Jdl4vVvs+ZOusMUiK1dyf0/ZT9snlaboo2e2nuU+/2rLHup7Vtm2irZXGadrtJhIBII6Y0/DO5GcjvEaVqgCuj0jVzb9OPiiwA0dbcWv0k2mcivwWnJWzfnZisCCwbmBAqvrgLFJ1f7kLdZvdprx+omHKf0Oi65+5LSB1Wu/Aj7Ym6yX2ybXjmn1XcWmJdFqDUyJV7ztONy+4ujbZ1tkN5BK1759TbzeRCABxxFINz2pYCn6jccUar5N7rCIQjEr3OxWZwrX1p1qqTOMEgE43Z/yIVQTtof6jlXl5pOasWF0/wFj9Rq/bukO2k93PEat4/0jN23u4yEq0PmE0dx27yOvSz3MOkYopJi/dt752ees3v34Z/d6vXi3289nXrwap2Oe1rgmxjltd9jzSze+0zwj2Lq/XNrDjrqYfCBWJABBHKtbw5iQ3wmtUmSLTEau6FuCSTkBrl2mcANA43QwC7b5U/vu6zN8vUft3Z+vdqnj9Pt97Uwayi0jXm8jOSq/ZFtw90HoHRzRlWp2KwVt1LEieet+M7H0suLvzXXf54PtvXD579C8uL//yX1Yuj3/0zy8vvve/XAWEKrZRp+NTl5W2oH5Ts/4+rTZVzb1NF1xO/fvw7iMSASCOkNM4QVYqvyPazrobWO3LDqZj9ycMnPyJdnegSKbxApdTlmnc/6PTzSBwH00DQSK1G9q8ZaqyKYn8/yxteJ49p9wncm1SVQe3TkV/3KbMaqbpTvT2P31ggd/dP/qNxqCvbnn0g392lR3Uepvnm9Rd9FQFbCbSflm5qmxf0745tHtQV5EIAHGEUg1v+nXyB2/bEc81TpFlp3mu7JyuF7Fu6qCO7jKNH0g7+e+ny0jgOnVZqFTdTiR1J7w++nY1sO1x7cGf2S3tYyL5/0foi1v39521PD7EVeb19h9850bgt/nB718mf/Q/X55H3/yi+dcW+/3ie791+fTPoxuB4P27v33VZKzjKjJf979PVH/+2CcQ3u2e0/S9x5q+6TeIRACIIxNrnGbbVDcPAk7DMjap5i1x4eRP7Md49X4ImabJpDr5QGjfYChWdX+/roFdXQaxq0j9TlpO/m/daP0XJvb5Qw1P27ftfxlqeUZqzvbHmuZkf9s+w71tMBcCOAsCLeizbKAt8R9+56qZ1wI7y/LZbbLNEp5H/8gCk23z7zcu0+R3rgWBT/8sCkHgnMewqTjVj6xPVP83xuq/rfcZULIbLE4pEgEgjojTOMGOU32H3/AefYNAp8OVgohVDBRxwr4yTXdwtkAi1f6lgar6+3Vp2nUavl2mas5g2uc6z5eL/DNd6LjY35bI72vlgTCbhudMcWFm3/nl/eS3vwjcHnz/966CPsvyWbDX1uxrwWLI+FkgWM4IloLAIRnrJWjLwj1qeG6fIK2qfExdH8NY03UPqhKJABBHJNU4V6fWIT1peNype/+q4JEOP8oxEUHgEJmmvzpP5L+jvgMyMlV/trYuB7GGnQScmi+W0vwzPMmXC53O9ld18g/sAnLs7J+z1yxn/kLW78H3f7d3/z9brO/g2de/dBVEVgSBc/RTm1JdH0Cn5gFUVc3+dRLdzMLXZeaHZuL7inRCAeCLwjGLt8ub2+UDDRPJHxTShnWy/H0s2OzShBWrqM93SMl2+Vjrv3o/Zsl2+VA+cOhzgrUTSlUfvEzNQas1F6ban+0DH+TvU2af3f4GCxTekN+nbuX3ZzoNGxUlfQI7Xtj+F2+XtzSu+9uAzd35rrv65YMf/lulf/Hv9PhH/6vOo29qH9sAUvf+1W/pnT/+sR5u/tPVfe7bX9P95HfsRwti19yE/4mq941M/mKlrpUnlf9eI7W7lb9Wmau5LxJTeE6GAPB4OfmdtepE1FfdCW3XRb5Ol5N0+GzPdXiJfKCw5gP3sbNtayMfKHTtamAnjtsV93+q+oyb3R9p/yxArJsXNva7ZTLe2y7vbJd3dToB3y7b399XMU1j6CtoAbEFf5nGE28Ds8gCNhOCv0c/+H1ts3UaIv7D72wjy9/Rux/8lbL/+F+v7ts2Jyv+g++EYHatbJ95u+Yx227tOFl1fLfv1S7SuuybL+tmsPe6bn73kXxAuoRzxFEiADxeifxJLNUwcX6bdlzfgjo70Z2N+JpTswPMZzqtiv9rZdtXrG4n2U1+G+3cbyefV2uek8hvl5n6c7p5YRPJBzoWdL4h+hcZC45fkw8YbLH/S6Txg+K7yR/9xtUP2X/4r0p++DejBH+BBYHxH3xb7yZ/VbyhDzZjrfdi0gLAukxeJh8EhsLsuy7ULQto6+wGdWeqDgA3wmQIAI9TrHGafk04oXW1kT/BNmUB39M4n21MlIVZh0w+U2SZCOuX2vadVWUl7OTzWsW6Tn6/+VD7sRPjRsWFzZ38M36Y/0wmo5DJBxuppsmGWvbP3f6Df3z1i2Xqtk3BowV/wb3v/dOr4PKjv/j3V79bU/B59I/sxy6tIEvUlsnbyGdwq/a9rllAe95uBtCCwmznvlcr1sOICACP01hNv3F+m+a3tuOGK7ymbFlbFtCeu9GyVB2AsEyZfNbIqX3WCMtKRLre5JupOgNo61kmeJ+Tju1ztg29X/rdlrd0fKN71+A89Pv75Mc/uWqmDU3BbT7800xv/O//zxdNu20ssLz4UfbF7+999+ra4rbWKwxKutPwuDXNPqh5bLePZ1m4/3nFfdnOuhyTJ0YAeHxsp7ETYqph7DXsBLZRMVemjQILV+2hmLKreK49py0LuCSx/AGJq831sO/LgkBrWm0KAkNWostIeNveU/UXyW/rb+XvZ68T55+Pbeow3nzz937t6of0z//dVf+8Js9/9g/6OB/Qsfnxf9aTv/6pPiwFdU3iP/zH22Dxv2yf95Or32/95td19vWXnNY7stu2YWvqte3Y1axzR9VBoj33Y9Uf++05WYf7zlTdLIwREQAepzGamiyD51SMorQDwiv5fS7/+SPVn3wtC1h3FbzRcqZhc+rfzI3liOWDwAcN6yS6frKy7fWzitcxqfpxuj5IKgR/Yw9oQHfRtin2zAIxY4HZ7T/4TuMTPvjhX+v8j3+8zf59pnv/6p9eBYxvtgSNZedvfnObafzPVz+fff1Loak50npt5I/vdd0s7BxjA5qq+gOm8sf+pouysqr98axmXYyIAPD4ZPI7T6T9OfmTmJ3UrD3DTpwb3dwZE/mrvarsyia/jSses+csoVyCvb8FsHagS4W1su2zafRlyGjcy9e1k9Nuvbl9LgLK28+FCP6WwoW+fpbJs6bcKM8G1nn123797D/8l6t+fDZYJJSJsT5+r/1vm8bnW7D45K9/9sXvt37zG3Zz6OPbUKHfat1+Zdntqv6AG9W3ALnt8nnFfV0GhWBkBIDHx3akUI/PaT+J/E6cqP0KzNaJVB1w2ueoCvTsZJnp8OUS7H9kB6pEWLOQjYhVP/fuRr5J1h637HU52Ivz21T92HYctp8ov7XPkamf0NyFcTiXB3Sfb5t282Cs0Z3vvqYH338jjOK9/mLb17Ig8LOGPoGvbLN+FmwG2ybgqxutn23PkeoHdoRj+W6wF/qBd2H/p2cV92FiBIDHJwzUsNt9p2ezDEnXbEgIOKuCuVRFs9guO7DYyTjSYYRO++8Kcwnb5i2NL5PPRjRdVFiwFulmyZF9sn/2nDfz93TyFxPvq3ufv9DH9llpeax1NxsuRsgAPv/ZfwvBWKvz6Ncr17Xgz7z8K1+qfa41+zb9vmJ2fLeMdqz6fn2hv2B5v97I72PnNa9ZVtUEjBkQAB6XMJXSpXy2w5pvY/Wb6ixR/9IMdhV4purm3nfz+6Od+0Nn4SmCgTblprq2DCeGc/JNpWEQUfh5SJa6SrpdXlC/ICoqPbcrJ7+fhKZe+3mj7qN97UQa9km7EHpF1/vURsIgNqjDPNsGgENZiRfrE9g1kPTvP/x9FyRT0d8vqnm8Kglg23NVFpBs30IQAB6HSP6EYiek8kwDtlgQ+JG6ZQOd+mX/ysJV4K5MRT+RqmBv7p3f/r4wYjMTphb6ydlAjTCIyG7t/2/Bmm2XFghGGsem52vF8hcifZznz8nUf5+xfaQ8I8hG/iLElgsV3SYwwPOf+wDs1j/5RqdyLu//yf9/VStwl5WEufjTp2Gat/r32wZ85RqD+Xse08Vl6O9Xd9EWSsfEpftSdZ8ebvd/lQmTIwBcP7vqshOsZVYiVdfXS+QDQXv8qep3SHutMJqxr03+vLjisTR/XWviCid7O4m+qXnrAdrByA5UIUDG9CzYseAvdCgP7IQSy2+XFgjadhGCQds25rowsG3wYb+nXNvPEnXPmDsVmcNNzTr2P3pBGCJ78m/8gAwLyqwJN2QE67z3XafNX/7karCHBYK2vPaHm23wl3WaPcRKx5T7GubNxl27A6yFHTvrBv2VB1qVR/Ba8mG3GfiVmufvcsKkCADXzcmfWMNOFjesm8mfeEJNtN0rOXuuBUip9mefo6mzcDjZ289J/lk2moeTz0JaINr3hI/9xWpuGs1UBIJ2ArERgomKPnEhIHTqJlP9NG+7zvLX3aif8gwF9nPXDGKi5mDRMolhpDL2twlZv1CSpTxAo4oN9Hj655Hu3/3tq/VtuZ/8tp7+WdRpEImVmrn1T3zZGQv+8hHBxxYAmkT1I+43ujn61461uyVhulzcPe+xLvbUvVMDligENIn8SdJ2yjD7QFbzHDsZP8yfY5nDcPKynXRoZizN3z9S9Uk1U3OQOhWn6+U6MA+7oHDqHmBtSuvagT9SUWTZMnWhqTRreE177G11/3yZ+rul6xmLLk19Tn4fe63mcfsbbd+xffAYA4c5Zdsm2efboOzM+u7ZnL0f/PBvFG0zeW2sXExbyZgbb5YHfG+/+etXv+cFoT/RcfYvDiPu7eLMzh2bncftfGTnpYt8XXs8ZPvDfS9XvO5Zxfs8z+8/xv/jIpABXK9YfudI8t8tqCv39yun4ndlKorjBm9pnMxYl7kgQ1Ps03x5rKIPyRTsgGQH5ESYk21/+wYzdtC37dECo0i+2ShkCMvNxW7nefacW+qeOeh7cgmvG/6u1zo+L1F99i/0C3xL1KMcy0cfb/726oer5t18OrgpWHBpQWYYJPLhn16VmEx1vDIVpcZ297ONbmYBLVAMF2XPVb1vVt1n+7oTJkMAuE6hhERVx/NE/qRkiwVWsZrdyZexsg6pmjv+2ns9yn+2TsV2Ure/IwwWONe4QlNFLMzN6WbR132FgDBW0VxcHkTiSuttNF0zqlP/oNGpfqBIeUQ6mb/xPEz/4t9f9f2zZuA7331V7yZ/pbFZ9s/eJ9QPtHmHt9nATMcfyNsFe6bqi/1QAzAEdamK1oBMN4O9qvtMn+oV2AMB4DrZzvWZ6g8ymXwgFUYU1o3cmoKdHOuygHZSts/+Rv6zndA3Kk7sYZRZpHHYZ7D/wzvCsdno+iCS8ij3qrpkdbpmCsvrlwNA6wOYtTwnUXX2z/aBWIxIn8Jm2wy8ybNxVwGaBWs21dtY7PXe+j//3+1r/8YXg0RiH2R+pNNQV+Jro+tZwOcqmoEz3Sx8bo+7itf/TASAkyIAXB8nf0KJO6ybqii3YdnAucpL2NVhuOILnNr7J1ogWFVPqo/Qd8yyibE4uR67TEUgaLd3db30kGt5bt8A0OxGEU0ZQafq7J/dH/r8ZcIU3k1++G+v+udZFvDBn/yu7vzJ/3dV128oyyy+88f/+moKuCTP/n2wfa9tM3Om0+lqkqn+Yn83C2i/385/3g3ssu3yes3rdx3QhT0QAK5Pon6Fmm29WD7rZrdzpNXthPixrgepkXw5kKzluaEvYKRuQnN46E9oo0dT+T5/b4iT6yFlmu8AnskH+6HPoG1HlomxCwFX85zQH6lPEOgqfm4KABNV7692f8iAYxrZdnn/nT/+8VXAZqN579/9nass3ZBMYMj8uW9/VWleH9BGGSc//Bv78S2dlnC8jnfu3+h6FtB+tv3slooZecrrOlU3DXfJ4mNPBIDrEsuPhvxA/WUqBolYNnBIlq2LVNevACN1P9lZ8OY6rGfr2N9iB93389tQbDgRo8cOra7D91Qy+YzEef57ouYg0D6fRQJ9TzJhu9ptDt7lVL2/2vPq+gRiXBfbgG1jQaCxwRqPf/TPdfGjp1e1/voODLHC0G/8H//31cwgD77/e1f3WUD4zvf+tf1ox6BMp8W2/9DlYndfD1nAsJ4lBWzfzHQ941e3H25EE/CkCADXJQz8yLS/RD4zNrWNin4f++gSOCQqZn6wbEomgr4lydQ/wzbURtfrjiUqRsbfqVjfttE+AaBTMZVVWwAYyZ/Ysor7n4js9Fze2fz4J0+syTZkAq24s02YacWeLRC0wRt1xaI/2waJ1rz7ylv/lx5u/nYb+P2u7n3vt64es+dZQLgNJO24fKHTtJHflu9U3G+i0u+h8Hq0s67dd75zX6aiVidw0kIz51hSVVd0H5Pt0GHE750e79c0W0lgB4btIZyDw4Flav6uLFgaoxnH9Vi3ajR5pOrpEMuj0rtIVGzH9h6bhnXt/eKa1zjVYOFQ7HjxwH37a5dP/zy6vPzLf3m1PP2z6PLOd92l+9bX7FhyuQ0OL7fZvavFfj77+ktXi/3+6Af/7Ivn2XLxvd+y59j2fUeI5P8Xuxd7iYr9q3zMvtxZNzx/l7XwnGs+keiWgYVx8juH0zjshDxHX0Dbwe1zR/l7dvkbbGfvEug6VR8wMK9MzQFgGIzTh203dlK1QRy2LVyWlmf5/XHD8xNVB3VON4NAp+oTV9NrhwAwVn3tzEj12/E+/xOMI9kul9um4GuBoC3PHv2LqyDv/t3fvloefP+Ny21z8bV1bNn84PevAkL54GSMi5tjYdt1snNfOAeE/SsEdLbubuBcdcGUat4AOxIBIBYm1bjZOtsJE80jkT9hm4v8vZtOtqnqP1sIDEKzwJgZUewnU3MAeKHu2a4woMdOGBv57/qWiu3lUf5adv8T1WfYQqahajtzunkhUnUyqpOo2D7ttm6/TFW9HTuRuT40J//9XAWCFtDtBnm7S7YNFi3jlwd+tv0kwq5I1RdT5f0rHA+qMu9199VdZE0hEgEgFqRr5qyrWPMGTrtXgCGrUydR80nVDsB2UHAiAFyCTM0BYKxuTaz2nYbAL6pZZzdzZj/bNmDbVNNJZ1ei60FprO7NwBcqTv7ln8uc6oO8WMxFvRRO/phylWW24O48+uZVk7AtFhza73nzcPmipGu2+BRV7XflwC6W3/6rLtKq7os073E+EgEgFsQ2/kTjqcuaTKncNNCUnTGxqk+QsYqTvZ14nQgAlyBTcwDY9n07+e2jS7/PqqbTq75dutmloSqbEISLqrPSa4SuCm1SXZ9+sSrIjFUf5NnnPBeWxsl/L/Z9JqUlVr+pBU+d/Q8f79xXPgaUu/hkurnP7d43d1/vSASAWIhY4wY5sQ4TNJUHg5imgQGhf+KuELgmKmY2IQA8vEzdAreqQCmS/w4toO9ygm3qO5fqeveCENS5jq8V55+l7XOkKgLAus9Td5EV3gM4ZlUXU+EY4FT03U5187hgF07xzn1dpjQdS6QTCgApA7NcTvXz/Q55vXc1v42uzw+cqbk47+5jcX6bCmtUngw+sG3RMndWt89OAs81TJy/xr38d/v5E9WfOOyxciYuVXUpiyZnulnK5Vbp9XaNuT8Dc3AqMqN2oWb7rAVkdiFjgdxlxWLsIv1Rvn4ivz+GY0C4yHqimzOAPNfNizDbV+sSBhjgJWGpEvnAKdU43stfb6P52U5ttdjO8/e3GUFczbpZfutKP3PiXDc7cdyWPxnYwdy2Rdsmxp6pxeZ8DqMMH6o4YSUV66a62VT1QcP6VV6puM9OlJuK++PS+wJLFckHW2/mP1swZsdrC9Zsn/04v7Ulq3kNV7p1+WvYvmLB3tP8ubZvXqo6sNsNADeabxpT4OCcxu334DRvP4oqkYp+V2EkWJ1MRbaw3GfEJKIJeEkydes75+S/81T7N+c0NQEHka7372vq21f1WFtfwFRFgFi1T9X1ZTxE31ugi0h+33ymYipNu5CZIutmr3mev99Gfh96rGL++FTVpWSa+hGPKdIJNQGTAVwmC3CGzvhRlqjf/MFT2GyXz+V38kzNJ1m72nT5z5YtIvu3fpnmqee1UTEHaaLrmeddls2Idh4LzU0bNQsno6x0X1T6DGVxfpsKWAbbxq1JNuyT1hXDMugbTetJvjzMf7f9KFLRT9x+T3W9Bcgyhp+pmPEJI6EP4PLEKrIlY3DyO/oSgqhUvikw2y6vNqwX+gHaEqn6oDTH1SDWKcxN6uRPGLbNVW0vG/mmrrKqfklVnG72W4xVva3ShQFLEckHWrZYs+w7+W2iw3UPCgM/7HPYvvuafMbcEiEhC2nrRAKO3NhNReUSLIcWqRiZ2TSLh12V2s6f6mZNwDBK2JoEEuHQMs13YO7SBBykKi6irIkpqljH6eZ2GOtm38Dd103y19tdr6r5967oqoDDi+T3n1DEeukX0E5FjUb73LYfPdb0IlEGBgcy9kYea3knHzsAWbq/rRbg03yp64dCBnAZMi0zACzX+ktUXxNwtyRRuMCok+avt9usHN6vzKl5Gwam5rSuwG+Xk//c4aLfaVqRCABxAE7jb+BL7HieqDggNdUCDJ2DsWyZlhkAhvUTNXci331Np6KURZU0f03LUpf7I+3+Hta9L+AwbJu046xlwtd+weyUz+OsYhDgFCJRBxAHkGjcgRpxfptqWexg5FTM51sl9K36UMD+rN/dbfntaaPq4NFKXJQvRMK213bC3K0BaP1sywGg03L63uK0OPkLGxtAZ338LBB8rnXL5M+R1j/wBfW/GEQFAsBlsOakNzV+0eclnnzsQPSOqgs+B5mKkzawr42KUYY2GvjtinWe6PpAkK4BoNtZN9L17dVOUHYBkwmYj51LrOXELmyszuZGxyWTD/zs3GbnuCmzgUePAHAZ7mncsi+W9bADQKplspOunZBdwzqhZAwwRCgDY9k5256incc3urkdfqZ2r6rYXyP5bTr8fie/TQTMJwRENpL2GLJ+TVL5ADdkA8+F3ggADy+cLFKNw6noo7Rk5Vp/dY+vvd8KDi+UgbGToQWD0c7jWX7rdu53apflt+f5a4fnWdPbuwLmY0mEWD4oeqjTYPt0LJ88scCX2UJ6IgA8LKein8ZYEh2+6HMXtvM21QLMRAYQw23y20j+xPhexTqZ+g9keS2/tYuU2ypOuokON+UiTpMFP3YR8pZOs8tBKh/4xvJTOZI46IgA8LASFTMXjMHJn4zW0PG8LQOYbZeXBQy3O+NHtPP47tzUTTUqg9AEbCfeT1T0TRqzLy/QxjJ/kU43+Asy+SDQWB9IJ7QiADwcp/FHCY49hdyULAN4pvqrNXucDCDGsFEx0MMGZuw2FdnFSDkbHbbNNs/z10p1feBVJmB6tr2dcuZvVxhgaN0xrF+gE7BQVqMv0Xji/DWd1iNTcy1AZlBYvkzLrQMYlOsAln8OwsjJLu+TqqhlacvT0v3U/MNcrI/32o73c0q03/8nEnUAMbE4v000njVmH5qKQWcq6gUCQ1hmwLJ8kYryQuVBUm3dEcqy/PZ9+dHCln2JRdMv5uPkj/c20CgTqiQiE9iKAHB+TuPX6Ivz21TrYn2vmpqAuzbFAW2sn16U/2zNwOXaf5maC5NXsaAxzn+m6RdzCjUmN0KTRASBjQgA52ejEDcaL1izE9fYAeVcmopBm0z0A8Q4NiqCPvt5tybgZ+q+rZX7CyYad38GmoT+q4nQRSKCwFoEgPNy8k1PYwZrFlDaySvV+rQ1vX0mdlqMYyMf4NkFU6gJWC4eW647+bm6e1VFDUBgSk4+oHlL6CORrwRgQSAtSiUEgPMae8YPJ79xx1onOxG/3vB4JgJAjMO2tXKW76F8yaRwQshKj/XpesAJBXNJtI4ar0tkiRe7yHsgfIEAcD6x/AnmQuNJtO4DQjnrUiUTASDGs1ER5NnP5X58ma7Xnewa2L0iYHpO66nxulQ2aMaJGUO+QAA4n9BP77nG4bT+A0JbLcBMzbOFAH1YwFfOOFvT7dv5z/vWnXxZxz3nKpYhEdm/oWw/teZzywaeCwSAM7Hgzza+VONJtP6Rh6FZztU83qc8B9AmlIIJrBk4DAYpZ6Mz9WsCJgDElCJRZmgsmXwm0Gp2Op04AsDpOflgbcz5fu3qxQ4IqdavqRZgn75YQJtwQRG2Kdu+wswg5RHp9nPTNIRhkEg5YASmYsGKZaszYQx24Wf/z5Mv3E4AOL1E46fuxx5Mcki787CW2f1kVzCWckHo4EJFgWjj8nXOVb1d2sVKVvqZ7RNTivPbRBhToqIqBzAJO4mMPV1PrOOaIi2S/3uqMn2puEpbukzTTwVn20aY+uqytNj0bfd7vn+imyMBH+b3Wzba5fdd5O9X7ivk8vcN69hjGwHTcPLbYCxMIdL1fT7ctxEwgil23mM8IKTyf1ekYkaGe2KuyzXINF0AGIqc20H6Mn+vVD5YS1RsNyEYjDq+5m63gyi/79nOa8T569vyIH88KT1uQelDYW5OPvi2/78F6nYR8KhisfsTFceVtUnFBfDUbPt5VPo9EgEgRhAyFmOyk+FjHadExcncTrR00l2HTNMEgLGK7WHT8h722ON83S7bTaKb+1GaPz+qWP88/zy7j4XMIaZjgbodS+17Dd+xHR+smT6VP4Hb43G+nJd+TuS/oyf58x5pPRfPsbgAnkO4IIzy3+12I2AApyKjNfZrOgHLkWnc7TxWEfjt07x7qW77ngUD90q/24nAggmn7rpmHdFdJH+ha99PyMpaEBdKdzjtx+l6RveulnssdaLpd06xim5IkQgAMVCq8VP3qWgOwPJkGh4EhaZeOwiHZtZ9m+ycigDybof1mtZpcpa/xxqbFpfEyQd35YAvlT8pO00jUpHxvaflBYKpONbPzba/RASAGMjpekfxpb4mMIZM+weAkXzWzU76G/mT/hgBlVNxgn/Q8Jouf+99RgJGOt7uGFOLVAyyCd+9fQdO83Iq+pHueyEwtnAh5IQ5RfLbIgO7MIjtvInGlYorQixTpn4BoK27m+2LNI07+Xs0nVBvqTjw95Fq3Gkdj5kF4LH8MSxk+UL5nSVkUCMVTcOxDse2wd1RqZhPGDy0EbCHWOMP/IjEFSGWK1N9AGcn93In/t2T/xycipO7q1knVnNB8ipj9/E9NqF0T2ja3WjaYH8Msfz3apldp3nteyGC8UQqBp0BvThNV/ZlnyYqYA6Zinp8YbGTfuiHZ4+nOkwTX1loaq4L8hLV16PcFeu4anGOpRz0hRPpHa2vn2Si7iPKxxCCP47zh0cGEHuxzsRjN9PG4kSDZcvkT5ixrpficFreiT9W84n2gW4Wid5lf9OhmwqX5FiCvl1O8/QPjETwtyT0AURvTtMM0uBEg6XLtK6mUKf6k/puTbAqqdqDxGN3rEFfFSef4Z7iWBz6qMbCUkQiAERPdkIYu0N46CgPLFmm9fWFc/L77L2Kx5oKuEc63f64pxT0VYl1faCI0/6cim4SffqdYnqRCADRQ6zxTwpOdDLHOmRa73aaqLrDf10WMNVpjcY/9aCvSiz/fwizFUXdn3qt/mAiakguUSQCQPQwRdNAKsq+YB0yrftCJdbNIDDR9flBg7bm4WNA0NeNU9FH0BbLKNv/KcoXl9/GKuabDSPgnbBUkQgA0dEUzbROFH3GemRaf1Dk5IPAO6Xfn+2sc8wzfzhdn35tI4K+PiL5/9dD+f9dVlqeyAd9sfh/rkEkAkB04DRNoJaK7B/WI9NxZMWcin6BYTCI23n8Uscj0s2gLxZBCk5bJAJAdJBq/EDNOgSfaidzrFOm42oWTVQ0652X7ndafwAY6foUbKkI+oCySASAaBFpmkBtimnkgCllOr5+cbF8gLQ7SnhtXTMssLMgdqlTsAFLE4kAEC2mmJ0jFmVfsD6ZjnNghNPN+m+Zlv+3Ol2fgs36oCWiogDQRSQCQDSINU2gRtFnrFGm4w4uYvl90wKq8kCRpQhZvnLT7kaHn3oPWKNIBICo4XSzb9AYYpH9wzplOo3SKImKvoGRDudM1wdwWLN0GGkaiaZdYIhIBICokWr8gR9OFH3GemU6nW3XqZgpZIwZIbrYDfgsw5eJARzAFCIRAKKC0zSdwK2jOWVfsFaZTvPiJZY/UdgxwQKzUAR4qFsqigc/zl8/UxHwOQGYSqQTCgBfErqyGmEfyB+Mx+LkTxyvCcCapPni5E8a1i3kvfz3zXZ5vl0+VVEQeJcr3b4qH/iF++x51qz7Qem1AGBUBIDdxCr6AY0pkT+JZAKwRpmKYNA4+WAuBHRR6f7d5z3PFwv2Ps5vMwEAFsECvylG6DrdnG0AWJtM9F8FcBwinVAT8ItCG2vWsSaZVOOyfn8fiit+AAAwM5qAmzn5Ztqx++jF+Wu/JQAAgJmRAWyWaJosnZV0+EAAAAAHQAawXrxd3tT4Wbo4v00FAACARZlq4AdTvuGYZGIQCIDjEIlBICfvbn6baly3Nc2AEgAAAAzgNE15FqdpZhIBDikTGUAAxyESGcCTlmyXhxp/4Eciij4DAIAFYBDIdVa9f4qBH06++Zcp3wAAwMGRAbzO5vudouyLFX0eex5hAACAvRAAFuL89kLjiuUzgKkAAACwGE6+PMu5xkfZFxyzTAwCAXAcIjEI5OQk8l/6Q40rzm9TAQAALASDQKYboHEmpnwDAAALRAbQD/yYYoDGe9vlM5H9AwAAWJRYvo/e2Jwo+ozTkIk+gACOQyT6AJ6MqZpoE1H0GQAALNQp9wG8ld+mGpcTRZ8BAMCCnXIGMNoun2p8iSj6DAAAFuyUA0DLAD7RuKyOoE0llwoAAGChKAMzrnsi+4fj5nR90MfL8hc+TgCwbq/mS1y6L9ORDgwhABxPnN+mAo5XJH+hE7pP2O0tFX1qAWDNrHxbnP9sF7if60grHZxyAGjNv69rPBR9xqmwoC8SABy3WEc8lesp9wG0AHCsuX8t+Hsusn8AAGAFTjkA3Mi37Q8NAp38FcI7AgAAWIFTLwT9oXx/pjPtL1ERTAIAACzeqQeAqXzgdk/7uSNf9oW+fwAAYDVOPQA076oY2diHBX/W98+afjMBAACsBAGgD97ekg8Cn6p9dKPbLg+2y3v588YuJg0AADAp6gB62XZ5Q34wx/38vo/l+/bZ6F7rI+i2y9vyAaL1HXw3fwwAAGBVCACvS/PFRgZH8s28YYCIZfosKLQmXwI/AACwWgSA1R7mCwAAwNEhAATQl82g80gAcNyc/NRwR+kFAUB3TkwDB+B0WJcvWgQBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwgf8Ou3H5qQufVjQAAAAASUVORK5CYII=", IP = "data:image/png;base64,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", EP = "data:image/png;base64,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", Yf = "data:image/png;base64,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", LP = "data:image/png;base64,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", NP = "data:image/png;base64,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", YP = "data:image/png;base64,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", SP = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoAAAAHgCAYAAAA10dzkAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAACogSURBVHgB7d1PbJznfSfwh0NKIkUpZtqN2qDZeIRie4iziHyo05xM5ZBi0SwiA81mTyvaRYE9bGAZPXQvjaTspQU2kI0W2C6KWAz20qQFrKAuivRQyYeiifdgFRvnsIuFx9ukTZ2mpi3xj2SRs89v9L72iKYl/pkhZ97n8wFev0NySIszw5nv/J7n+T0pAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA42siAQCwb7rd7tzy8vJCq9Vq58tL+VPXZ2dnryQAAJrn9u3bZ1dWVt5cXV3tbjpey0c77RMVQACAfZCrfmdy1e+F+1ylMz09/ejExMRSGrJWAgBg6HL4u/SAq7RzdfBc2o9/SwIAYKjy0O+pfGo/6Ho5JJ5N+0AABAAYsvX19bltXrWd9oEACAAwZJOTk9ua19ftdq+nfSAAAgAM2eHDh69XLV/ua2JiQgAEAGiKVqt18QFX6eTjQdcBAGCcrK6uXtiiB2CvD+DNmzdPpX2iDyAAwD6Khs8bGxsLqVrwEcO+MzMzi/vR/w8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHHR7XbnEgAAZVhdXW3n43ICKMhEopHyC9p8Pl1N0GC5cvfM0aNHn017sLy8vNhqtc5OT09/eGJiYikx8vLz22v51E7QXJ2ZmZmTaYgEwAbLT5IX8ul8XM4vlK8naJAc1h7Oj+uleJLcbXCL6l8+RZhI6+vrTx47dmwxMdLW1tYu5fv9XNz3+cO3EjTHQ/m5bC4e2/n8aH5u6yTYrfwCdzUf3ZWVlUsJGiTe4Oz1sR2VpPgZ1WEYeMTl+/pcdV+9VoV3aIz6+Sge5wn2Kia3e1DRRP2P7Rs3bsynHarDRD6/kI8340iMrAh8cR9VAbCdoEFu3bp1vno+upZgUG7evHmqfoGLywkaIua6xpNmHhZ8ZYff1+6r/rXrSrm/j9HkjSxNVj0HqWwzHPkF8t2hEy0v9l/8Ud++fftsYuDq8La8vHxhu98TCz/6v6evGihcjKD6/sr3z54W/MAo6nszupBgGOLJsx7ySuyrulIlBA5ePTRYDQ+2H3T9XOVbqN8M9f+M6nNWzo+YemjMm1eaqO/xbQ4ywxNPnjFUVj3Yzif2TR0AhcDhqBeEbCfA9b3bnu//fB0ihYzREUPy1ZvWbYV7GCeGftlX/ROpdzNxnt3pqzoJgUOynQUh93u3XVfI/V2Mhk3zNBcSNEj/vFaPb/ZNXY3yrnr/9AXAq0LgcPRVWbccKnzQu+36PjLPbDTsZm4njIvoZ2nolwNRD5ntdPUkuxMvYtUq0wgZC0LgcGxe3NEv5r7e79129Y78nrmBHIy6Uuv5iSaKUQZDvxyoVU2i900dAOvhRSFwOCLEbbUgZKuFH1vpq9C2Ewci/62c8eJIU22a2jCf4CDorbV/6spU//wyIXA4+loe9RaEbHrCbd/ve1ff213E38MB8OJI02lpxMjQJHp/1H/0m29jIXA4+uaPndnJE249jzB/z5XEvqvDn3l/NFH/SIRuA4wETaKH735Di0Lg4G1a6LSjx7Zt4Q5G31ZY+pTSODsZiYB9pUn0cNUB8INCiBA4ePVj+n4LP7ay1XA9w9VfGfHiSBPdb4EaHChNoocrh5FO3Lb3u44QOFj19m47bbNQf58n6v2x2tebVPijiba7CA0OzKom0UMTAXA7w4pC4GDsZbilrx2MbeGGrH8hmsBNExn6ZWysahI9FDt59ycE7t1eh1vqiq05scNV30+rmuHSUKsamjNOVjWJHrgqVF/bwfWFwF0axHBLPX8wflZiKPq25bP4jEbqm4Zi6JfxsapJ9MBUQwA7CoDV9wmBuzCIPnKr720rpzI1BH1/E0YaaKR6SpXHOGNHk+jBqV/sdtNbTgjcmb6q0p6CW/+OIomB2jQnaiFBA3n9ZKxpEj0Ye60mCYHbUwftQbUSqavgHvuDVe/JbE4UTdXX0/JagnGlSfTe9S2s2fXWP0Lgg9XBYlBVpXr+jnfwg9M/7y9BAw36jSgcKE2i96ZelLDXiocQ+MGG0Wer74lcO5gBiG35vDDSdKY30CiaRO9NHU4GUUkSAt9vdYh9tuopEKrfe9N/H+Uq4JkEDTSoOcgwUlY1id61qPwNsqWIEHivupfcXobYP0hd/faY35tVzZ5pOEO/NNqqJtG7UgfAQYYIIfCu/ifdYVTp+qq3Aw+XpeibEG8KCY3U3zXD0C+NtapJ9I7VFapBV5GEwOHPt+nbFs6ihV3on5vpTSNNlV8PLxn6pQirmkTvSB0Ah9FOpOQQ2Ndlf6hPuvXjXYDZmf5pI247mire2HuTQzE0id6ZYQeIEkPgMBd+bPH/uuCxvjP9zxHm/dFUm56H5hOUQJPo7asD4DBXkpYWAuuq6n6Ei3ru6252cilVff8YEqPJhrkADUaaJtHbk58cOnE7pSErJQQOo+ffg9gWbvv6mz17XqCp+p+HPM4pkibRDxYBcL/CQwkh8CCGXIa1kKdp6lXZOgXQZPs5BQVGlibRD7bf1aomh8CDarRaLzgxn+2DbXpRXEjQUPs5BQVG2qom0fe1egCbgjcxBK4eYKPVvnYwtoX7APVezOZD0WQHMQUFRtqqJtFb6hsSu5b2WdNCYB0wDqq6VM/lNN/n/frn/SVoKEO/8AFWNYl+nzoAHtQK0qaEwFF4113Pdx3Uln5NoQ8apag7Ohj6hS2sahJ9j7oyunqA7TDGPQSOyrvuUbgvR03/fZOrgGcSNFRf43lVbtiKJtH36hsaP9B5UeMcAkel11Y8trWDuVe9AExFhCar57k3bYrTVIIBmpiYWMpDZE+0Wq2YLH8+X7527Nix66lQGxsbc/m2iPCwlA7QzMxMhKi4eHl9fX0xP5GdifsqjYcIrJ38O1xIByhur3wbxmN5Ppqfl/y4DjHvLz++T+XH9kuzs7MXEjTX1fz3P5cf68/k56FOaggBkIGLF8ZcGbiY/1guTU5OvpDPj45R2BioesHAKPz+/SEw/3vGbbju4ijchvn+/Hb+d8znUD+fPyw2AMY8yBz+LuSLnXx7LCRoqOqNTjve6Bw9erRRK9wFQIZienr62VxlaucXh6erOVNPpALl378d5/wEMhIBOEJgHgK+nquAY7OSNf9bl0al2pbvz1jMcymfv5DPRbY7iSGweHMXl/N980S+bzoJGige697owC5oEt2bv3ZBf8RmqecCldgOpn+Or3l/NJ3G5rAHpTeJtoVY89TtYEq8T/MbuktWQlOCg9p1CBql5CbRdQCMRQOJRqh7Epa240V/GwzNsGmyg9x1aD9NJHalGt6cu3PnTnvz16ampjpNWik0CNEkOp/OT0xMXJ+enn40FaLaOmw+Hyc9Jpqh+tuPVjDxd34yFaB6EYzgt5T/hh/1WKap6qlL+WI7H0/GvOnUUBaBPEA8GKJ6k5/0Tk1OTn4qzrEiKMJffD2HvS2/L1ZbRtjJ1+3k46X8qaLboUQLj3ybPJ5vz/loEn306NFnUkFy6C1yFXQTVe1gruWLUdluNz0MVeGv3gP5ovBHk8XQb7ob/habHP6CCuAmMa8nQl6r1Xo8zunuA+EeE++8kdL6SmpVDcF7H2fdydmUWrOpe/hE73J3+n3f2snHtfX19edKDIP976yin1LTltRvJX7f/Lueyk8k/tYapK5ol/A4jj2Yo21Q/l2fy79r8c3daa54/c9FnXiz08nH6aa/2fGilO7e6bm6F33Rzkazx/rzExvLKd3+SS/otW69libWOvnI5/Xlbf/sjdlP9oLg+vFP58uP9H+pk4PgxRwEF1NBoppaNYmO1iinmx6E84tnJ58eyi+cH040Rsxrzaer+TH87dnZ2cZugVb1QLuQChrupkx9le44R/i7lhqu6AAYk7lz8ItdBubj4wh8E6udNHnje6n19svvVvYGJaqCG8cfS+tzn+0Pg8UFwVwVO1f1EevEfMAmN4mOicTJi2cj1VvCNTXcl1YNoWyxYC8XJ86WVOkuMgDmO/pMvqMjgLTj49byq2nyp3+WWiuv7qi6txcxTHznI1/KYfB0/alOKuhJNlZQRpPo/Md2Jf+xNbZJdATAqoP8fKJR6heMO3funD5+/Pi11CD91ZD8Oz5x5MiRKwkaqioGRbuXxhcl+rVSQaql3VfzE9oLKZ7YcvA73PlKPn4nV/1e3rfwFyZuv5EO/ej305H/8x/T5FJvRLSdj9dKaZgci0JikUzMLWrq71xay5vSxOM3ztW2cI2Sf7fec2Qe/r0o/NFk8Tydw1/9GnS6pG1LiwmA0cMqV2JiAcJ8f/BrLX8/HaQ6CMZRDTlfaHrvoRB/ZPn+eCLaSuQPLzS5qW71O9Iw9QrBWDCWGiTm/cXCpahcz87OXkjQYNUc196bndKmOTQ+AFZbF8Xm95da3ZW5Qz9+fiSC32ZRBYxQOvn2y/FhOx9Xm948OP7Y8v3SG/7N78BeaGDobcd/ckB4M9E41ZuY1/PF+aY0Ro6hMHufUop4vMc0jnyxU+KbnUYHwAgU+d1sjK8uRHXt8P/9rTT50xfTqOpVA//ud9PUT74ZH8bcm6tN326qWml1MVZfV8NOjZPDwVuJpuoNj8a84jTm4vmymhud1tfXn7DogybbPPSbCtTYRSD9k5gnl/4qTf348r7O8durOz/7+XTn55+6e7mBk8w369sxAxqn2kFjO1MBOml7Hni9XMl7/UHXqaYn9P5d1YthO+Y25uec5zZdr5O2IXZBetB1BEtGQf2aE0O/pU51aGQAvCf8/fTP0qEfj+dezrFC+J1f+HLvSbrpPfPqvmrVC9LfJhhf7QddIYeshxMfaBwC8wOu10nbIDAfjFgTENPCUuEtuhoXAPt3m5h644/zcOq30jjrqwR2UoPbxNQBMN3dfufJBGx3Jfl2rhPDuh94vfxiOF/1QLuSj/u+AYvpGtuZ85iv107b88DrCcz3JzC/50GvkfE3VS0ITaXva924vYCjv1x+ImtHW5dxD39hKuYsTs5Gz8AYmnkhP3CLWqYOJdvmi9N2rnNfN2/ejNPZ2NlkXJvSV2/+t7MYp72N69w3MNe2E3L3KzDn/8dE3896eCffuxv5dTaNohzwHnidfPvE7fVM6dXVRgXAatuis7HgY+pHv5+aYuqNb6bukZNp/UOPnap65j2TAHhX9cZ4kFWwRis1MEc4jspkCXvRP0hjAmCUdaN9QWznFu1UxmnBx3ZM/f3vp42Zr6V06MS5GzdufLvpi0IAGJ5SA3Psz55/926iUW1gettpRLUs2qk0TQTaQz/6g97lqamp8VzVAgCMhEZUAKOZY6q2dht0n7+3VzbSd753I333+yvpB6/fSj9843Z6e3nj3a9/aLaVfuWR2fSrjx1Lv376oTRM0bw6fseN2UfasYpJCRsA2I1GBMC6meOhvx/cvL/vvrqSLn3zn3rnfh87cSh97COHcvCbzEFwPQfCd9Jfvnyjd1z61j+lZ/7dvxhqEIzf8da/+sO4GNs1LVoQAgDs1NgHwLr6F1upDWLod3Pw+9DRVnrq8z+Tq3xH0yMnp3sVv81efW0tPf/im+lPr72VfusP/iF9/c/fTH/027/QC4qDFr9j/K7rc6fnogqYP3UhAQDswNjPAayrf9X2absWQ71fvfyP6Utf+X+98BeB748vfjz9r//xS+mZL/2L9JlPHt0y/IUIhl/78kfTX/+3X+x93w9yIIyf88OfvJOGof5dqz0MAQB2ZKwDYNU8uD359st7qv5FUIvA9vVcxYuqXQS/b371473QtxMxPBzfdy4PA8fQ8LBCYPyuMRcwazd9r2AAYPDGegh4Y2NjIZpRxl6/u1WHvwhsUb37o9/+2JaVvqgKfuflm71zzP0LMQ/wE+0j6YunH+p9by0qhuHZb/1T72f/xddO9oaSBymqgLdnvxoV0NiE/loCANimsQ6AExMTX4imz60bL6fd+s3f+1Ev/MXCja/9p4++7+tbLQaJSt/bN+8uAInh3j+9+lb63GPH0/mnTrw77y9CYATF5//8zfSbv/vDXmVwkCbWXuu1hum2jsYw8LkEALBNYxsAq+HfuWoodFeezcEuAtznfvnYluEvvh4re0NU+CIk/moOenWFMNrBfOflG73rxSrgCInxcz732LHe188/9XO9z8URIXGQq4Mj/EXw7c6dnothYI2hAYDtGts5gN1uN4Y+0+Tb30u7EUO/Ee6iYhdBbbNYzRtfj6HbGBaOCl4M9fYPD8fl+Nxf/+Ev9ub9RcXvN3/vh/dUC+tgefHyG72FJoPUylXAkIeBTyUAgG0a2wCYh38/1Tvf6qTd+JO/eqt3/vXPPtQb0u0Xq4GjYhfhMObv1RW9+4kh3zrsRXisw94nTk6nX59/qBcO6//noLTevjv0ncPwfAIA2KZxrgCeimHQ3a7+jSHb8MX5e4dl/yQHv3o1cFT9NofD+4kh3qd+7cO9uYFff/Gf3/189BHs/38OSsx/7A0Ft1qfSgAA2zSWAXB1dbWdK4BzE9UQ6E5FNe4HnVu9FbybA96z1Zy/nYa/Wr0COLaOqz1y8khvDmEMDUc4HKh3egG4nQPxXAIA2IZxrQC24z8Tt3+SduMHr93qnT924vA9n3+1c+vddjC7CX8hWsPE90bA7BdhM/zNpq3l9qq11umdl5eX2wkAYBvGMgBubGz0ql0T7+xt67cPCnl73cItvr/uFViLuYBh0BXA1ntVUAtBAIBtGcsAWA93xvy3vYhefv3+5Uemeqt+//J/3tzTit1oLROVwH4PzQ7ppq5ug1arJQACANsy3nsBb+wuANaVv83btEVoiwUbUb3b7TZusdAjwmP/ziDhreXBtoCp1X0QcyhuJwCAbRjvALhLEQDjiEUZP+is3bPTx298/sO9+XpRxYsQGC1detu/baMiGIEx+v2Fp/LP6Vf//F/Z4f7CD1IPg1sJDABs11hvBdc9dCLtVvTmixW/F59/o1qde3c/36gCRu+/CIXx9T99461eT8DaX/zXk+kTJ4+87+dF+Ku3lYsq4mc2VQDrAPhINRdwkCIE5tuinWi8WAEf5zt37rQT95iamurEeWZmppMAuK+xDIATExNLaY+i0vf8i//8bjDbXOGLdi6xy0es2v3L790d1o2Q9/bKvfMG4/Pxc6LvX2wNF70Azz95bzCNreJ6+w3n0BlzDAdtYvW1XhiOcODFrzni/lxfXz+Tq7uP58d8zPFs11/LYSextXy7xXPE9Y2NjU4+XpqcnLzi7wLgXmP5KnLo0KFOfmHcUwUwKn3nvvSR3q4f4btbtGeJYeIvnnioFwQ3i+t/5+WbuTq41At+Eey+8uTP9YJlv6ge1lvO1T0CB23inbvtcPKLXYSETmJsxQKn5eXlhRxavpA/nM/n+vPxpuf1fL6ez3t+A9RUOfi18ykWiZ2K0Jxvv9gy8tLa2tr1XDV97tixY4sJgDEPgDPttBcR1n74xu30/J+/2Vv48fyLb/aGdze3gYnK39/lCt4Pqj6B3311uRf6QgS/p37tZ3o/a3NbmagM1nMCY7/h3fYWfJBoBRN1yfyCN59PVxJjKVeuzufjXA4tvVXuOey9lE9XcrC/loPL9cSO3Lx581Suns7nixECH8+36+W4jfNzx0VBECjd2A4Br6ysvJ4rgA+nPYpgFsO4Uam7WFUDHyRC3+d++VhvQccXT8/lauLWw7oR+OK68f/Yzn7Cu1WvBK73R2a83LhxYz4P6V5Od4d4l3Lwey6HvkWhb2+q2y+OZ2M4Pd+mF3IgPNsXBJ9wGwOlGueJRNe7k7MPxzDwXhtCx5y9ep7f5vYtdTWwXjn8mR3sEvK5x46nv/ja9NAqf7XensB3F4LMxxDiIOZIsj9u3bp1PoJJXM733ZV83z1jvtrgVbfpQg5+F/qC4Cvxcf7axQRQmHEOgNfy8YWN44+lyX9+Me1F/3zACIGxD/CgFmsMO/zVWm+/nNZ/9vOxJVwMdy0mRloE9bW1tUs5jCzE/L4cRp48cuSI4fsh6wuC1/L5fD4uVIunnkwABRnbPoCxyi/O6x96LA1CzOGLYd26/99edgLZbLt9BPdi8sbLd8+Tk2cTIy3CX678Xc0XF/LRyY/lR4W//ZUD32I+nU53F00t5DD+Sr3DEEAJxjYA5ifwa1E56U6fTN3JwTRX/tqXP/puE+h/81uv3dP/byci7EXoiwUg//o//O9eoPzu9/e2bd2DtJa/X88FnI/J74mRFZW//NiNVarXp6enHzXkezDido/bP+6HuD/ifkkAhRj3ZmLf6E7OPr3x0Gf3PAwc6ibQF5//x97K4NgF5Ov5/Bu/9uH0iZPTvXC4lR9WK4RjV5G/+f7d3UX6VwlH/7/NK4uHYfLG99LG7CNRBXw6f2hIawRVc/4W8sVOrvqdNl/zYMXtn8Pf6ajI5nMMDXfMCQRKMNYBMD95x7DZ0zEMPIgAWLu7avd4byeQqORFEKxtntMX4W+zOvRFU+jY+eODVgkPWmvpapr4yJdyRXQ2XsguqiyNlpifWS346ORD+BsRcT/kv5cn8sUYlr9w48aNl44fP34tATTYWAfAGAaOydwbs5+c3zj6SGqtvJoG5TOfPJqPj/cC3ndevpGHcFd6/QCj0leLoBeB8BMPH8nnw70egjtZJTxoE+vLafIn30x3fv6p+DDaipxOjIR60Uf14ZPC+WiJ+yM/l0TV/Gq05Mn316MCOtBkTdhPKoZr5u+c+FI63PlKGrQIc7/x+Z/pHeNg6qcvpvW506k7fXI+Kk6zs7MWF4yA27dvx7B8Ox+L8cYlMXLifllZWXkuB7+n8/lc/tSFBNBQY7sIpFa9mEYVMEUVkJQO/fhy75xfyKLhbTtxoOomxOnu0K/5ZSMsP59ciMVlEQKtCgaabOwDYKX3ovrOL3x5YCuCx1msCJ7KQ8H5RSyaQr+QOFARJuKcQ+A3DP2Othj2zUdUAeeqKiBAIzUiAFYtYZ7rHj6R1j/ypUQeCn7jm722MNHeIlegLicOTL4Pojl3arVai4mRNz09/WxdBUwADdWUCmBv6CafOnd+9t8aCq4c+rvfrbfJi1XB5xP7Lt/u8+m9uX+dxMirFn+8FFXA2Kc5ATRQYwJg9aTd6333zsf/c+oe+kgqXawKjoUxVQi8IATuv7r6l4d/v50YG/n+6i2empycPJMAGqgxATDEUHAOgs90J2fT7fZ/EQKzidtv3BMCV1ZWXrAwZP/kYd/H43z06NFribHRt3r+8QTQQE1oA3OPmL+TQ047HT7xdITAw53fyeHnJ6lkdQi83f5qHhc+ERWNmBd42pDk8MUczHxcH7eeclXfwt4q2PX19bl6RWz+Pdp9V4tFRr3P56D7cL7ec8eOHbueGiDur/w88no+x/03pycg0DSNC4AhV1vOLS8vz7UOnzhbcgjsto6m3l7JMyfTxpGT+ZV8OQfA3pfa+Xgth8ALtr0antu3b5/KoSjC1OtpjMS8xRz+rtYf52HQ7XzbYlPCX5/4fR6ugrAACDRKIwNgyEM4CzkEplJCYPfQid4+wBtH2ilXP9NGDn3xufddL4eRqiLV2djYeF11Y3iichbnuK3TGKl22In5tNtdPd5Jzexv2In/3Llzp11fBmiKxgbAECEwNnfvHj5x/tYv/fd06B+eH+iewQdhc1VvY6Ydw7qx/++91+t2l9J7Ya935OHxsRuKHGc5ALajeta7L8ZMDoGL1VzR7SwcGtl9p/fyBqdqBbN52BugERodAEO0h8lDOEv5yfzSOx99Km1Mt+82SR6DauCOqnobG3VV73oOHdfyMHgnMRaq+XZvRuBotVqdKjDWFdql6n5dmpqa6uxn0Iq/nZWVlbkH9MOL9jaLaZ/VcxSjOlcFtLl828Xlh9LdKQ7t6jpxW55MANyj8QEwxMKQXM2IVX1X1z/82fbGhz6dJn/6ZzkIfiuNAlW9skWQyffp3+aLD8eikfrzOdCkzZfz4zhOEbqeTPsg5tPm/+en8sX5Lb7cSQcw9Jtvr1fy0budcii+31Xjb+WtBMD7FBEAQ1U5ORkLHzZaR5/unvj3c+tzn+1VA2PrtP2qCKrqlSPfZ5041ytlP0j12Hw3+FVDr7F/8Fw1hNn7uB6KzOd9XVSS32Q8cevWrav94bRyIEO/URnNp4l6dXW8McpHp7rcybf70iD+XfX9Fj8zATRMMQGwFsNa+QV2Mb+IXIgFIrF/cJh886/S5NLV1Fp5NQ2Cqh6pWjiQ79v2Dr6nDoSdNCLisZj/Zp7IF2NlcLv69IEM/Yb8Rmi/mjO34z/+FoEmKi4AhuoFdqFXDYwg2Go9HkPD+ejtnhEVwQiCE6uvpYm1fGys3PfnqeqxlXicxZBtfnx9Ko256nc5nR/Dr8TH+THc+PZB0dsw/76pge1tAMoMgLU6CMbl5eXlqCqcmWgd/UL3Q5+eW//Qp9+9XoTCtLHca6hc6x6+G/A+IOip6tET933VDHqg7XZimDg/ppb28zEVfy8rKytv5f9n9yCGfvuaUQ/9d47bt27inQAaqOgA2K/a+qm3/VM0wq2e/E/FvKs8nNuemJx9eHPYq4LeW3199VT1uEd+TLwUu0lUbzAWd/K9EXjy97Xzxd7jMCpS8bPyz4zPxdceTXebFe+L+PdUi1AORP5/L+Tf/1IOoUtVsF6qFs/E5c4gK3Xr6+vzVQPslxJAAwmAW4hGuPl0bauvaZzMTuTHSrypeDqHibPpPgEwKk45dJyJVib5w17QW1tba2/ehSOGJLPXI1jmr82lfXDjxo35qamps/nfeKZeGJEvv5bu/o3s20KQWFSTb6MIZL1VyVWPvnfnA0Y47Q+G+Tbq5Dd2i7v5e833Q+/n5v/flQTQQALgDgl/7ES8magqVvP3e/OQw8qpHHAu1R9XvQD/thqC7FQrUa/nQNPZj8dghL7874kQdLZvFXMEq+fi98gBKQLtQhw5qF6/c+fOc1H9HmYYPHLkyLtV+qrHX2y1V6+OPlWf4+txe1fheTHtULUK+wv56Bw/fvxaAmggARCGLIeR5/LpfA6C5/L5wlbXOXr0aGy/9kwEvRyurh/0NIJc8YsdQCK0LuVw+o38b1qMf2P99fz5czmAncnnhfzh4zlsXc4h8HTap9XLVQi+ttXXbt68GWF6rprCsZvq39n8O8fv+FwCAIYn5l3mo5uP7e4/OzaiWpXD35tx1AsZRt2tW7fO5CC1sJ1/b1TM8u/2bGqA+F1ieLt6LLZTIeK+jt85zgkaLD9XdaopLMVrJWCoogoVVcAYSs1PPNvZW/fAxXDrsWPHtjV/LoZ9Y8eQ1ADRFirdbcI9svsbAwyCAAj7ILYjzKeYv3cu5tclRk6s1K7mNsbikQsJoMEEQNgHVSWtt3/v5OTkCyUNL46DuD9y+KsX4ezLPssAB0kAhH1StRe6WK2qvTou8wGbrrofetvcVUO/1xJAwwmAsI9iL+pYVZsvtm/dunVVJfBgRfiL+yHdDX/fMPQLlEIAhH2WQ8ZChI1oU5I/FAIPSNzua2trr8T9UIW/hQRQCAEQDkCEjarPXDsfV7Xf2F+x4CPf/q+k9yp/CwmgIAIgHJCqdcrFfMSWb5ejB6Jq4HBVff6utlqtF2IuZg6Bzwh/QIkEQDhAMScwn06muztoLOQjmhBfjt0sEgMTrXdy1W8xX4wGsLGP8PX19fVHcwhvRANrgJ2yFRwcsKrh8Mkc/BbyORpFL+SKYG+P3RxSvp2HKK/Zk3ZnYnFHhOipqanH84fz1VHvsRwrfQU/oGgCIIyIHEoW82kxgmC9x24eqjyVj/P5c9FL8HoEmDh2s8dt00Xoq1rsxOKOdg5//V97KZ+uxG3stgMQAGHk9AXBdj7P5wrgmRxa4nJvWDhfTrxf/+2SA9/r+bgWoVnoA3g/ARBGVDU0vFgdPVHlytUtDaTvwx6+AA8mAMIYqSpZqlkA7IlVwAAAhREAAQAKIwACABRGAAQAKIwACABQGAEQAKAwAiAAQGEEQACAwgiAAACFEQABAAojAAIAFEYABAAojAAIAFAYARAAoDACIABAYQRAAIDCCIAAAIURAAEACiMAAgAURgAEACiMAAgAUBgBEACgMAIgAEBhBEAAgMIIgAAAhREAAQAKIwACABRGAAQAKIwACABQGAEQAKAwAiAAQGEEQACAwgiAAACFEQABAAojAAIAFEYABAAojAAIAFAYARAAoDACIABAYQRAAIDCCIAAAIURAAEACiMAAgAURgAEACiMAAgAUBgBEACgMFMJAAp38+bNU5OTk0/ni/P5aKcG63a7S61Wq3Pnzp3nZmdnr0xMTCwliqMCCEDRVlZWzuXw90q+uJAaHv5CDnxzOQRG4L28trb2yurqajtRHAEQgGItLy+fyYHoUipXOx9XcyCcSxRFAASgWHkotOTwV2vnKuBCoigCIABFqoY+24mYFzifKIoACECp2omeXAn9VKIoAiAARZqcnLT6tZIrgK8niiIAAlCkw4cPX4+WKIlwPVEUARCAYuWhz4upcBGCJyYmnk0URQAEoFjT09PPbmxsfCMVLA+FPzkzM9NJFEUABKBos7OzC/n0ZD46qSC58vfS+vr6o0eOHLmSKI6t4AAoXq6ALebTYrUlXKObIufQt5RDb8cWcGUTAAGgcuzYMYshKIIhYACAwgiAAACFEQABAAojAAIAFEYABAAojAAIAFAYARAAoDACIABAYTSCBoDK6upqOxVgenp6yU4gZRMAASjeysrKuXw6n49GbwNXW1tbi7B7LV98cmZmppMojiFgAIqWg9DlXA27lI8iwl+f+Xy8try8fCZRHAEQgGLdvHlzIZ8WUsFy8L3c7XZLC7/FEwABKNbk5OT5VLiofFZD4BREAASgSLdv3z6VT+1EhMAvJIoiAAJQpPX1dcOelQLnPxZPAASgVJ1ET7fbfT1RFAEQgCJV7U+uJaICuJgoigAIQMkuJjo5DC8miiIAAlCsHHyupbJDYCcfpxPFEQABKFoOgRfy6eTGxsY3ut1uEdujVXP+Lk5PTz9qJ5Ay2QoOgOJVIWghQSFUAAEACiMAAgAURgAEACiMAAgAUBgBEACgMAIgAEBhBEAAgMIIgAAAhREAAQAKIwACABRGAAQAKIwACABQGAEQAKAwAiAAQGEEQACAwgiAAACFEQABAAojAAIAFEYABAAojAAIAFAYARAAoDACIABAYQRAAIDCCIAAAIURAAEACiMAAgAURgAEACiMAAgAUBgBEACgMAIgAEBhBEAAgMIIgAAAhREAAQAKIwACABRGAAQAKIwACABQGAEQAKAwU4mhWF1dba+vr5+ZnJz8VLfbfSsf12ZnZ68kAIADJgAOwa1bt85vbGxcyOGv9/HExEQcT6+trV3PQfCJmZmZTgIAOCCGgAesDn9bfS2Hv1M5CL6QAAAOkAA4QDHs+0HhrxYhcGVl5VwCADggAuAA5fB3ajvXyyFwPgEAHBABcIBysJvbzvXyMPC2rgcAMAwCIABAYQTAAYo2L7kKuPSg6+UK4GICADggAuAA5WC31Gq1Lj7gap2ZmZnFBABwQATAAZuenn42n7YMgbk6+FI+nU4AAAdII+ghyBW+C6urq4sbGxsL+cN2VAbzceXo0aPXEgDAARMAh6Ta7eNCAgAYMYaAAQAKIwACABRGAAQAKIwACABQGAEQAKAwAiAAQGEEQACAwgiAAACFEQABAAojAAIAFEYABAAojAAIAFAYARAAoDACIABAYQRAAIDCCIAAAIURAAEACiMAAgAURgAEACiMAAgAUBgBEACgMAIgAEBhBEAAgMIIgAAAhREAAQAKIwACABRGAAQAKIwACABQGAEQAKAwEwlGwOrq6nw+XU0AMFydmZmZk6lwUwlGwOTk5NKdO3deSgAwRN1ut5MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgw/x848K7ReB+D4wAAAABJRU5ErkJggg==", VP = { class: "ui-not-found-page" }, WP = { class: "ui-not-found-page__left-section left-section" }, XP = {
  key: 0,
  class: "illustration"
}, QP = { class: "left-section__info" }, HP = { class: "left-section__buttons" }, FP = {
  key: 0,
  class: "illustration"
}, y6 = /* @__PURE__ */ We({
  name: "UiNotFoundPage",
  __name: "UiNotFoundPage",
  props: {
    errorCode: {
      type: Number,
      default: 404
    },
    mainPageLink: {
      type: String,
      default: "https://rc.company/"
    },
    supportLink: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    yA((p) => ({
      "3211bb42": u.value,
      "77f13e75": s.value
    }));
    const a = e, { width: t } = sa(), r = U(1);
    function i(p, v) {
      return p = Math.ceil(p), v = Math.floor(v), Math.floor(Math.random() * (v - p + 1)) + p;
    }
    const s = V(() => {
      switch (r.value) {
        case 1:
          return `url(${Yf}) center/cover no-repeat`;
        case 2:
          return `url(${LP}) center/cover no-repeat`;
        case 3:
          return `url(${NP}) center/cover no-repeat`;
        case 4:
          return `url(${YP}) center/cover no-repeat`;
        case 5:
          return `url(${SP}) center/cover no-repeat`;
        default:
          return `url(${Yf}) center/cover no-repeat`;
      }
    }), u = V(() => {
      switch (r.value) {
        case 1:
          return `url(${Nf}) center/cover no-repeat`;
        case 2:
          return `url(${MP}) center/cover no-repeat`;
        case 3:
          return `url(${zP}) center/cover no-repeat`;
        case 4:
          return `url(${IP}) center/cover no-repeat`;
        case 5:
          return `url(${EP}) center/cover no-repeat`;
        default:
          return `url(${Nf}) center/cover no-repeat`;
      }
    }), A = V(() => a.errorCode === 403 ? {
      title: "Доступ к странице запрещен",
      message: "Попробуйте обновить страницу или свяжитесь с нами, если вы считаете, что это ошибка"
    } : a.errorCode === 404 ? {
      title: "Страница не найдена",
      message: "Попробуйте обновить страницу или вернуться на главную"
    } : a.errorCode >= 500 ? {
      title: "Возникла проблема на сервере",
      message: "Мы делаем все возможное, чтобы вернуться в рабочий режим"
    } : {
      title: "Что-то пошло не так",
      message: "Попробуйте обновить страницу или вернуться на главную"
    }), c = V(() => t.value <= 1023), g = V(() => t.value <= 767 ? "m" : "l");
    return bt(() => {
      r.value = i(1, 5);
    }), (p, v) => (f(), y("div", VP, [
      X("div", WP, [
        Ce(j7, {
          label: e.errorCode.toString(),
          type: "soft",
          color: "neutral",
          size: "l"
        }, null, 8, ["label"]),
        c.value ? (f(), y("div", XP)) : Y("", !0),
        X("div", QP, [
          X("h2", null, we(A.value.title), 1),
          X("p", null, we(A.value.message), 1)
        ]),
        X("div", HP, [
          Ce(nl, {
            "full-width": c.value,
            label: "На главную",
            size: g.value,
            color: "accent",
            href: e.mainPageLink
          }, null, 8, ["full-width", "size", "href"]),
          e.supportLink ? (f(), ce(nl, {
            key: 0,
            "full-width": c.value,
            label: "Поддержка",
            size: g.value,
            color: "secondary",
            href: e.supportLink
          }, null, 8, ["full-width", "size", "href"])) : Y("", !0)
        ])
      ]),
      c.value ? Y("", !0) : (f(), y("div", FP))
    ]));
  }
});
const qP = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjUgMTEuMjk2OVYxMi43MDMxSDcuNVYxMS4yOTY5SDE2LjVaIiBmaWxsPSIjNzE3Mzc4Ii8+Cjwvc3ZnPgo=", UP = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMyIgZmlsbD0iIzcxNzM3OCIvPgo8L3N2Zz4K", RP = { class: "item__title title" }, ZP = /* @__PURE__ */ We({
  __name: "UiList",
  props: {
    type: {
      type: String,
      default: "dot"
    },
    listOptions: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    }
  },
  setup(e) {
    const a = e, t = (s) => {
      switch (a.type) {
        case "icon":
          return s.icon;
        default:
          return "img";
      }
    }, r = V(() => a.type === "number" ? "ol" : "ul"), i = V(() => ({
      ...a.type === "dot" && {
        src: UP,
        alt: "icon"
      },
      ...a.type === "line" && {
        src: qP,
        alt: "icon"
      }
    }));
    return (s, u) => (f(), ce(Dt(r.value), {
      class: he(["ui-list", [`ui-list__type_${e.type}`, `ui-list__size_${e.size}`]])
    }, {
      default: ue(() => [
        (f(!0), y(Qe, null, tt(e.listOptions, (A) => (f(), y("li", {
          key: A.id,
          class: "ui-list__item item"
        }, [
          a.type !== "number" ? (f(), ce(Dt(t(A)), Xt({
            key: 0,
            class: "item__icon",
            ref_for: !0
          }, i.value), null, 16)) : Y("", !0),
          X("span", RP, we(A.label), 1)
        ]))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
const b6 = /* @__PURE__ */ je(ZP, [["__scopeId", "data-v-0e1d8981"]]), GP = ["id"], jP = { class: "ui-drawer__header-title" }, KP = { class: "ui-drawer-body body" }, JP = {
  key: 0,
  class: "body__title"
}, _P = { class: "ui-drawer__footer" }, $P = /* @__PURE__ */ We({
  __name: "UiDrawer",
  props: {
    modelValue: {
      type: Boolean,
      required: !1
    },
    overlay: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "m"
    },
    closeButton: {
      type: Boolean,
      default: !0
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = mn(), s = DA(document.body), u = () => r("update:modelValue", !1), A = V(
      () => t.overlay ? "var(--color-semantic-background-normal-overlay)" : "transparent"
    );
    return st(
      () => t.modelValue,
      (c) => {
        s.value = c;
      }
    ), (c, g) => (f(), ce(rl, { to: "body" }, [
      e.modelValue ? (f(), y("div", {
        key: 0,
        id: e.id,
        class: "ui-drawer__overlay",
        style: Tt({ background: A.value }),
        onClick: u
      }, null, 12, GP)) : Y("", !0),
      Ce(Jn, { name: "slide" }, {
        default: ue(() => [
          e.modelValue ? (f(), y("div", {
            key: 0,
            class: he(["ui-drawer", `ui-drawer_size_${e.size}`]),
            onClick: g[0] || (g[0] = _t(() => {
            }, ["stop"]))
          }, [
            X("header", {
              class: he(["ui-drawer__header", { "ui-drawer__header_compact": e.closeButton }])
            }, [
              e.closeButton ? (f(), y("button", {
                key: 0,
                type: "button",
                class: "ui-drawer__close",
                onClick: _t(u, ["prevent"])
              }, [
                Ce(b(Gw), { class: "ui-drawer__icon" })
              ])) : Y("", !0),
              X("div", jP, [
                fe(c.$slots, "header", {}, void 0, !0)
              ])
            ], 2),
            X("div", KP, [
              i.title ? (f(), y("div", JP, [
                fe(c.$slots, "title", {}, void 0, !0)
              ])) : Y("", !0),
              fe(c.$slots, "body", {}, void 0, !0)
            ]),
            X("footer", _P, [
              fe(c.$slots, "footer", {}, void 0, !0)
            ])
          ], 2)) : Y("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
const w6 = /* @__PURE__ */ je($P, [["__scopeId", "data-v-715ff0b1"]]), ek = {
  key: 0,
  class: "ui-dropzone-input__label label"
}, tk = {
  key: 1,
  class: "symbol-required"
}, nk = ["for"], ak = ["id", "multiple", "accept", "disabled"], rk = {
  key: 0,
  class: "main__info"
}, lk = {
  key: 1,
  class: "ui-dropzone-input__caption caption"
}, ik = /* @__PURE__ */ We({
  name: "UiDropzoneInput",
  __name: "UiDropzoneInput",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !0
    },
    filesAcceptTypes: {
      type: String,
      default: "*"
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    }
  },
  emits: ["error", "update:modelValue", "addFiles"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = U(!1), s = wA(() => i.value = !1, 100, {
      maxWait: 1e3
    }), u = (m) => {
      i.value = m, m && s();
    }, A = V(() => t.error || t.caption || ""), c = V(() => !!A.value), g = U(null), p = (m) => {
      const w = m.target;
      w.files && (r("addFiles", w.files), w.value = "");
    }, v = () => {
      var m;
      (m = g.value) == null || m.click();
    };
    return (m, w) => (f(), y("div", {
      class: he(["ui-dropzone-input", {
        [`ui-dropzone-input__size_${e.size}`]: e.size != null,
        "ui-dropzone-input_dragging": i.value,
        "ui-dropzone-input_error": e.error,
        "ui-dropzone-input_disabled": e.disabled
      }])
    }, [
      e.label || e.hint || e.required ? (f(), y("div", ek, [
        X("p", null, we(e.label), 1),
        e.hint ? (f(), ce(ls, {
          key: 0,
          "hint-content": e.hint
        }, {
          default: ue(() => [
            Ce(b(wa))
          ]),
          _: 1
        }, 8, ["hint-content"])) : Y("", !0),
        e.required ? (f(), y("span", tk, "*")) : Y("", !0)
      ])) : Y("", !0),
      X("div", {
        class: "ui-dropzone-input__main main",
        onDragenter: w[0] || (w[0] = (B) => u(!0)),
        onDragover: w[1] || (w[1] = (B) => u(!0)),
        onDragexit: w[2] || (w[2] = (B) => u(!1)),
        onDragleave: w[3] || (w[3] = (B) => u(!1)),
        onDragend: w[4] || (w[4] = (B) => u(!1)),
        onDrop: w[5] || (w[5] = (B) => u(!1)),
        onDrag: w[6] || (w[6] = (B) => u(!1))
      }, [
        Ce(b(S2), { class: "main__icon" }),
        X("label", { for: e.id }, [
          X("input", {
            id: e.id,
            ref_key: "dropzoneInput",
            ref: g,
            type: "file",
            multiple: e.multiple,
            accept: e.filesAcceptTypes,
            class: "main__input",
            disabled: e.disabled,
            title: "dropzone",
            name: "dropzone",
            "aria-label": "dropzone",
            onChange: p
          }, null, 40, ak)
        ], 8, nk),
        w[7] || (w[7] = X("div", { class: "main__action" }, [
          X("span", { class: "link__style" }, "Выберите файлы"),
          X("span", null, " или перетащите сюда")
        ], -1)),
        e.info ? (f(), y("p", rk, we(e.info), 1)) : Y("", !0),
        Ce(nl, {
          size: "m",
          label: "Загрузить файл",
          color: "secondary",
          class: "main__action-open",
          disabled: e.disabled,
          "full-width": e.size === "s",
          onClick: v
        }, {
          default: ue(() => [
            Ce(b(J2), { class: "local-icon" })
          ]),
          _: 1
        }, 8, ["disabled", "full-width"])
      ], 32),
      c.value ? (f(), y("p", lk, we(A.value), 1)) : Y("", !0)
    ], 2));
  }
});
const ok = /* @__PURE__ */ je(ik, [["__scopeId", "data-v-062aa0c9"]]), sk = { class: "file-preview" }, uk = /* @__PURE__ */ We({
  name: "FilePreview",
  __name: "FilePreview",
  props: {
    filePath: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    yA((r) => ({
      b2c11cc8: t.value
    }));
    const a = e, t = V(() => `url(${a.filePath}) lightgray 50% / cover no-repeat`);
    return (r, i) => (f(), y("div", sk));
  }
});
const Ak = /* @__PURE__ */ je(uk, [["__scopeId", "data-v-b58fefd9"]]), dk = { class: "ui-dropzone-file" }, ck = { class: "ui-dropzone-file__body body" }, fk = { class: "body__title" }, vk = { class: "body__name" }, pk = { class: "body__ext" }, gk = { class: "body__name" }, hk = { class: "body__ext" }, mk = { class: "body__size" }, yk = {
  key: 0,
  class: "body__error"
}, bk = { class: "ui-dropzone-file_actions actions" }, wk = /* @__PURE__ */ We({
  name: "UiDropzoneFile",
  __name: "UiDropzoneFile",
  props: {
    file: {
      type: Object,
      required: !0
    },
    fileIcon: {
      type: Boolean,
      default: !0
    },
    fileAction: {
      type: Boolean,
      default: !0
    },
    fileDisabledDownload: {
      type: Boolean,
      default: !1
    },
    fileDisabledAction: {
      type: Boolean,
      default: !1
    },
    fileReload: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    },
    fileError: {
      type: String,
      default: ""
    }
  },
  emits: ["deleteFile", "downloadFile", "resendFile"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = V(() => t.file.progress ?? 0), s = V(() => i.value > 0 && i.value < 100), u = () => {
      r("deleteFile", t.file.id);
    }, A = () => {
      r("downloadFile", t.file.id);
    }, c = () => {
      r("resendFile", t.file);
    }, g = () => {
      t.fileReload || t.file.resend ? c() : A();
    }, p = V(() => w(t.file)), v = V(() => t.fileError || t.file.error), m = V(() => t.fileReload || t.file.resend), w = (B) => {
      var N, k;
      const T = ((k = (N = B.ext) == null ? void 0 : N.toLowerCase()) == null ? void 0 : k.replace(".", "")) || "";
      if ({
        gif: OC,
        img: UC,
        jpg: J3,
        png: wC,
        svg: SC
      }[T])
        return Ak;
      const E = {
        avi: $C,
        mp3: D9,
        mp4: p9,
        wav: o9,
        rar: fC,
        zip: lC,
        csv: u7,
        doc: E7,
        docx: T7,
        pdf: Q7,
        ppt: W9,
        txt: h7,
        xls: t7,
        pptx: z9,
        xlsx: Z9,
        default: lA
      };
      return E[T] || E.default;
    };
    return (B, T) => (f(), y("div", dk, [
      p.value ? (f(), ce(Dt(p.value), {
        key: 0,
        "file-path": e.file.url,
        class: "ui-dropzone-file__icon"
      }, null, 8, ["file-path"])) : Y("", !0),
      X("div", ck, [
        X("div", fk, [
          e.size === "l" ? (f(), ce(ls, {
            key: 0,
            "hint-content": e.file.name,
            class: "body__hint"
          }, {
            default: ue(() => [
              Ce(Zo, {
                label: e.file.name,
                disabled: e.fileDisabledDownload,
                class: "body__link",
                onClick: A
              }, {
                default: ue(() => [
                  X("span", vk, we(e.file.title), 1),
                  X("span", pk, we(e.file.ext), 1)
                ]),
                _: 1
              }, 8, ["label", "disabled"])
            ]),
            _: 1
          }, 8, ["hint-content"])) : (f(), ce(Zo, {
            key: 1,
            label: e.file.name,
            disabled: e.fileDisabledDownload,
            class: "body__link",
            onClick: A
          }, {
            default: ue(() => [
              X("span", gk, we(e.file.title), 1),
              X("span", hk, we(e.file.ext), 1)
            ]),
            _: 1
          }, 8, ["label", "disabled"])),
          X("span", mk, we(e.file.size), 1)
        ]),
        v.value ? (f(), y("p", yk, we(v.value), 1)) : Y("", !0),
        s.value ? (f(), ce(nP, {
          key: 1,
          value: i.value,
          size: "s",
          class: "body__progress"
        }, null, 8, ["value"])) : Y("", !0)
      ]),
      X("div", bk, [
        e.fileAction ? (f(), ce(Pf, {
          key: 0,
          size: "m",
          disabled: e.fileDisabledAction,
          class: "reset_button",
          color: "ghost",
          onClick: g
        }, {
          default: ue(() => [
            m.value ? (f(), ce(b(o2), { key: 0 })) : (f(), ce(b(wv), { key: 1 }))
          ]),
          _: 1
        }, 8, ["disabled"])) : Y("", !0),
        Ce(Pf, {
          size: "m",
          class: "reset_button",
          color: "ghost",
          onClick: u
        }, {
          default: ue(() => [
            Ce(b(Oi))
          ]),
          _: 1
        })
      ])
    ]));
  }
});
const Ck = /* @__PURE__ */ je(wk, [["__scopeId", "data-v-d049e6eb"]]), Go = (e, a = 1) => {
  if (!+e)
    return "0 Bytes";
  const t = 1024, r = Math.max(0, a), i = ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ"], s = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, s)).toFixed(r))} ${i[s]}`;
}, Dk = (e) => {
  var a;
  return ((a = e.match(/\.\w+$/)) == null ? void 0 : a[0]) || null;
}, Bk = (e) => TA(e).split(", "), TA = (e) => typeof e == "string" ? e : Array.isArray(e) ? e.join(", ") : "", Tk = (e, a, t) => {
  const r = [];
  e && e > 1 && r.push(`Загрузите не более ${e} файлов`), a > 0 && (r.length ? r.push(`до ${Go(a)}`) : r.push(`До ${Go(a)}`));
  const i = TA(t);
  if (i) {
    const s = i.replaceAll(".", "").toUpperCase();
    r.length ? r.push(`— ${s}`) : r.push(s);
  }
  return r.join(" ");
}, Hv = (e, a) => (e.isNew && a && e.file.size > a && (e.error = "Превышен максимальный размер файла"), e), xk = (e, a) => (e.isNew && Array.isArray(a) && a.length && a.every((t) => t !== "*") && a.every((t) => t && e.ext !== t) && (e.error = "Неподдерживаемый формат файла"), e), Pk = (e, a, t) => {
  const r = e.reduce((u, A) => u + A.file.size, 0), i = a.filter((u) => e.some((A) => A.id === u.id)).reduce((u, A) => u + A.file.size, 0), s = r !== i ? r + i : i;
  return t && s > t;
}, kk = (e, a, t, r, i) => {
  const s = Bk(i), u = e.map((v) => Hv(v, t)).map((v) => xk(v, s)), A = Pk(
    u,
    a,
    t
  ), c = a.length + u.length, g = r > 0 && c > r, p = u.filter((v) => s.every(
    (m) => m && m !== "*" && v.ext !== m
  ));
  return {
    filesSizeError: A,
    fileCountError: g,
    fileExtError: p,
    files: u,
    valid: !A && !g && !p.length
  };
};
class Sf {
  constructor(a, t) {
    Ee(this, "file");
    Ee(this, "id");
    Ee(this, "url");
    Ee(this, "downloadPath");
    Ee(this, "size");
    Ee(this, "name");
    Ee(this, "progress", null);
    Ee(this, "error", null);
    Ee(this, "errorCode", null);
    Ee(this, "ext", null);
    Ee(this, "title", null);
    Ee(this, "isNew", !1);
    Ee(this, "resend", !1);
    this.file = a, this.size = Go(a.size), this.id = `${a.name}-${a.size}-${a.lastModified}-${a.type}`, this.url = URL.createObjectURL(a), this.name = a.name, this.ext = Dk(a.name), t && (this.isNew = t), this.ext && (this.title = a.name.replace(this.ext, ""));
  }
}
const Ok = /* @__PURE__ */ We({
  name: "UiDropzone",
  __name: "UiDropzone",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    filled: {
      type: Boolean,
      default: !1
    },
    filesMaxSize: {
      type: Number,
      default: 10485760
      // 10mb
    },
    filesMaxCount: {
      type: Number,
      default: 1
    },
    filesAcceptTypes: {
      type: [Array, String],
      default: () => [".png", ".jpeg", ".jpg"]
    },
    fileIcon: {
      type: Boolean,
      default: !0
    },
    fileAction: {
      type: Boolean,
      default: !1
    },
    fileDisabledAction: {
      type: Boolean,
      default: !1
    },
    fileReload: {
      type: Boolean,
      default: !1
    },
    fileError: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "addFiles",
    "resendFile",
    "deleteFile",
    "downloadFile"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = e, i = t, s = V(
      () => TA(r.filesAcceptTypes) || "*"
    ), u = V(
      () => Tk(
        r.filesMaxCount,
        r.filesMaxSize,
        r.filesAcceptTypes
      )
    ), A = V({
      get: () => r.modelValue,
      set: (N) => i("update:modelValue", N)
    }), c = V(
      () => r.disabled || p.value
    ), g = U(""), p = U(!1), v = (N) => A.value.some(({ id: k }) => k === N), m = (N) => {
      const k = [...N].map((S) => new Sf(S, !0)).map((S) => Hv(S, r.filesMaxSize)).filter((S) => !v(S.id));
      L(k).hasErrors || (w(k), i("addFiles"));
    }, w = (N) => {
      A.value = [
        ...N,
        ...A.value.filter(
          (k) => !N.some((F) => F.id === k.id)
        )
      ];
    }, B = (N) => {
      const k = A.value.findIndex(
        (F) => F.id === N
      );
      k !== -1 ? (i("deleteFile", k), A.value.splice(k, 1)) : console.warn(`deleteFile error, file with id ${N} not found`);
    }, T = (N) => {
      const k = A.value.indexOf(N);
      k >= 0 && (A.value[k].progress = null, A.value[k].error = null, A.value[k].errorCode = null), i("resendFile", N);
    }, L = (N) => {
      var F;
      const k = kk(
        N,
        A.value || [],
        r.filesMaxSize,
        r.filesMaxCount,
        r.filesAcceptTypes
      );
      return (F = k.fileExtError) != null && F.length ? (E("Добавлены неподдерживаемые файлы"), { hasErrors: !0 }) : k.filesSizeError ? (E(
        `Суммарный размер файлов не должен превышать ${Go(r.filesMaxSize)}`
      ), { hasErrors: !0 }) : k.fileCountError ? (E("Превышено ограничение по количеству загружаемых файлов"), { hasErrors: !0 }) : (E(""), { hasErrors: !1 });
    }, E = (N) => {
      g.value = N, N && setTimeout(() => g.value = "", 3e3);
    };
    return a({
      validation: L,
      FileToUpload: Sf
    }), (N, k) => (f(), y("div", {
      class: he(["ui-dropzone", {
        "ui-dropzone_required": r.required,
        "ui-dropzone_disabled": r.disabled,
        [`ui-dropzone__size_${r.size}`]: r.size,
        "ui-dropzone_error": r.error
      }])
    }, [
      Ce(ok, {
        modelValue: A.value,
        "onUpdate:modelValue": k[0] || (k[0] = (F) => A.value = F),
        size: e.size,
        disabled: c.value,
        required: e.required,
        label: e.label,
        hint: e.hint,
        caption: e.caption,
        info: u.value,
        error: e.error || g.value,
        multiple: e.filesMaxCount > 1,
        "files-accept-types": s.value,
        onAddFiles: m
      }, null, 8, ["modelValue", "size", "disabled", "required", "label", "hint", "caption", "info", "error", "multiple", "files-accept-types"]),
      e.filled ? (f(), ce(mv, {
        key: 0,
        tag: "div",
        name: "fade",
        class: "list_container"
      }, {
        default: ue(() => [
          (f(!0), y(Qe, null, tt(A.value, (F) => (f(), ce(Ck, {
            key: F.id,
            file: F,
            size: e.size,
            "file-icon": e.fileIcon,
            "file-action": e.fileAction,
            "file-disabled-action": e.fileDisabledAction,
            "file-reload": e.fileReload,
            "file-error": e.fileError,
            onDeleteFile: B,
            onResendFile: T
          }, null, 8, ["file", "size", "file-icon", "file-action", "file-disabled-action", "file-reload", "file-error"]))), 128))
        ]),
        _: 1
      })) : Y("", !0)
    ], 2));
  }
});
const C6 = /* @__PURE__ */ je(Ok, [["__scopeId", "data-v-44a041f6"]]), Mk = (e, a = 1) => {
  if (!+e)
    return "0 Bytes";
  const t = 1024, r = a < 0 ? 0 : a, i = ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ", "EB", "ZB", "YB"], s = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, s)).toFixed(r))} ${(i == null ? void 0 : i[s]) || ""}`;
}, zk = (e) => {
  const a = Math.round(e.length / 2), t = 3, r = 3, i = e.substring(0, a - t).trim(), s = e.substring(a + r, e.length).trim();
  return `${i} ... ${s}`.replaceAll(/\s+/g, " ").trim();
}, Ik = () => ({
  width: 0,
  maxWidth: 0
}), Fv = (e, a, t = Ik) => {
  if (e) {
    e.innerText = a;
    const { width: r, maxWidth: i } = t();
    if (r === 0 || i === 0)
      return;
    r < i ? e.innerText = a : Fv(e, zk(a.trim()), t);
  }
}, Ek = { class: "ui-file__size" }, Lk = 320, Vf = 252, Nk = /* @__PURE__ */ We({
  name: "UiFile",
  __name: "UiFile",
  props: {
    fileIcon: {
      type: Object,
      default: lA
    },
    fileId: {
      type: [String, Number],
      default: () => Math.random().toString(36).substring(2, 8)
    },
    fileTitle: {
      type: String,
      default: ""
    },
    fileSize: {
      type: Number,
      default: 10485760
    },
    fileDisabledDownload: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String,
      default: ""
    }
  },
  emits: ["downloadFile"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = U(!0), s = U(void 0), u = U(void 0), A = V(() => t.fileIcon || lA), c = V(() => t.hint || t.fileTitle), g = () => {
      r("downloadFile", t.fileId);
    }, p = () => {
      var T, L, E, N, k;
      const { width: m } = ((T = u.value) == null ? void 0 : T.getBoundingClientRect()) || {
        width: 0
      }, w = ((E = (L = u.value) == null ? void 0 : L.parentElement) == null ? void 0 : E.clientWidth) || 0, B = w < Vf && (((N = s.value) == null ? void 0 : N.clientWidth) || 0) === Lk ? Vf : w;
      return t.fileTitle === ((k = u.value) == null ? void 0 : k.innerText) ? i.value = !0 : i.value = !1, {
        width: m,
        maxWidth: B
      };
    }, v = () => {
      (u.value || window.innerWidth) && Fv(u.value, t.fileTitle, p);
    };
    return ki(() => {
      v();
    }), bt(() => {
      window.addEventListener("resize", v);
    }), al(() => {
      window.removeEventListener("resize", v);
    }), (m, w) => (f(), y("div", {
      ref_key: "uiFile",
      ref: s,
      class: "ui-file"
    }, [
      A.value ? (f(), ce(Dt(A.value), {
        key: 0,
        class: "ui-file__icon"
      })) : Y("", !0),
      Ce(ls, {
        "hint-content": c.value,
        disabled: i.value,
        class: "ui-file__hint hint_item"
      }, {
        default: ue(() => [
          Ce(Zo, {
            disabled: t.fileDisabledDownload,
            class: "ui-file__link link",
            onClick: g
          }, {
            default: ue(() => [
              X("span", {
                ref_key: "truncateMiddle",
                ref: u,
                class: "link__name"
              }, null, 512)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["hint-content", "disabled"]),
      X("span", Ek, we(b(Mk)(t.fileSize)), 1)
    ], 512));
  }
});
const D6 = /* @__PURE__ */ je(Nk, [["__scopeId", "data-v-a2ac8a37"]]);
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Wf(e, a) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    a && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Ya(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a] != null ? arguments[a] : {};
    a % 2 ? Wf(Object(t), !0).forEach(function(r) {
      Yk(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Wf(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function Wo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wo = function(a) {
    return typeof a;
  } : Wo = function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, Wo(e);
}
function Yk(e, a, t) {
  return a in e ? Object.defineProperty(e, a, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = t, e;
}
function _a() {
  return _a = Object.assign || function(e) {
    for (var a = 1; a < arguments.length; a++) {
      var t = arguments[a];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, _a.apply(this, arguments);
}
function Sk(e, a) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(a.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function Vk(e, a) {
  if (e == null)
    return {};
  var t = Sk(e, a), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (i = 0; i < s.length; i++)
      r = s[i], !(a.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
var Wk = "1.15.6";
function Ka(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var nr = Ka(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Ei = Ka(/Edge/i), Xf = Ka(/firefox/i), mi = Ka(/safari/i) && !Ka(/chrome/i) && !Ka(/android/i), xA = Ka(/iP(ad|od|hone)/i), qv = Ka(/chrome/i) && Ka(/android/i), Uv = {
  capture: !1,
  passive: !1
};
function pt(e, a, t) {
  e.addEventListener(a, t, !nr && Uv);
}
function ct(e, a, t) {
  e.removeEventListener(a, t, !nr && Uv);
}
function jo(e, a) {
  if (a) {
    if (a[0] === ">" && (a = a.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(a);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(a);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(a);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Rv(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function ga(e, a, t, r) {
  if (e) {
    t = t || document;
    do {
      if (a != null && (a[0] === ">" ? e.parentNode === t && jo(e, a) : jo(e, a)) || r && e === t)
        return e;
      if (e === t)
        break;
    } while (e = Rv(e));
  }
  return null;
}
var Qf = /\s+/g;
function Gn(e, a, t) {
  if (e && a)
    if (e.classList)
      e.classList[t ? "add" : "remove"](a);
    else {
      var r = (" " + e.className + " ").replace(Qf, " ").replace(" " + a + " ", " ");
      e.className = (r + (t ? " " + a : "")).replace(Qf, " ");
    }
}
function _e(e, a, t) {
  var r = e && e.style;
  if (r) {
    if (t === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? t = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (t = e.currentStyle), a === void 0 ? t : t[a];
    !(a in r) && a.indexOf("webkit") === -1 && (a = "-webkit-" + a), r[a] = t + (typeof t == "string" ? "" : "px");
  }
}
function Ml(e, a) {
  var t = "";
  if (typeof e == "string")
    t = e;
  else
    do {
      var r = _e(e, "transform");
      r && r !== "none" && (t = r + " " + t);
    } while (!a && (e = e.parentNode));
  var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return i && new i(t);
}
function Zv(e, a, t) {
  if (e) {
    var r = e.getElementsByTagName(a), i = 0, s = r.length;
    if (t)
      for (; i < s; i++)
        t(r[i], i);
    return r;
  }
  return [];
}
function La() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function nn(e, a, t, r, i) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var s, u, A, c, g, p, v;
    if (e !== window && e.parentNode && e !== La() ? (s = e.getBoundingClientRect(), u = s.top, A = s.left, c = s.bottom, g = s.right, p = s.height, v = s.width) : (u = 0, A = 0, c = window.innerHeight, g = window.innerWidth, p = window.innerHeight, v = window.innerWidth), (a || t) && e !== window && (i = i || e.parentNode, !nr))
      do
        if (i && i.getBoundingClientRect && (_e(i, "transform") !== "none" || t && _e(i, "position") !== "static")) {
          var m = i.getBoundingClientRect();
          u -= m.top + parseInt(_e(i, "border-top-width")), A -= m.left + parseInt(_e(i, "border-left-width")), c = u + s.height, g = A + s.width;
          break;
        }
      while (i = i.parentNode);
    if (r && e !== window) {
      var w = Ml(i || e), B = w && w.a, T = w && w.d;
      w && (u /= T, A /= B, v /= B, p /= T, c = u + p, g = A + v);
    }
    return {
      top: u,
      left: A,
      bottom: c,
      right: g,
      width: v,
      height: p
    };
  }
}
function Hf(e, a, t) {
  for (var r = hr(e, !0), i = nn(e)[a]; r; ) {
    var s = nn(r)[t], u = void 0;
    if (t === "top" || t === "left" ? u = i >= s : u = i <= s, !u)
      return r;
    if (r === La())
      break;
    r = hr(r, !1);
  }
  return !1;
}
function Ll(e, a, t, r) {
  for (var i = 0, s = 0, u = e.children; s < u.length; ) {
    if (u[s].style.display !== "none" && u[s] !== $e.ghost && (r || u[s] !== $e.dragged) && ga(u[s], t.draggable, e, !1)) {
      if (i === a)
        return u[s];
      i++;
    }
    s++;
  }
  return null;
}
function PA(e, a) {
  for (var t = e.lastElementChild; t && (t === $e.ghost || _e(t, "display") === "none" || a && !jo(t, a)); )
    t = t.previousElementSibling;
  return t || null;
}
function oa(e, a) {
  var t = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== $e.clone && (!a || jo(e, a)) && t++;
  return t;
}
function Ff(e) {
  var a = 0, t = 0, r = La();
  if (e)
    do {
      var i = Ml(e), s = i.a, u = i.d;
      a += e.scrollLeft * s, t += e.scrollTop * u;
    } while (e !== r && (e = e.parentNode));
  return [a, t];
}
function Xk(e, a) {
  for (var t in e)
    if (e.hasOwnProperty(t)) {
      for (var r in a)
        if (a.hasOwnProperty(r) && a[r] === e[t][r])
          return Number(t);
    }
  return -1;
}
function hr(e, a) {
  if (!e || !e.getBoundingClientRect)
    return La();
  var t = e, r = !1;
  do
    if (t.clientWidth < t.scrollWidth || t.clientHeight < t.scrollHeight) {
      var i = _e(t);
      if (t.clientWidth < t.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || t.clientHeight < t.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
        if (!t.getBoundingClientRect || t === document.body)
          return La();
        if (r || a)
          return t;
        r = !0;
      }
    }
  while (t = t.parentNode);
  return La();
}
function Qk(e, a) {
  if (e && a)
    for (var t in a)
      a.hasOwnProperty(t) && (e[t] = a[t]);
  return e;
}
function Nu(e, a) {
  return Math.round(e.top) === Math.round(a.top) && Math.round(e.left) === Math.round(a.left) && Math.round(e.height) === Math.round(a.height) && Math.round(e.width) === Math.round(a.width);
}
var yi;
function Gv(e, a) {
  return function() {
    if (!yi) {
      var t = arguments, r = this;
      t.length === 1 ? e.call(r, t[0]) : e.apply(r, t), yi = setTimeout(function() {
        yi = void 0;
      }, a);
    }
  };
}
function Hk() {
  clearTimeout(yi), yi = void 0;
}
function jv(e, a, t) {
  e.scrollLeft += a, e.scrollTop += t;
}
function Kv(e) {
  var a = window.Polymer, t = window.jQuery || window.Zepto;
  return a && a.dom ? a.dom(e).cloneNode(!0) : t ? t(e).clone(!0)[0] : e.cloneNode(!0);
}
function Jv(e, a, t) {
  var r = {};
  return Array.from(e.children).forEach(function(i) {
    var s, u, A, c;
    if (!(!ga(i, a.draggable, e, !1) || i.animated || i === t)) {
      var g = nn(i);
      r.left = Math.min((s = r.left) !== null && s !== void 0 ? s : 1 / 0, g.left), r.top = Math.min((u = r.top) !== null && u !== void 0 ? u : 1 / 0, g.top), r.right = Math.max((A = r.right) !== null && A !== void 0 ? A : -1 / 0, g.right), r.bottom = Math.max((c = r.bottom) !== null && c !== void 0 ? c : -1 / 0, g.bottom);
    }
  }), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
var Wn = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Fk() {
  var e = [], a;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(i) {
          if (!(_e(i, "display") === "none" || i === $e.ghost)) {
            e.push({
              target: i,
              rect: nn(i)
            });
            var s = Ya({}, e[e.length - 1].rect);
            if (i.thisAnimationDuration) {
              var u = Ml(i, !0);
              u && (s.top -= u.f, s.left -= u.e);
            }
            i.fromRect = s;
          }
        });
      }
    },
    addAnimationState: function(r) {
      e.push(r);
    },
    removeAnimationState: function(r) {
      e.splice(Xk(e, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var i = this;
      if (!this.options.animation) {
        clearTimeout(a), typeof r == "function" && r();
        return;
      }
      var s = !1, u = 0;
      e.forEach(function(A) {
        var c = 0, g = A.target, p = g.fromRect, v = nn(g), m = g.prevFromRect, w = g.prevToRect, B = A.rect, T = Ml(g, !0);
        T && (v.top -= T.f, v.left -= T.e), g.toRect = v, g.thisAnimationDuration && Nu(m, v) && !Nu(p, v) && // Make sure animatingRect is on line between toRect & fromRect
        (B.top - v.top) / (B.left - v.left) === (p.top - v.top) / (p.left - v.left) && (c = Uk(B, m, w, i.options)), Nu(v, p) || (g.prevFromRect = p, g.prevToRect = v, c || (c = i.options.animation), i.animate(g, B, v, c)), c && (s = !0, u = Math.max(u, c), clearTimeout(g.animationResetTimer), g.animationResetTimer = setTimeout(function() {
          g.animationTime = 0, g.prevFromRect = null, g.fromRect = null, g.prevToRect = null, g.thisAnimationDuration = null;
        }, c), g.thisAnimationDuration = c);
      }), clearTimeout(a), s ? a = setTimeout(function() {
        typeof r == "function" && r();
      }, u) : typeof r == "function" && r(), e = [];
    },
    animate: function(r, i, s, u) {
      if (u) {
        _e(r, "transition", ""), _e(r, "transform", "");
        var A = Ml(this.el), c = A && A.a, g = A && A.d, p = (i.left - s.left) / (c || 1), v = (i.top - s.top) / (g || 1);
        r.animatingX = !!p, r.animatingY = !!v, _e(r, "transform", "translate3d(" + p + "px," + v + "px,0)"), this.forRepaintDummy = qk(r), _e(r, "transition", "transform " + u + "ms" + (this.options.easing ? " " + this.options.easing : "")), _e(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          _e(r, "transition", ""), _e(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, u);
      }
    }
  };
}
function qk(e) {
  return e.offsetWidth;
}
function Uk(e, a, t, r) {
  return Math.sqrt(Math.pow(a.top - e.top, 2) + Math.pow(a.left - e.left, 2)) / Math.sqrt(Math.pow(a.top - t.top, 2) + Math.pow(a.left - t.left, 2)) * r.animation;
}
var wl = [], Yu = {
  initializeByDefault: !0
}, Li = {
  mount: function(a) {
    for (var t in Yu)
      Yu.hasOwnProperty(t) && !(t in a) && (a[t] = Yu[t]);
    wl.forEach(function(r) {
      if (r.pluginName === a.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(a.pluginName, " more than once");
    }), wl.push(a);
  },
  pluginEvent: function(a, t, r) {
    var i = this;
    this.eventCanceled = !1, r.cancel = function() {
      i.eventCanceled = !0;
    };
    var s = a + "Global";
    wl.forEach(function(u) {
      t[u.pluginName] && (t[u.pluginName][s] && t[u.pluginName][s](Ya({
        sortable: t
      }, r)), t.options[u.pluginName] && t[u.pluginName][a] && t[u.pluginName][a](Ya({
        sortable: t
      }, r)));
    });
  },
  initializePlugins: function(a, t, r, i) {
    wl.forEach(function(A) {
      var c = A.pluginName;
      if (!(!a.options[c] && !A.initializeByDefault)) {
        var g = new A(a, t, a.options);
        g.sortable = a, g.options = a.options, a[c] = g, _a(r, g.defaults);
      }
    });
    for (var s in a.options)
      if (a.options.hasOwnProperty(s)) {
        var u = this.modifyOption(a, s, a.options[s]);
        typeof u < "u" && (a.options[s] = u);
      }
  },
  getEventProperties: function(a, t) {
    var r = {};
    return wl.forEach(function(i) {
      typeof i.eventProperties == "function" && _a(r, i.eventProperties.call(t[i.pluginName], a));
    }), r;
  },
  modifyOption: function(a, t, r) {
    var i;
    return wl.forEach(function(s) {
      a[s.pluginName] && s.optionListeners && typeof s.optionListeners[t] == "function" && (i = s.optionListeners[t].call(a[s.pluginName], r));
    }), i;
  }
};
function Rk(e) {
  var a = e.sortable, t = e.rootEl, r = e.name, i = e.targetEl, s = e.cloneEl, u = e.toEl, A = e.fromEl, c = e.oldIndex, g = e.newIndex, p = e.oldDraggableIndex, v = e.newDraggableIndex, m = e.originalEvent, w = e.putSortable, B = e.extraEventProperties;
  if (a = a || t && t[Wn], !!a) {
    var T, L = a.options, E = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !nr && !Ei ? T = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (T = document.createEvent("Event"), T.initEvent(r, !0, !0)), T.to = u || t, T.from = A || t, T.item = i || t, T.clone = s, T.oldIndex = c, T.newIndex = g, T.oldDraggableIndex = p, T.newDraggableIndex = v, T.originalEvent = m, T.pullMode = w ? w.lastPutMode : void 0;
    var N = Ya(Ya({}, B), Li.getEventProperties(r, a));
    for (var k in N)
      T[k] = N[k];
    t && t.dispatchEvent(T), L[E] && L[E].call(a, T);
  }
}
var Zk = ["evt"], Vn = function(a, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.evt, s = Vk(r, Zk);
  Li.pluginEvent.bind($e)(a, t, Ya({
    dragEl: Le,
    parentEl: Ft,
    ghostEl: at,
    rootEl: Et,
    nextEl: Zr,
    lastDownEl: Xo,
    cloneEl: St,
    cloneHidden: gr,
    dragStarted: di,
    putSortable: gn,
    activeSortable: $e.active,
    originalEvent: i,
    oldIndex: Pl,
    oldDraggableIndex: bi,
    newIndex: jn,
    newDraggableIndex: pr,
    hideGhostForTarget: tp,
    unhideGhostForTarget: np,
    cloneNowHidden: function() {
      gr = !0;
    },
    cloneNowShown: function() {
      gr = !1;
    },
    dispatchSortableEvent: function(A) {
      On({
        sortable: t,
        name: A,
        originalEvent: i
      });
    }
  }, s));
};
function On(e) {
  Rk(Ya({
    putSortable: gn,
    cloneEl: St,
    targetEl: Le,
    rootEl: Et,
    oldIndex: Pl,
    oldDraggableIndex: bi,
    newIndex: jn,
    newDraggableIndex: pr
  }, e));
}
var Le, Ft, at, Et, Zr, Xo, St, gr, Pl, jn, bi, pr, Oo, gn, Tl = !1, Ko = !1, Jo = [], Ur, va, Su, Vu, qf, Uf, di, Cl, wi, Ci = !1, Mo = !1, Qo, Cn, Wu = [], uA = !1, _o = [], os = typeof document < "u", zo = xA, Rf = Ei || nr ? "cssFloat" : "float", Gk = os && !qv && !xA && "draggable" in document.createElement("div"), _v = function() {
  if (os) {
    if (nr)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), $v = function(a, t) {
  var r = _e(a), i = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), s = Ll(a, 0, t), u = Ll(a, 1, t), A = s && _e(s), c = u && _e(u), g = A && parseInt(A.marginLeft) + parseInt(A.marginRight) + nn(s).width, p = c && parseInt(c.marginLeft) + parseInt(c.marginRight) + nn(u).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (s && A.float && A.float !== "none") {
    var v = A.float === "left" ? "left" : "right";
    return u && (c.clear === "both" || c.clear === v) ? "vertical" : "horizontal";
  }
  return s && (A.display === "block" || A.display === "flex" || A.display === "table" || A.display === "grid" || g >= i && r[Rf] === "none" || u && r[Rf] === "none" && g + p > i) ? "vertical" : "horizontal";
}, jk = function(a, t, r) {
  var i = r ? a.left : a.top, s = r ? a.right : a.bottom, u = r ? a.width : a.height, A = r ? t.left : t.top, c = r ? t.right : t.bottom, g = r ? t.width : t.height;
  return i === A || s === c || i + u / 2 === A + g / 2;
}, Kk = function(a, t) {
  var r;
  return Jo.some(function(i) {
    var s = i[Wn].options.emptyInsertThreshold;
    if (!(!s || PA(i))) {
      var u = nn(i), A = a >= u.left - s && a <= u.right + s, c = t >= u.top - s && t <= u.bottom + s;
      if (A && c)
        return r = i;
    }
  }), r;
}, ep = function(a) {
  function t(s, u) {
    return function(A, c, g, p) {
      var v = A.options.group.name && c.options.group.name && A.options.group.name === c.options.group.name;
      if (s == null && (u || v))
        return !0;
      if (s == null || s === !1)
        return !1;
      if (u && s === "clone")
        return s;
      if (typeof s == "function")
        return t(s(A, c, g, p), u)(A, c, g, p);
      var m = (u ? A : c).options.group.name;
      return s === !0 || typeof s == "string" && s === m || s.join && s.indexOf(m) > -1;
    };
  }
  var r = {}, i = a.group;
  (!i || Wo(i) != "object") && (i = {
    name: i
  }), r.name = i.name, r.checkPull = t(i.pull, !0), r.checkPut = t(i.put), r.revertClone = i.revertClone, a.group = r;
}, tp = function() {
  !_v && at && _e(at, "display", "none");
}, np = function() {
  !_v && at && _e(at, "display", "");
};
os && !qv && document.addEventListener("click", function(e) {
  if (Ko)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), Ko = !1, !1;
}, !0);
var Rr = function(a) {
  if (Le) {
    a = a.touches ? a.touches[0] : a;
    var t = Kk(a.clientX, a.clientY);
    if (t) {
      var r = {};
      for (var i in a)
        a.hasOwnProperty(i) && (r[i] = a[i]);
      r.target = r.rootEl = t, r.preventDefault = void 0, r.stopPropagation = void 0, t[Wn]._onDragOver(r);
    }
  }
}, Jk = function(a) {
  Le && Le.parentNode[Wn]._isOutsideThisEl(a.target);
};
function $e(e, a) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = a = _a({}, a), e[Wn] = this;
  var t = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return $v(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(u, A) {
      u.setData("Text", A.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: $e.supportPointer !== !1 && "PointerEvent" in window && (!mi || xA),
    emptyInsertThreshold: 5
  };
  Li.initializePlugins(this, e, t);
  for (var r in t)
    !(r in a) && (a[r] = t[r]);
  ep(a);
  for (var i in this)
    i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
  this.nativeDraggable = a.forceFallback ? !1 : Gk, this.nativeDraggable && (this.options.touchStartThreshold = 1), a.supportPointer ? pt(e, "pointerdown", this._onTapStart) : (pt(e, "mousedown", this._onTapStart), pt(e, "touchstart", this._onTapStart)), this.nativeDraggable && (pt(e, "dragover", this), pt(e, "dragenter", this)), Jo.push(this.el), a.store && a.store.get && this.sort(a.store.get(this) || []), _a(this, Fk());
}
$e.prototype = /** @lends Sortable.prototype */
{
  constructor: $e,
  _isOutsideThisEl: function(a) {
    !this.el.contains(a) && a !== this.el && (Cl = null);
  },
  _getDirection: function(a, t) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, a, t, Le) : this.options.direction;
  },
  _onTapStart: function(a) {
    if (a.cancelable) {
      var t = this, r = this.el, i = this.options, s = i.preventOnFilter, u = a.type, A = a.touches && a.touches[0] || a.pointerType && a.pointerType === "touch" && a, c = (A || a).target, g = a.target.shadowRoot && (a.path && a.path[0] || a.composedPath && a.composedPath()[0]) || c, p = i.filter;
      if (lO(r), !Le && !(/mousedown|pointerdown/.test(u) && a.button !== 0 || i.disabled) && !g.isContentEditable && !(!this.nativeDraggable && mi && c && c.tagName.toUpperCase() === "SELECT") && (c = ga(c, i.draggable, r, !1), !(c && c.animated) && Xo !== c)) {
        if (Pl = oa(c), bi = oa(c, i.draggable), typeof p == "function") {
          if (p.call(this, a, c, this)) {
            On({
              sortable: t,
              rootEl: g,
              name: "filter",
              targetEl: c,
              toEl: r,
              fromEl: r
            }), Vn("filter", t, {
              evt: a
            }), s && a.preventDefault();
            return;
          }
        } else if (p && (p = p.split(",").some(function(v) {
          if (v = ga(g, v.trim(), r, !1), v)
            return On({
              sortable: t,
              rootEl: v,
              name: "filter",
              targetEl: c,
              fromEl: r,
              toEl: r
            }), Vn("filter", t, {
              evt: a
            }), !0;
        }), p)) {
          s && a.preventDefault();
          return;
        }
        i.handle && !ga(g, i.handle, r, !1) || this._prepareDragStart(a, A, c);
      }
    }
  },
  _prepareDragStart: function(a, t, r) {
    var i = this, s = i.el, u = i.options, A = s.ownerDocument, c;
    if (r && !Le && r.parentNode === s) {
      var g = nn(r);
      if (Et = s, Le = r, Ft = Le.parentNode, Zr = Le.nextSibling, Xo = r, Oo = u.group, $e.dragged = Le, Ur = {
        target: Le,
        clientX: (t || a).clientX,
        clientY: (t || a).clientY
      }, qf = Ur.clientX - g.left, Uf = Ur.clientY - g.top, this._lastX = (t || a).clientX, this._lastY = (t || a).clientY, Le.style["will-change"] = "all", c = function() {
        if (Vn("delayEnded", i, {
          evt: a
        }), $e.eventCanceled) {
          i._onDrop();
          return;
        }
        i._disableDelayedDragEvents(), !Xf && i.nativeDraggable && (Le.draggable = !0), i._triggerDragStart(a, t), On({
          sortable: i,
          name: "choose",
          originalEvent: a
        }), Gn(Le, u.chosenClass, !0);
      }, u.ignore.split(",").forEach(function(p) {
        Zv(Le, p.trim(), Xu);
      }), pt(A, "dragover", Rr), pt(A, "mousemove", Rr), pt(A, "touchmove", Rr), u.supportPointer ? (pt(A, "pointerup", i._onDrop), !this.nativeDraggable && pt(A, "pointercancel", i._onDrop)) : (pt(A, "mouseup", i._onDrop), pt(A, "touchend", i._onDrop), pt(A, "touchcancel", i._onDrop)), Xf && this.nativeDraggable && (this.options.touchStartThreshold = 4, Le.draggable = !0), Vn("delayStart", this, {
        evt: a
      }), u.delay && (!u.delayOnTouchOnly || t) && (!this.nativeDraggable || !(Ei || nr))) {
        if ($e.eventCanceled) {
          this._onDrop();
          return;
        }
        u.supportPointer ? (pt(A, "pointerup", i._disableDelayedDrag), pt(A, "pointercancel", i._disableDelayedDrag)) : (pt(A, "mouseup", i._disableDelayedDrag), pt(A, "touchend", i._disableDelayedDrag), pt(A, "touchcancel", i._disableDelayedDrag)), pt(A, "mousemove", i._delayedDragTouchMoveHandler), pt(A, "touchmove", i._delayedDragTouchMoveHandler), u.supportPointer && pt(A, "pointermove", i._delayedDragTouchMoveHandler), i._dragStartTimer = setTimeout(c, u.delay);
      } else
        c();
    }
  },
  _delayedDragTouchMoveHandler: function(a) {
    var t = a.touches ? a.touches[0] : a;
    Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    Le && Xu(Le), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var a = this.el.ownerDocument;
    ct(a, "mouseup", this._disableDelayedDrag), ct(a, "touchend", this._disableDelayedDrag), ct(a, "touchcancel", this._disableDelayedDrag), ct(a, "pointerup", this._disableDelayedDrag), ct(a, "pointercancel", this._disableDelayedDrag), ct(a, "mousemove", this._delayedDragTouchMoveHandler), ct(a, "touchmove", this._delayedDragTouchMoveHandler), ct(a, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(a, t) {
    t = t || a.pointerType == "touch" && a, !this.nativeDraggable || t ? this.options.supportPointer ? pt(document, "pointermove", this._onTouchMove) : t ? pt(document, "touchmove", this._onTouchMove) : pt(document, "mousemove", this._onTouchMove) : (pt(Le, "dragend", this), pt(Et, "dragstart", this._onDragStart));
    try {
      document.selection ? Ho(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(a, t) {
    if (Tl = !1, Et && Le) {
      Vn("dragStarted", this, {
        evt: t
      }), this.nativeDraggable && pt(document, "dragover", Jk);
      var r = this.options;
      !a && Gn(Le, r.dragClass, !1), Gn(Le, r.ghostClass, !0), $e.active = this, a && this._appendGhost(), On({
        sortable: this,
        name: "start",
        originalEvent: t
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (va) {
      this._lastX = va.clientX, this._lastY = va.clientY, tp();
      for (var a = document.elementFromPoint(va.clientX, va.clientY), t = a; a && a.shadowRoot && (a = a.shadowRoot.elementFromPoint(va.clientX, va.clientY), a !== t); )
        t = a;
      if (Le.parentNode[Wn]._isOutsideThisEl(a), t)
        do {
          if (t[Wn]) {
            var r = void 0;
            if (r = t[Wn]._onDragOver({
              clientX: va.clientX,
              clientY: va.clientY,
              target: a,
              rootEl: t
            }), r && !this.options.dragoverBubble)
              break;
          }
          a = t;
        } while (t = Rv(t));
      np();
    }
  },
  _onTouchMove: function(a) {
    if (Ur) {
      var t = this.options, r = t.fallbackTolerance, i = t.fallbackOffset, s = a.touches ? a.touches[0] : a, u = at && Ml(at, !0), A = at && u && u.a, c = at && u && u.d, g = zo && Cn && Ff(Cn), p = (s.clientX - Ur.clientX + i.x) / (A || 1) + (g ? g[0] - Wu[0] : 0) / (A || 1), v = (s.clientY - Ur.clientY + i.y) / (c || 1) + (g ? g[1] - Wu[1] : 0) / (c || 1);
      if (!$e.active && !Tl) {
        if (r && Math.max(Math.abs(s.clientX - this._lastX), Math.abs(s.clientY - this._lastY)) < r)
          return;
        this._onDragStart(a, !0);
      }
      if (at) {
        u ? (u.e += p - (Su || 0), u.f += v - (Vu || 0)) : u = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: p,
          f: v
        };
        var m = "matrix(".concat(u.a, ",").concat(u.b, ",").concat(u.c, ",").concat(u.d, ",").concat(u.e, ",").concat(u.f, ")");
        _e(at, "webkitTransform", m), _e(at, "mozTransform", m), _e(at, "msTransform", m), _e(at, "transform", m), Su = p, Vu = v, va = s;
      }
      a.cancelable && a.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!at) {
      var a = this.options.fallbackOnBody ? document.body : Et, t = nn(Le, !0, zo, !0, a), r = this.options;
      if (zo) {
        for (Cn = a; _e(Cn, "position") === "static" && _e(Cn, "transform") === "none" && Cn !== document; )
          Cn = Cn.parentNode;
        Cn !== document.body && Cn !== document.documentElement ? (Cn === document && (Cn = La()), t.top += Cn.scrollTop, t.left += Cn.scrollLeft) : Cn = La(), Wu = Ff(Cn);
      }
      at = Le.cloneNode(!0), Gn(at, r.ghostClass, !1), Gn(at, r.fallbackClass, !0), Gn(at, r.dragClass, !0), _e(at, "transition", ""), _e(at, "transform", ""), _e(at, "box-sizing", "border-box"), _e(at, "margin", 0), _e(at, "top", t.top), _e(at, "left", t.left), _e(at, "width", t.width), _e(at, "height", t.height), _e(at, "opacity", "0.8"), _e(at, "position", zo ? "absolute" : "fixed"), _e(at, "zIndex", "100000"), _e(at, "pointerEvents", "none"), $e.ghost = at, a.appendChild(at), _e(at, "transform-origin", qf / parseInt(at.style.width) * 100 + "% " + Uf / parseInt(at.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(a, t) {
    var r = this, i = a.dataTransfer, s = r.options;
    if (Vn("dragStart", this, {
      evt: a
    }), $e.eventCanceled) {
      this._onDrop();
      return;
    }
    Vn("setupClone", this), $e.eventCanceled || (St = Kv(Le), St.removeAttribute("id"), St.draggable = !1, St.style["will-change"] = "", this._hideClone(), Gn(St, this.options.chosenClass, !1), $e.clone = St), r.cloneId = Ho(function() {
      Vn("clone", r), !$e.eventCanceled && (r.options.removeCloneOnHide || Et.insertBefore(St, Le), r._hideClone(), On({
        sortable: r,
        name: "clone"
      }));
    }), !t && Gn(Le, s.dragClass, !0), t ? (Ko = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (ct(document, "mouseup", r._onDrop), ct(document, "touchend", r._onDrop), ct(document, "touchcancel", r._onDrop), i && (i.effectAllowed = "move", s.setData && s.setData.call(r, i, Le)), pt(document, "drop", r), _e(Le, "transform", "translateZ(0)")), Tl = !0, r._dragStartId = Ho(r._dragStarted.bind(r, t, a)), pt(document, "selectstart", r), di = !0, window.getSelection().removeAllRanges(), mi && _e(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(a) {
    var t = this.el, r = a.target, i, s, u, A = this.options, c = A.group, g = $e.active, p = Oo === c, v = A.sort, m = gn || g, w, B = this, T = !1;
    if (uA)
      return;
    function L(Oe, pe) {
      Vn(Oe, B, Ya({
        evt: a,
        isOwner: p,
        axis: w ? "vertical" : "horizontal",
        revert: u,
        dragRect: i,
        targetRect: s,
        canSort: v,
        fromSortable: m,
        target: r,
        completed: N,
        onMove: function(Me, me) {
          return Io(Et, t, Le, i, Me, nn(Me), a, me);
        },
        changed: k
      }, pe));
    }
    function E() {
      L("dragOverAnimationCapture"), B.captureAnimationState(), B !== m && m.captureAnimationState();
    }
    function N(Oe) {
      return L("dragOverCompleted", {
        insertion: Oe
      }), Oe && (p ? g._hideClone() : g._showClone(B), B !== m && (Gn(Le, gn ? gn.options.ghostClass : g.options.ghostClass, !1), Gn(Le, A.ghostClass, !0)), gn !== B && B !== $e.active ? gn = B : B === $e.active && gn && (gn = null), m === B && (B._ignoreWhileAnimating = r), B.animateAll(function() {
        L("dragOverAnimationComplete"), B._ignoreWhileAnimating = null;
      }), B !== m && (m.animateAll(), m._ignoreWhileAnimating = null)), (r === Le && !Le.animated || r === t && !r.animated) && (Cl = null), !A.dragoverBubble && !a.rootEl && r !== document && (Le.parentNode[Wn]._isOutsideThisEl(a.target), !Oe && Rr(a)), !A.dragoverBubble && a.stopPropagation && a.stopPropagation(), T = !0;
    }
    function k() {
      jn = oa(Le), pr = oa(Le, A.draggable), On({
        sortable: B,
        name: "change",
        toEl: t,
        newIndex: jn,
        newDraggableIndex: pr,
        originalEvent: a
      });
    }
    if (a.preventDefault !== void 0 && a.cancelable && a.preventDefault(), r = ga(r, A.draggable, t, !0), L("dragOver"), $e.eventCanceled)
      return T;
    if (Le.contains(a.target) || r.animated && r.animatingX && r.animatingY || B._ignoreWhileAnimating === r)
      return N(!1);
    if (Ko = !1, g && !A.disabled && (p ? v || (u = Ft !== Et) : gn === this || (this.lastPutMode = Oo.checkPull(this, g, Le, a)) && c.checkPut(this, g, Le, a))) {
      if (w = this._getDirection(a, r) === "vertical", i = nn(Le), L("dragOverValid"), $e.eventCanceled)
        return T;
      if (u)
        return Ft = Et, E(), this._hideClone(), L("revert"), $e.eventCanceled || (Zr ? Et.insertBefore(Le, Zr) : Et.appendChild(Le)), N(!0);
      var F = PA(t, A.draggable);
      if (!F || tO(a, w, this) && !F.animated) {
        if (F === Le)
          return N(!1);
        if (F && t === a.target && (r = F), r && (s = nn(r)), Io(Et, t, Le, i, r, s, a, !!r) !== !1)
          return E(), F && F.nextSibling ? t.insertBefore(Le, F.nextSibling) : t.appendChild(Le), Ft = t, k(), N(!0);
      } else if (F && eO(a, w, this)) {
        var S = Ll(t, 0, A, !0);
        if (S === Le)
          return N(!1);
        if (r = S, s = nn(r), Io(Et, t, Le, i, r, s, a, !1) !== !1)
          return E(), t.insertBefore(Le, S), Ft = t, k(), N(!0);
      } else if (r.parentNode === t) {
        s = nn(r);
        var Q = 0, x, W = Le.parentNode !== t, z = !jk(Le.animated && Le.toRect || i, r.animated && r.toRect || s, w), q = w ? "top" : "left", J = Hf(r, "top", "top") || Hf(Le, "top", "top"), le = J ? J.scrollTop : void 0;
        Cl !== r && (x = s[q], Ci = !1, Mo = !z && A.invertSwap || W), Q = nO(a, r, s, w, z ? 1 : A.swapThreshold, A.invertedSwapThreshold == null ? A.swapThreshold : A.invertedSwapThreshold, Mo, Cl === r);
        var ve;
        if (Q !== 0) {
          var R = oa(Le);
          do
            R -= Q, ve = Ft.children[R];
          while (ve && (_e(ve, "display") === "none" || ve === at));
        }
        if (Q === 0 || ve === r)
          return N(!1);
        Cl = r, wi = Q;
        var _ = r.nextElementSibling, G = !1;
        G = Q === 1;
        var oe = Io(Et, t, Le, i, r, s, a, G);
        if (oe !== !1)
          return (oe === 1 || oe === -1) && (G = oe === 1), uA = !0, setTimeout($k, 30), E(), G && !_ ? t.appendChild(Le) : r.parentNode.insertBefore(Le, G ? _ : r), J && jv(J, 0, le - J.scrollTop), Ft = Le.parentNode, x !== void 0 && !Mo && (Qo = Math.abs(x - nn(r)[q])), k(), N(!0);
      }
      if (t.contains(Le))
        return N(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    ct(document, "mousemove", this._onTouchMove), ct(document, "touchmove", this._onTouchMove), ct(document, "pointermove", this._onTouchMove), ct(document, "dragover", Rr), ct(document, "mousemove", Rr), ct(document, "touchmove", Rr);
  },
  _offUpEvents: function() {
    var a = this.el.ownerDocument;
    ct(a, "mouseup", this._onDrop), ct(a, "touchend", this._onDrop), ct(a, "pointerup", this._onDrop), ct(a, "pointercancel", this._onDrop), ct(a, "touchcancel", this._onDrop), ct(document, "selectstart", this);
  },
  _onDrop: function(a) {
    var t = this.el, r = this.options;
    if (jn = oa(Le), pr = oa(Le, r.draggable), Vn("drop", this, {
      evt: a
    }), Ft = Le && Le.parentNode, jn = oa(Le), pr = oa(Le, r.draggable), $e.eventCanceled) {
      this._nulling();
      return;
    }
    Tl = !1, Mo = !1, Ci = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), AA(this.cloneId), AA(this._dragStartId), this.nativeDraggable && (ct(document, "drop", this), ct(t, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), mi && _e(document.body, "user-select", ""), _e(Le, "transform", ""), a && (di && (a.cancelable && a.preventDefault(), !r.dropBubble && a.stopPropagation()), at && at.parentNode && at.parentNode.removeChild(at), (Et === Ft || gn && gn.lastPutMode !== "clone") && St && St.parentNode && St.parentNode.removeChild(St), Le && (this.nativeDraggable && ct(Le, "dragend", this), Xu(Le), Le.style["will-change"] = "", di && !Tl && Gn(Le, gn ? gn.options.ghostClass : this.options.ghostClass, !1), Gn(Le, this.options.chosenClass, !1), On({
      sortable: this,
      name: "unchoose",
      toEl: Ft,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: a
    }), Et !== Ft ? (jn >= 0 && (On({
      rootEl: Ft,
      name: "add",
      toEl: Ft,
      fromEl: Et,
      originalEvent: a
    }), On({
      sortable: this,
      name: "remove",
      toEl: Ft,
      originalEvent: a
    }), On({
      rootEl: Ft,
      name: "sort",
      toEl: Ft,
      fromEl: Et,
      originalEvent: a
    }), On({
      sortable: this,
      name: "sort",
      toEl: Ft,
      originalEvent: a
    })), gn && gn.save()) : jn !== Pl && jn >= 0 && (On({
      sortable: this,
      name: "update",
      toEl: Ft,
      originalEvent: a
    }), On({
      sortable: this,
      name: "sort",
      toEl: Ft,
      originalEvent: a
    })), $e.active && ((jn == null || jn === -1) && (jn = Pl, pr = bi), On({
      sortable: this,
      name: "end",
      toEl: Ft,
      originalEvent: a
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Vn("nulling", this), Et = Le = Ft = at = Zr = St = Xo = gr = Ur = va = di = jn = pr = Pl = bi = Cl = wi = gn = Oo = $e.dragged = $e.ghost = $e.clone = $e.active = null, _o.forEach(function(a) {
      a.checked = !0;
    }), _o.length = Su = Vu = 0;
  },
  handleEvent: function(a) {
    switch (a.type) {
      case "drop":
      case "dragend":
        this._onDrop(a);
        break;
      case "dragenter":
      case "dragover":
        Le && (this._onDragOver(a), _k(a));
        break;
      case "selectstart":
        a.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var a = [], t, r = this.el.children, i = 0, s = r.length, u = this.options; i < s; i++)
      t = r[i], ga(t, u.draggable, this.el, !1) && a.push(t.getAttribute(u.dataIdAttr) || rO(t));
    return a;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(a, t) {
    var r = {}, i = this.el;
    this.toArray().forEach(function(s, u) {
      var A = i.children[u];
      ga(A, this.options.draggable, i, !1) && (r[s] = A);
    }, this), t && this.captureAnimationState(), a.forEach(function(s) {
      r[s] && (i.removeChild(r[s]), i.appendChild(r[s]));
    }), t && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var a = this.options.store;
    a && a.set && a.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(a, t) {
    return ga(a, t || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(a, t) {
    var r = this.options;
    if (t === void 0)
      return r[a];
    var i = Li.modifyOption(this, a, t);
    typeof i < "u" ? r[a] = i : r[a] = t, a === "group" && ep(r);
  },
  /**
   * Destroy
   */
  destroy: function() {
    Vn("destroy", this);
    var a = this.el;
    a[Wn] = null, ct(a, "mousedown", this._onTapStart), ct(a, "touchstart", this._onTapStart), ct(a, "pointerdown", this._onTapStart), this.nativeDraggable && (ct(a, "dragover", this), ct(a, "dragenter", this)), Array.prototype.forEach.call(a.querySelectorAll("[draggable]"), function(t) {
      t.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Jo.splice(Jo.indexOf(this.el), 1), this.el = a = null;
  },
  _hideClone: function() {
    if (!gr) {
      if (Vn("hideClone", this), $e.eventCanceled)
        return;
      _e(St, "display", "none"), this.options.removeCloneOnHide && St.parentNode && St.parentNode.removeChild(St), gr = !0;
    }
  },
  _showClone: function(a) {
    if (a.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (gr) {
      if (Vn("showClone", this), $e.eventCanceled)
        return;
      Le.parentNode == Et && !this.options.group.revertClone ? Et.insertBefore(St, Le) : Zr ? Et.insertBefore(St, Zr) : Et.appendChild(St), this.options.group.revertClone && this.animate(Le, St), _e(St, "display", ""), gr = !1;
    }
  }
};
function _k(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Io(e, a, t, r, i, s, u, A) {
  var c, g = e[Wn], p = g.options.onMove, v;
  return window.CustomEvent && !nr && !Ei ? c = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = a, c.from = e, c.dragged = t, c.draggedRect = r, c.related = i || a, c.relatedRect = s || nn(a), c.willInsertAfter = A, c.originalEvent = u, e.dispatchEvent(c), p && (v = p.call(g, c, u)), v;
}
function Xu(e) {
  e.draggable = !1;
}
function $k() {
  uA = !1;
}
function eO(e, a, t) {
  var r = nn(Ll(t.el, 0, t.options, !0)), i = Jv(t.el, t.options, at), s = 10;
  return a ? e.clientX < i.left - s || e.clientY < r.top && e.clientX < r.right : e.clientY < i.top - s || e.clientY < r.bottom && e.clientX < r.left;
}
function tO(e, a, t) {
  var r = nn(PA(t.el, t.options.draggable)), i = Jv(t.el, t.options, at), s = 10;
  return a ? e.clientX > i.right + s || e.clientY > r.bottom && e.clientX > r.left : e.clientY > i.bottom + s || e.clientX > r.right && e.clientY > r.top;
}
function nO(e, a, t, r, i, s, u, A) {
  var c = r ? e.clientY : e.clientX, g = r ? t.height : t.width, p = r ? t.top : t.left, v = r ? t.bottom : t.right, m = !1;
  if (!u) {
    if (A && Qo < g * i) {
      if (!Ci && (wi === 1 ? c > p + g * s / 2 : c < v - g * s / 2) && (Ci = !0), Ci)
        m = !0;
      else if (wi === 1 ? c < p + Qo : c > v - Qo)
        return -wi;
    } else if (c > p + g * (1 - i) / 2 && c < v - g * (1 - i) / 2)
      return aO(a);
  }
  return m = m || u, m && (c < p + g * s / 2 || c > v - g * s / 2) ? c > p + g / 2 ? 1 : -1 : 0;
}
function aO(e) {
  return oa(Le) < oa(e) ? 1 : -1;
}
function rO(e) {
  for (var a = e.tagName + e.className + e.src + e.href + e.textContent, t = a.length, r = 0; t--; )
    r += a.charCodeAt(t);
  return r.toString(36);
}
function lO(e) {
  _o.length = 0;
  for (var a = e.getElementsByTagName("input"), t = a.length; t--; ) {
    var r = a[t];
    r.checked && _o.push(r);
  }
}
function Ho(e) {
  return setTimeout(e, 0);
}
function AA(e) {
  return clearTimeout(e);
}
os && pt(document, "touchmove", function(e) {
  ($e.active || Tl) && e.cancelable && e.preventDefault();
});
$e.utils = {
  on: pt,
  off: ct,
  css: _e,
  find: Zv,
  is: function(a, t) {
    return !!ga(a, t, a, !1);
  },
  extend: Qk,
  throttle: Gv,
  closest: ga,
  toggleClass: Gn,
  clone: Kv,
  index: oa,
  nextTick: Ho,
  cancelNextTick: AA,
  detectDirection: $v,
  getChild: Ll,
  expando: Wn
};
$e.get = function(e) {
  return e[Wn];
};
$e.mount = function() {
  for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++)
    a[t] = arguments[t];
  a[0].constructor === Array && (a = a[0]), a.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && ($e.utils = Ya(Ya({}, $e.utils), r.utils)), Li.mount(r);
  });
};
$e.create = function(e, a) {
  return new $e(e, a);
};
$e.version = Wk;
var tn = [], ci, dA, cA = !1, Qu, Hu, $o, fi;
function iO() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var a in this)
      a.charAt(0) === "_" && typeof this[a] == "function" && (this[a] = this[a].bind(this));
  }
  return e.prototype = {
    dragStarted: function(t) {
      var r = t.originalEvent;
      this.sortable.nativeDraggable ? pt(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? pt(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? pt(document, "touchmove", this._handleFallbackAutoScroll) : pt(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(t) {
      var r = t.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? ct(document, "dragover", this._handleAutoScroll) : (ct(document, "pointermove", this._handleFallbackAutoScroll), ct(document, "touchmove", this._handleFallbackAutoScroll), ct(document, "mousemove", this._handleFallbackAutoScroll)), Zf(), Fo(), Hk();
    },
    nulling: function() {
      $o = dA = ci = cA = fi = Qu = Hu = null, tn.length = 0;
    },
    _handleFallbackAutoScroll: function(t) {
      this._handleAutoScroll(t, !0);
    },
    _handleAutoScroll: function(t, r) {
      var i = this, s = (t.touches ? t.touches[0] : t).clientX, u = (t.touches ? t.touches[0] : t).clientY, A = document.elementFromPoint(s, u);
      if ($o = t, r || this.options.forceAutoScrollFallback || Ei || nr || mi) {
        Fu(t, this.options, A, r);
        var c = hr(A, !0);
        cA && (!fi || s !== Qu || u !== Hu) && (fi && Zf(), fi = setInterval(function() {
          var g = hr(document.elementFromPoint(s, u), !0);
          g !== c && (c = g, Fo()), Fu(t, i.options, g, r);
        }, 10), Qu = s, Hu = u);
      } else {
        if (!this.options.bubbleScroll || hr(A, !0) === La()) {
          Fo();
          return;
        }
        Fu(t, this.options, hr(A, !1), !1);
      }
    }
  }, _a(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function Fo() {
  tn.forEach(function(e) {
    clearInterval(e.pid);
  }), tn = [];
}
function Zf() {
  clearInterval(fi);
}
var Fu = Gv(function(e, a, t, r) {
  if (a.scroll) {
    var i = (e.touches ? e.touches[0] : e).clientX, s = (e.touches ? e.touches[0] : e).clientY, u = a.scrollSensitivity, A = a.scrollSpeed, c = La(), g = !1, p;
    dA !== t && (dA = t, Fo(), ci = a.scroll, p = a.scrollFn, ci === !0 && (ci = hr(t, !0)));
    var v = 0, m = ci;
    do {
      var w = m, B = nn(w), T = B.top, L = B.bottom, E = B.left, N = B.right, k = B.width, F = B.height, S = void 0, Q = void 0, x = w.scrollWidth, W = w.scrollHeight, z = _e(w), q = w.scrollLeft, J = w.scrollTop;
      w === c ? (S = k < x && (z.overflowX === "auto" || z.overflowX === "scroll" || z.overflowX === "visible"), Q = F < W && (z.overflowY === "auto" || z.overflowY === "scroll" || z.overflowY === "visible")) : (S = k < x && (z.overflowX === "auto" || z.overflowX === "scroll"), Q = F < W && (z.overflowY === "auto" || z.overflowY === "scroll"));
      var le = S && (Math.abs(N - i) <= u && q + k < x) - (Math.abs(E - i) <= u && !!q), ve = Q && (Math.abs(L - s) <= u && J + F < W) - (Math.abs(T - s) <= u && !!J);
      if (!tn[v])
        for (var R = 0; R <= v; R++)
          tn[R] || (tn[R] = {});
      (tn[v].vx != le || tn[v].vy != ve || tn[v].el !== w) && (tn[v].el = w, tn[v].vx = le, tn[v].vy = ve, clearInterval(tn[v].pid), (le != 0 || ve != 0) && (g = !0, tn[v].pid = setInterval((function() {
        r && this.layer === 0 && $e.active._onTouchMove($o);
        var _ = tn[this.layer].vy ? tn[this.layer].vy * A : 0, G = tn[this.layer].vx ? tn[this.layer].vx * A : 0;
        typeof p == "function" && p.call($e.dragged.parentNode[Wn], G, _, e, $o, tn[this.layer].el) !== "continue" || jv(tn[this.layer].el, G, _);
      }).bind({
        layer: v
      }), 24))), v++;
    } while (a.bubbleScroll && m !== c && (m = hr(m, !1)));
    cA = g;
  }
}, 30), ap = function(a) {
  var t = a.originalEvent, r = a.putSortable, i = a.dragEl, s = a.activeSortable, u = a.dispatchSortableEvent, A = a.hideGhostForTarget, c = a.unhideGhostForTarget;
  if (t) {
    var g = r || s;
    A();
    var p = t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t, v = document.elementFromPoint(p.clientX, p.clientY);
    c(), g && !g.el.contains(v) && (u("spill"), this.onSpill({
      dragEl: i,
      putSortable: r
    }));
  }
};
function kA() {
}
kA.prototype = {
  startIndex: null,
  dragStart: function(a) {
    var t = a.oldDraggableIndex;
    this.startIndex = t;
  },
  onSpill: function(a) {
    var t = a.dragEl, r = a.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var i = Ll(this.sortable.el, this.startIndex, this.options);
    i ? this.sortable.el.insertBefore(t, i) : this.sortable.el.appendChild(t), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: ap
};
_a(kA, {
  pluginName: "revertOnSpill"
});
function OA() {
}
OA.prototype = {
  onSpill: function(a) {
    var t = a.dragEl, r = a.putSortable, i = r || this.sortable;
    i.captureAnimationState(), t.parentNode && t.parentNode.removeChild(t), i.animateAll();
  },
  drop: ap
};
_a(OA, {
  pluginName: "removeOnSpill"
});
$e.mount(new iO());
$e.mount(OA, kA);
function oO(e, a, t = {}) {
  let r;
  const { document: i = vD, ...s } = t, u = {
    onUpdate: (p) => {
      sO(a, p.oldIndex, p.newIndex);
    }
  }, A = () => {
    const p = typeof e == "string" ? i == null ? void 0 : i.querySelector(e) : Ia(e);
    !p || r !== void 0 || (r = new $e(p, { ...u, ...s }));
  }, c = () => {
    r == null || r.destroy(), r = void 0;
  }, g = (p, v) => {
    if (v !== void 0)
      r == null || r.option(p, v);
    else
      return r == null ? void 0 : r.option(p);
  };
  return CA(A), Br(c), {
    stop: c,
    start: A,
    option: g
  };
}
function sO(e, a, t) {
  const r = Cr(e), i = r ? [...Vt(e)] : Vt(e);
  if (t >= 0 && t < i.length) {
    const s = i.splice(a, 1)[0];
    Bt(() => {
      i.splice(t, 0, s), r && (e.value = i);
    });
  }
}
const uO = { class: "ui-image-uploader" }, AO = { class: "ui-image-uploader__label" }, dO = {
  key: 0,
  class: "symbol-required"
}, cO = { class: "ui-image-uploader__item" }, fO = ["src"], vO = ["onClick"], pO = ["id", "accept", "required"], gO = /* @__PURE__ */ We({
  name: "UiImageUploader",
  __name: "UiImageUploader",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Label"
    },
    caption: {
      type: String,
      default: ""
    },
    acceptTypes: {
      type: String,
      default: ".png, .jpeg, .jpg"
    },
    inputId: {
      type: String,
      default: `input-id-${Date.now()}`
    },
    tooltipContent: {
      type: String,
      default: ""
    },
    maxFilesCount: {
      type: Number,
      default: 5
    },
    maxFileSize: {
      type: Number,
      // 5 Мб
      default: 5242880
    },
    errorMessage: {
      type: String,
      default: ""
    },
    isShowMainImage: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["error", "update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, i = U(!1);
    class s {
      constructor(T) {
        Ee(this, "file");
        Ee(this, "id");
        Ee(this, "url");
        Ee(this, "status");
        this.file = T, this.id = `${T.name}-${T.size}-${T.lastModified}-${T.type}`, this.url = URL.createObjectURL(T), this.status = null;
      }
    }
    const u = U(null), A = U([]), c = U("");
    oO(u, A, {
      animation: 150,
      draggable: ".ui-image-uploader__item-wrapper",
      dragClass: "ui-image-uploader__item-wrapper_draggable"
    }), st(A, () => {
      r("update:modelValue", A.value);
    });
    function g(B) {
      const T = [...B].map((L) => new s(L)).filter((L) => !p(L.id)).filter((L) => L.file.size < t.maxFileSize ? !0 : (c.value = "Превышен максимальный размер файла", setTimeout(() => {
        c.value = "";
      }, 5e3), !1));
      A.value = A.value.concat(T).slice(0, t.maxFilesCount), r("update:modelValue", A.value);
    }
    function p(B) {
      return A.value.some(({ id: T }) => T === B);
    }
    function v(B) {
      const T = A.value.indexOf(B);
      T > -1 && (A.value.splice(T, 1), r("update:modelValue", A.value));
    }
    function m(B) {
      const T = B.target;
      T.files && (g(T.files), T.value = "");
    }
    function w() {
      document.getElementById(t.inputId).click();
    }
    return (B, T) => (f(), y("div", uO, [
      X("div", AO, [
        X("p", null, we(e.label), 1),
        Ce(zi, {
          class: "ui-image-uploader__tooltip",
          label: e.tooltipContent
        }, {
          icon: ue(() => [
            Ce(b(wa), { class: "ui-image-uploader__icon-info" })
          ]),
          _: 1
        }, 8, ["label"]),
        e.required ? (f(), y("span", dO, "*")) : Y("", !0)
      ]),
      X("div", {
        ref_key: "imageUploaderList",
        ref: u,
        class: he(["ui-image-uploader__list", {
          "ui-image-uploader__list_margin": e.isShowMainImage && A.value.length
        }])
      }, [
        (f(!0), y(Qe, null, tt(A.value, (L) => (f(), y("div", {
          key: L.id,
          class: he(["ui-image-uploader__item-wrapper", {
            "ui-image-uploader__item-wrapper_main-image": e.isShowMainImage
          }])
        }, [
          X("div", cO, [
            X("img", {
              src: L.url,
              alt: ""
            }, null, 8, fO),
            X("button", {
              class: he(["ui-image-uploader__button-delete", { "elevation-shadow-low": i.value }]),
              type: "button",
              onClick: _t((E) => v(L), ["stop"]),
              onMouseenter: T[0] || (T[0] = (E) => i.value = !0),
              onMouseleave: T[1] || (T[1] = (E) => i.value = !1)
            }, [
              Ce(b(tl), { class: "icon-close-regular" })
            ], 42, vO)
          ])
        ], 2))), 128)),
        A.value.length < e.maxFilesCount ? (f(), y("button", {
          key: 0,
          class: "ui-image-uploader__button-add",
          type: "button",
          onClick: w
        }, [
          Ce(b(Z3), { class: "icon-camera-fill" })
        ])) : Y("", !0)
      ], 2),
      X("p", {
        class: he(["ui-image-uploader__caption", { "ui-image-uploader__caption_error": e.errorMessage || c.value }])
      }, we(e.errorMessage || c.value ? e.errorMessage || c.value : e.caption), 3),
      X("input", {
        id: e.inputId,
        type: "file",
        multiple: "",
        accept: e.acceptTypes,
        required: e.required,
        onChange: m
      }, null, 40, pO)
    ]));
  }
});
const B6 = /* @__PURE__ */ je(gO, [["__scopeId", "data-v-25173462"]]), hO = {
  key: 0,
  class: "ui-accordion__custom-icon custom-icon"
}, mO = { class: "ui-accordion__content content" }, yO = /* @__PURE__ */ We({
  name: "UiAccordion",
  __name: "UiAccordion",
  props: {
    type: {
      type: String,
      default: "stroke"
    },
    size: {
      type: String,
      default: "m"
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const a = mn(), t = U(!1);
    return (r, i) => (f(), y("div", {
      class: he(["ui-accordion", [`ui-accordion_${e.type}`, `ui-accordion__size_${e.size}`]])
    }, [
      X("button", {
        type: "button",
        class: he(["ui-accordion__button button", { button_open: t.value }]),
        onClick: i[0] || (i[0] = (s) => t.value = !t.value)
      }, [
        a.icon ? (f(), y("span", hO, [
          fe(r.$slots, "icon", {}, void 0, !0)
        ])) : Y("", !0),
        X("sub", null, we(e.title), 1),
        Ce(b(rs), {
          class: he(["ui-accordion__close", { "icon-chevron_down-regular_rotate": t.value }])
        }, null, 8, ["class"])
      ], 2),
      X("div", {
        class: he(["ui-accordion__content-wrapper content-wrapper", { "content-wrapper_open": t.value }])
      }, [
        X("div", mO, [
          fe(r.$slots, "default", {}, void 0, !0)
        ])
      ], 2)
    ], 2));
  }
});
const T6 = /* @__PURE__ */ je(yO, [["__scopeId", "data-v-4f20dfdb"]]);
function He(e) {
  const a = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && a === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || a === "[object Number]" || typeof e == "string" || a === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function ht(e, a) {
  return e instanceof Date ? new e.constructor(a) : new Date(a);
}
function ma(e, a) {
  const t = He(e);
  return isNaN(a) ? ht(e, NaN) : (a && t.setDate(t.getDate() + a), t);
}
function ba(e, a) {
  const t = He(e);
  if (isNaN(a))
    return ht(e, NaN);
  if (!a)
    return t;
  const r = t.getDate(), i = ht(e, t.getTime());
  i.setMonth(t.getMonth() + a + 1, 0);
  const s = i.getDate();
  return r >= s ? i : (t.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), t);
}
function rp(e, a) {
  const {
    years: t = 0,
    months: r = 0,
    weeks: i = 0,
    days: s = 0,
    hours: u = 0,
    minutes: A = 0,
    seconds: c = 0
  } = a, g = He(e), p = r || t ? ba(g, r + t * 12) : g, v = s || i ? ma(p, s + i * 7) : p, m = A + u * 60, B = (c + m * 60) * 1e3;
  return ht(e, v.getTime() + B);
}
function bO(e, a) {
  const t = +He(e);
  return ht(e, t + a);
}
const lp = 6048e5, wO = 864e5, CO = 6e4, ip = 36e5, DO = 1e3;
function BO(e, a) {
  return bO(e, a * ip);
}
let TO = {};
function ll() {
  return TO;
}
function Ca(e, a) {
  var A, c, g, p;
  const t = ll(), r = (a == null ? void 0 : a.weekStartsOn) ?? ((c = (A = a == null ? void 0 : a.locale) == null ? void 0 : A.options) == null ? void 0 : c.weekStartsOn) ?? t.weekStartsOn ?? ((p = (g = t.locale) == null ? void 0 : g.options) == null ? void 0 : p.weekStartsOn) ?? 0, i = He(e), s = i.getDay(), u = (s < r ? 7 : 0) + s - r;
  return i.setDate(i.getDate() - u), i.setHours(0, 0, 0, 0), i;
}
function Nl(e) {
  return Ca(e, { weekStartsOn: 1 });
}
function op(e) {
  const a = He(e), t = a.getFullYear(), r = ht(e, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Nl(r), s = ht(e, 0);
  s.setFullYear(t, 0, 4), s.setHours(0, 0, 0, 0);
  const u = Nl(s);
  return a.getTime() >= i.getTime() ? t + 1 : a.getTime() >= u.getTime() ? t : t - 1;
}
function Kr(e) {
  const a = He(e);
  return a.setHours(0, 0, 0, 0), a;
}
function es(e) {
  const a = He(e), t = new Date(
    Date.UTC(
      a.getFullYear(),
      a.getMonth(),
      a.getDate(),
      a.getHours(),
      a.getMinutes(),
      a.getSeconds(),
      a.getMilliseconds()
    )
  );
  return t.setUTCFullYear(a.getFullYear()), +e - +t;
}
function sp(e, a) {
  const t = Kr(e), r = Kr(a), i = +t - es(t), s = +r - es(r);
  return Math.round((i - s) / wO);
}
function xO(e) {
  const a = op(e), t = ht(e, 0);
  return t.setFullYear(a, 0, 4), t.setHours(0, 0, 0, 0), Nl(t);
}
function PO(e, a) {
  const t = a * 3;
  return ba(e, t);
}
function MA(e, a) {
  return ba(e, a * 12);
}
function Gf(e, a) {
  const t = He(e), r = He(a), i = t.getTime() - r.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function up(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Di(e) {
  if (!up(e) && typeof e != "number")
    return !1;
  const a = He(e);
  return !isNaN(Number(a));
}
function jf(e) {
  const a = He(e);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function kO(e, a) {
  const t = He(e), r = He(a);
  return t.getFullYear() - r.getFullYear();
}
function ii(e) {
  const a = He(e);
  return a.setHours(23, 59, 59, 999), a;
}
function OO(e, a) {
  const t = He(e), r = He(a), i = Gf(t, r), s = Math.abs(kO(t, r));
  t.setFullYear(1584), r.setFullYear(1584);
  const u = Gf(t, r) === -i, A = i * (s - +u);
  return A === 0 ? 0 : A;
}
function Ap(e, a) {
  const t = He(e.start), r = He(e.end);
  let i = +t > +r;
  const s = i ? +t : +r, u = i ? r : t;
  u.setHours(0, 0, 0, 0);
  let A = (a == null ? void 0 : a.step) ?? 1;
  if (!A)
    return [];
  A < 0 && (A = -A, i = !i);
  const c = [];
  for (; +u <= s; )
    c.push(He(u)), u.setDate(u.getDate() + A), u.setHours(0, 0, 0, 0);
  return i ? c.reverse() : c;
}
function _r(e) {
  const a = He(e), t = a.getMonth(), r = t - t % 3;
  return a.setMonth(r, 1), a.setHours(0, 0, 0, 0), a;
}
function MO(e, a) {
  const t = He(e.start), r = He(e.end);
  let i = +t > +r;
  const s = i ? +_r(t) : +_r(r);
  let u = _r(i ? r : t), A = (a == null ? void 0 : a.step) ?? 1;
  if (!A)
    return [];
  A < 0 && (A = -A, i = !i);
  const c = [];
  for (; +u <= s; )
    c.push(He(u)), u = PO(u, A);
  return i ? c.reverse() : c;
}
function zO(e) {
  const a = He(e);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function dp(e) {
  const a = He(e), t = a.getFullYear();
  return a.setFullYear(t + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function Ti(e) {
  const a = He(e), t = ht(e, 0);
  return t.setFullYear(a.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function cp(e, a) {
  var A, c, g, p;
  const t = ll(), r = (a == null ? void 0 : a.weekStartsOn) ?? ((c = (A = a == null ? void 0 : a.locale) == null ? void 0 : A.options) == null ? void 0 : c.weekStartsOn) ?? t.weekStartsOn ?? ((p = (g = t.locale) == null ? void 0 : g.options) == null ? void 0 : p.weekStartsOn) ?? 0, i = He(e), s = i.getDay(), u = (s < r ? -7 : 0) + 6 - (s - r);
  return i.setDate(i.getDate() + u), i.setHours(23, 59, 59, 999), i;
}
function Kf(e) {
  const a = He(e), t = a.getMonth(), r = t - t % 3 + 3;
  return a.setMonth(r, 0), a.setHours(23, 59, 59, 999), a;
}
const IO = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, EO = (e, a, t) => {
  let r;
  const i = IO[e];
  return typeof i == "string" ? r = i : a === 1 ? r = i.one : r = i.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function qu(e) {
  return (a = {}) => {
    const t = a.width ? String(a.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const LO = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, NO = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, YO = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, SO = {
  date: qu({
    formats: LO,
    defaultWidth: "full"
  }),
  time: qu({
    formats: NO,
    defaultWidth: "full"
  }),
  dateTime: qu({
    formats: YO,
    defaultWidth: "full"
  })
}, VO = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, WO = (e, a, t, r) => VO[e];
function oi(e) {
  return (a, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const u = e.defaultFormattingWidth || e.defaultWidth, A = t != null && t.width ? String(t.width) : u;
      i = e.formattingValues[A] || e.formattingValues[u];
    } else {
      const u = e.defaultWidth, A = t != null && t.width ? String(t.width) : e.defaultWidth;
      i = e.values[A] || e.values[u];
    }
    const s = e.argumentCallback ? e.argumentCallback(a) : a;
    return i[s];
  };
}
const XO = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, QO = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, HO = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, FO = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, qO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, UO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, RO = (e, a) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, ZO = {
  ordinalNumber: RO,
  era: oi({
    values: XO,
    defaultWidth: "wide"
  }),
  quarter: oi({
    values: QO,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: oi({
    values: HO,
    defaultWidth: "wide"
  }),
  day: oi({
    values: FO,
    defaultWidth: "wide"
  }),
  dayPeriod: oi({
    values: qO,
    defaultWidth: "wide",
    formattingValues: UO,
    defaultFormattingWidth: "wide"
  })
};
function si(e) {
  return (a, t = {}) => {
    const r = t.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = a.match(i);
    if (!s)
      return null;
    const u = s[0], A = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(A) ? jO(A, (v) => v.test(u)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      GO(A, (v) => v.test(u))
    );
    let g;
    g = e.valueCallback ? e.valueCallback(c) : c, g = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(g)
    ) : g;
    const p = a.slice(u.length);
    return { value: g, rest: p };
  };
}
function GO(e, a) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && a(e[t]))
      return t;
}
function jO(e, a) {
  for (let t = 0; t < e.length; t++)
    if (a(e[t]))
      return t;
}
function KO(e) {
  return (a, t = {}) => {
    const r = a.match(e.matchPattern);
    if (!r)
      return null;
    const i = r[0], s = a.match(e.parsePattern);
    if (!s)
      return null;
    let u = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    u = t.valueCallback ? t.valueCallback(u) : u;
    const A = a.slice(i.length);
    return { value: u, rest: A };
  };
}
const JO = /^(\d+)(th|st|nd|rd)?/i, _O = /\d+/i, $O = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, eM = {
  any: [/^b/i, /^(a|c)/i]
}, tM = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, nM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, aM = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rM = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, lM = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, iM = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, oM = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, sM = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, uM = {
  ordinalNumber: KO({
    matchPattern: JO,
    parsePattern: _O,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: si({
    matchPatterns: $O,
    defaultMatchWidth: "wide",
    parsePatterns: eM,
    defaultParseWidth: "any"
  }),
  quarter: si({
    matchPatterns: tM,
    defaultMatchWidth: "wide",
    parsePatterns: nM,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: si({
    matchPatterns: aM,
    defaultMatchWidth: "wide",
    parsePatterns: rM,
    defaultParseWidth: "any"
  }),
  day: si({
    matchPatterns: lM,
    defaultMatchWidth: "wide",
    parsePatterns: iM,
    defaultParseWidth: "any"
  }),
  dayPeriod: si({
    matchPatterns: oM,
    defaultMatchWidth: "any",
    parsePatterns: sM,
    defaultParseWidth: "any"
  })
}, fp = {
  code: "en-US",
  formatDistance: EO,
  formatLong: SO,
  formatRelative: WO,
  localize: ZO,
  match: uM,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function AM(e) {
  const a = He(e);
  return sp(a, Ti(a)) + 1;
}
function zA(e) {
  const a = He(e), t = +Nl(a) - +xO(a);
  return Math.round(t / lp) + 1;
}
function IA(e, a) {
  var p, v, m, w;
  const t = He(e), r = t.getFullYear(), i = ll(), s = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((v = (p = a == null ? void 0 : a.locale) == null ? void 0 : p.options) == null ? void 0 : v.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((w = (m = i.locale) == null ? void 0 : m.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, u = ht(e, 0);
  u.setFullYear(r + 1, 0, s), u.setHours(0, 0, 0, 0);
  const A = Ca(u, a), c = ht(e, 0);
  c.setFullYear(r, 0, s), c.setHours(0, 0, 0, 0);
  const g = Ca(c, a);
  return t.getTime() >= A.getTime() ? r + 1 : t.getTime() >= g.getTime() ? r : r - 1;
}
function dM(e, a) {
  var A, c, g, p;
  const t = ll(), r = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((c = (A = a == null ? void 0 : a.locale) == null ? void 0 : A.options) == null ? void 0 : c.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((p = (g = t.locale) == null ? void 0 : g.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = IA(e, a), s = ht(e, 0);
  return s.setFullYear(i, 0, r), s.setHours(0, 0, 0, 0), Ca(s, a);
}
function EA(e, a) {
  const t = He(e), r = +Ca(t, a) - +dM(t, a);
  return Math.round(r / lp) + 1;
}
function Ct(e, a) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(a, "0");
  return t + r;
}
const fr = {
  // Year
  y(e, a) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return Ct(a === "yy" ? r % 100 : r, a.length);
  },
  // Month
  M(e, a) {
    const t = e.getMonth();
    return a === "M" ? String(t + 1) : Ct(t + 1, 2);
  },
  // Day of the month
  d(e, a) {
    return Ct(e.getDate(), a.length);
  },
  // AM or PM
  a(e, a) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, a) {
    return Ct(e.getHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H(e, a) {
    return Ct(e.getHours(), a.length);
  },
  // Minute
  m(e, a) {
    return Ct(e.getMinutes(), a.length);
  },
  // Second
  s(e, a) {
    return Ct(e.getSeconds(), a.length);
  },
  // Fraction of second
  S(e, a) {
    const t = a.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return Ct(i, a.length);
  }
}, Dl = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Jf = {
  // Era
  G: function(e, a, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, a, t) {
    if (a === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return t.ordinalNumber(i, { unit: "year" });
    }
    return fr.y(e, a);
  },
  // Local week-numbering year
  Y: function(e, a, t, r) {
    const i = IA(e, r), s = i > 0 ? i : 1 - i;
    if (a === "YY") {
      const u = s % 100;
      return Ct(u, 2);
    }
    return a === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : Ct(s, a.length);
  },
  // ISO week-numbering year
  R: function(e, a) {
    const t = op(e);
    return Ct(t, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, a) {
    const t = e.getFullYear();
    return Ct(t, a.length);
  },
  // Quarter
  Q: function(e, a, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "Q":
        return String(r);
      case "QQ":
        return Ct(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, a, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "q":
        return String(r);
      case "qq":
        return Ct(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, a, t) {
    const r = e.getMonth();
    switch (a) {
      case "M":
      case "MM":
        return fr.M(e, a);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, a, t) {
    const r = e.getMonth();
    switch (a) {
      case "L":
        return String(r + 1);
      case "LL":
        return Ct(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, a, t, r) {
    const i = EA(e, r);
    return a === "wo" ? t.ordinalNumber(i, { unit: "week" }) : Ct(i, a.length);
  },
  // ISO week of year
  I: function(e, a, t) {
    const r = zA(e);
    return a === "Io" ? t.ordinalNumber(r, { unit: "week" }) : Ct(r, a.length);
  },
  // Day of the month
  d: function(e, a, t) {
    return a === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : fr.d(e, a);
  },
  // Day of year
  D: function(e, a, t) {
    const r = AM(e);
    return a === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : Ct(r, a.length);
  },
  // Day of week
  E: function(e, a, t) {
    const r = e.getDay();
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, a, t, r) {
    const i = e.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "e":
        return String(s);
      case "ee":
        return Ct(s, 2);
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, a, t, r) {
    const i = e.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "c":
        return String(s);
      case "cc":
        return Ct(s, a.length);
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, a, t) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (a) {
      case "i":
        return String(i);
      case "ii":
        return Ct(i, a.length);
      case "io":
        return t.ordinalNumber(i, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, a, t) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, a, t) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = Dl.noon : r === 0 ? i = Dl.midnight : i = r / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, a, t) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = Dl.evening : r >= 12 ? i = Dl.afternoon : r >= 4 ? i = Dl.morning : i = Dl.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, a, t) {
    if (a === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return fr.h(e, a);
  },
  // Hour [0-23]
  H: function(e, a, t) {
    return a === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : fr.H(e, a);
  },
  // Hour [0-11]
  K: function(e, a, t) {
    const r = e.getHours() % 12;
    return a === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : Ct(r, a.length);
  },
  // Hour [1-24]
  k: function(e, a, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), a === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : Ct(r, a.length);
  },
  // Minute
  m: function(e, a, t) {
    return a === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : fr.m(e, a);
  },
  // Second
  s: function(e, a, t) {
    return a === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : fr.s(e, a);
  },
  // Fraction of second
  S: function(e, a) {
    return fr.S(e, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (a) {
      case "X":
        return $f(r);
      case "XXXX":
      case "XX":
        return Gr(r);
      case "XXXXX":
      case "XXX":
      default:
        return Gr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, t) {
    const r = e.getTimezoneOffset();
    switch (a) {
      case "x":
        return $f(r);
      case "xxxx":
      case "xx":
        return Gr(r);
      case "xxxxx":
      case "xxx":
      default:
        return Gr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, t) {
    const r = e.getTimezoneOffset();
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + _f(r, ":");
      case "OOOO":
      default:
        return "GMT" + Gr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, t) {
    const r = e.getTimezoneOffset();
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + _f(r, ":");
      case "zzzz":
      default:
        return "GMT" + Gr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, a, t) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Ct(r, a.length);
  },
  // Milliseconds timestamp
  T: function(e, a, t) {
    const r = e.getTime();
    return Ct(r, a.length);
  }
};
function _f(e, a = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? t + String(i) : t + String(i) + a + Ct(s, 2);
}
function $f(e, a) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ct(Math.abs(e) / 60, 2) : Gr(e, a);
}
function Gr(e, a = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), i = Ct(Math.trunc(r / 60), 2), s = Ct(r % 60, 2);
  return t + i + a + s;
}
const ev = (e, a) => {
  switch (e) {
    case "P":
      return a.date({ width: "short" });
    case "PP":
      return a.date({ width: "medium" });
    case "PPP":
      return a.date({ width: "long" });
    case "PPPP":
    default:
      return a.date({ width: "full" });
  }
}, vp = (e, a) => {
  switch (e) {
    case "p":
      return a.time({ width: "short" });
    case "pp":
      return a.time({ width: "medium" });
    case "ppp":
      return a.time({ width: "long" });
    case "pppp":
    default:
      return a.time({ width: "full" });
  }
}, cM = (e, a) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], i = t[2];
  if (!i)
    return ev(e, a);
  let s;
  switch (r) {
    case "P":
      s = a.dateTime({ width: "short" });
      break;
    case "PP":
      s = a.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = a.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = a.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", ev(r, a)).replace("{{time}}", vp(i, a));
}, fA = {
  p: vp,
  P: cM
}, fM = /^D+$/, vM = /^Y+$/, pM = ["D", "DD", "YY", "YYYY"];
function pp(e) {
  return fM.test(e);
}
function gp(e) {
  return vM.test(e);
}
function vA(e, a, t) {
  const r = gM(e, a, t);
  if (console.warn(r), pM.includes(e))
    throw new RangeError(r);
}
function gM(e, a, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${a}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const hM = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, mM = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yM = /^'([^]*?)'?$/, bM = /''/g, wM = /[a-zA-Z]/;
function Na(e, a, t) {
  var p, v, m, w, B, T, L, E;
  const r = ll(), i = (t == null ? void 0 : t.locale) ?? r.locale ?? fp, s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((v = (p = t == null ? void 0 : t.locale) == null ? void 0 : p.options) == null ? void 0 : v.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((w = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, u = (t == null ? void 0 : t.weekStartsOn) ?? ((T = (B = t == null ? void 0 : t.locale) == null ? void 0 : B.options) == null ? void 0 : T.weekStartsOn) ?? r.weekStartsOn ?? ((E = (L = r.locale) == null ? void 0 : L.options) == null ? void 0 : E.weekStartsOn) ?? 0, A = He(e);
  if (!Di(A))
    throw new RangeError("Invalid time value");
  let c = a.match(mM).map((N) => {
    const k = N[0];
    if (k === "p" || k === "P") {
      const F = fA[k];
      return F(N, i.formatLong);
    }
    return N;
  }).join("").match(hM).map((N) => {
    if (N === "''")
      return { isToken: !1, value: "'" };
    const k = N[0];
    if (k === "'")
      return { isToken: !1, value: CM(N) };
    if (Jf[k])
      return { isToken: !0, value: N };
    if (k.match(wM))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + k + "`"
      );
    return { isToken: !1, value: N };
  });
  i.localize.preprocessor && (c = i.localize.preprocessor(A, c));
  const g = {
    firstWeekContainsDate: s,
    weekStartsOn: u,
    locale: i
  };
  return c.map((N) => {
    if (!N.isToken)
      return N.value;
    const k = N.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && gp(k) || !(t != null && t.useAdditionalDayOfYearTokens) && pp(k)) && vA(k, a, String(e));
    const F = Jf[k[0]];
    return F(A, k, i.localize, g);
  }).join("");
}
function CM(e) {
  const a = e.match(yM);
  return a ? a[1].replace(bM, "'") : e;
}
function DM(e) {
  return He(e).getDay();
}
function BM(e) {
  const a = He(e), t = a.getFullYear(), r = a.getMonth(), i = ht(e, 0);
  return i.setFullYear(t, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function TM() {
  return Object.assign({}, ll());
}
function $a(e) {
  return He(e).getHours();
}
function xM(e) {
  let t = He(e).getDay();
  return t === 0 && (t = 7), t;
}
function Dr(e) {
  return He(e).getMinutes();
}
function At(e) {
  return He(e).getMonth();
}
function Yl(e) {
  return He(e).getSeconds();
}
function et(e) {
  return He(e).getFullYear();
}
function Sl(e, a) {
  const t = He(e), r = He(a);
  return t.getTime() > r.getTime();
}
function xi(e, a) {
  const t = He(e), r = He(a);
  return +t < +r;
}
function kl(e, a) {
  const t = He(e), r = He(a);
  return +t == +r;
}
function PM(e, a) {
  const t = a instanceof Date ? ht(a, 0) : new a(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const kM = 10;
class hp {
  constructor() {
    Ee(this, "subPriority", 0);
  }
  validate(a, t) {
    return !0;
  }
}
class OM extends hp {
  constructor(a, t, r, i, s) {
    super(), this.value = a, this.validateValue = t, this.setValue = r, this.priority = i, s && (this.subPriority = s);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, r) {
    return this.setValue(a, t, this.value, r);
  }
}
class MM extends hp {
  constructor() {
    super(...arguments);
    Ee(this, "priority", kM);
    Ee(this, "subPriority", -1);
  }
  set(t, r) {
    return r.timestampIsSet ? t : ht(t, PM(t, Date));
  }
}
class mt {
  run(a, t, r, i) {
    const s = this.parse(a, t, r, i);
    return s ? {
      setter: new OM(
        s.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: s.rest
    } : null;
  }
  validate(a, t, r) {
    return !0;
  }
}
class zM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 140);
    Ee(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(t, { width: "abbreviated" }) || i.era(t, { width: "narrow" });
      case "GGGGG":
        return i.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(t, { width: "wide" }) || i.era(t, { width: "abbreviated" }) || i.era(t, { width: "narrow" });
    }
  }
  set(t, r, i) {
    return r.era = i, t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const Kt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ma = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Jt(e, a) {
  return e && {
    value: a(e.value),
    rest: e.rest
  };
}
function Wt(e, a) {
  const t = a.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function za(e, a) {
  const t = a.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, i = t[2] ? parseInt(t[2], 10) : 0, s = t[3] ? parseInt(t[3], 10) : 0, u = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (i * ip + s * CO + u * DO),
    rest: a.slice(t[0].length)
  };
}
function mp(e) {
  return Wt(Kt.anyDigitsSigned, e);
}
function Ut(e, a) {
  switch (e) {
    case 1:
      return Wt(Kt.singleDigit, a);
    case 2:
      return Wt(Kt.twoDigits, a);
    case 3:
      return Wt(Kt.threeDigits, a);
    case 4:
      return Wt(Kt.fourDigits, a);
    default:
      return Wt(new RegExp("^\\d{1," + e + "}"), a);
  }
}
function ts(e, a) {
  switch (e) {
    case 1:
      return Wt(Kt.singleDigitSigned, a);
    case 2:
      return Wt(Kt.twoDigitsSigned, a);
    case 3:
      return Wt(Kt.threeDigitsSigned, a);
    case 4:
      return Wt(Kt.fourDigitsSigned, a);
    default:
      return Wt(new RegExp("^-?\\d{1," + e + "}"), a);
  }
}
function LA(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function yp(e, a) {
  const t = a > 0, r = t ? a : 1 - a;
  let i;
  if (r <= 50)
    i = e || 100;
  else {
    const s = r + 50, u = Math.trunc(s / 100) * 100, A = e >= s % 100;
    i = e + u - (A ? 100 : 0);
  }
  return t ? i : 1 - i;
}
function bp(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class IM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 130);
    Ee(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, i) {
    const s = (u) => ({
      year: u,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return Jt(Ut(4, t), s);
      case "yo":
        return Jt(
          i.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return Jt(Ut(r.length, t), s);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, i) {
    const s = t.getFullYear();
    if (i.isTwoDigitYear) {
      const A = yp(
        i.year,
        s
      );
      return t.setFullYear(A, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const u = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return t.setFullYear(u, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class EM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 130);
    Ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    const s = (u) => ({
      year: u,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return Jt(Ut(4, t), s);
      case "Yo":
        return Jt(
          i.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return Jt(Ut(r.length, t), s);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, i, s) {
    const u = IA(t, s);
    if (i.isTwoDigitYear) {
      const c = yp(
        i.year,
        u
      );
      return t.setFullYear(
        c,
        0,
        s.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), Ca(t, s);
    }
    const A = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return t.setFullYear(A, 0, s.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Ca(t, s);
  }
}
class LM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 130);
    Ee(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return ts(r === "R" ? 4 : r.length, t);
  }
  set(t, r, i) {
    const s = ht(t, 0);
    return s.setFullYear(i, 0, 4), s.setHours(0, 0, 0, 0), Nl(s);
  }
}
class NM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 130);
    Ee(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return ts(r === "u" ? 4 : r.length, t);
  }
  set(t, r, i) {
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class YM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 120);
    Ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "Q":
      case "QQ":
        return Ut(r.length, t);
      case "Qo":
        return i.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return i.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, i) {
    return t.setMonth((i - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class SM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 120);
    Ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "q":
      case "qq":
        return Ut(r.length, t);
      case "qo":
        return i.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return i.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, i) {
    return t.setMonth((i - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class VM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Ee(this, "priority", 110);
  }
  parse(t, r, i) {
    const s = (u) => u - 1;
    switch (r) {
      case "M":
        return Jt(
          Wt(Kt.month, t),
          s
        );
      case "MM":
        return Jt(Ut(2, t), s);
      case "Mo":
        return Jt(
          i.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      case "MMM":
        return i.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return i.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(t, { width: "wide", context: "formatting" }) || i.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, i) {
    return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class WM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 110);
    Ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    const s = (u) => u - 1;
    switch (r) {
      case "L":
        return Jt(
          Wt(Kt.month, t),
          s
        );
      case "LL":
        return Jt(Ut(2, t), s);
      case "Lo":
        return Jt(
          i.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      case "LLL":
        return i.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return i.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(t, { width: "wide", context: "standalone" }) || i.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, i) {
    return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function XM(e, a, t) {
  const r = He(e), i = EA(r, t) - a;
  return r.setDate(r.getDate() - i * 7), r;
}
class QM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 100);
    Ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "w":
        return Wt(Kt.week, t);
      case "wo":
        return i.ordinalNumber(t, { unit: "week" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, i, s) {
    return Ca(XM(t, i, s), s);
  }
}
function HM(e, a) {
  const t = He(e), r = zA(t) - a;
  return t.setDate(t.getDate() - r * 7), t;
}
class FM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 100);
    Ee(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "I":
        return Wt(Kt.week, t);
      case "Io":
        return i.ordinalNumber(t, { unit: "week" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, i) {
    return Nl(HM(t, i));
  }
}
const qM = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], UM = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class RM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 90);
    Ee(this, "subPriority", 1);
    Ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "d":
        return Wt(Kt.date, t);
      case "do":
        return i.ordinalNumber(t, { unit: "date" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    const i = t.getFullYear(), s = bp(i), u = t.getMonth();
    return s ? r >= 1 && r <= UM[u] : r >= 1 && r <= qM[u];
  }
  set(t, r, i) {
    return t.setDate(i), t.setHours(0, 0, 0, 0), t;
  }
}
class ZM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 90);
    Ee(this, "subpriority", 1);
    Ee(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "D":
      case "DD":
        return Wt(Kt.dayOfYear, t);
      case "Do":
        return i.ordinalNumber(t, { unit: "date" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    const i = t.getFullYear();
    return bp(i) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, i) {
    return t.setMonth(0, i), t.setHours(0, 0, 0, 0), t;
  }
}
function NA(e, a, t) {
  var v, m, w, B;
  const r = ll(), i = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((B = (w = r.locale) == null ? void 0 : w.options) == null ? void 0 : B.weekStartsOn) ?? 0, s = He(e), u = s.getDay(), c = (a % 7 + 7) % 7, g = 7 - i, p = a < 0 || a > 6 ? a - (u + g) % 7 : (c + g) % 7 - (u + g) % 7;
  return ma(s, p);
}
class GM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 90);
    Ee(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return i.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return i.day(t, { width: "wide", context: "formatting" }) || i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, i, s) {
    return t = NA(t, i, s), t.setHours(0, 0, 0, 0), t;
  }
}
class jM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 90);
    Ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i, s) {
    const u = (A) => {
      const c = Math.floor((A - 1) / 7) * 7;
      return (A + s.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "e":
      case "ee":
        return Jt(Ut(r.length, t), u);
      case "eo":
        return Jt(
          i.ordinalNumber(t, {
            unit: "day"
          }),
          u
        );
      case "eee":
        return i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return i.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return i.day(t, { width: "wide", context: "formatting" }) || i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, i, s) {
    return t = NA(t, i, s), t.setHours(0, 0, 0, 0), t;
  }
}
class KM extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 90);
    Ee(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, i, s) {
    const u = (A) => {
      const c = Math.floor((A - 1) / 7) * 7;
      return (A + s.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "c":
      case "cc":
        return Jt(Ut(r.length, t), u);
      case "co":
        return Jt(
          i.ordinalNumber(t, {
            unit: "day"
          }),
          u
        );
      case "ccc":
        return i.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(t, { width: "short", context: "standalone" }) || i.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return i.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(t, { width: "short", context: "standalone" }) || i.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return i.day(t, { width: "wide", context: "standalone" }) || i.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(t, { width: "short", context: "standalone" }) || i.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, i, s) {
    return t = NA(t, i, s), t.setHours(0, 0, 0, 0), t;
  }
}
function JM(e, a) {
  const t = He(e), r = xM(t), i = a - r;
  return ma(t, i);
}
class _M extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 90);
    Ee(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    const s = (u) => u === 0 ? 7 : u;
    switch (r) {
      case "i":
      case "ii":
        return Ut(r.length, t);
      case "io":
        return i.ordinalNumber(t, { unit: "day" });
      case "iii":
        return Jt(
          i.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(t, {
            width: "short",
            context: "formatting"
          }) || i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiii":
        return Jt(
          i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiiiii":
        return Jt(
          i.day(t, {
            width: "short",
            context: "formatting"
          }) || i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      case "iiii":
      default:
        return Jt(
          i.day(t, {
            width: "wide",
            context: "formatting"
          }) || i.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(t, {
            width: "short",
            context: "formatting"
          }) || i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, i) {
    return t = JM(t, i), t.setHours(0, 0, 0, 0), t;
  }
}
class $M extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 80);
    Ee(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, i) {
    return t.setHours(LA(i), 0, 0, 0), t;
  }
}
class ez extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 80);
    Ee(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, i) {
    return t.setHours(LA(i), 0, 0, 0), t;
  }
}
class tz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 80);
    Ee(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, i) {
    return t.setHours(LA(i), 0, 0, 0), t;
  }
}
class nz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 70);
    Ee(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "h":
        return Wt(Kt.hour12h, t);
      case "ho":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, i) {
    const s = t.getHours() >= 12;
    return s && i < 12 ? t.setHours(i + 12, 0, 0, 0) : !s && i === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(i, 0, 0, 0), t;
  }
}
class az extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 70);
    Ee(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "H":
        return Wt(Kt.hour23h, t);
      case "Ho":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, i) {
    return t.setHours(i, 0, 0, 0), t;
  }
}
class rz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 70);
    Ee(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "K":
        return Wt(Kt.hour11h, t);
      case "Ko":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, i) {
    return t.getHours() >= 12 && i < 12 ? t.setHours(i + 12, 0, 0, 0) : t.setHours(i, 0, 0, 0), t;
  }
}
class lz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 70);
    Ee(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "k":
        return Wt(Kt.hour24h, t);
      case "ko":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, i) {
    const s = i <= 24 ? i % 24 : i;
    return t.setHours(s, 0, 0, 0), t;
  }
}
class iz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 60);
    Ee(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "m":
        return Wt(Kt.minute, t);
      case "mo":
        return i.ordinalNumber(t, { unit: "minute" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, i) {
    return t.setMinutes(i, 0, 0), t;
  }
}
class oz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 50);
    Ee(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "s":
        return Wt(Kt.second, t);
      case "so":
        return i.ordinalNumber(t, { unit: "second" });
      default:
        return Ut(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, i) {
    return t.setSeconds(i, 0), t;
  }
}
class sz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 30);
    Ee(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const i = (s) => Math.trunc(s * Math.pow(10, -r.length + 3));
    return Jt(Ut(r.length, t), i);
  }
  set(t, r, i) {
    return t.setMilliseconds(i), t;
  }
}
class uz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 10);
    Ee(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return za(
          Ma.basicOptionalMinutes,
          t
        );
      case "XX":
        return za(Ma.basic, t);
      case "XXXX":
        return za(
          Ma.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return za(
          Ma.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return za(Ma.extended, t);
    }
  }
  set(t, r, i) {
    return r.timestampIsSet ? t : ht(
      t,
      t.getTime() - es(t) - i
    );
  }
}
class Az extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 10);
    Ee(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return za(
          Ma.basicOptionalMinutes,
          t
        );
      case "xx":
        return za(Ma.basic, t);
      case "xxxx":
        return za(
          Ma.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return za(
          Ma.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return za(Ma.extended, t);
    }
  }
  set(t, r, i) {
    return r.timestampIsSet ? t : ht(
      t,
      t.getTime() - es(t) - i
    );
  }
}
class dz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 40);
    Ee(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return mp(t);
  }
  set(t, r, i) {
    return [ht(t, i * 1e3), { timestampIsSet: !0 }];
  }
}
class cz extends mt {
  constructor() {
    super(...arguments);
    Ee(this, "priority", 20);
    Ee(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return mp(t);
  }
  set(t, r, i) {
    return [ht(t, i), { timestampIsSet: !0 }];
  }
}
const fz = {
  G: new zM(),
  y: new IM(),
  Y: new EM(),
  R: new LM(),
  u: new NM(),
  Q: new YM(),
  q: new SM(),
  M: new VM(),
  L: new WM(),
  w: new QM(),
  I: new FM(),
  d: new RM(),
  D: new ZM(),
  E: new GM(),
  e: new jM(),
  c: new KM(),
  i: new _M(),
  a: new $M(),
  b: new ez(),
  B: new tz(),
  h: new nz(),
  H: new az(),
  K: new rz(),
  k: new lz(),
  m: new iz(),
  s: new oz(),
  S: new sz(),
  X: new uz(),
  x: new Az(),
  t: new dz(),
  T: new cz()
}, vz = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pz = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gz = /^'([^]*?)'?$/, hz = /''/g, mz = /\S/, yz = /[a-zA-Z]/;
function pA(e, a, t, r) {
  var T, L, E, N, k, F, S, Q;
  const i = TM(), s = (r == null ? void 0 : r.locale) ?? i.locale ?? fp, u = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((L = (T = r == null ? void 0 : r.locale) == null ? void 0 : T.options) == null ? void 0 : L.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((N = (E = i.locale) == null ? void 0 : E.options) == null ? void 0 : N.firstWeekContainsDate) ?? 1, A = (r == null ? void 0 : r.weekStartsOn) ?? ((F = (k = r == null ? void 0 : r.locale) == null ? void 0 : k.options) == null ? void 0 : F.weekStartsOn) ?? i.weekStartsOn ?? ((Q = (S = i.locale) == null ? void 0 : S.options) == null ? void 0 : Q.weekStartsOn) ?? 0;
  if (a === "")
    return e === "" ? He(t) : ht(t, NaN);
  const c = {
    firstWeekContainsDate: u,
    weekStartsOn: A,
    locale: s
  }, g = [new MM()], p = a.match(pz).map((x) => {
    const W = x[0];
    if (W in fA) {
      const z = fA[W];
      return z(x, s.formatLong);
    }
    return x;
  }).join("").match(vz), v = [];
  for (let x of p) {
    !(r != null && r.useAdditionalWeekYearTokens) && gp(x) && vA(x, a, e), !(r != null && r.useAdditionalDayOfYearTokens) && pp(x) && vA(x, a, e);
    const W = x[0], z = fz[W];
    if (z) {
      const { incompatibleTokens: q } = z;
      if (Array.isArray(q)) {
        const le = v.find(
          (ve) => q.includes(ve.token) || ve.token === W
        );
        if (le)
          throw new RangeError(
            `The format string mustn't contain \`${le.fullToken}\` and \`${x}\` at the same time`
          );
      } else if (z.incompatibleTokens === "*" && v.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${x}\` and any other token at the same time`
        );
      v.push({ token: W, fullToken: x });
      const J = z.run(
        e,
        x,
        s.match,
        c
      );
      if (!J)
        return ht(t, NaN);
      g.push(J.setter), e = J.rest;
    } else {
      if (W.match(yz))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + W + "`"
        );
      if (x === "''" ? x = "'" : W === "'" && (x = bz(x)), e.indexOf(x) === 0)
        e = e.slice(x.length);
      else
        return ht(t, NaN);
    }
  }
  if (e.length > 0 && mz.test(e))
    return ht(t, NaN);
  const m = g.map((x) => x.priority).sort((x, W) => W - x).filter((x, W, z) => z.indexOf(x) === W).map(
    (x) => g.filter((W) => W.priority === x).sort((W, z) => z.subPriority - W.subPriority)
  ).map((x) => x[0]);
  let w = He(t);
  if (isNaN(w.getTime()))
    return ht(t, NaN);
  const B = {};
  for (const x of m) {
    if (!x.validate(w, c))
      return ht(t, NaN);
    const W = x.set(w, B, c);
    Array.isArray(W) ? (w = W[0], Object.assign(B, W[1])) : w = W;
  }
  return ht(t, w);
}
function bz(e) {
  return e.match(gz)[1].replace(hz, "'");
}
function tv(e, a) {
  const t = _r(e), r = _r(a);
  return +t == +r;
}
function vi(e, a) {
  return ma(e, -a);
}
function wp(e, a) {
  const t = He(e), r = t.getFullYear(), i = t.getDate(), s = ht(e, 0);
  s.setFullYear(r, a, 15), s.setHours(0, 0, 0, 0);
  const u = BM(s);
  return t.setMonth(a, Math.min(i, u)), t;
}
function Pt(e, a) {
  let t = He(e);
  return isNaN(+t) ? ht(e, NaN) : (a.year != null && t.setFullYear(a.year), a.month != null && (t = wp(t, a.month)), a.date != null && t.setDate(a.date), a.hours != null && t.setHours(a.hours), a.minutes != null && t.setMinutes(a.minutes), a.seconds != null && t.setSeconds(a.seconds), a.milliseconds != null && t.setMilliseconds(a.milliseconds), t);
}
function wz(e, a) {
  const t = He(e);
  return t.setHours(a), t;
}
function Cp(e, a) {
  const t = He(e);
  return t.setMilliseconds(a), t;
}
function Cz(e, a) {
  const t = He(e);
  return t.setMinutes(a), t;
}
function Dp(e, a) {
  const t = He(e);
  return t.setSeconds(a), t;
}
function Ea(e, a) {
  const t = He(e);
  return isNaN(+t) ? ht(e, NaN) : (t.setFullYear(a), t);
}
function Vl(e, a) {
  return ba(e, -a);
}
function Dz(e, a) {
  const {
    years: t = 0,
    months: r = 0,
    weeks: i = 0,
    days: s = 0,
    hours: u = 0,
    minutes: A = 0,
    seconds: c = 0
  } = a, g = Vl(e, r + t * 12), p = vi(g, s + i * 7), v = A + u * 60, w = (c + v * 60) * 1e3;
  return ht(e, p.getTime() - w);
}
function YA(e, a) {
  return MA(e, -a);
}
function Hl() {
  const e = ww();
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...e
    },
    [
      X("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      X("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      X("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      X("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Hl.compatConfig = {
  MODE: 3
};
function Bp() {
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      X("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      X("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Bp.compatConfig = {
  MODE: 3
};
function SA() {
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      X("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
SA.compatConfig = {
  MODE: 3
};
function VA() {
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      X("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
VA.compatConfig = {
  MODE: 3
};
function WA() {
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      X("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      X("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
WA.compatConfig = {
  MODE: 3
};
function XA() {
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      X("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
XA.compatConfig = {
  MODE: 3
};
function QA() {
  return f(), y(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      X("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
QA.compatConfig = {
  MODE: 3
};
const Qn = (e, a) => a ? new Date(e.toLocaleString("en-US", { timeZone: a })) : new Date(e), HA = (e, a, t) => gA(e, a, t) || Be(), Bz = (e, a, t) => {
  const r = a.dateInTz ? Qn(new Date(e), a.dateInTz) : Be(e);
  return t ? In(r, !0) : r;
}, gA = (e, a, t) => {
  if (!e)
    return null;
  const r = t ? In(Be(e), !0) : Be(e);
  return a ? a.exactMatch ? Bz(e, a, t) : Qn(r, a.timezone) : r;
}, Tz = (e) => {
  if (!e)
    return 0;
  const a = /* @__PURE__ */ new Date(), t = new Date(a.toLocaleString("en-US", { timeZone: "UTC" })), r = new Date(a.toLocaleString("en-US", { timeZone: e })), i = r.getTimezoneOffset() / 60;
  return (+t - +r) / (1e3 * 60 * 60) - i;
};
var pa = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(pa || {}), jr = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(jr || {}), $r = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))($r || {}), Bn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Bn || {});
const xz = ["timestamp", "date", "iso"];
var Mn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(Mn || {}), zt = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(zt || {});
function nv(e) {
  return (a) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`)).slice(0, 2);
}
function Pz(e) {
  return (a) => Na(Qn(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const kz = (e, a, t) => {
  const r = [1, 2, 3, 4, 5, 6, 7];
  let i;
  if (e !== null)
    try {
      i = r.map(Pz(e));
    } catch {
      i = r.map(nv(a));
    }
  else
    i = r.map(nv(a));
  const s = i.slice(0, t), u = i.slice(t + 1, i.length);
  return [i[t]].concat(...u).concat(...s);
}, FA = (e, a, t) => {
  const r = [];
  for (let i = +e[0]; i <= +e[1]; i++)
    r.push({ value: +i, text: kp(i, a) });
  return t ? r.reverse() : r;
}, Tp = (e, a, t) => {
  const r = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((s) => {
    const u = s < 10 ? `0${s}` : s;
    return /* @__PURE__ */ new Date(`2017-${u}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const s = t === "long" ? "LLLL" : "LLL";
      return r.map((u, A) => {
        const c = Na(Qn(u, "UTC"), s, { locale: e });
        return {
          text: c.charAt(0).toUpperCase() + c.substring(1),
          value: A
        };
      });
    } catch {
    }
  const i = new Intl.DateTimeFormat(a, { month: t, timeZone: "UTC" });
  return r.map((s, u) => {
    const A = i.format(s);
    return {
      text: A.charAt(0).toUpperCase() + A.substring(1),
      value: u
    };
  });
}, Oz = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], on = (e) => {
  const a = b(e);
  return a != null && a.$el ? a == null ? void 0 : a.$el : a;
}, Mz = (e) => ({ type: "dot", ...e ?? {} }), xp = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, qA = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, dn = (e) => e, av = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, rv = (e) => e === null, Pp = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, zz = (e) => {
  const a = [], t = (r) => r.filter((i) => i);
  for (let r = 0; r < e.length; r += 3) {
    const i = [e[r], e[r + 1], e[r + 2]];
    a.push(t(i));
  }
  return a;
}, Pi = (e, a, t) => {
  const r = t != null, i = a != null;
  if (!r && !i)
    return !1;
  const s = +t, u = +a;
  return r && i ? +e > s || +e < u : r ? +e > s : i ? +e < u : !1;
}, Wl = (e, a) => zz(e).map((t) => t.map((r) => {
  const { active: i, disabled: s, isBetween: u, highlighted: A } = a(r);
  return {
    ...r,
    active: i,
    disabled: s,
    className: {
      dp__overlay_cell_active: i,
      dp__overlay_cell: !i,
      dp__overlay_cell_disabled: s,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: s && i,
      dp__cell_in_between: u,
      "dp--highlighted": A
    }
  };
})), br = (e, a, t = !1) => {
  e && a.allowStopPropagation && (t && e.stopImmediatePropagation(), e.stopPropagation());
}, Iz = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function Ez(e, a) {
  let t = [...document.querySelectorAll(Iz())];
  t = t.filter((i) => !e.contains(i) || i.hasAttribute("data-datepicker-instance"));
  const r = t.indexOf(e);
  if (r >= 0 && (a ? r - 1 >= 0 : r + 1 <= t.length))
    return t[r + (a ? -1 : 1)];
}
const hA = (e, a) => e == null ? void 0 : e.querySelector(`[data-dp-element="${a}"]`), kp = (e, a) => new Intl.NumberFormat(a, { useGrouping: !1, style: "decimal" }).format(e), UA = (e) => Na(e, "dd-MM-yyyy"), Uu = (e) => Array.isArray(e), ns = (e, a) => a.get(UA(e)), Lz = (e, a) => e ? a ? a instanceof Map ? !!ns(e, a) : a(Be(e)) : !1 : !0, zn = (e, a, t = !1, r) => {
  if (e.key === zt.enter || e.key === zt.space)
    return t && e.preventDefault(), a();
  if (r)
    return r(e);
}, lv = () => ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].some(
  (e) => navigator.userAgent.includes(e)
) || navigator.userAgent.includes("Mac") && "ontouchend" in document, iv = (e, a, t, r, i, s) => {
  const u = pA(e, a.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: s });
  return Di(u) && up(u) ? r || i ? u : Pt(u, {
    hours: +t.hours,
    minutes: +(t == null ? void 0 : t.minutes),
    seconds: +(t == null ? void 0 : t.seconds),
    milliseconds: 0
  }) : null;
}, Nz = (e, a, t, r, i, s) => {
  const u = Array.isArray(t) ? t[0] : t;
  if (typeof a == "string")
    return iv(e, a, u, r, i, s);
  if (Array.isArray(a)) {
    let A = null;
    for (const c of a)
      if (A = iv(e, c, u, r, i, s), A)
        break;
    return A;
  }
  return typeof a == "function" ? a(e) : null;
}, Be = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), Yz = (e, a, t) => {
  if (a) {
    const i = (e.getMonth() + 1).toString().padStart(2, "0"), s = e.getDate().toString().padStart(2, "0"), u = e.getHours().toString().padStart(2, "0"), A = e.getMinutes().toString().padStart(2, "0"), c = t ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${i}-${s}T${u}:${A}:${c}.000Z`;
  }
  const r = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(r).toISOString();
}, In = (e, a) => {
  const t = Be(JSON.parse(JSON.stringify(e))), r = Pt(t, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return a ? zO(r) : r;
}, wr = (e, a, t, r) => {
  let i = e ? Be(e) : Be();
  return (a || a === 0) && (i = wz(i, +a)), (t || t === 0) && (i = Cz(i, +t)), (r || r === 0) && (i = Dp(i, +r)), Cp(i, 0);
}, qt = (e, a) => !e || !a ? !1 : xi(In(e), In(a)), ft = (e, a) => !e || !a ? !1 : kl(In(e), In(a)), jt = (e, a) => !e || !a ? !1 : Sl(In(e), In(a)), ss = (e, a, t) => e != null && e[0] && e != null && e[1] ? jt(t, e[0]) && qt(t, e[1]) : e != null && e[0] && a ? jt(t, e[0]) && qt(t, a) || qt(t, e[0]) && jt(t, a) : !1, ya = (e) => {
  const a = Pt(new Date(e), { date: 1 });
  return In(a);
}, Ru = (e, a, t) => a && (t || t === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((r) => r === a ? [r, t] : [r, isNaN(+e[r]) ? void 0 : +e[r]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, el = (e) => ({
  hours: $a(e),
  minutes: Dr(e),
  seconds: Yl(e)
}), Op = (e, a) => {
  if (a) {
    const t = et(Be(a));
    if (t > e)
      return 12;
    if (t === e)
      return At(Be(a));
  }
}, Mp = (e, a) => {
  if (a) {
    const t = et(Be(a));
    return t < e ? -1 : t === e ? At(Be(a)) : void 0;
  }
}, Xl = (e) => {
  if (e)
    return et(Be(e));
}, zp = (e, a) => {
  const t = jt(e, a) ? a : e, r = jt(a, e) ? a : e;
  return Ap({ start: t, end: r });
}, Sz = (e) => {
  const a = ba(e, 1);
  return { month: At(a), year: et(a) };
}, Za = (e, a) => {
  const t = Ca(e, { weekStartsOn: +a }), r = cp(e, { weekStartsOn: +a });
  return [t, r];
}, Ip = (e, a) => {
  const t = {
    hours: $a(Be()),
    minutes: Dr(Be()),
    seconds: a ? Yl(Be()) : 0
  };
  return Object.assign(t, e);
}, mr = (e, a, t) => [Pt(Be(e), { date: 1 }), Pt(Be(), { month: a, year: t, date: 1 })], ja = (e, a, t) => {
  let r = e ? Be(e) : Be();
  return (a || a === 0) && (r = wp(r, a)), t && (r = Ea(r, t)), r;
}, Ep = (e, a, t, r, i) => {
  if (!r || i && !a || !i && !t)
    return !1;
  const s = i ? ba(e, 1) : Vl(e, 1), u = [At(s), et(s)];
  return i ? !Wz(...u, a) : !Vz(...u, t);
}, Vz = (e, a, t) => qt(...mr(t, e, a)) || ft(...mr(t, e, a)), Wz = (e, a, t) => jt(...mr(t, e, a)) || ft(...mr(t, e, a)), Lp = (e, a, t, r, i, s, u) => {
  if (typeof a == "function" && !u)
    return a(e);
  const A = t ? { locale: t } : void 0;
  return Array.isArray(e) ? `${Na(e[0], s, A)}${i && !e[1] ? "" : r}${e[1] ? Na(e[1], s, A) : ""}` : Na(e, s, A);
}, Bl = (e) => {
  if (e)
    return null;
  throw new Error(qA.prop("partial-range"));
}, Eo = (e, a) => {
  if (a)
    return e();
  throw new Error(qA.prop("range"));
}, mA = (e) => Array.isArray(e) ? Di(e[0]) && (e[1] ? Di(e[1]) : !0) : e ? Di(e) : !1, Xz = (e, a) => Pt(a ?? Be(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), Zu = (e, a, t, r) => {
  if (!e)
    return !0;
  if (r) {
    const i = t === "max" ? xi(e, a) : Sl(e, a), s = { seconds: 0, milliseconds: 0 };
    return i || kl(Pt(e, s), Pt(a, s));
  }
  return t === "max" ? e.getTime() <= a.getTime() : e.getTime() >= a.getTime();
}, Gu = (e, a, t) => e ? Xz(e, a) : Be(t ?? a), ov = (e, a, t, r, i) => {
  if (Array.isArray(r)) {
    const u = Gu(e, r[0], a), A = Gu(e, r[1], a);
    return Zu(r[0], u, t, !!a) && Zu(r[1], A, t, !!a) && i;
  }
  const s = Gu(e, r, a);
  return Zu(r, s, t, !!a) && i;
}, ju = (e) => Pt(Be(), el(e)), Qz = (e, a) => e instanceof Map ? Array.from(e.values()).filter((t) => et(Be(t)) === a).map((t) => At(t)) : [], Np = (e, a, t) => typeof e == "function" ? e({ month: a, year: t }) : !!e.months.find((r) => r.month === a && r.year === t), RA = (e, a) => typeof e == "function" ? e(a) : e.years.includes(a), Yp = (e) => Na(e, "yyyy-MM-dd"), ui = Ja({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Sp = () => {
  const e = (t) => {
    ui.menuFocused = t;
  }, a = (t) => {
    ui.shiftKeyInMenu !== t && (ui.shiftKeyInMenu = t);
  };
  return {
    control: V(() => ({ shiftKeyInMenu: ui.shiftKeyInMenu, menuFocused: ui.menuFocused })),
    setMenuFocused: e,
    setShiftKey: a
  };
}, Mt = Ja({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Ku = U(null), Lo = U(!1), Ju = U(!1), _u = U(!1), $u = U(!1), Dn = U(0), Gt = U(0), Tr = () => {
  const e = V(() => Lo.value ? [...Mt.selectionGrid, Mt.actionRow].filter((v) => v.length) : Ju.value ? [
    ...Mt.timePicker[0],
    ...Mt.timePicker[1],
    $u.value ? [] : [Ku.value],
    Mt.actionRow
  ].filter((v) => v.length) : _u.value ? [...Mt.monthPicker, Mt.actionRow] : [Mt.monthYear, ...Mt.calendar, Mt.time, Mt.actionRow].filter((v) => v.length)), a = (v) => {
    Dn.value = v ? Dn.value + 1 : Dn.value - 1;
    let m = null;
    e.value[Gt.value] && (m = e.value[Gt.value][Dn.value]), !m && e.value[Gt.value + (v ? 1 : -1)] ? (Gt.value = Gt.value + (v ? 1 : -1), Dn.value = v ? 0 : e.value[Gt.value].length - 1) : m || (Dn.value = v ? Dn.value - 1 : Dn.value + 1);
  }, t = (v) => {
    Gt.value === 0 && !v || Gt.value === e.value.length && v || (Gt.value = v ? Gt.value + 1 : Gt.value - 1, e.value[Gt.value] ? e.value[Gt.value] && !e.value[Gt.value][Dn.value] && Dn.value !== 0 && (Dn.value = e.value[Gt.value].length - 1) : Gt.value = v ? Gt.value - 1 : Gt.value + 1);
  }, r = (v) => {
    let m = null;
    e.value[Gt.value] && (m = e.value[Gt.value][Dn.value]), m ? m.focus({ preventScroll: !Lo.value }) : Dn.value = v ? Dn.value - 1 : Dn.value + 1;
  }, i = () => {
    a(!0), r(!0);
  }, s = () => {
    a(!1), r(!1);
  }, u = () => {
    t(!1), r(!0);
  }, A = () => {
    t(!0), r(!0);
  }, c = (v, m) => {
    Mt[m] = v;
  }, g = (v, m) => {
    Mt[m] = v;
  }, p = () => {
    Dn.value = 0, Gt.value = 0;
  };
  return {
    buildMatrix: c,
    buildMultiLevelMatrix: g,
    setTimePickerBackRef: (v) => {
      Ku.value = v;
    },
    setSelectionGrid: (v) => {
      Lo.value = v, p(), v || (Mt.selectionGrid = []);
    },
    setTimePicker: (v, m = !1) => {
      Ju.value = v, $u.value = m, p(), v || (Mt.timePicker[0] = [], Mt.timePicker[1] = []);
    },
    setTimePickerElements: (v, m = 0) => {
      Mt.timePicker[m] = v;
    },
    arrowRight: i,
    arrowLeft: s,
    arrowUp: u,
    arrowDown: A,
    clearArrowNav: () => {
      Mt.monthYear = [], Mt.calendar = [], Mt.time = [], Mt.actionRow = [], Mt.selectionGrid = [], Mt.timePicker[0] = [], Mt.timePicker[1] = [], Lo.value = !1, Ju.value = !1, $u.value = !1, _u.value = !1, p(), Ku.value = null;
    },
    setMonthPicker: (v) => {
      _u.value = v, p();
    },
    refSets: Mt
    // exposed for testing
  };
}, sv = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), Hz = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (a) => `Increment ${a}`,
  decrementValue: (a) => `Decrement ${a}`,
  openTpOverlay: (a) => `Open ${a} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (a) => `Month picker${a ? " overlay" : ""}`,
  yearPicker: (a) => `Year picker${a ? " overlay" : ""}`,
  timeOverlay: (a) => `${a} overlay`,
  ...e ?? {}
}), uv = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, Fz = (e) => {
  const a = typeof e == "object" && e, t = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...t, count: uv(!1) };
  const r = a ? e : {}, i = a ? r.count ?? !0 : e, s = uv(i);
  return Object.assign(t, r, { count: s });
}, qz = (e, a, t) => e || (typeof t == "string" ? t : a), Uz = (e) => typeof e == "boolean" ? e ? sv({}) : !1 : sv(e), Rz = (e) => {
  const a = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...a, ...e ?? {}, enabled: !0 } : { ...a, enabled: e };
}, Zz = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Gz = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), jz = (e) => {
  const a = { input: !1 };
  return typeof e == "object" ? { ...a, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...a
  };
}, Kz = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, ...e ?? {} }), Jz = (e) => {
  const a = {
    dates: Array.isArray(e) ? e.map((t) => Be(t)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...a, ...e ?? {} };
}, _z = (e) => typeof e == "object" ? {
  type: (e == null ? void 0 : e.type) ?? "local",
  hideOnOffsetDates: (e == null ? void 0 : e.hideOnOffsetDates) ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, $z = (e) => {
  const a = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof e == "object" ? { enabled: !0, ...a, ...e } : {
    enabled: e,
    ...a
  };
}, eI = (e) => e ? typeof e == "string" ? {
  timezone: e,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: e.emitTimezone ?? void 0,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, eA = (e, a, t) => new Map(
  e.map((r) => {
    const i = HA(r, a, t);
    return [UA(i), i];
  })
), tI = (e, a) => e.length ? new Map(
  e.map((t) => {
    const r = HA(t.date, a);
    return [UA(r), t];
  })
) : null, nI = (e) => {
  var a;
  return {
    minDate: gA(e.minDate, e.timezone, e.isSpecific),
    maxDate: gA(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: Uu(e.disabledDates) ? eA(e.disabledDates, e.timezone, e.isSpecific) : e.disabledDates,
    allowedDates: Uu(e.allowedDates) ? eA(e.allowedDates, e.timezone, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && Uu((a = e.highlight) == null ? void 0 : a.dates) ? eA(e.highlight.dates, e.timezone) : e.highlight,
    markers: tI(e.markers, e.timezone)
  };
}, aI = (e) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: null } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, rI = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((a) => {
      const t = a, r = e[t], i = typeof e[t] == "string" ? { [r]: !0 } : Object.fromEntries(r.map((s) => [s, !0]));
      return [a, i];
    })
  )
}), Nt = (e) => {
  const a = () => {
    const Q = e.enableSeconds ? ":ss" : "", x = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${x}${Q}` : `hh${x}${Q} aa`;
  }, t = () => {
    var Q;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? a() : e.weekPicker ? `${((Q = L.value) == null ? void 0 : Q.type) === "iso" ? "RR" : "ww"}-yyyy` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${a()}` : "MM/dd/yyyy";
  }, r = (Q) => Ip(Q, e.enableSeconds), i = () => F.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [r(e.startTime[0]), r(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? r(e.startTime) : null, s = V(() => Fz(e.multiCalendars)), u = V(() => i()), A = V(() => Hz(e.ariaLabels)), c = V(() => Zz(e.filters)), g = V(() => Uz(e.transitions)), p = V(() => Gz(e.actionRow)), v = V(
    () => qz(e.previewFormat, e.format, t())
  ), m = V(() => Rz(e.textInput)), w = V(() => jz(e.inline)), B = V(() => Kz(e.config)), T = V(() => Jz(e.highlight)), L = V(() => _z(e.weekNumbers)), E = V(() => eI(e.timezone)), N = V(() => aI(e.multiDates)), k = V(
    () => nI({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: T.value,
      markers: e.markers,
      timezone: E.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker
    })
  ), F = V(() => $z(e.range)), S = V(() => rI(e.ui));
  return {
    defaultedTransitions: g,
    defaultedMultiCalendars: s,
    defaultedStartTime: u,
    defaultedAriaLabels: A,
    defaultedFilters: c,
    defaultedActionRow: p,
    defaultedPreviewFormat: v,
    defaultedTextInput: m,
    defaultedInline: w,
    defaultedConfig: B,
    defaultedHighlight: T,
    defaultedWeekNumbers: L,
    defaultedRange: F,
    propDates: k,
    defaultedTz: E,
    defaultedMultiDates: N,
    defaultedUI: S,
    getDefaultPattern: t,
    getDefaultStartTime: i
  };
}, lI = (e, a, t) => {
  const r = U(), { defaultedTextInput: i, defaultedRange: s, defaultedTz: u, defaultedMultiDates: A, getDefaultPattern: c } = Nt(a), g = U(""), p = zl(a, "format"), v = zl(a, "formatLocale");
  st(
    r,
    () => {
      typeof a.onInternalModelChange == "function" && e("internal-model-change", r.value, ae(!0));
    },
    { deep: !0 }
  ), st(s, (O, ke) => {
    O.enabled !== ke.enabled && (r.value = null);
  }), st(p, () => {
    Oe();
  });
  const m = (O) => u.value.timezone && u.value.convertModel ? Qn(O, u.value.timezone) : O, w = (O) => {
    if (u.value.timezone && u.value.convertModel) {
      const ke = Tz(u.value.timezone);
      return BO(O, ke);
    }
    return O;
  }, B = (O, ke, Ue = !1) => Lp(
    O,
    a.format,
    a.formatLocale,
    i.value.rangeSeparator,
    a.modelAuto,
    ke ?? c(),
    Ue
  ), T = (O) => O ? a.modelType ? $(O) : {
    hours: $a(O),
    minutes: Dr(O),
    seconds: a.enableSeconds ? Yl(O) : 0
  } : null, L = (O) => a.modelType ? $(O) : { month: At(O), year: et(O) }, E = (O) => Array.isArray(O) ? A.value.enabled ? O.map((ke) => N(ke, Ea(Be(), ke))) : Eo(
    () => [
      Ea(Be(), O[0]),
      O[1] ? Ea(Be(), O[1]) : Bl(s.value.partialRange)
    ],
    s.value.enabled
  ) : Ea(Be(), +O), N = (O, ke) => (typeof O == "string" || typeof O == "number") && a.modelType ? pe(O) : ke, k = (O) => Array.isArray(O) ? [
    N(
      O[0],
      wr(null, +O[0].hours, +O[0].minutes, O[0].seconds)
    ),
    N(
      O[1],
      wr(null, +O[1].hours, +O[1].minutes, O[1].seconds)
    )
  ] : N(O, wr(null, O.hours, O.minutes, O.seconds)), F = (O) => {
    const ke = Pt(Be(), { date: 1 });
    return Array.isArray(O) ? A.value.enabled ? O.map((Ue) => N(Ue, ja(ke, +Ue.month, +Ue.year))) : Eo(
      () => [
        N(O[0], ja(ke, +O[0].month, +O[0].year)),
        N(
          O[1],
          O[1] ? ja(ke, +O[1].month, +O[1].year) : Bl(s.value.partialRange)
        )
      ],
      s.value.enabled
    ) : N(O, ja(ke, +O.month, +O.year));
  }, S = (O) => {
    if (Array.isArray(O))
      return O.map((ke) => pe(ke));
    throw new Error(qA.dateArr("multi-dates"));
  }, Q = (O) => {
    if (Array.isArray(O) && s.value.enabled) {
      const ke = O[0], Ue = O[1];
      return [
        Be(Array.isArray(ke) ? ke[0] : null),
        Array.isArray(Ue) && Ue.length ? Be(Ue[0]) : null
      ];
    }
    return Be(O[0]);
  }, x = (O) => a.modelAuto ? Array.isArray(O) ? [pe(O[0]), pe(O[1])] : a.autoApply ? [pe(O)] : [pe(O), null] : Array.isArray(O) ? Eo(
    () => O[1] ? [
      pe(O[0]),
      O[1] ? pe(O[1]) : Bl(s.value.partialRange)
    ] : [pe(O[0])],
    s.value.enabled
  ) : pe(O), W = () => {
    Array.isArray(r.value) && s.value.enabled && r.value.length === 1 && r.value.push(Bl(s.value.partialRange));
  }, z = () => {
    const O = r.value;
    return [
      $(O[0]),
      O[1] ? $(O[1]) : Bl(s.value.partialRange)
    ];
  }, q = () => r.value[1] ? z() : $(dn(r.value[0])), J = () => (r.value || []).map((O) => $(O)), le = (O = !1) => (O || W(), a.modelAuto ? q() : A.value.enabled ? J() : Array.isArray(r.value) ? Eo(() => z(), s.value.enabled) : $(dn(r.value))), ve = (O) => !O || Array.isArray(O) && !O.length ? null : a.timePicker ? k(dn(O)) : a.monthPicker ? F(dn(O)) : a.yearPicker ? E(dn(O)) : A.value.enabled ? S(dn(O)) : a.weekPicker ? Q(dn(O)) : x(dn(O)), R = (O) => {
    const ke = ve(O);
    mA(dn(ke)) ? (r.value = dn(ke), Oe()) : (r.value = null, g.value = "");
  }, _ = () => {
    const O = (ke) => Na(ke, i.value.format);
    return `${O(r.value[0])} ${i.value.rangeSeparator} ${r.value[1] ? O(r.value[1]) : ""}`;
  }, G = () => t.value && r.value ? Array.isArray(r.value) ? _() : Na(r.value, i.value.format) : B(r.value), oe = () => r.value ? A.value.enabled ? r.value.map((O) => B(O)).join("; ") : i.value.enabled && typeof i.value.format == "string" ? G() : B(r.value) : "", Oe = () => {
    !a.format || typeof a.format == "string" || i.value.enabled && typeof i.value.format == "string" ? g.value = oe() : g.value = a.format(r.value);
  }, pe = (O) => {
    if (a.utc) {
      const ke = new Date(O);
      return a.utc === "preserve" ? new Date(ke.getTime() + ke.getTimezoneOffset() * 6e4) : ke;
    }
    return a.modelType ? xz.includes(a.modelType) ? m(new Date(O)) : a.modelType === "format" && (typeof a.format == "string" || !a.format) ? m(
      pA(O, c(), /* @__PURE__ */ new Date(), { locale: v.value })
    ) : m(
      pA(O, a.modelType, /* @__PURE__ */ new Date(), { locale: v.value })
    ) : m(new Date(O));
  }, $ = (O) => O ? a.utc ? Yz(O, a.utc === "preserve", a.enableSeconds) : a.modelType ? a.modelType === "timestamp" ? +w(O) : a.modelType === "iso" ? w(O).toISOString() : a.modelType === "format" && (typeof a.format == "string" || !a.format) ? B(w(O)) : B(w(O), a.modelType, !0) : w(O) : "", Me = (O, ke = !1, Ue = !1) => {
    if (Ue)
      return O;
    if (e("update:model-value", O), u.value.emitTimezone && ke) {
      const Qt = Array.isArray(O) ? O.map((ie) => Qn(dn(ie), u.value.emitTimezone)) : Qn(dn(O), u.value.emitTimezone);
      e("update:model-timezone-value", Qt);
    }
  }, me = (O) => Array.isArray(r.value) ? A.value.enabled ? r.value.map((ke) => O(ke)) : [
    O(r.value[0]),
    r.value[1] ? O(r.value[1]) : Bl(s.value.partialRange)
  ] : O(dn(r.value)), te = () => {
    if (Array.isArray(r.value)) {
      const O = Za(r.value[0], a.weekStart), ke = r.value[1] ? Za(r.value[1], a.weekStart) : [];
      return [O.map((Ue) => Be(Ue)), ke.map((Ue) => Be(Ue))];
    }
    return Za(r.value, a.weekStart).map((O) => Be(O));
  }, P = (O, ke) => Me(dn(me(O)), !1, ke), Z = (O) => {
    const ke = te();
    return O ? ke : e("update:model-value", te());
  }, ae = (O = !1) => (O || Oe(), a.monthPicker ? P(L, O) : a.timePicker ? P(T, O) : a.yearPicker ? P(et, O) : a.weekPicker ? Z(O) : Me(le(O), !0, O));
  return {
    inputValue: g,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? s.value.enabled ? s.value.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: R,
    formatInputValue: Oe,
    emitModelValue: ae
  };
}, iI = (e, a) => {
  const { defaultedFilters: t, propDates: r } = Nt(e), { validateMonthYearInRange: i } = xr(e), s = (p, v) => {
    let m = p;
    return t.value.months.includes(At(m)) ? (m = v ? ba(p, 1) : Vl(p, 1), s(m, v)) : m;
  }, u = (p, v) => {
    let m = p;
    return t.value.years.includes(et(m)) ? (m = v ? MA(p, 1) : YA(p, 1), u(m, v)) : m;
  }, A = (p, v = !1) => {
    const m = Pt(Be(), { month: e.month, year: e.year });
    let w = p ? ba(m, 1) : Vl(m, 1);
    e.disableYearSelect && (w = Ea(w, e.year));
    let B = At(w), T = et(w);
    t.value.months.includes(B) && (w = s(w, p), B = At(w), T = et(w)), t.value.years.includes(T) && (w = u(w, p), T = et(w)), i(B, T, p, e.preventMinMaxNavigation) && c(B, T, v);
  }, c = (p, v, m) => {
    a("update-month-year", { month: p, year: v, fromNav: m });
  }, g = V(() => (p) => Ep(
    Pt(Be(), { month: e.month, year: e.year }),
    r.value.maxDate,
    r.value.minDate,
    e.preventMinMaxNavigation,
    p
  ));
  return { handleMonthYearChange: A, isDisabled: g, updateMonthYear: c };
}, us = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Da = {
  ...us,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 }
}, oI = ["title"], sI = ["disabled"], uI = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Da
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: a }) {
    const t = a, r = e, {
      defaultedActionRow: i,
      defaultedPreviewFormat: s,
      defaultedMultiCalendars: u,
      defaultedTextInput: A,
      defaultedInline: c,
      defaultedRange: g,
      defaultedMultiDates: p
    } = Nt(r), { isTimeValid: v, isMonthValid: m } = xr(r), { buildMatrix: w } = Tr(), B = U(null), T = U(null), L = U(!1), E = U({}), N = U(null), k = U(null);
    bt(() => {
      r.arrowNavigation && w([on(B), on(T)], "actionRow"), F(), window.addEventListener("resize", F);
    }), al(() => {
      window.removeEventListener("resize", F);
    });
    const F = () => {
      L.value = !1, setTimeout(() => {
        var R, _;
        const G = (R = N.value) == null ? void 0 : R.getBoundingClientRect(), oe = (_ = k.value) == null ? void 0 : _.getBoundingClientRect();
        G && oe && (E.value.maxWidth = `${oe.width - G.width - 20}px`), L.value = !0;
      }, 0);
    }, S = V(() => g.value.enabled && !g.value.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), Q = V(
      () => !v.value(r.internalModelValue) || !m.value(r.internalModelValue) || !S.value
    ), x = () => {
      const R = s.value;
      return r.timePicker || r.monthPicker, R(dn(r.internalModelValue));
    }, W = () => {
      const R = r.internalModelValue;
      return u.value.count > 0 ? `${z(R[0])} - ${z(R[1])}` : [z(R[0]), z(R[1])];
    }, z = (R) => Lp(
      R,
      s.value,
      r.formatLocale,
      A.value.rangeSeparator,
      r.modelAuto,
      s.value
    ), q = V(() => !r.internalModelValue || !r.menuMount ? "" : typeof s.value == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? W() : p.value.enabled ? r.internalModelValue.map((R) => `${z(R)}`) : r.modelAuto ? `${z(r.internalModelValue[0])}` : `${z(r.internalModelValue[0])} -` : z(r.internalModelValue) : x()), J = () => p.value.enabled ? "; " : " - ", le = V(
      () => Array.isArray(q.value) ? q.value.join(J()) : q.value
    ), ve = () => {
      v.value(r.internalModelValue) && m.value(r.internalModelValue) && S.value ? t("select-date") : t("invalid-select");
    };
    return (R, _) => (f(), y("div", {
      ref_key: "actionRowRef",
      ref: k,
      class: "dp__action_row"
    }, [
      R.$slots["action-row"] ? fe(R.$slots, "action-row", fn(Xt({ key: 0 }, {
        internalModelValue: R.internalModelValue,
        disabled: Q.value,
        selectDate: () => R.$emit("select-date"),
        closePicker: () => R.$emit("close-picker")
      }))) : (f(), y(Qe, { key: 1 }, [
        b(i).showPreview ? (f(), y("div", {
          key: 0,
          class: "dp__selection_preview",
          title: le.value,
          style: Tt(E.value)
        }, [
          R.$slots["action-preview"] && L.value ? fe(R.$slots, "action-preview", {
            key: 0,
            value: R.internalModelValue
          }) : Y("", !0),
          !R.$slots["action-preview"] && L.value ? (f(), y(Qe, { key: 1 }, [
            $t(we(le.value), 1)
          ], 64)) : Y("", !0)
        ], 12, oI)) : Y("", !0),
        X("div", {
          ref_key: "actionBtnContainer",
          ref: N,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          R.$slots["action-buttons"] ? fe(R.$slots, "action-buttons", {
            key: 0,
            value: R.internalModelValue
          }) : Y("", !0),
          R.$slots["action-buttons"] ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
            !b(c).enabled && b(i).showCancel ? (f(), y("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: B,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: _[0] || (_[0] = (G) => R.$emit("close-picker")),
              onKeydown: _[1] || (_[1] = (G) => b(zn)(G, () => R.$emit("close-picker")))
            }, we(R.cancelText), 545)) : Y("", !0),
            b(i).showNow ? (f(), y("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: _[2] || (_[2] = (G) => R.$emit("select-now")),
              onKeydown: _[3] || (_[3] = (G) => b(zn)(G, () => R.$emit("select-now")))
            }, we(R.nowButtonLabel), 33)) : Y("", !0),
            b(i).showSelect ? (f(), y("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: T,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: Q.value,
              "data-test": "select-button",
              onKeydown: _[4] || (_[4] = (G) => b(zn)(G, () => ve())),
              onClick: ve
            }, we(R.selectText), 41, sI)) : Y("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), AI = ["role", "aria-label", "tabindex"], dI = { class: "dp__selection_grid_header" }, cI = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], fI = ["aria-label"], Ni = /* @__PURE__ */ We({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: a, emit: t }) {
    const { setSelectionGrid: r, buildMultiLevelMatrix: i, setMonthPicker: s } = Tr(), u = t, A = e, { defaultedAriaLabels: c, defaultedTextInput: g, defaultedConfig: p } = Nt(
      A
    ), { hideNavigationButtons: v } = cs(), m = U(!1), w = U(null), B = U(null), T = U([]), L = U(), E = U(null), N = U(0), k = U(null);
    Cw(() => {
      w.value = null;
    }), bt(() => {
      Bt().then(() => J()), A.noOverlayFocus || S(), F(!0);
    }), al(() => F(!1));
    const F = (me) => {
      var te;
      A.arrowNavigation && ((te = A.headerRefs) != null && te.length ? s(me) : r(me));
    }, S = () => {
      var me;
      const te = on(B);
      te && (g.value.enabled || (w.value ? (me = w.value) == null || me.focus({ preventScroll: !0 }) : te.focus({ preventScroll: !0 })), m.value = te.clientHeight < te.scrollHeight);
    }, Q = V(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !A.useRelative,
        "dp--overlay-relative": A.useRelative
      })
    ), x = V(
      () => A.useRelative ? { height: `${A.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), W = V(() => ({
      dp__overlay_col: !0
    })), z = V(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: m.value,
        dp__button_bottom: A.isLast
      })
    ), q = V(() => {
      var me, te;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((me = A.items) == null ? void 0 : me.length) <= 6,
        dp__container_block: ((te = A.items) == null ? void 0 : te.length) > 6
      };
    });
    st(
      () => A.items,
      () => J(!1),
      { deep: !0 }
    );
    const J = (me = !0) => {
      Bt().then(() => {
        const te = on(w), P = on(B), Z = on(E), ae = on(k), O = Z ? Z.getBoundingClientRect().height : 0;
        P && (P.getBoundingClientRect().height ? N.value = P.getBoundingClientRect().height - O : N.value = p.value.modeHeight - O), te && ae && me && (ae.scrollTop = te.offsetTop - ae.offsetTop - (N.value / 2 - te.getBoundingClientRect().height) - O);
      });
    }, le = (me) => {
      me.disabled || u("selected", me.value);
    }, ve = () => {
      u("toggle"), u("reset-flow");
    }, R = () => {
      A.escClose && ve();
    }, _ = (me, te, P, Z) => {
      me && ((te.active || te.value === A.focusValue) && (w.value = me), A.arrowNavigation && (Array.isArray(T.value[P]) ? T.value[P][Z] = me : T.value[P] = [me], G()));
    }, G = () => {
      var me, te;
      const P = (me = A.headerRefs) != null && me.length ? [A.headerRefs].concat(T.value) : T.value.concat([A.skipButtonRef ? [] : [E.value]]);
      i(dn(P), (te = A.headerRefs) != null && te.length ? "monthPicker" : "selectionGrid");
    }, oe = (me) => {
      A.arrowNavigation || br(me, p.value, !0);
    }, Oe = (me) => {
      L.value = me, u("hover-value", me);
    }, pe = () => {
      if (ve(), !A.isLast) {
        const me = hA(A.menuWrapRef ?? null, "action-row");
        if (me) {
          const te = Pp(me);
          te == null || te.focus();
        }
      }
    }, $ = (me) => {
      switch (me.key) {
        case zt.esc:
          return R();
        case zt.arrowLeft:
          return oe(me);
        case zt.arrowRight:
          return oe(me);
        case zt.arrowUp:
          return oe(me);
        case zt.arrowDown:
          return oe(me);
        default:
          return;
      }
    }, Me = (me) => {
      if (me.key === zt.enter)
        return ve();
      if (me.key === zt.tab)
        return pe();
    };
    return a({ focusGrid: S }), (me, te) => {
      var P;
      return f(), y("div", {
        ref_key: "gridWrapRef",
        ref: B,
        class: he(Q.value),
        style: Tt(x.value),
        role: me.useRelative ? void 0 : "dialog",
        "aria-label": me.overlayLabel,
        tabindex: me.useRelative ? void 0 : "0",
        onKeydown: $,
        onClick: te[0] || (te[0] = _t(() => {
        }, ["prevent"]))
      }, [
        X("div", {
          ref_key: "containerRef",
          ref: k,
          class: he(q.value),
          style: Tt({ "--dp-overlay-height": `${N.value}px` }),
          role: "grid"
        }, [
          X("div", dI, [
            fe(me.$slots, "header")
          ]),
          me.$slots.overlay ? fe(me.$slots, "overlay", { key: 0 }) : (f(!0), y(Qe, { key: 1 }, tt(me.items, (Z, ae) => (f(), y("div", {
            key: ae,
            class: he(["dp__overlay_row", { dp__flex_row: me.items.length >= 3 }]),
            role: "row"
          }, [
            (f(!0), y(Qe, null, tt(Z, (O, ke) => (f(), y("div", {
              key: O.value,
              ref_for: !0,
              ref: (Ue) => _(Ue, O, ae, ke),
              role: "gridcell",
              class: he(W.value),
              "aria-selected": O.active || void 0,
              "aria-disabled": O.disabled || void 0,
              tabindex: "0",
              "data-test": O.text,
              onClick: _t((Ue) => le(O), ["prevent"]),
              onKeydown: (Ue) => b(zn)(Ue, () => le(O), !0),
              onMouseover: (Ue) => Oe(O.value)
            }, [
              X("div", {
                class: he(O.className)
              }, [
                me.$slots.item ? fe(me.$slots, "item", {
                  key: 0,
                  item: O
                }) : Y("", !0),
                me.$slots.item ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                  $t(we(O.text), 1)
                ], 64))
              ], 2)
            ], 42, cI))), 128))
          ], 2))), 128))
        ], 6),
        me.$slots["button-icon"] ? cn((f(), y("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: E,
          type: "button",
          "aria-label": (P = b(c)) == null ? void 0 : P.toggleOverlay,
          class: he(z.value),
          tabindex: "0",
          onClick: ve,
          onKeydown: Me
        }, [
          fe(me.$slots, "button-icon")
        ], 42, fI)), [
          [No, !b(v)(me.hideNavigation, me.type)]
        ]) : Y("", !0)
      ], 46, AI);
    };
  }
}), As = /* @__PURE__ */ We({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const a = e, t = V(
      () => a.multiCalendars > 0 ? [...Array(a.multiCalendars).keys()] : [0]
    ), r = V(() => ({
      dp__instance_calendar: a.multiCalendars > 0
    }));
    return (i, s) => (f(), y("div", {
      class: he({
        dp__menu_inner: !i.stretch,
        "dp--menu--inner-stretched": i.stretch,
        dp__flex_display: i.multiCalendars > 0,
        "dp--flex-display-collapsed": i.collapse
      })
    }, [
      (f(!0), y(Qe, null, tt(t.value, (u, A) => (f(), y("div", {
        key: u,
        class: he(r.value)
      }, [
        fe(i.$slots, "default", {
          instance: u,
          index: A
        })
      ], 2))), 128))
    ], 2));
  }
}), vI = ["data-dp-element", "aria-label", "aria-disabled"], Bi = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: a }) {
    const t = a, r = U(null);
    return bt(() => t("set-ref", r)), (i, s) => (f(), y("button", {
      ref_key: "elRef",
      ref: r,
      type: "button",
      "data-dp-element": i.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": i.ariaLabel,
      "aria-disabled": i.disabled || void 0,
      onClick: s[0] || (s[0] = (u) => i.$emit("activate")),
      onKeydown: s[1] || (s[1] = (u) => b(zn)(u, () => i.$emit("activate"), !0))
    }, [
      X("span", {
        class: he(["dp__inner_nav", { dp__inner_nav_disabled: i.disabled }])
      }, [
        fe(i.$slots, "default")
      ], 2)
    ], 40, vI));
  }
}), pI = ["aria-label", "data-test"], Vp = /* @__PURE__ */ We({
  __name: "YearModePicker",
  props: {
    ...Da,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: a }) {
    const t = a, r = e, { showRightIcon: i, showLeftIcon: s } = cs(), { defaultedConfig: u, defaultedMultiCalendars: A, defaultedAriaLabels: c, defaultedTransitions: g, defaultedUI: p } = Nt(r), { showTransition: v, transitionName: m } = Yi(g), w = U(!1), B = (E = !1, N) => {
      w.value = !w.value, t("toggle-year-picker", { flow: E, show: N });
    }, T = (E) => {
      w.value = !1, t("year-select", E);
    }, L = (E = !1) => {
      t("handle-year", E);
    };
    return (E, N) => {
      var k, F, S, Q, x;
      return f(), y(Qe, null, [
        X("div", {
          class: he(["dp--year-mode-picker", { "dp--hidden-el": w.value }])
        }, [
          b(s)(b(A), e.instance) ? (f(), ce(Bi, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (k = b(c)) == null ? void 0 : k.prevYear,
            disabled: e.isDisabled(!1),
            class: he((F = b(p)) == null ? void 0 : F.navBtnPrev),
            onActivate: N[0] || (N[0] = (W) => L(!1))
          }, {
            default: ue(() => [
              E.$slots["arrow-left"] ? fe(E.$slots, "arrow-left", { key: 0 }) : Y("", !0),
              E.$slots["arrow-left"] ? Y("", !0) : (f(), ce(b(SA), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : Y("", !0),
          X("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(S = b(c)) == null ? void 0 : S.openYearsOverlay}`,
            "data-test": `year-mode-btn-${e.instance}`,
            onClick: N[1] || (N[1] = () => B(!1)),
            onKeydown: N[2] || (N[2] = aA(() => B(!1), ["enter"]))
          }, [
            E.$slots.year ? fe(E.$slots, "year", {
              key: 0,
              year: e.year
            }) : Y("", !0),
            E.$slots.year ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
              $t(we(e.year), 1)
            ], 64))
          ], 40, pI),
          b(i)(b(A), e.instance) ? (f(), ce(Bi, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (Q = b(c)) == null ? void 0 : Q.nextYear,
            disabled: e.isDisabled(!0),
            class: he((x = b(p)) == null ? void 0 : x.navBtnNext),
            onActivate: N[3] || (N[3] = (W) => L(!0))
          }, {
            default: ue(() => [
              E.$slots["arrow-right"] ? fe(E.$slots, "arrow-right", { key: 0 }) : Y("", !0),
              E.$slots["arrow-right"] ? Y("", !0) : (f(), ce(b(VA), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : Y("", !0)
        ], 2),
        Ce(Jn, {
          name: b(m)(e.showYearPicker),
          css: b(v)
        }, {
          default: ue(() => {
            var W, z;
            return [
              e.showYearPicker ? (f(), ce(Ni, {
                key: 0,
                items: e.items,
                "text-input": E.textInput,
                "esc-close": E.escClose,
                config: E.config,
                "is-last": E.autoApply && !b(u).keepActionRow,
                "hide-navigation": E.hideNavigation,
                "aria-labels": E.ariaLabels,
                "overlay-label": (z = (W = b(c)) == null ? void 0 : W.yearPicker) == null ? void 0 : z.call(W, !0),
                type: "year",
                onToggle: B,
                onSelected: N[4] || (N[4] = (q) => T(q))
              }, Lt({
                "button-icon": ue(() => [
                  E.$slots["calendar-icon"] ? fe(E.$slots, "calendar-icon", { key: 0 }) : Y("", !0),
                  E.$slots["calendar-icon"] ? Y("", !0) : (f(), ce(b(Hl), { key: 1 }))
                ]),
                _: 2
              }, [
                E.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: ue(({ item: q }) => [
                    fe(E.$slots, "year-overlay-value", {
                      text: q.text,
                      value: q.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : Y("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), ZA = (e, a, t) => {
  if (a.value && Array.isArray(a.value))
    if (a.value.some((r) => ft(e, r))) {
      const r = a.value.filter((i) => !ft(i, e));
      a.value = r.length ? r : null;
    } else
      (t && +t > a.value.length || !t) && a.value.push(e);
  else
    a.value = [e];
}, GA = (e, a, t) => {
  let r = e.value ? e.value.slice() : [];
  return r.length === 2 && r[1] !== null && (r = []), r.length ? qt(a, r[0]) ? (r.unshift(a), t("range-start", r[0]), t("range-start", r[1])) : (r[1] = a, t("range-end", a)) : (r = [a], t("range-start", a)), r;
}, ds = (e, a, t, r) => {
  e && (e[0] && e[1] && t && a("auto-apply"), e[0] && !e[1] && r && t && a("auto-apply"));
}, Wp = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((a) => Qn(Be(a), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Qn(Be(e.value), e.timezone));
}, Xp = (e, a, t, r) => Array.isArray(a.value) && (a.value.length === 2 || a.value.length === 1 && r.value.partialRange) ? r.value.fixedStart && (jt(e, a.value[0]) || ft(e, a.value[0])) ? [a.value[0], e] : r.value.fixedEnd && (qt(e, a.value[1]) || ft(e, a.value[1])) ? [e, a.value[1]] : (t("invalid-fixed-range", e), a.value) : [], Qp = ({
  multiCalendars: e,
  range: a,
  highlight: t,
  propDates: r,
  calendars: i,
  modelValue: s,
  props: u,
  filters: A,
  year: c,
  month: g,
  emit: p
}) => {
  const v = V(() => FA(u.yearRange, u.locale, u.reverseYears)), m = U([!1]), w = V(() => (q, J) => {
    const le = Pt(ya(/* @__PURE__ */ new Date()), {
      month: g.value(q),
      year: c.value(q)
    }), ve = J ? dp(le) : Ti(le);
    return Ep(
      ve,
      r.value.maxDate,
      r.value.minDate,
      u.preventMinMaxNavigation,
      J
    );
  }), B = () => Array.isArray(s.value) && e.value.solo && s.value[1], T = () => {
    for (let q = 0; q < e.value.count; q++)
      if (q === 0)
        i.value[q] = i.value[0];
      else if (q === e.value.count - 1 && B())
        i.value[q] = {
          month: At(s.value[1]),
          year: et(s.value[1])
        };
      else {
        const J = Pt(Be(), i.value[q - 1]);
        i.value[q] = { month: At(J), year: et(MA(J, 1)) };
      }
  }, L = (q) => {
    if (!q)
      return T();
    const J = Pt(Be(), i.value[q]);
    return i.value[0].year = et(YA(J, e.value.count - 1)), T();
  }, E = (q, J) => {
    const le = OO(J, q);
    return a.value.showLastInRange && le > 1 ? J : q;
  }, N = (q) => u.focusStartDate || e.value.solo ? q[0] : q[1] ? E(q[0], q[1]) : q[0], k = () => {
    if (s.value) {
      const q = Array.isArray(s.value) ? N(s.value) : s.value;
      i.value[0] = { month: At(q), year: et(q) };
    }
  }, F = () => {
    k(), e.value.count && T();
  };
  st(s, (q, J) => {
    u.isTextInputDate && JSON.stringify(q ?? {}) !== JSON.stringify(J ?? {}) && F();
  }), bt(() => {
    F();
  });
  const S = (q, J) => {
    i.value[J].year = q, p("update-month-year", { instance: J, year: q, month: i.value[J].month }), e.value.count && !e.value.solo && L(J);
  }, Q = V(() => (q) => Wl(v.value, (J) => {
    var le;
    const ve = c.value(q) === J.value, R = Pi(
      J.value,
      Xl(r.value.minDate),
      Xl(r.value.maxDate)
    ) || ((le = A.value.years) == null ? void 0 : le.includes(c.value(q))), _ = RA(t.value, J.value);
    return { active: ve, disabled: R, highlighted: _ };
  })), x = (q, J) => {
    S(q, J), z(J);
  }, W = (q, J = !1) => {
    if (!w.value(q, J)) {
      const le = J ? c.value(q) + 1 : c.value(q) - 1;
      S(le, q);
    }
  }, z = (q, J = !1, le) => {
    J || p("reset-flow"), le !== void 0 ? m.value[q] = le : m.value[q] = !m.value[q], m.value[q] ? p("overlay-toggle", { open: !0, overlay: Bn.year }) : (p("overlay-closed"), p("overlay-toggle", { open: !1, overlay: Bn.year }));
  };
  return {
    isDisabled: w,
    groupedYears: Q,
    showYearPicker: m,
    selectYear: S,
    toggleYearPicker: z,
    handleYearSelect: x,
    handleYear: W
  };
}, gI = (e, a) => {
  const {
    defaultedMultiCalendars: t,
    defaultedAriaLabels: r,
    defaultedTransitions: i,
    defaultedConfig: s,
    defaultedRange: u,
    defaultedHighlight: A,
    propDates: c,
    defaultedTz: g,
    defaultedFilters: p,
    defaultedMultiDates: v
  } = Nt(e), m = () => {
    e.isTextInputDate && F(et(Be(e.startDate)), 0);
  }, { modelValue: w, year: B, month: T, calendars: L } = Si(e, a, m), E = V(() => Tp(e.formatLocale, e.locale, e.monthNameFormat)), N = U(null), { checkMinMaxRange: k } = xr(e), {
    selectYear: F,
    groupedYears: S,
    showYearPicker: Q,
    toggleYearPicker: x,
    handleYearSelect: W,
    handleYear: z,
    isDisabled: q
  } = Qp({
    modelValue: w,
    multiCalendars: t,
    range: u,
    highlight: A,
    calendars: L,
    year: B,
    propDates: c,
    month: T,
    filters: p,
    props: e,
    emit: a
  });
  bt(() => {
    e.startDate && (w.value && e.focusStartDate || !w.value) && F(et(Be(e.startDate)), 0);
  });
  const J = (P) => P ? { month: At(P), year: et(P) } : { month: null, year: null }, le = () => w.value ? Array.isArray(w.value) ? w.value.map((P) => J(P)) : J(w.value) : J(), ve = (P, Z) => {
    const ae = L.value[P], O = le();
    return Array.isArray(O) ? O.some((ke) => ke.year === (ae == null ? void 0 : ae.year) && ke.month === Z) : (ae == null ? void 0 : ae.year) === O.year && Z === O.month;
  }, R = (P, Z, ae) => {
    var O, ke;
    const Ue = le();
    return Array.isArray(Ue) ? B.value(Z) === ((O = Ue[ae]) == null ? void 0 : O.year) && P === ((ke = Ue[ae]) == null ? void 0 : ke.month) : !1;
  }, _ = (P, Z) => {
    if (u.value.enabled) {
      const ae = le();
      if (Array.isArray(w.value) && Array.isArray(ae)) {
        const O = R(P, Z, 0) || R(P, Z, 1), ke = ja(ya(Be()), P, B.value(Z));
        return ss(w.value, N.value, ke) && !O;
      }
      return !1;
    }
    return !1;
  }, G = V(() => (P) => Wl(E.value, (Z) => {
    var ae;
    const O = ve(P, Z.value), ke = Pi(
      Z.value,
      Op(B.value(P), c.value.minDate),
      Mp(B.value(P), c.value.maxDate)
    ) || Qz(c.value.disabledDates, B.value(P)).includes(Z.value) || ((ae = p.value.months) == null ? void 0 : ae.includes(Z.value)), Ue = _(Z.value, P), Qt = Np(A.value, Z.value, B.value(P));
    return { active: O, disabled: ke, isBetween: Ue, highlighted: Qt };
  })), oe = (P, Z) => ja(ya(Be()), P, B.value(Z)), Oe = (P, Z) => {
    const ae = w.value ? w.value : ya(/* @__PURE__ */ new Date());
    w.value = ja(ae, P, B.value(Z)), a("auto-apply"), a("update-flow-step");
  }, pe = (P, Z) => {
    const ae = oe(P, Z);
    u.value.fixedEnd || u.value.fixedStart ? w.value = Xp(ae, w, a, u) : w.value ? k(ae, w.value) && (w.value = GA(w, oe(P, Z), a)) : w.value = [oe(P, Z)], Bt().then(() => {
      ds(w.value, a, e.autoApply, e.modelAuto);
    });
  }, $ = (P, Z) => {
    ZA(oe(P, Z), w, v.value.limit), a("auto-apply", !0);
  }, Me = (P, Z) => (L.value[Z].month = P, te(Z, L.value[Z].year, P), v.value.enabled ? $(P, Z) : u.value.enabled ? pe(P, Z) : Oe(P, Z)), me = (P, Z) => {
    F(P, Z), te(Z, P, null);
  }, te = (P, Z, ae) => {
    let O = ae;
    if (!O && O !== 0) {
      const ke = le();
      O = Array.isArray(ke) ? ke[P].month : ke.month;
    }
    a("update-month-year", { instance: P, year: Z, month: O });
  };
  return {
    groupedMonths: G,
    groupedYears: S,
    year: B,
    isDisabled: q,
    defaultedMultiCalendars: t,
    defaultedAriaLabels: r,
    defaultedTransitions: i,
    defaultedConfig: s,
    showYearPicker: Q,
    modelValue: w,
    presetDate: (P, Z) => {
      Wp({
        value: P,
        modelValue: w,
        range: u.value.enabled,
        timezone: Z ? void 0 : g.value.timezone
      }), a("auto-apply");
    },
    setHoverDate: (P, Z) => {
      N.value = oe(P, Z);
    },
    selectMonth: Me,
    selectYear: me,
    toggleYearPicker: x,
    handleYearSelect: W,
    handleYear: z,
    getModelMonthYear: le
  };
}, hI = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Da
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = mn(), s = Kn(i, "yearMode"), u = e;
    bt(() => {
      u.shadow || r("mount", null);
    });
    const {
      groupedMonths: A,
      groupedYears: c,
      year: g,
      isDisabled: p,
      defaultedMultiCalendars: v,
      defaultedConfig: m,
      showYearPicker: w,
      modelValue: B,
      presetDate: T,
      setHoverDate: L,
      selectMonth: E,
      selectYear: N,
      toggleYearPicker: k,
      handleYearSelect: F,
      handleYear: S,
      getModelMonthYear: Q
    } = gI(u, r);
    return a({ getSidebarProps: () => ({
      modelValue: B,
      year: g,
      getModelMonthYear: Q,
      selectMonth: E,
      selectYear: N,
      handleYear: S
    }), presetDate: T, toggleYearPicker: (x) => k(0, x) }), (x, W) => (f(), ce(As, {
      "multi-calendars": b(v).count,
      collapse: x.collapse,
      stretch: ""
    }, {
      default: ue(({ instance: z }) => [
        x.$slots["top-extra"] ? fe(x.$slots, "top-extra", {
          key: 0,
          value: x.internalModelValue
        }) : Y("", !0),
        x.$slots["month-year"] ? fe(x.$slots, "month-year", fn(Xt({ key: 1 }, {
          year: b(g),
          months: b(A)(z),
          years: b(c)(z),
          selectMonth: b(E),
          selectYear: b(N),
          instance: z
        }))) : (f(), ce(Ni, {
          key: 2,
          items: b(A)(z),
          "arrow-navigation": x.arrowNavigation,
          "is-last": x.autoApply && !b(m).keepActionRow,
          "esc-close": x.escClose,
          height: b(m).modeHeight,
          config: x.config,
          "no-overlay-focus": !!(x.noOverlayFocus || x.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (q) => b(E)(q, z),
          onHoverValue: (q) => b(L)(q, z)
        }, Lt({
          header: ue(() => [
            Ce(Vp, Xt(x.$props, {
              items: b(c)(z),
              instance: z,
              "show-year-picker": b(w)[z],
              year: b(g)(z),
              "is-disabled": (q) => b(p)(z, q),
              onHandleYear: (q) => b(S)(z, q),
              onYearSelect: (q) => b(F)(q, z),
              onToggleYearPicker: (q) => b(k)(z, q == null ? void 0 : q.flow, q == null ? void 0 : q.show)
            }), Lt({ _: 2 }, [
              tt(b(s), (q, J) => ({
                name: q,
                fn: ue((le) => [
                  fe(x.$slots, q, fn(Xn(le)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          x.$slots["month-overlay-value"] ? {
            name: "item",
            fn: ue(({ item: q }) => [
              fe(x.$slots, "month-overlay-value", {
                text: q.text,
                value: q.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), mI = (e, a) => {
  const t = () => {
    e.isTextInputDate && (p.value = et(Be(e.startDate)));
  }, { modelValue: r } = Si(e, a, t), i = U(null), { defaultedHighlight: s, defaultedMultiDates: u, defaultedFilters: A, defaultedRange: c, propDates: g } = Nt(e), p = U();
  bt(() => {
    e.startDate && (r.value && e.focusStartDate || !r.value) && (p.value = et(Be(e.startDate)));
  });
  const v = (T) => Array.isArray(r.value) ? r.value.some((L) => et(L) === T) : r.value ? et(r.value) === T : !1, m = (T) => c.value.enabled && Array.isArray(r.value) ? ss(r.value, i.value, B(T)) : !1, w = V(() => Wl(FA(e.yearRange, e.locale, e.reverseYears), (T) => {
    const L = v(T.value), E = Pi(
      T.value,
      Xl(g.value.minDate),
      Xl(g.value.maxDate)
    ) || A.value.years.includes(T.value), N = m(T.value) && !L, k = RA(s.value, T.value);
    return { active: L, disabled: E, isBetween: N, highlighted: k };
  })), B = (T) => Ea(ya(Ti(/* @__PURE__ */ new Date())), T);
  return {
    groupedYears: w,
    modelValue: r,
    focusYear: p,
    setHoverValue: (T) => {
      i.value = Ea(ya(/* @__PURE__ */ new Date()), T);
    },
    selectYear: (T) => {
      var L;
      if (a("update-month-year", { instance: 0, year: T }), u.value.enabled)
        return r.value ? Array.isArray(r.value) && (((L = r.value) == null ? void 0 : L.map((E) => et(E))).includes(T) ? r.value = r.value.filter((E) => et(E) !== T) : r.value.push(Ea(In(Be()), T))) : r.value = [Ea(In(Ti(Be())), T)], a("auto-apply", !0);
      c.value.enabled ? (r.value = GA(r, B(T), a), Bt().then(() => {
        ds(r.value, a, e.autoApply, e.modelAuto);
      })) : (r.value = B(T), a("auto-apply"));
    }
  };
}, yI = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Da
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, { groupedYears: s, modelValue: u, focusYear: A, selectYear: c, setHoverValue: g } = mI(i, r), { defaultedConfig: p } = Nt(i);
    return a({ getSidebarProps: () => ({
      modelValue: u,
      selectYear: c
    }) }), (v, m) => (f(), y("div", null, [
      v.$slots["top-extra"] ? fe(v.$slots, "top-extra", {
        key: 0,
        value: v.internalModelValue
      }) : Y("", !0),
      v.$slots["month-year"] ? fe(v.$slots, "month-year", fn(Xt({ key: 1 }, {
        years: b(s),
        selectYear: b(c)
      }))) : (f(), ce(Ni, {
        key: 2,
        items: b(s),
        "is-last": v.autoApply && !b(p).keepActionRow,
        height: b(p).modeHeight,
        config: v.config,
        "no-overlay-focus": !!(v.noOverlayFocus || v.textInput),
        "focus-value": b(A),
        type: "year",
        "use-relative": "",
        onSelected: b(c),
        onHoverValue: b(g)
      }, Lt({ _: 2 }, [
        v.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ue(({ item: w }) => [
            fe(v.$slots, "year-overlay-value", {
              text: w.text,
              value: w.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), bI = {
  key: 0,
  class: "dp__time_input"
}, wI = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], CI = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], DI = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], BI = { key: 0 }, TI = ["aria-label"], xI = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Da
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, { setTimePickerElements: s, setTimePickerBackRef: u } = Tr(), { defaultedAriaLabels: A, defaultedTransitions: c, defaultedFilters: g, defaultedConfig: p, defaultedRange: v } = Nt(i), { transitionName: m, showTransition: w } = Yi(c), B = Ja({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), T = U("AM"), L = U(null), E = U([]), N = U(), k = U(!1);
    bt(() => {
      r("mounted");
    });
    const F = (M) => Pt(/* @__PURE__ */ new Date(), {
      hours: M.hours,
      minutes: M.minutes,
      seconds: i.enableSeconds ? M.seconds : 0,
      milliseconds: 0
    }), S = V(
      () => (M) => oe(M, i[M]) || x(M, i[M])
    ), Q = V(() => ({ hours: i.hours, minutes: i.minutes, seconds: i.seconds })), x = (M, Ae) => v.value.enabled && !v.value.disableTimeRangeValidation ? !i.validateTime(M, Ae) : !1, W = (M, Ae) => {
      if (v.value.enabled && !v.value.disableTimeRangeValidation) {
        const xe = Ae ? +i[`${M}Increment`] : -+i[`${M}Increment`], de = i[M] + xe;
        return !i.validateTime(M, de);
      }
      return !1;
    }, z = V(() => (M) => !me(+i[M] + +i[`${M}Increment`], M) || W(M, !0)), q = V(() => (M) => !me(+i[M] - +i[`${M}Increment`], M) || W(M, !1)), J = (M, Ae) => rp(Pt(Be(), M), Ae), le = (M, Ae) => Dz(Pt(Be(), M), Ae), ve = V(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !i.timePickerInline,
        dp__time_col_reg_block: !i.enableSeconds && i.is24 && !i.timePickerInline,
        dp__time_col_reg_inline: !i.enableSeconds && i.is24 && i.timePickerInline,
        dp__time_col_reg_with_button: !i.enableSeconds && !i.is24,
        dp__time_col_sec: i.enableSeconds && i.is24,
        dp__time_col_sec_with_button: i.enableSeconds && !i.is24
      })
    ), R = V(() => {
      const M = [{ type: "hours" }];
      return i.enableMinutes && M.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), i.enableSeconds && M.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), M;
    }), _ = V(() => R.value.filter((M) => !M.separator)), G = V(() => (M) => {
      if (M === "hours") {
        const Ae = ke(+i.hours);
        return { text: Ae < 10 ? `0${Ae}` : `${Ae}`, value: Ae };
      }
      return { text: i[M] < 10 ? `0${i[M]}` : `${i[M]}`, value: i[M] };
    }), oe = (M, Ae) => {
      var xe;
      if (!i.disabledTimesConfig)
        return !1;
      const de = i.disabledTimesConfig(i.order, M === "hours" ? Ae : void 0);
      return de[M] ? !!((xe = de[M]) != null && xe.includes(Ae)) : !0;
    }, Oe = (M, Ae) => Ae !== "hours" || T.value === "AM" ? M : M + 12, pe = (M) => {
      const Ae = i.is24 ? 24 : 12, xe = M === "hours" ? Ae : 60, de = +i[`${M}GridIncrement`], Re = M === "hours" && !i.is24 ? de : 0, ne = [];
      for (let Pe = Re; Pe < xe; Pe += de)
        ne.push({ value: i.is24 ? Pe : Oe(Pe, M), text: Pe < 10 ? `0${Pe}` : `${Pe}` });
      return M === "hours" && !i.is24 && ne.unshift({ value: T.value === "PM" ? 12 : 0, text: "12" }), Wl(ne, (Pe) => ({ active: !1, disabled: g.value.times[M].includes(Pe.value) || !me(Pe.value, M) || oe(M, Pe.value) || x(M, Pe.value) }));
    }, $ = (M) => M >= 0 ? M : 59, Me = (M) => M >= 0 ? M : 23, me = (M, Ae) => {
      const xe = i.minTime ? F(Ru(i.minTime)) : null, de = i.maxTime ? F(Ru(i.maxTime)) : null, Re = F(
        Ru(
          Q.value,
          Ae,
          Ae === "minutes" || Ae === "seconds" ? $(M) : Me(M)
        )
      );
      return xe && de ? (xi(Re, de) || kl(Re, de)) && (Sl(Re, xe) || kl(Re, xe)) : xe ? Sl(Re, xe) || kl(Re, xe) : de ? xi(Re, de) || kl(Re, de) : !0;
    }, te = (M) => i[`no${M[0].toUpperCase() + M.slice(1)}Overlay`], P = (M) => {
      te(M) || (B[M] = !B[M], B[M] ? (k.value = !0, r("overlay-opened", M)) : (k.value = !1, r("overlay-closed", M)));
    }, Z = (M) => M === "hours" ? $a : M === "minutes" ? Dr : Yl, ae = () => {
      N.value && clearTimeout(N.value);
    }, O = (M, Ae = !0, xe) => {
      const de = Ae ? J : le, Re = Ae ? +i[`${M}Increment`] : -+i[`${M}Increment`];
      me(+i[M] + Re, M) && r(
        `update:${M}`,
        Z(M)(de({ [M]: +i[M] }, { [M]: +i[`${M}Increment`] }))
      ), !(xe != null && xe.keyboard) && p.value.timeArrowHoldThreshold && (N.value = setTimeout(() => {
        O(M, Ae);
      }, p.value.timeArrowHoldThreshold));
    }, ke = (M) => i.is24 ? M : (M >= 12 ? T.value = "PM" : T.value = "AM", Oz(M)), Ue = () => {
      T.value === "PM" ? (T.value = "AM", r("update:hours", i.hours - 12)) : (T.value = "PM", r("update:hours", i.hours + 12)), r("am-pm-change", T.value);
    }, Qt = (M) => {
      B[M] = !0;
    }, ie = (M, Ae, xe) => {
      if (M && i.arrowNavigation) {
        Array.isArray(E.value[Ae]) ? E.value[Ae][xe] = M : E.value[Ae] = [M];
        const de = E.value.reduce(
          (Re, ne) => ne.map((Pe, Ve) => [...Re[Ve] || [], ne[Ve]]),
          []
        );
        u(i.closeTimePickerBtn), L.value && (de[1] = de[1].concat(L.value)), s(de, i.order);
      }
    }, Te = (M, Ae) => (P(M), r(`update:${M}`, Ae));
    return a({ openChildCmp: Qt }), (M, Ae) => {
      var xe;
      return M.disabled ? Y("", !0) : (f(), y("div", bI, [
        (f(!0), y(Qe, null, tt(R.value, (de, Re) => {
          var ne, Pe, Ve;
          return f(), y("div", {
            key: Re,
            class: he(ve.value)
          }, [
            de.separator ? (f(), y(Qe, { key: 0 }, [
              k.value ? Y("", !0) : (f(), y(Qe, { key: 0 }, [
                $t(":")
              ], 64))
            ], 64)) : (f(), y(Qe, { key: 1 }, [
              X("button", {
                ref_for: !0,
                ref: (Ze) => ie(Ze, Re, 0),
                type: "button",
                class: he({
                  dp__btn: !0,
                  dp__inc_dec_button: !M.timePickerInline,
                  dp__inc_dec_button_inline: M.timePickerInline,
                  dp__tp_inline_btn_top: M.timePickerInline,
                  dp__inc_dec_button_disabled: z.value(de.type),
                  "dp--hidden-el": k.value
                }),
                "data-test": `${de.type}-time-inc-btn-${i.order}`,
                "aria-label": (ne = b(A)) == null ? void 0 : ne.incrementValue(de.type),
                tabindex: "0",
                onKeydown: (Ze) => b(zn)(Ze, () => O(de.type, !0, { keyboard: !0 }), !0),
                onClick: (Ze) => b(p).timeArrowHoldThreshold ? void 0 : O(de.type, !0),
                onMousedown: (Ze) => b(p).timeArrowHoldThreshold ? O(de.type, !0) : void 0,
                onMouseup: ae
              }, [
                i.timePickerInline ? (f(), y(Qe, { key: 1 }, [
                  M.$slots["tp-inline-arrow-up"] ? fe(M.$slots, "tp-inline-arrow-up", { key: 0 }) : (f(), y(Qe, { key: 1 }, [
                    Ae[2] || (Ae[2] = X("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    Ae[3] || (Ae[3] = X("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (f(), y(Qe, { key: 0 }, [
                  M.$slots["arrow-up"] ? fe(M.$slots, "arrow-up", { key: 0 }) : Y("", !0),
                  M.$slots["arrow-up"] ? Y("", !0) : (f(), ce(b(XA), { key: 1 }))
                ], 64))
              ], 42, wI),
              X("button", {
                ref_for: !0,
                ref: (Ze) => ie(Ze, Re, 1),
                type: "button",
                "aria-label": `${G.value(de.type).text}-${(Pe = b(A)) == null ? void 0 : Pe.openTpOverlay(de.type)}`,
                class: he({
                  dp__time_display: !0,
                  dp__time_display_block: !M.timePickerInline,
                  dp__time_display_inline: M.timePickerInline,
                  "dp--time-invalid": S.value(de.type),
                  "dp--time-overlay-btn": !S.value(de.type),
                  "dp--hidden-el": k.value
                }),
                disabled: te(de.type),
                tabindex: "0",
                "data-test": `${de.type}-toggle-overlay-btn-${i.order}`,
                onKeydown: (Ze) => b(zn)(Ze, () => P(de.type), !0),
                onClick: (Ze) => P(de.type)
              }, [
                M.$slots[de.type] ? fe(M.$slots, de.type, {
                  key: 0,
                  text: G.value(de.type).text,
                  value: G.value(de.type).value
                }) : Y("", !0),
                M.$slots[de.type] ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                  $t(we(G.value(de.type).text), 1)
                ], 64))
              ], 42, CI),
              X("button", {
                ref_for: !0,
                ref: (Ze) => ie(Ze, Re, 2),
                type: "button",
                class: he({
                  dp__btn: !0,
                  dp__inc_dec_button: !M.timePickerInline,
                  dp__inc_dec_button_inline: M.timePickerInline,
                  dp__tp_inline_btn_bottom: M.timePickerInline,
                  dp__inc_dec_button_disabled: q.value(de.type),
                  "dp--hidden-el": k.value
                }),
                "data-test": `${de.type}-time-dec-btn-${i.order}`,
                "aria-label": (Ve = b(A)) == null ? void 0 : Ve.decrementValue(de.type),
                tabindex: "0",
                onKeydown: (Ze) => b(zn)(Ze, () => O(de.type, !1, { keyboard: !0 }), !0),
                onClick: (Ze) => b(p).timeArrowHoldThreshold ? void 0 : O(de.type, !1),
                onMousedown: (Ze) => b(p).timeArrowHoldThreshold ? O(de.type, !1) : void 0,
                onMouseup: ae
              }, [
                i.timePickerInline ? (f(), y(Qe, { key: 1 }, [
                  M.$slots["tp-inline-arrow-down"] ? fe(M.$slots, "tp-inline-arrow-down", { key: 0 }) : (f(), y(Qe, { key: 1 }, [
                    Ae[4] || (Ae[4] = X("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    Ae[5] || (Ae[5] = X("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (f(), y(Qe, { key: 0 }, [
                  M.$slots["arrow-down"] ? fe(M.$slots, "arrow-down", { key: 0 }) : Y("", !0),
                  M.$slots["arrow-down"] ? Y("", !0) : (f(), ce(b(QA), { key: 1 }))
                ], 64))
              ], 42, DI)
            ], 64))
          ], 2);
        }), 128)),
        M.is24 ? Y("", !0) : (f(), y("div", BI, [
          M.$slots["am-pm-button"] ? fe(M.$slots, "am-pm-button", {
            key: 0,
            toggle: Ue,
            value: T.value
          }) : Y("", !0),
          M.$slots["am-pm-button"] ? Y("", !0) : (f(), y("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: L,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (xe = b(A)) == null ? void 0 : xe.amPmButton,
            tabindex: "0",
            onClick: Ue,
            onKeydown: Ae[0] || (Ae[0] = (de) => b(zn)(de, () => Ue(), !0))
          }, we(T.value), 41, TI))
        ])),
        (f(!0), y(Qe, null, tt(_.value, (de, Re) => (f(), ce(Jn, {
          key: Re,
          name: b(m)(B[de.type]),
          css: b(w)
        }, {
          default: ue(() => {
            var ne, Pe;
            return [
              B[de.type] ? (f(), ce(Ni, {
                key: 0,
                items: pe(de.type),
                "is-last": M.autoApply && !b(p).keepActionRow,
                "esc-close": M.escClose,
                type: de.type,
                "text-input": M.textInput,
                config: M.config,
                "arrow-navigation": M.arrowNavigation,
                "aria-labels": M.ariaLabels,
                "overlay-label": (Pe = (ne = b(A)).timeOverlay) == null ? void 0 : Pe.call(ne, de.type),
                onSelected: (Ve) => Te(de.type, Ve),
                onToggle: (Ve) => P(de.type),
                onResetFlow: Ae[1] || (Ae[1] = (Ve) => M.$emit("reset-flow"))
              }, Lt({
                "button-icon": ue(() => [
                  M.$slots["clock-icon"] ? fe(M.$slots, "clock-icon", { key: 0 }) : Y("", !0),
                  M.$slots["clock-icon"] ? Y("", !0) : (f(), ce(Dt(M.timePickerInline ? b(Hl) : b(WA)), { key: 1 }))
                ]),
                _: 2
              }, [
                M.$slots[`${de.type}-overlay-value`] ? {
                  name: "item",
                  fn: ue(({ item: Ve }) => [
                    fe(M.$slots, `${de.type}-overlay-value`, {
                      text: Ve.text,
                      value: Ve.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                M.$slots[`${de.type}-overlay-header`] ? {
                  name: "header",
                  fn: ue(() => [
                    fe(M.$slots, `${de.type}-overlay-header`, {
                      toggle: () => P(de.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : Y("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), PI = { class: "dp--tp-wrap" }, kI = ["aria-label", "tabindex"], OI = ["role", "aria-label", "tabindex"], MI = ["aria-label"], Hp = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Da
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, { buildMatrix: s, setTimePicker: u } = Tr(), A = mn(), { defaultedTransitions: c, defaultedAriaLabels: g, defaultedTextInput: p, defaultedConfig: v, defaultedRange: m } = Nt(i), { transitionName: w, showTransition: B } = Yi(c), { hideNavigationButtons: T } = cs(), L = U(null), E = U(null), N = U([]), k = U(null), F = U(!1);
    bt(() => {
      r("mount"), !i.timePicker && i.arrowNavigation ? s([on(L.value)], "time") : u(!0, i.timePicker);
    });
    const S = V(() => m.value.enabled && i.modelAuto ? xp(i.internalModelValue) : !0), Q = U(!1), x = (pe) => ({
      hours: Array.isArray(i.hours) ? i.hours[pe] : i.hours,
      minutes: Array.isArray(i.minutes) ? i.minutes[pe] : i.minutes,
      seconds: Array.isArray(i.seconds) ? i.seconds[pe] : i.seconds
    }), W = V(() => {
      const pe = [];
      if (m.value.enabled)
        for (let $ = 0; $ < 2; $++)
          pe.push(x($));
      else
        pe.push(x(0));
      return pe;
    }), z = (pe, $ = !1, Me = "") => {
      $ || r("reset-flow"), Q.value = pe, r(pe ? "overlay-opened" : "overlay-closed", Bn.time), i.arrowNavigation && u(pe), Bt(() => {
        Me !== "" && N.value[0] && N.value[0].openChildCmp(Me);
      });
    }, q = V(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: i.autoApply && !v.value.keepActionRow
    })), J = Kn(A, "timePicker"), le = (pe, $, Me) => m.value.enabled ? $ === 0 ? [pe, W.value[1][Me]] : [W.value[0][Me], pe] : pe, ve = (pe) => {
      r("update:hours", pe);
    }, R = (pe) => {
      r("update:minutes", pe);
    }, _ = (pe) => {
      r("update:seconds", pe);
    }, G = () => {
      if (k.value && !p.value.enabled && !i.noOverlayFocus) {
        const pe = Pp(k.value);
        pe && pe.focus({ preventScroll: !0 });
      }
    }, oe = (pe) => {
      F.value = !1, r("overlay-closed", pe);
    }, Oe = (pe) => {
      F.value = !0, r("overlay-opened", pe);
    };
    return a({ toggleTimePicker: z }), (pe, $) => {
      var Me;
      return f(), y("div", PI, [
        !pe.timePicker && !pe.timePickerInline ? cn((f(), y("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: L,
          type: "button",
          class: he({ ...q.value, "dp--hidden-el": Q.value }),
          "aria-label": (Me = b(g)) == null ? void 0 : Me.openTimePicker,
          tabindex: pe.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: $[0] || ($[0] = (me) => b(zn)(me, () => z(!0))),
          onClick: $[1] || ($[1] = (me) => z(!0))
        }, [
          pe.$slots["clock-icon"] ? fe(pe.$slots, "clock-icon", { key: 0 }) : Y("", !0),
          pe.$slots["clock-icon"] ? Y("", !0) : (f(), ce(b(WA), { key: 1 }))
        ], 42, kI)), [
          [No, !b(T)(pe.hideNavigation, "time")]
        ]) : Y("", !0),
        Ce(Jn, {
          name: b(w)(Q.value),
          css: b(B) && !pe.timePickerInline
        }, {
          default: ue(() => {
            var me, te;
            return [
              Q.value || pe.timePicker || pe.timePickerInline ? (f(), y("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: k,
                role: pe.timePickerInline ? void 0 : "dialog",
                class: he({
                  dp__overlay: !pe.timePickerInline,
                  "dp--overlay-absolute": !i.timePicker && !pe.timePickerInline,
                  "dp--overlay-relative": i.timePicker
                }),
                style: Tt(pe.timePicker ? { height: `${b(v).modeHeight}px` } : void 0),
                "aria-label": (me = b(g)) == null ? void 0 : me.timePicker,
                tabindex: pe.timePickerInline ? void 0 : 0
              }, [
                X("div", {
                  class: he(
                    pe.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  pe.$slots["time-picker-overlay"] ? fe(pe.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: ve,
                    setMinutes: R,
                    setSeconds: _
                  }) : Y("", !0),
                  pe.$slots["time-picker-overlay"] ? Y("", !0) : (f(), y("div", {
                    key: 1,
                    class: he(pe.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (f(!0), y(Qe, null, tt(W.value, (P, Z) => cn((f(), ce(xI, Xt({
                      key: Z,
                      ref_for: !0
                    }, {
                      ...pe.$props,
                      order: Z,
                      hours: P.hours,
                      minutes: P.minutes,
                      seconds: P.seconds,
                      closeTimePickerBtn: E.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: Z === 0 ? b(m).fixedStart : b(m).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: N,
                      "validate-time": (ae, O) => e.validateTime(ae, le(O, Z, ae)),
                      "onUpdate:hours": (ae) => ve(le(ae, Z, "hours")),
                      "onUpdate:minutes": (ae) => R(le(ae, Z, "minutes")),
                      "onUpdate:seconds": (ae) => _(le(ae, Z, "seconds")),
                      onMounted: G,
                      onOverlayClosed: oe,
                      onOverlayOpened: Oe,
                      onAmPmChange: $[2] || ($[2] = (ae) => pe.$emit("am-pm-change", ae))
                    }), Lt({ _: 2 }, [
                      tt(b(J), (ae, O) => ({
                        name: ae,
                        fn: ue((ke) => [
                          fe(pe.$slots, ae, Xt({ ref_for: !0 }, ke))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [No, Z === 0 ? !0 : S.value]
                    ])), 128))
                  ], 2)),
                  !pe.timePicker && !pe.timePickerInline ? cn((f(), y("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: E,
                    type: "button",
                    class: he({ ...q.value, "dp--hidden-el": F.value }),
                    "aria-label": (te = b(g)) == null ? void 0 : te.closeTimePicker,
                    tabindex: "0",
                    onKeydown: $[3] || ($[3] = (P) => b(zn)(P, () => z(!1))),
                    onClick: $[4] || ($[4] = (P) => z(!1))
                  }, [
                    pe.$slots["calendar-icon"] ? fe(pe.$slots, "calendar-icon", { key: 0 }) : Y("", !0),
                    pe.$slots["calendar-icon"] ? Y("", !0) : (f(), ce(b(Hl), { key: 1 }))
                  ], 42, MI)), [
                    [No, !b(T)(pe.hideNavigation, "time")]
                  ]) : Y("", !0)
                ], 2)
              ], 14, OI)) : Y("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Fp = (e, a, t, r) => {
  const { defaultedRange: i } = Nt(e), s = (k, F) => Array.isArray(a[k]) ? a[k][F] : a[k], u = (k) => e.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[k] : a.seconds : 0, A = (k, F) => k ? F !== void 0 ? wr(k, s("hours", F), s("minutes", F), u(F)) : wr(k, a.hours, a.minutes, u()) : Dp(Be(), u(F)), c = (k, F) => {
    a[k] = F;
  }, g = V(() => e.modelAuto && i.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : i.value.enabled), p = (k, F) => {
    const S = Object.fromEntries(
      Object.keys(a).map((Q) => Q === k ? [Q, F] : [Q, a[Q]].slice())
    );
    if (g.value && !i.value.disableTimeRangeValidation) {
      const Q = (W) => t.value ? wr(
        t.value[W],
        S.hours[W],
        S.minutes[W],
        S.seconds[W]
      ) : null, x = (W) => Cp(t.value[W], 0);
      return !(ft(Q(0), Q(1)) && (Sl(Q(0), x(1)) || xi(Q(1), x(0))));
    }
    return !0;
  }, v = (k, F) => {
    p(k, F) && (c(k, F), r && r());
  }, m = (k) => {
    v("hours", k);
  }, w = (k) => {
    v("minutes", k);
  }, B = (k) => {
    v("seconds", k);
  }, T = (k, F, S, Q) => {
    F && m(k), !F && !S && w(k), S && B(k), t.value && Q(t.value);
  }, L = (k) => {
    if (k) {
      const F = Array.isArray(k), S = F ? [+k[0].hours, +k[1].hours] : +k.hours, Q = F ? [+k[0].minutes, +k[1].minutes] : +k.minutes, x = F ? [+k[0].seconds, +k[1].seconds] : +k.seconds;
      c("hours", S), c("minutes", Q), e.enableSeconds && c("seconds", x);
    }
  }, E = (k, F) => {
    const S = {
      hours: Array.isArray(a.hours) ? a.hours[k] : a.hours,
      disabledArr: []
    };
    return (F || F === 0) && (S.hours = F), Array.isArray(e.disabledTimes) && (S.disabledArr = i.value.enabled && Array.isArray(e.disabledTimes[k]) ? e.disabledTimes[k] : e.disabledTimes), S;
  }, N = V(() => (k, F) => {
    var S;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: Q, hours: x } = E(k, F), W = Q.filter((z) => +z.hours === x);
      return ((S = W[0]) == null ? void 0 : S.minutes) === "*" ? { hours: [x], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (W == null ? void 0 : W.map((z) => +z.minutes)) ?? [],
        seconds: (W == null ? void 0 : W.map((z) => z.seconds ? +z.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: c,
    updateHours: m,
    updateMinutes: w,
    updateSeconds: B,
    getSetDateTime: A,
    updateTimeValues: T,
    getSecondsValue: u,
    assignStartTime: L,
    validateTime: p,
    disabledTimesConfig: N
  };
}, zI = (e, a) => {
  const t = () => {
    e.isTextInputDate && F();
  }, { modelValue: r, time: i } = Si(e, a, t), { defaultedStartTime: s, defaultedRange: u, defaultedTz: A } = Nt(e), { updateTimeValues: c, getSetDateTime: g, setTime: p, assignStartTime: v, disabledTimesConfig: m, validateTime: w } = Fp(e, i, r, B);
  function B() {
    a("update-flow-step");
  }
  const T = (Q) => {
    const { hours: x, minutes: W, seconds: z } = Q;
    return { hours: +x, minutes: +W, seconds: z ? +z : 0 };
  }, L = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const x = T(e.startTime[0]), W = T(e.startTime[1]);
        return [Pt(Be(), x), Pt(Be(), W)];
      }
      const Q = T(e.startTime);
      return Pt(Be(), Q);
    }
    return u.value.enabled ? [null, null] : null;
  }, E = () => {
    if (u.value.enabled) {
      const [Q, x] = L();
      r.value = [
        Qn(g(Q, 0), A.value.timezone),
        Qn(g(x, 1), A.value.timezone)
      ];
    } else
      r.value = Qn(g(L()), A.value.timezone);
  }, N = (Q) => Array.isArray(Q) ? [el(Be(Q[0])), el(Be(Q[1]))] : [el(Q ?? Be())], k = (Q, x, W) => {
    p("hours", Q), p("minutes", x), p("seconds", e.enableSeconds ? W : 0);
  }, F = () => {
    const [Q, x] = N(r.value);
    return u.value.enabled ? k(
      [Q.hours, x.hours],
      [Q.minutes, x.minutes],
      [Q.seconds, x.seconds]
    ) : k(Q.hours, Q.minutes, Q.seconds);
  };
  bt(() => {
    if (!e.shadow)
      return v(s.value), r.value ? F() : E();
  });
  const S = () => {
    Array.isArray(r.value) ? r.value = r.value.map((Q, x) => Q && g(Q, x)) : r.value = g(r.value), a("time-update");
  };
  return {
    modelValue: r,
    time: i,
    disabledTimesConfig: m,
    updateTime: (Q, x = !0, W = !1) => {
      c(Q, x, W, S);
    },
    validateTime: w
  };
}, II = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Da
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, s = mn(), u = Kn(s, "timePicker"), A = U(null), { time: c, modelValue: g, disabledTimesConfig: p, updateTime: v, validateTime: m } = zI(i, r);
    return bt(() => {
      i.shadow || r("mount", null);
    }), a({ getSidebarProps: () => ({
      modelValue: g,
      time: c,
      updateTime: v
    }), toggleTimePicker: (w, B = !1, T = "") => {
      var L;
      (L = A.value) == null || L.toggleTimePicker(w, B, T);
    } }), (w, B) => (f(), ce(As, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ue(() => [
        Ce(Hp, Xt({
          ref_key: "tpRef",
          ref: A
        }, w.$props, {
          hours: b(c).hours,
          minutes: b(c).minutes,
          seconds: b(c).seconds,
          "internal-model-value": w.internalModelValue,
          "disabled-times-config": b(p),
          "validate-time": b(m),
          "onUpdate:hours": B[0] || (B[0] = (T) => b(v)(T)),
          "onUpdate:minutes": B[1] || (B[1] = (T) => b(v)(T, !1)),
          "onUpdate:seconds": B[2] || (B[2] = (T) => b(v)(T, !1, !0)),
          onAmPmChange: B[3] || (B[3] = (T) => w.$emit("am-pm-change", T)),
          onResetFlow: B[4] || (B[4] = (T) => w.$emit("reset-flow")),
          onOverlayClosed: B[5] || (B[5] = (T) => w.$emit("overlay-toggle", { open: !1, overlay: T })),
          onOverlayOpened: B[6] || (B[6] = (T) => w.$emit("overlay-toggle", { open: !0, overlay: T }))
        }), Lt({ _: 2 }, [
          tt(b(u), (T, L) => ({
            name: T,
            fn: ue((E) => [
              fe(w.$slots, T, fn(Xn(E)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), EI = { class: "dp--header-wrap" }, LI = {
  key: 0,
  class: "dp__month_year_wrap"
}, NI = { key: 0 }, YI = { class: "dp__month_year_wrap" }, SI = ["data-dp-element", "aria-label", "data-test", "onClick", "onKeydown"], VI = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Da
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, {
      defaultedTransitions: s,
      defaultedAriaLabels: u,
      defaultedMultiCalendars: A,
      defaultedFilters: c,
      defaultedConfig: g,
      defaultedHighlight: p,
      propDates: v,
      defaultedUI: m
    } = Nt(i), { transitionName: w, showTransition: B } = Yi(s), { buildMatrix: T } = Tr(), { handleMonthYearChange: L, isDisabled: E, updateMonthYear: N } = iI(i, r), { showLeftIcon: k, showRightIcon: F } = cs(), S = U(!1), Q = U(!1), x = U(!1), W = U([null, null, null, null]);
    bt(() => {
      r("mount");
    });
    const z = (te) => ({
      get: () => i[te],
      set: (P) => {
        const Z = te === pa.month ? pa.year : pa.month;
        r("update-month-year", { [te]: P, [Z]: i[Z] }), te === pa.month ? oe(!0) : Oe(!0);
      }
    }), q = V(z(pa.month)), J = V(z(pa.year)), le = V(() => (te) => ({
      month: i.month,
      year: i.year,
      items: te === pa.month ? i.months : i.years,
      instance: i.instance,
      updateMonthYear: N,
      toggle: te === pa.month ? oe : Oe
    })), ve = V(() => i.months.find((P) => P.value === i.month) || { text: "", value: 0 }), R = V(() => Wl(i.months, (te) => {
      const P = i.month === te.value, Z = Pi(
        te.value,
        Op(i.year, v.value.minDate),
        Mp(i.year, v.value.maxDate)
      ) || c.value.months.includes(te.value), ae = Np(p.value, te.value, i.year);
      return { active: P, disabled: Z, highlighted: ae };
    })), _ = V(() => Wl(i.years, (te) => {
      const P = i.year === te.value, Z = Pi(
        te.value,
        Xl(v.value.minDate),
        Xl(v.value.maxDate)
      ) || c.value.years.includes(te.value), ae = RA(p.value, te.value);
      return { active: P, disabled: Z, highlighted: ae };
    })), G = (te, P, Z) => {
      Z !== void 0 ? te.value = Z : te.value = !te.value, te.value ? (x.value = !0, r("overlay-opened", P)) : (x.value = !1, r("overlay-closed", P));
    }, oe = (te = !1, P) => {
      pe(te), G(S, Bn.month, P);
    }, Oe = (te = !1, P) => {
      pe(te), G(Q, Bn.year, P);
    }, pe = (te) => {
      te || r("reset-flow");
    }, $ = (te, P) => {
      i.arrowNavigation && (W.value[P] = on(te), T(W.value, "monthYear"));
    }, Me = V(() => {
      var te, P, Z, ae, O, ke;
      return [
        {
          type: pa.month,
          index: 1,
          toggle: oe,
          modelValue: q.value,
          updateModelValue: (Ue) => q.value = Ue,
          text: ve.value.text,
          showSelectionGrid: S.value,
          items: R.value,
          ariaLabel: (te = u.value) == null ? void 0 : te.openMonthsOverlay,
          overlayLabel: ((Z = (P = u.value).monthPicker) == null ? void 0 : Z.call(P, !0)) ?? void 0
        },
        {
          type: pa.year,
          index: 2,
          toggle: Oe,
          modelValue: J.value,
          updateModelValue: (Ue) => J.value = Ue,
          text: kp(i.year, i.locale),
          showSelectionGrid: Q.value,
          items: _.value,
          ariaLabel: (ae = u.value) == null ? void 0 : ae.openYearsOverlay,
          overlayLabel: ((ke = (O = u.value).yearPicker) == null ? void 0 : ke.call(O, !0)) ?? void 0
        }
      ];
    }), me = V(() => i.disableYearSelect ? [Me.value[0]] : i.yearFirst ? [...Me.value].reverse() : Me.value);
    return a({
      toggleMonthPicker: oe,
      toggleYearPicker: Oe,
      handleMonthYearChange: L
    }), (te, P) => {
      var Z, ae, O, ke, Ue, Qt;
      return f(), y("div", EI, [
        te.$slots["month-year"] ? (f(), y("div", LI, [
          fe(te.$slots, "month-year", fn(Xn({ month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: b(N), handleMonthYearChange: b(L), instance: e.instance })))
        ])) : (f(), y(Qe, { key: 1 }, [
          te.$slots["top-extra"] ? (f(), y("div", NI, [
            fe(te.$slots, "top-extra", { value: te.internalModelValue })
          ])) : Y("", !0),
          X("div", YI, [
            b(k)(b(A), e.instance) && !te.vertical ? (f(), ce(Bi, {
              key: 0,
              "aria-label": (Z = b(u)) == null ? void 0 : Z.prevMonth,
              disabled: b(E)(!1),
              class: he((ae = b(m)) == null ? void 0 : ae.navBtnPrev),
              "el-name": "action-prev",
              onActivate: P[0] || (P[0] = (ie) => b(L)(!1, !0)),
              onSetRef: P[1] || (P[1] = (ie) => $(ie, 0))
            }, {
              default: ue(() => [
                te.$slots["arrow-left"] ? fe(te.$slots, "arrow-left", { key: 0 }) : Y("", !0),
                te.$slots["arrow-left"] ? Y("", !0) : (f(), ce(b(SA), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : Y("", !0),
            X("div", {
              class: he(["dp__month_year_wrap", {
                dp__year_disable_select: te.disableYearSelect
              }])
            }, [
              (f(!0), y(Qe, null, tt(me.value, (ie, Te) => (f(), y(Qe, {
                key: ie.type
              }, [
                X("button", {
                  ref_for: !0,
                  ref: (M) => $(M, Te + 1),
                  type: "button",
                  "data-dp-element": `overlay-${ie.type}`,
                  class: he(["dp__btn dp__month_year_select", { "dp--hidden-el": x.value }]),
                  "aria-label": `${ie.text}-${ie.ariaLabel}`,
                  "data-test": `${ie.type}-toggle-overlay-${e.instance}`,
                  onClick: ie.toggle,
                  onKeydown: (M) => b(zn)(M, () => ie.toggle(), !0)
                }, [
                  te.$slots[ie.type] ? fe(te.$slots, ie.type, {
                    key: 0,
                    text: ie.text,
                    value: i[ie.type]
                  }) : Y("", !0),
                  te.$slots[ie.type] ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                    $t(we(ie.text), 1)
                  ], 64))
                ], 42, SI),
                Ce(Jn, {
                  name: b(w)(ie.showSelectionGrid),
                  css: b(B)
                }, {
                  default: ue(() => [
                    ie.showSelectionGrid ? (f(), ce(Ni, {
                      key: 0,
                      items: ie.items,
                      "arrow-navigation": te.arrowNavigation,
                      "hide-navigation": te.hideNavigation,
                      "is-last": te.autoApply && !b(g).keepActionRow,
                      "skip-button-ref": !1,
                      config: te.config,
                      type: ie.type,
                      "header-refs": [],
                      "esc-close": te.escClose,
                      "menu-wrap-ref": te.menuWrapRef,
                      "text-input": te.textInput,
                      "aria-labels": te.ariaLabels,
                      "overlay-label": ie.overlayLabel,
                      onSelected: ie.updateModelValue,
                      onToggle: ie.toggle
                    }, Lt({
                      "button-icon": ue(() => [
                        te.$slots["calendar-icon"] ? fe(te.$slots, "calendar-icon", { key: 0 }) : Y("", !0),
                        te.$slots["calendar-icon"] ? Y("", !0) : (f(), ce(b(Hl), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      te.$slots[`${ie.type}-overlay-value`] ? {
                        name: "item",
                        fn: ue(({ item: M }) => [
                          fe(te.$slots, `${ie.type}-overlay-value`, {
                            text: M.text,
                            value: M.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      te.$slots[`${ie.type}-overlay`] ? {
                        name: "overlay",
                        fn: ue(() => [
                          fe(te.$slots, `${ie.type}-overlay`, Xt({ ref_for: !0 }, le.value(ie.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      te.$slots[`${ie.type}-overlay-header`] ? {
                        name: "header",
                        fn: ue(() => [
                          fe(te.$slots, `${ie.type}-overlay-header`, {
                            toggle: ie.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : Y("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            b(k)(b(A), e.instance) && te.vertical ? (f(), ce(Bi, {
              key: 1,
              "aria-label": (O = b(u)) == null ? void 0 : O.prevMonth,
              "el-name": "action-prev",
              disabled: b(E)(!1),
              class: he((ke = b(m)) == null ? void 0 : ke.navBtnPrev),
              onActivate: P[2] || (P[2] = (ie) => b(L)(!1, !0))
            }, {
              default: ue(() => [
                te.$slots["arrow-up"] ? fe(te.$slots, "arrow-up", { key: 0 }) : Y("", !0),
                te.$slots["arrow-up"] ? Y("", !0) : (f(), ce(b(XA), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : Y("", !0),
            b(F)(b(A), e.instance) ? (f(), ce(Bi, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: b(E)(!0),
              "aria-label": (Ue = b(u)) == null ? void 0 : Ue.nextMonth,
              class: he((Qt = b(m)) == null ? void 0 : Qt.navBtnNext),
              onActivate: P[3] || (P[3] = (ie) => b(L)(!0, !0)),
              onSetRef: P[4] || (P[4] = (ie) => $(ie, te.disableYearSelect ? 2 : 3))
            }, {
              default: ue(() => [
                te.$slots[te.vertical ? "arrow-down" : "arrow-right"] ? fe(te.$slots, te.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : Y("", !0),
                te.$slots[te.vertical ? "arrow-down" : "arrow-right"] ? Y("", !0) : (f(), ce(Dt(te.vertical ? b(QA) : b(VA)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : Y("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), WI = {
  class: "dp__calendar_header",
  role: "row"
}, XI = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, QI = ["aria-label"], HI = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, FI = { class: "dp__cell_inner" }, qI = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], UI = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Da
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, { buildMultiLevelMatrix: s } = Tr(), {
      defaultedTransitions: u,
      defaultedConfig: A,
      defaultedAriaLabels: c,
      defaultedMultiCalendars: g,
      defaultedWeekNumbers: p,
      defaultedMultiDates: v,
      defaultedUI: m
    } = Nt(i), w = U(null), B = U({
      bottom: "",
      left: "",
      transform: ""
    }), T = U([]), L = U(null), E = U(!0), N = U(""), k = U({ startX: 0, endX: 0, startY: 0, endY: 0 }), F = U([]), S = U({ left: "50%" }), Q = U(!1), x = V(() => i.calendar ? i.calendar(i.mappedDates) : i.mappedDates), W = V(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames(i.locale, +i.weekStart) : kz(i.formatLocale, i.locale, +i.weekStart));
    bt(() => {
      r("mount", { cmp: "calendar", refs: T }), A.value.noSwipe || L.value && (L.value.addEventListener("touchstart", $, { passive: !1 }), L.value.addEventListener("touchend", Me, { passive: !1 }), L.value.addEventListener("touchmove", me, { passive: !1 })), i.monthChangeOnScroll && L.value && L.value.addEventListener("wheel", Z, { passive: !1 });
    });
    const z = (ie) => ie ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", q = (ie, Te) => {
      if (i.transitions) {
        const M = In(ja(Be(), i.month, i.year));
        N.value = jt(In(ja(Be(), ie, Te)), M) ? u.value[z(!0)] : u.value[z(!1)], E.value = !1, Bt(() => {
          E.value = !0;
        });
      }
    }, J = V(
      () => ({
        ...m.value.calendar ?? {}
      })
    ), le = V(() => (ie) => {
      const Te = Mz(ie);
      return {
        dp__marker_dot: Te.type === "dot",
        dp__marker_line: Te.type === "line"
      };
    }), ve = V(() => (ie) => ft(ie, w.value)), R = V(() => ({
      dp__calendar: !0,
      dp__calendar_next: g.value.count > 0 && i.instance !== 0
    })), _ = V(() => (ie) => i.hideOffsetDates ? ie.current : !0), G = async (ie, Te) => {
      const { width: M, height: Ae } = ie.getBoundingClientRect();
      w.value = Te.value;
      let xe = { left: `${M / 2}px` }, de = -50;
      if (await Bt(), F.value[0]) {
        const { left: Re, width: ne } = F.value[0].getBoundingClientRect();
        Re < 0 && (xe = { left: "0" }, de = 0, S.value.left = `${M / 2}px`), window.innerWidth < Re + ne && (xe = { right: "0" }, de = 0, S.value.left = `${ne - M / 2}px`);
      }
      B.value = {
        bottom: `${Ae}px`,
        ...xe,
        transform: `translateX(${de}%)`
      };
    }, oe = async (ie, Te, M) => {
      var Ae, xe, de;
      const Re = on(T.value[Te][M]);
      Re && ((Ae = ie.marker) != null && Ae.customPosition && (de = (xe = ie.marker) == null ? void 0 : xe.tooltip) != null && de.length ? B.value = ie.marker.customPosition(Re) : await G(Re, ie), r("tooltip-open", ie.marker));
    }, Oe = async (ie, Te, M) => {
      var Ae, xe;
      if (Q.value && v.value.enabled && v.value.dragSelect)
        return r("select-date", ie);
      r("set-hover-date", ie), (xe = (Ae = ie.marker) == null ? void 0 : Ae.tooltip) != null && xe.length && await oe(ie, Te, M);
    }, pe = (ie) => {
      w.value && (w.value = null, B.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", ie.marker));
    }, $ = (ie) => {
      k.value.startX = ie.changedTouches[0].screenX, k.value.startY = ie.changedTouches[0].screenY;
    }, Me = (ie) => {
      k.value.endX = ie.changedTouches[0].screenX, k.value.endY = ie.changedTouches[0].screenY, te();
    }, me = (ie) => {
      i.vertical && !i.inline && ie.preventDefault();
    }, te = () => {
      const ie = i.vertical ? "Y" : "X";
      Math.abs(k.value[`start${ie}`] - k.value[`end${ie}`]) > 10 && r("handle-swipe", k.value[`start${ie}`] > k.value[`end${ie}`] ? "right" : "left");
    }, P = (ie, Te, M) => {
      ie && (Array.isArray(T.value[Te]) ? T.value[Te][M] = ie : T.value[Te] = [ie]), i.arrowNavigation && s(T.value, "calendar");
    }, Z = (ie) => {
      i.monthChangeOnScroll && (ie.preventDefault(), r("handle-scroll", ie));
    }, ae = (ie) => p.value.type === "local" ? EA(ie.value, { weekStartsOn: +i.weekStart }) : p.value.type === "iso" ? zA(ie.value) : typeof p.value.type == "function" ? p.value.type(ie.value) : "", O = (ie) => {
      const Te = ie[0];
      return p.value.hideOnOffsetDates ? ie.some((M) => M.current) ? ae(Te) : "" : ae(Te);
    }, ke = (ie, Te, M = !0) => {
      M && lv() || !M && !lv() || v.value.enabled || (br(ie, A.value), r("select-date", Te));
    }, Ue = (ie) => {
      br(ie, A.value);
    }, Qt = (ie) => {
      v.value.enabled && v.value.dragSelect ? (Q.value = !0, r("select-date", ie)) : v.value.enabled && r("select-date", ie);
    };
    return a({ triggerTransition: q }), (ie, Te) => (f(), y("div", {
      class: he(R.value)
    }, [
      X("div", {
        ref_key: "calendarWrapRef",
        ref: L,
        class: he(J.value),
        role: "grid"
      }, [
        X("div", WI, [
          ie.weekNumbers ? (f(), y("div", XI, we(ie.weekNumName), 1)) : Y("", !0),
          (f(!0), y(Qe, null, tt(W.value, (M, Ae) => {
            var xe, de;
            return f(), y("div", {
              key: Ae,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test": "calendar-header",
              "aria-label": (de = (xe = b(c)) == null ? void 0 : xe.weekDay) == null ? void 0 : de.call(xe, Ae)
            }, [
              ie.$slots["calendar-header"] ? fe(ie.$slots, "calendar-header", {
                key: 0,
                day: M,
                index: Ae
              }) : Y("", !0),
              ie.$slots["calendar-header"] ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                $t(we(M), 1)
              ], 64))
            ], 8, QI);
          }), 128))
        ]),
        Te[2] || (Te[2] = X("div", { class: "dp__calendar_header_separator" }, null, -1)),
        Ce(Jn, {
          name: N.value,
          css: !!ie.transitions
        }, {
          default: ue(() => [
            E.value ? (f(), y("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: Te[1] || (Te[1] = (M) => Q.value = !1)
            }, [
              (f(!0), y(Qe, null, tt(x.value, (M, Ae) => (f(), y("div", {
                key: Ae,
                class: "dp__calendar_row",
                role: "row"
              }, [
                ie.weekNumbers ? (f(), y("div", HI, [
                  X("div", FI, we(O(M.days)), 1)
                ])) : Y("", !0),
                (f(!0), y(Qe, null, tt(M.days, (xe, de) => {
                  var Re, ne, Pe;
                  return f(), y("div", {
                    id: b(Yp)(xe.value),
                    ref_for: !0,
                    ref: (Ve) => P(Ve, Ae, de),
                    key: de + Ae,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (xe.classData.dp__active_date || xe.classData.dp__range_start || xe.classData.dp__range_start) ?? void 0,
                    "aria-disabled": xe.classData.dp__cell_disabled || void 0,
                    "aria-label": (ne = (Re = b(c)) == null ? void 0 : Re.day) == null ? void 0 : ne.call(Re, xe),
                    tabindex: !xe.current && ie.hideOffsetDates ? void 0 : 0,
                    "data-test": xe.value,
                    onClick: _t((Ve) => ke(Ve, xe), ["prevent"]),
                    onTouchend: (Ve) => ke(Ve, xe, !1),
                    onKeydown: (Ve) => b(zn)(Ve, () => ie.$emit("select-date", xe)),
                    onMouseenter: (Ve) => Oe(xe, Ae, de),
                    onMouseleave: (Ve) => pe(xe),
                    onMousedown: (Ve) => Qt(xe),
                    onMouseup: Te[0] || (Te[0] = (Ve) => Q.value = !1)
                  }, [
                    X("div", {
                      class: he(["dp__cell_inner", xe.classData])
                    }, [
                      ie.$slots.day && _.value(xe) ? fe(ie.$slots, "day", {
                        key: 0,
                        day: +xe.text,
                        date: xe.value
                      }) : Y("", !0),
                      ie.$slots.day ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                        $t(we(xe.text), 1)
                      ], 64)),
                      xe.marker && _.value(xe) ? (f(), y(Qe, { key: 2 }, [
                        ie.$slots.marker ? fe(ie.$slots, "marker", {
                          key: 0,
                          marker: xe.marker,
                          day: +xe.text,
                          date: xe.value
                        }) : (f(), y("div", {
                          key: 1,
                          class: he(le.value(xe.marker)),
                          style: Tt(xe.marker.color ? { backgroundColor: xe.marker.color } : {})
                        }, null, 6))
                      ], 64)) : Y("", !0),
                      ve.value(xe.value) ? (f(), y("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: F,
                        class: "dp__marker_tooltip",
                        style: Tt(B.value)
                      }, [
                        (Pe = xe.marker) != null && Pe.tooltip ? (f(), y("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: Ue
                        }, [
                          (f(!0), y(Qe, null, tt(xe.marker.tooltip, (Ve, Ze) => (f(), y("div", {
                            key: Ze,
                            class: "dp__tooltip_text"
                          }, [
                            ie.$slots["marker-tooltip"] ? fe(ie.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: Ve,
                              day: xe.value
                            }) : Y("", !0),
                            ie.$slots["marker-tooltip"] ? Y("", !0) : (f(), y(Qe, { key: 1 }, [
                              X("div", {
                                class: "dp__tooltip_mark",
                                style: Tt(Ve.color ? { backgroundColor: Ve.color } : {})
                              }, null, 4),
                              X("div", null, we(Ve.text), 1)
                            ], 64))
                          ]))), 128)),
                          X("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Tt(S.value)
                          }, null, 4)
                        ])) : Y("", !0)
                      ], 4)) : Y("", !0)
                    ], 2)
                  ], 40, qI);
                }), 128))
              ]))), 128))
            ], 32)) : Y("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), Av = (e) => Array.isArray(e), RI = (e, a, t, r) => {
  const i = U([]), s = U(/* @__PURE__ */ new Date()), u = U(), A = () => $(e.isTextInputDate), { modelValue: c, calendars: g, time: p, today: v } = Si(e, a, A), {
    defaultedMultiCalendars: m,
    defaultedStartTime: w,
    defaultedRange: B,
    defaultedConfig: T,
    defaultedTz: L,
    propDates: E,
    defaultedMultiDates: N
  } = Nt(e), { validateMonthYearInRange: k, isDisabled: F, isDateRangeAllowed: S, checkMinMaxRange: Q } = xr(e), { updateTimeValues: x, getSetDateTime: W, setTime: z, assignStartTime: q, validateTime: J, disabledTimesConfig: le } = Fp(e, p, c, r), ve = V(
    () => (ee) => g.value[ee] ? g.value[ee].month : 0
  ), R = V(
    () => (ee) => g.value[ee] ? g.value[ee].year : 0
  ), _ = (ee) => !T.value.keepViewOnOffsetClick || ee ? !0 : !u.value, G = (ee, Ie, se, ze = !1) => {
    var Ye, un;
    _(ze) && (g.value[ee] || (g.value[ee] = { month: 0, year: 0 }), g.value[ee].month = rv(Ie) ? (Ye = g.value[ee]) == null ? void 0 : Ye.month : Ie, g.value[ee].year = rv(se) ? (un = g.value[ee]) == null ? void 0 : un.year : se);
  }, oe = () => {
    e.autoApply && a("select-date");
  };
  bt(() => {
    e.shadow || (c.value || (ie(), w.value && q(w.value)), $(!0), e.focusStartDate && e.startDate && ie());
  });
  const Oe = V(() => {
    var ee;
    return (ee = e.flow) != null && ee.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), pe = () => {
    e.autoApply && Oe.value && a("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
  }, $ = (ee = !1) => {
    if (c.value)
      return Array.isArray(c.value) ? (i.value = c.value, O(ee)) : te(c.value, ee);
    if (m.value.count && ee && !e.startDate)
      return me(Be(), ee);
  }, Me = () => Array.isArray(c.value) && B.value.enabled ? At(c.value[0]) === At(c.value[1] ?? c.value[0]) : !1, me = (ee = /* @__PURE__ */ new Date(), Ie = !1) => {
    if ((!m.value.count || !m.value.static || Ie) && G(0, At(ee), et(ee)), m.value.count && (!m.value.solo || !c.value || Me()))
      for (let se = 1; se < m.value.count; se++) {
        const ze = Pt(Be(), { month: ve.value(se - 1), year: R.value(se - 1) }), Ye = rp(ze, { months: 1 });
        g.value[se] = { month: At(Ye), year: et(Ye) };
      }
  }, te = (ee, Ie) => {
    me(ee), z("hours", $a(ee)), z("minutes", Dr(ee)), z("seconds", Yl(ee)), m.value.count && Ie && Qt();
  }, P = (ee) => {
    if (m.value.count) {
      if (m.value.solo)
        return 0;
      const Ie = At(ee[0]), se = At(ee[1]);
      return Math.abs(se - Ie) < m.value.count ? 0 : 1;
    }
    return 1;
  }, Z = (ee, Ie) => {
    ee[1] && B.value.showLastInRange ? me(ee[P(ee)], Ie) : me(ee[0], Ie);
    const se = (ze, Ye) => [
      ze(ee[0]),
      ee[1] ? ze(ee[1]) : p[Ye][1]
    ];
    z("hours", se($a, "hours")), z("minutes", se(Dr, "minutes")), z("seconds", se(Yl, "seconds"));
  }, ae = (ee, Ie) => {
    if ((B.value.enabled || e.weekPicker) && !N.value.enabled)
      return Z(ee, Ie);
    if (N.value.enabled && Ie) {
      const se = ee[ee.length - 1];
      return te(se, Ie);
    }
  }, O = (ee) => {
    const Ie = c.value;
    ae(Ie, ee), m.value.count && m.value.solo && Qt();
  }, ke = (ee, Ie) => {
    const se = Pt(Be(), { month: ve.value(Ie), year: R.value(Ie) }), ze = ee < 0 ? ba(se, 1) : Vl(se, 1);
    k(At(ze), et(ze), ee < 0, e.preventMinMaxNavigation) && (G(Ie, At(ze), et(ze)), a("update-month-year", { instance: Ie, month: At(ze), year: et(ze) }), m.value.count && !m.value.solo && Ue(Ie), t());
  }, Ue = (ee) => {
    for (let Ie = ee - 1; Ie >= 0; Ie--) {
      const se = Vl(Pt(Be(), { month: ve.value(Ie + 1), year: R.value(Ie + 1) }), 1);
      G(Ie, At(se), et(se));
    }
    for (let Ie = ee + 1; Ie <= m.value.count - 1; Ie++) {
      const se = ba(Pt(Be(), { month: ve.value(Ie - 1), year: R.value(Ie - 1) }), 1);
      G(Ie, At(se), et(se));
    }
  }, Qt = () => {
    if (Array.isArray(c.value) && c.value.length === 2) {
      const ee = Be(
        Be(c.value[1] ? c.value[1] : ba(c.value[0], 1))
      ), [Ie, se] = [At(c.value[0]), et(c.value[0])], [ze, Ye] = [At(c.value[1]), et(c.value[1])];
      (Ie !== ze || Ie === ze && se !== Ye) && m.value.solo && G(1, At(ee), et(ee));
    } else
      c.value && !Array.isArray(c.value) && (G(0, At(c.value), et(c.value)), me(Be()));
  }, ie = () => {
    e.startDate && (G(0, At(Be(e.startDate)), et(Be(e.startDate))), m.value.count && Ue(0));
  }, Te = (ee, Ie) => {
    if (e.monthChangeOnScroll) {
      const se = (/* @__PURE__ */ new Date()).getTime() - s.value.getTime(), ze = Math.abs(ee.deltaY);
      let Ye = 500;
      ze > 1 && (Ye = 100), ze > 100 && (Ye = 0), se > Ye && (s.value = /* @__PURE__ */ new Date(), ke(e.monthChangeOnScroll !== "inverse" ? -ee.deltaY : ee.deltaY, Ie));
    }
  }, M = (ee, Ie, se = !1) => {
    e.monthChangeOnArrows && e.vertical === se && Ae(ee, Ie);
  }, Ae = (ee, Ie) => {
    ke(ee === "right" ? -1 : 1, Ie);
  }, xe = (ee) => {
    if (E.value.markers)
      return ns(ee.value, E.value.markers);
  }, de = (ee, Ie) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [ee == 0, !0];
      case "fair":
        return [ee == 0 || Ie > ee, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Re = (ee, Ie, se, ze) => {
    if (e.sixWeeks && ee.length < 6) {
      const Ye = 6 - ee.length, un = (Ie.getDay() + 7 - ze) % 7, En = 6 - (se.getDay() + 7 - ze) % 7, [Sa, il] = de(un, En);
      for (let Nr = 1; Nr <= Ye; Nr++)
        if (il ? !!(Nr % 2) == Sa : Sa) {
          const ua = ee[0].days[0], Fl = ne(ma(ua.value, -7), At(Ie));
          ee.unshift({ days: Fl });
        } else {
          const ua = ee[ee.length - 1], Fl = ua.days[ua.days.length - 1], vs = ne(ma(Fl.value, 1), At(Ie));
          ee.push({ days: vs });
        }
    }
    return ee;
  }, ne = (ee, Ie) => {
    const se = Be(ee), ze = [];
    for (let Ye = 0; Ye < 7; Ye++) {
      const un = ma(se, Ye), En = At(un) !== Ie;
      ze.push({
        text: e.hideOffsetDates && En ? "" : un.getDate(),
        value: un,
        current: !En,
        classData: {}
      });
    }
    return ze;
  }, Pe = (ee, Ie) => {
    const se = [], ze = new Date(Ie, ee), Ye = new Date(Ie, ee + 1, 0), un = e.weekStart, En = Ca(ze, { weekStartsOn: un }), Sa = (il) => {
      const Nr = ne(il, ee);
      if (se.push({ days: Nr }), !se[se.length - 1].days.some(
        (ua) => ft(In(ua.value), In(Ye))
      )) {
        const ua = ma(il, 7);
        Sa(ua);
      }
    };
    return Sa(En), Re(se, ze, Ye, un);
  }, Ve = (ee) => {
    const Ie = wr(Be(ee.value), p.hours, p.minutes, an());
    a("date-update", Ie), N.value.enabled ? ZA(Ie, c, N.value.limit) : c.value = Ie, r(), Bt().then(() => {
      pe();
    });
  }, Ze = (ee) => B.value.noDisabledRange ? zp(i.value[0], ee).some((Ie) => F(Ie)) : !1, sn = () => {
    i.value = c.value ? c.value.slice() : [], i.value.length === 2 && !(B.value.fixedStart || B.value.fixedEnd) && (i.value = []);
  }, Fe = (ee, Ie) => {
    const se = [
      Be(ee.value),
      ma(Be(ee.value), +B.value.autoRange)
    ];
    S(se) ? (Ie && Ba(ee.value), i.value = se) : a("invalid-date", ee.value);
  }, Ba = (ee) => {
    const Ie = At(Be(ee)), se = et(Be(ee));
    if (G(0, Ie, se), m.value.count > 0)
      for (let ze = 1; ze < m.value.count; ze++) {
        const Ye = Sz(
          Pt(Be(ee), { year: R.value(ze - 1), month: ve.value(ze - 1) })
        );
        G(ze, Ye.month, Ye.year);
      }
  }, yn = (ee) => {
    if (Ze(ee.value) || !Q(ee.value, c.value, B.value.fixedStart ? 0 : 1))
      return a("invalid-date", ee.value);
    i.value = Xp(Be(ee.value), c, a, B);
  }, Pr = (ee, Ie) => {
    if (sn(), B.value.autoRange)
      return Fe(ee, Ie);
    if (B.value.fixedStart || B.value.fixedEnd)
      return yn(ee);
    i.value[0] ? Q(Be(ee.value), c.value) && !Ze(ee.value) ? qt(Be(ee.value), Be(i.value[0])) ? (i.value.unshift(Be(ee.value)), a("range-end", i.value[0])) : (i.value[1] = Be(ee.value), a("range-end", i.value[1])) : (e.autoApply && a("auto-apply-invalid", ee.value), a("invalid-date", ee.value)) : (i.value[0] = Be(ee.value), a("range-start", i.value[0]));
  }, an = (ee = !0) => e.enableSeconds ? Array.isArray(p.seconds) ? ee ? p.seconds[0] : p.seconds[1] : p.seconds : 0, _n = (ee) => {
    i.value[ee] = wr(
      i.value[ee],
      p.hours[ee],
      p.minutes[ee],
      an(ee !== 1)
    );
  }, kr = () => {
    var ee, Ie;
    i.value[0] && i.value[1] && +((ee = i.value) == null ? void 0 : ee[0]) > +((Ie = i.value) == null ? void 0 : Ie[1]) && (i.value.reverse(), a("range-start", i.value[0]), a("range-end", i.value[1]));
  }, ar = () => {
    i.value.length && (i.value[0] && !i.value[1] ? _n(0) : (_n(0), _n(1), r()), kr(), c.value = i.value.slice(), ds(i.value, a, e.autoApply, e.modelAuto));
  }, Or = (ee, Ie = !1) => {
    if (F(ee.value) || !ee.current && e.hideOffsetDates)
      return a("invalid-date", ee.value);
    if (u.value = JSON.parse(JSON.stringify(ee)), !B.value.enabled)
      return Ve(ee);
    Av(p.hours) && Av(p.minutes) && !N.value.enabled && (Pr(ee, Ie), ar());
  }, Mr = (ee, Ie) => {
    var se;
    G(ee, Ie.month, Ie.year, !0), m.value.count && !m.value.solo && Ue(ee), a("update-month-year", { instance: ee, month: Ie.month, year: Ie.year }), t(m.value.solo ? ee : void 0);
    const ze = (se = e.flow) != null && se.length ? e.flow[e.flowStep] : void 0;
    !Ie.fromNav && (ze === Bn.month || ze === Bn.year) && r();
  }, zr = (ee, Ie) => {
    Wp({
      value: ee,
      modelValue: c,
      range: B.value.enabled,
      timezone: Ie ? void 0 : L.value.timezone
    }), oe(), e.multiCalendars && Bt().then(() => $(!0));
  }, Ir = () => {
    const ee = HA(Be(), L.value);
    B.value.enabled ? c.value && Array.isArray(c.value) && c.value[0] ? c.value = qt(ee, c.value[0]) ? [ee, c.value[0]] : [c.value[0], ee] : c.value = [ee] : c.value = ee, oe();
  }, Er = () => {
    if (Array.isArray(c.value))
      if (N.value.enabled) {
        const ee = Lr();
        c.value[c.value.length - 1] = W(ee);
      } else
        c.value = c.value.map((ee, Ie) => ee && W(ee, Ie));
    else
      c.value = W(c.value);
    a("time-update");
  }, Lr = () => Array.isArray(c.value) && c.value.length ? c.value[c.value.length - 1] : null;
  return {
    calendars: g,
    modelValue: c,
    month: ve,
    year: R,
    time: p,
    disabledTimesConfig: le,
    today: v,
    validateTime: J,
    getCalendarDays: Pe,
    getMarker: xe,
    handleScroll: Te,
    handleSwipe: Ae,
    handleArrow: M,
    selectDate: Or,
    updateMonthYear: Mr,
    presetDate: zr,
    selectCurrentDate: Ir,
    updateTime: (ee, Ie = !0, se = !1) => {
      x(ee, Ie, se, Er);
    },
    assignMonthAndYear: me
  };
}, ZI = { key: 0 }, GI = /* @__PURE__ */ We({
  __name: "DatePicker",
  props: {
    ...Da
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, {
      calendars: s,
      month: u,
      year: A,
      modelValue: c,
      time: g,
      disabledTimesConfig: p,
      today: v,
      validateTime: m,
      getCalendarDays: w,
      getMarker: B,
      handleArrow: T,
      handleScroll: L,
      handleSwipe: E,
      selectDate: N,
      updateMonthYear: k,
      presetDate: F,
      selectCurrentDate: S,
      updateTime: Q,
      assignMonthAndYear: x
    } = RI(i, r, Me, me), W = mn(), { setHoverDate: z, getDayClassData: q, clearHoverDate: J } = uE(c, i), { defaultedMultiCalendars: le } = Nt(i), ve = U([]), R = U([]), _ = U(null), G = Kn(W, "calendar"), oe = Kn(W, "monthYear"), Oe = Kn(W, "timePicker"), pe = (Te) => {
      i.shadow || r("mount", Te);
    };
    st(
      s,
      () => {
        i.shadow || setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), st(
      le,
      (Te, M) => {
        Te.count - M.count > 0 && x();
      },
      { deep: !0 }
    );
    const $ = V(() => (Te) => w(u.value(Te), A.value(Te)).map((M) => ({
      ...M,
      days: M.days.map((Ae) => (Ae.marker = B(Ae), Ae.classData = q(Ae), Ae))
    })));
    function Me(Te) {
      var M;
      Te || Te === 0 ? (M = R.value[Te]) == null || M.triggerTransition(u.value(Te), A.value(Te)) : R.value.forEach((Ae, xe) => Ae.triggerTransition(u.value(xe), A.value(xe)));
    }
    function me() {
      r("update-flow-step");
    }
    const te = (Te, M = !1) => {
      N(Te, M), i.spaceConfirm && r("select-date");
    }, P = (Te, M, Ae = 0) => {
      var xe;
      (xe = ve.value[Ae]) == null || xe.toggleMonthPicker(Te, M);
    }, Z = (Te, M, Ae = 0) => {
      var xe;
      (xe = ve.value[Ae]) == null || xe.toggleYearPicker(Te, M);
    }, ae = (Te, M, Ae) => {
      var xe;
      (xe = _.value) == null || xe.toggleTimePicker(Te, M, Ae);
    }, O = (Te, M) => {
      var Ae;
      if (!i.range) {
        const xe = c.value ? c.value : v, de = M ? new Date(M) : xe, Re = Te ? Ca(de, { weekStartsOn: 1 }) : cp(de, { weekStartsOn: 1 });
        N({
          value: Re,
          current: At(de) === u.value(0),
          text: "",
          classData: {}
        }), (Ae = document.getElementById(Yp(Re))) == null || Ae.focus();
      }
    }, ke = (Te) => {
      var M;
      (M = ve.value[0]) == null || M.handleMonthYearChange(Te, !0);
    }, Ue = (Te) => {
      k(0, { month: u.value(0), year: A.value(0) + (Te ? 1 : -1), fromNav: !0 });
    }, Qt = (Te, M) => {
      Te === Bn.time && r(`time-picker-${M ? "open" : "close"}`), r("overlay-toggle", { open: M, overlay: Te });
    }, ie = (Te) => {
      r("overlay-toggle", { open: !1, overlay: Te }), r("focus-menu");
    };
    return a({
      clearHoverDate: J,
      presetDate: F,
      selectCurrentDate: S,
      toggleMonthPicker: P,
      toggleYearPicker: Z,
      toggleTimePicker: ae,
      handleArrow: T,
      updateMonthYear: k,
      getSidebarProps: () => ({
        modelValue: c,
        month: u,
        year: A,
        time: g,
        updateTime: Q,
        updateMonthYear: k,
        selectDate: N,
        presetDate: F
      }),
      changeMonth: ke,
      changeYear: Ue,
      selectWeekDate: O
    }), (Te, M) => (f(), y(Qe, null, [
      Ce(As, {
        "multi-calendars": b(le).count,
        collapse: Te.collapse
      }, {
        default: ue(({ instance: Ae, index: xe }) => [
          Te.disableMonthYearSelect ? Y("", !0) : (f(), ce(VI, Xt({
            key: 0,
            ref: (de) => {
              de && (ve.value[xe] = de);
            },
            months: b(Tp)(Te.formatLocale, Te.locale, Te.monthNameFormat),
            years: b(FA)(Te.yearRange, Te.locale, Te.reverseYears),
            month: b(u)(Ae),
            year: b(A)(Ae),
            instance: Ae
          }, Te.$props, {
            onMount: M[0] || (M[0] = (de) => pe(b($r).header)),
            onResetFlow: M[1] || (M[1] = (de) => Te.$emit("reset-flow")),
            onUpdateMonthYear: (de) => b(k)(Ae, de),
            onOverlayClosed: ie,
            onOverlayOpened: M[2] || (M[2] = (de) => Te.$emit("overlay-toggle", { open: !0, overlay: de }))
          }), Lt({ _: 2 }, [
            tt(b(oe), (de, Re) => ({
              name: de,
              fn: ue((ne) => [
                fe(Te.$slots, de, fn(Xn(ne)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Ce(UI, Xt({
            ref: (de) => {
              de && (R.value[xe] = de);
            },
            "mapped-dates": $.value(Ae),
            month: b(u)(Ae),
            year: b(A)(Ae),
            instance: Ae
          }, Te.$props, {
            onSelectDate: (de) => b(N)(de, Ae !== 1),
            onHandleSpace: (de) => te(de, Ae !== 1),
            onSetHoverDate: M[3] || (M[3] = (de) => b(z)(de)),
            onHandleScroll: (de) => b(L)(de, Ae),
            onHandleSwipe: (de) => b(E)(de, Ae),
            onMount: M[4] || (M[4] = (de) => pe(b($r).calendar)),
            onResetFlow: M[5] || (M[5] = (de) => Te.$emit("reset-flow")),
            onTooltipOpen: M[6] || (M[6] = (de) => Te.$emit("tooltip-open", de)),
            onTooltipClose: M[7] || (M[7] = (de) => Te.$emit("tooltip-close", de))
          }), Lt({ _: 2 }, [
            tt(b(G), (de, Re) => ({
              name: de,
              fn: ue((ne) => [
                fe(Te.$slots, de, fn(Xn({ ...ne })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      Te.enableTimePicker ? (f(), y("div", ZI, [
        Te.$slots["time-picker"] ? fe(Te.$slots, "time-picker", fn(Xt({ key: 0 }, { time: b(g), updateTime: b(Q) }))) : (f(), ce(Hp, Xt({
          key: 1,
          ref_key: "timePickerRef",
          ref: _
        }, Te.$props, {
          hours: b(g).hours,
          minutes: b(g).minutes,
          seconds: b(g).seconds,
          "internal-model-value": Te.internalModelValue,
          "disabled-times-config": b(p),
          "validate-time": b(m),
          onMount: M[8] || (M[8] = (Ae) => pe(b($r).timePicker)),
          "onUpdate:hours": M[9] || (M[9] = (Ae) => b(Q)(Ae)),
          "onUpdate:minutes": M[10] || (M[10] = (Ae) => b(Q)(Ae, !1)),
          "onUpdate:seconds": M[11] || (M[11] = (Ae) => b(Q)(Ae, !1, !0)),
          onResetFlow: M[12] || (M[12] = (Ae) => Te.$emit("reset-flow")),
          onOverlayClosed: M[13] || (M[13] = (Ae) => Qt(Ae, !1)),
          onOverlayOpened: M[14] || (M[14] = (Ae) => Qt(Ae, !0)),
          onAmPmChange: M[15] || (M[15] = (Ae) => Te.$emit("am-pm-change", Ae))
        }), Lt({ _: 2 }, [
          tt(b(Oe), (Ae, xe) => ({
            name: Ae,
            fn: ue((de) => [
              fe(Te.$slots, Ae, fn(Xn(de)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : Y("", !0)
    ], 64));
  }
}), jI = (e, a) => {
  const t = U(), {
    defaultedMultiCalendars: r,
    defaultedConfig: i,
    defaultedHighlight: s,
    defaultedRange: u,
    propDates: A,
    defaultedFilters: c,
    defaultedMultiDates: g
  } = Nt(e), { modelValue: p, year: v, month: m, calendars: w } = Si(e, a), { isDisabled: B } = xr(e), { selectYear: T, groupedYears: L, showYearPicker: E, isDisabled: N, toggleYearPicker: k, handleYearSelect: F, handleYear: S } = Qp({
    modelValue: p,
    multiCalendars: r,
    range: u,
    highlight: s,
    calendars: w,
    propDates: A,
    month: m,
    year: v,
    filters: c,
    props: e,
    emit: a
  }), Q = (_, G) => [_, G].map((oe) => Na(oe, "MMMM", { locale: e.formatLocale })).join("-"), x = V(() => (_) => p.value ? Array.isArray(p.value) ? p.value.some((G) => tv(_, G)) : tv(p.value, _) : !1), W = (_) => {
    if (u.value.enabled) {
      if (Array.isArray(p.value)) {
        const G = ft(_, p.value[0]) || ft(_, p.value[1]);
        return ss(p.value, t.value, _) && !G;
      }
      return !1;
    }
    return !1;
  }, z = (_, G) => _.quarter === jf(G) && _.year === et(G), q = (_) => typeof s.value == "function" ? s.value({ quarter: jf(_), year: et(_) }) : !!s.value.quarters.find((G) => z(G, _)), J = V(() => (_) => {
    const G = Pt(/* @__PURE__ */ new Date(), { year: v.value(_) });
    return MO({
      start: Ti(G),
      end: dp(G)
    }).map((oe) => {
      const Oe = _r(oe), pe = Kf(oe), $ = B(oe), Me = W(Oe), me = q(Oe);
      return {
        text: Q(Oe, pe),
        value: Oe,
        active: x.value(Oe),
        highlighted: me,
        disabled: $,
        isBetween: Me
      };
    });
  }), le = (_) => {
    ZA(_, p, g.value.limit), a("auto-apply", !0);
  }, ve = (_) => {
    p.value = GA(p, _, a), ds(p.value, a, e.autoApply, e.modelAuto);
  }, R = (_) => {
    p.value = _, a("auto-apply");
  };
  return {
    defaultedConfig: i,
    defaultedMultiCalendars: r,
    groupedYears: L,
    year: v,
    isDisabled: N,
    quarters: J,
    showYearPicker: E,
    modelValue: p,
    setHoverDate: (_) => {
      t.value = _;
    },
    selectYear: T,
    selectQuarter: (_, G, oe) => {
      if (!oe)
        return w.value[G].month = At(Kf(_)), g.value.enabled ? le(_) : u.value.enabled ? ve(_) : R(_);
    },
    toggleYearPicker: k,
    handleYearSelect: F,
    handleYear: S
  };
}, KI = { class: "dp--quarter-items" }, JI = ["data-test", "disabled", "onClick", "onMouseover"], _I = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Da
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, s = mn(), u = Kn(s, "yearMode"), {
      defaultedMultiCalendars: A,
      defaultedConfig: c,
      groupedYears: g,
      year: p,
      isDisabled: v,
      quarters: m,
      modelValue: w,
      showYearPicker: B,
      setHoverDate: T,
      selectQuarter: L,
      toggleYearPicker: E,
      handleYearSelect: N,
      handleYear: k
    } = jI(i, r);
    return a({ getSidebarProps: () => ({
      modelValue: w,
      year: p,
      selectQuarter: L,
      handleYearSelect: N,
      handleYear: k
    }) }), (F, S) => (f(), ce(As, {
      "multi-calendars": b(A).count,
      collapse: F.collapse,
      stretch: ""
    }, {
      default: ue(({ instance: Q }) => [
        X("div", {
          class: "dp-quarter-picker-wrap",
          style: Tt({ minHeight: `${b(c).modeHeight}px` })
        }, [
          F.$slots["top-extra"] ? fe(F.$slots, "top-extra", {
            key: 0,
            value: F.internalModelValue
          }) : Y("", !0),
          X("div", null, [
            Ce(Vp, Xt(F.$props, {
              items: b(g)(Q),
              instance: Q,
              "show-year-picker": b(B)[Q],
              year: b(p)(Q),
              "is-disabled": (x) => b(v)(Q, x),
              onHandleYear: (x) => b(k)(Q, x),
              onYearSelect: (x) => b(N)(x, Q),
              onToggleYearPicker: (x) => b(E)(Q, x == null ? void 0 : x.flow, x == null ? void 0 : x.show)
            }), Lt({ _: 2 }, [
              tt(b(u), (x, W) => ({
                name: x,
                fn: ue((z) => [
                  fe(F.$slots, x, fn(Xn(z)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          X("div", KI, [
            (f(!0), y(Qe, null, tt(b(m)(Q), (x, W) => (f(), y("div", { key: W }, [
              X("button", {
                type: "button",
                class: he(["dp--qr-btn", {
                  "dp--qr-btn-active": x.active,
                  "dp--qr-btn-between": x.isBetween,
                  "dp--qr-btn-disabled": x.disabled,
                  "dp--highlighted": x.highlighted
                }]),
                "data-test": x.value,
                disabled: x.disabled,
                onClick: (z) => b(L)(x.value, Q, x.disabled),
                onMouseover: (z) => b(T)(x.value)
              }, [
                F.$slots.quarter ? fe(F.$slots, "quarter", {
                  key: 0,
                  value: x.value,
                  text: x.text
                }) : (f(), y(Qe, { key: 1 }, [
                  $t(we(x.text), 1)
                ], 64))
              ], 42, JI)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), $I = ["id", "tabindex", "role", "aria-label"], eE = {
  key: 0,
  class: "dp--menu-load-container"
}, tE = {
  key: 1,
  class: "dp--menu-header"
}, nE = {
  key: 0,
  class: "dp__sidebar_left"
}, aE = ["data-test", "onClick", "onKeydown"], rE = {
  key: 2,
  class: "dp__sidebar_right"
}, lE = {
  key: 3,
  class: "dp__action_extra"
}, dv = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...us,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, s = U(null), u = V(() => {
      const { openOnTop: ne, ...Pe } = i;
      return {
        ...Pe,
        flowStep: z.value,
        collapse: i.collapse,
        noOverlayFocus: i.noOverlayFocus,
        menuWrapRef: s.value
      };
    }), { setMenuFocused: A, setShiftKey: c, control: g } = Sp(), p = mn(), { defaultedTextInput: v, defaultedInline: m, defaultedConfig: w, defaultedUI: B } = Nt(i), T = U(null), L = U(0), E = U(null), N = U(!1), k = U(null);
    bt(() => {
      if (!i.shadow) {
        N.value = !0, F(), window.addEventListener("resize", F);
        const ne = on(s);
        if (ne && !v.value.enabled && !m.value.enabled && (A(!0), G()), ne) {
          const Pe = (Ve) => {
            w.value.allowPreventDefault && Ve.preventDefault(), br(Ve, w.value, !0);
          };
          ne.addEventListener("pointerdown", Pe), ne.addEventListener("mousedown", Pe);
        }
      }
    }), al(() => {
      window.removeEventListener("resize", F);
    });
    const F = () => {
      const ne = on(E);
      ne && (L.value = ne.getBoundingClientRect().width);
    }, { arrowRight: S, arrowLeft: Q, arrowDown: x, arrowUp: W } = Tr(), { flowStep: z, updateFlowStep: q, childMount: J, resetFlow: le, handleFlow: ve } = AE(i, r, k), R = V(() => i.monthPicker ? hI : i.yearPicker ? yI : i.timePicker ? II : i.quarterPicker ? _I : GI), _ = V(() => {
      var ne;
      if (w.value.arrowLeft)
        return w.value.arrowLeft;
      const Pe = (ne = s.value) == null ? void 0 : ne.getBoundingClientRect(), Ve = i.getInputRect();
      return (Ve == null ? void 0 : Ve.width) < (L == null ? void 0 : L.value) && (Ve == null ? void 0 : Ve.left) <= ((Pe == null ? void 0 : Pe.left) ?? 0) ? `${(Ve == null ? void 0 : Ve.width) / 2}px` : (Ve == null ? void 0 : Ve.right) >= ((Pe == null ? void 0 : Pe.right) ?? 0) && (Ve == null ? void 0 : Ve.width) < (L == null ? void 0 : L.value) ? `${(L == null ? void 0 : L.value) - (Ve == null ? void 0 : Ve.width) / 2}px` : "50%";
    }), G = () => {
      const ne = on(s);
      ne && ne.focus({ preventScroll: !0 });
    }, oe = V(() => {
      var ne;
      return ((ne = k.value) == null ? void 0 : ne.getSidebarProps()) || {};
    }), Oe = () => {
      i.openOnTop && r("recalculate-position");
    }, pe = Kn(p, "action"), $ = V(() => i.monthPicker || i.yearPicker ? Kn(p, "monthYear") : i.timePicker ? Kn(p, "timePicker") : Kn(p, "shared")), Me = V(() => i.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), me = V(() => ({
      dp__menu_disabled: i.disabled,
      dp__menu_readonly: i.readonly,
      "dp-menu-loading": i.loading
    })), te = V(
      () => ({
        dp__menu: !0,
        dp__menu_index: !m.value.enabled,
        dp__relative: m.value.enabled,
        ...B.value.menu ?? {}
      })
    ), P = (ne) => {
      br(ne, w.value, !0);
    }, Z = () => {
      i.escClose && r("close-picker");
    }, ae = (ne) => {
      if (i.arrowNavigation) {
        if (ne === Mn.up)
          return W();
        if (ne === Mn.down)
          return x();
        if (ne === Mn.left)
          return Q();
        if (ne === Mn.right)
          return S();
      } else
        ne === Mn.left || ne === Mn.up ? ie("handleArrow", Mn.left, 0, ne === Mn.up) : ie("handleArrow", Mn.right, 0, ne === Mn.down);
    }, O = (ne) => {
      c(ne.shiftKey), !i.disableMonthYearSelect && ne.code === zt.tab && ne.target.classList.contains("dp__menu") && g.value.shiftKeyInMenu && (ne.preventDefault(), br(ne, w.value, !0), r("close-picker"));
    }, ke = () => {
      G(), r("time-picker-close");
    }, Ue = (ne) => {
      var Pe, Ve, Ze;
      (Pe = k.value) == null || Pe.toggleTimePicker(!1, !1), (Ve = k.value) == null || Ve.toggleMonthPicker(!1, !1, ne), (Ze = k.value) == null || Ze.toggleYearPicker(!1, !1, ne);
    }, Qt = (ne, Pe = 0) => {
      var Ve, Ze, sn;
      return ne === "month" ? (Ve = k.value) == null ? void 0 : Ve.toggleMonthPicker(!1, !0, Pe) : ne === "year" ? (Ze = k.value) == null ? void 0 : Ze.toggleYearPicker(!1, !0, Pe) : ne === "time" ? (sn = k.value) == null ? void 0 : sn.toggleTimePicker(!0, !1) : Ue(Pe);
    }, ie = (ne, ...Pe) => {
      var Ve, Ze;
      (Ve = k.value) != null && Ve[ne] && ((Ze = k.value) == null || Ze[ne](...Pe));
    }, Te = () => {
      ie("selectCurrentDate");
    }, M = (ne, Pe) => {
      ie("presetDate", ne, Pe);
    }, Ae = () => {
      ie("clearHoverDate");
    }, xe = (ne, Pe) => {
      ie("updateMonthYear", ne, Pe);
    }, de = (ne, Pe) => {
      ne.preventDefault(), ae(Pe);
    }, Re = (ne) => {
      var Pe, Ve, Ze;
      if (O(ne), ne.key === zt.home || ne.key === zt.end)
        return ie(
          "selectWeekDate",
          ne.key === zt.home,
          ne.target.getAttribute("id")
        );
      switch ((ne.key === zt.pageUp || ne.key === zt.pageDown) && (ne.shiftKey ? (ie("changeYear", ne.key === zt.pageUp), (Pe = hA(s.value, "overlay-year")) == null || Pe.focus()) : (ie("changeMonth", ne.key === zt.pageUp), (Ve = hA(s.value, ne.key === zt.pageUp ? "action-prev" : "action-next")) == null || Ve.focus()), ne.target.getAttribute("id") && ((Ze = s.value) == null || Ze.focus({ preventScroll: !0 }))), ne.key) {
        case zt.esc:
          return Z();
        case zt.arrowLeft:
          return de(ne, Mn.left);
        case zt.arrowRight:
          return de(ne, Mn.right);
        case zt.arrowUp:
          return de(ne, Mn.up);
        case zt.arrowDown:
          return de(ne, Mn.down);
        default:
          return;
      }
    };
    return a({
      updateMonthYear: xe,
      switchView: Qt,
      handleFlow: ve
    }), (ne, Pe) => {
      var Ve, Ze, sn;
      return f(), y("div", {
        id: ne.uid ? `dp-menu-${ne.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: s,
        tabindex: b(m).enabled ? void 0 : "0",
        role: b(m).enabled ? void 0 : "dialog",
        "aria-label": (Ve = ne.ariaLabels) == null ? void 0 : Ve.menu,
        class: he(te.value),
        style: Tt({ "--dp-arrow-left": _.value }),
        onMouseleave: Ae,
        onClick: P,
        onKeydown: Re
      }, [
        (ne.disabled || ne.readonly) && b(m).enabled || ne.loading ? (f(), y("div", {
          key: 0,
          class: he(me.value)
        }, [
          ne.loading ? (f(), y("div", eE, Pe[19] || (Pe[19] = [
            X("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : Y("", !0)
        ], 2)) : Y("", !0),
        ne.$slots["menu-header"] ? (f(), y("div", tE, [
          fe(ne.$slots, "menu-header")
        ])) : Y("", !0),
        !b(m).enabled && !ne.teleportCenter ? (f(), y("div", {
          key: 2,
          class: he(Me.value)
        }, null, 2)) : Y("", !0),
        X("div", {
          ref_key: "innerMenuRef",
          ref: E,
          class: he({
            dp__menu_content_wrapper: ((Ze = ne.presetDates) == null ? void 0 : Ze.length) || !!ne.$slots["left-sidebar"] || !!ne.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((sn = ne.presetDates) == null ? void 0 : sn.length) || !!ne.$slots["left-sidebar"] || !!ne.$slots["right-sidebar"])
          }),
          style: Tt({ "--dp-menu-width": `${L.value}px` })
        }, [
          ne.$slots["left-sidebar"] ? (f(), y("div", nE, [
            fe(ne.$slots, "left-sidebar", fn(Xn(oe.value)))
          ])) : Y("", !0),
          ne.presetDates.length ? (f(), y("div", {
            key: 1,
            class: he({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 })
          }, [
            (f(!0), y(Qe, null, tt(ne.presetDates, (Fe, Ba) => (f(), y(Qe, { key: Ba }, [
              Fe.slot ? fe(ne.$slots, Fe.slot, {
                key: 0,
                presetDate: M,
                label: Fe.label,
                value: Fe.value
              }) : (f(), y("button", {
                key: 1,
                type: "button",
                style: Tt(Fe.style || {}),
                class: he(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test": Fe.testId ?? void 0,
                onClick: _t((yn) => M(Fe.value, Fe.noTz), ["prevent"]),
                onKeydown: (yn) => b(zn)(yn, () => M(Fe.value, Fe.noTz), !0)
              }, we(Fe.label), 47, aE))
            ], 64))), 128))
          ], 2)) : Y("", !0),
          X("div", {
            ref_key: "calendarWrapperRef",
            ref: T,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (f(), ce(Dt(R.value), Xt({
              ref_key: "dynCmpRef",
              ref: k
            }, u.value, {
              "flow-step": b(z),
              onMount: b(J),
              onUpdateFlowStep: b(q),
              onResetFlow: b(le),
              onFocusMenu: G,
              onSelectDate: Pe[0] || (Pe[0] = (Fe) => ne.$emit("select-date")),
              onDateUpdate: Pe[1] || (Pe[1] = (Fe) => ne.$emit("date-update", Fe)),
              onTooltipOpen: Pe[2] || (Pe[2] = (Fe) => ne.$emit("tooltip-open", Fe)),
              onTooltipClose: Pe[3] || (Pe[3] = (Fe) => ne.$emit("tooltip-close", Fe)),
              onAutoApply: Pe[4] || (Pe[4] = (Fe) => ne.$emit("auto-apply", Fe)),
              onRangeStart: Pe[5] || (Pe[5] = (Fe) => ne.$emit("range-start", Fe)),
              onRangeEnd: Pe[6] || (Pe[6] = (Fe) => ne.$emit("range-end", Fe)),
              onInvalidFixedRange: Pe[7] || (Pe[7] = (Fe) => ne.$emit("invalid-fixed-range", Fe)),
              onTimeUpdate: Pe[8] || (Pe[8] = (Fe) => ne.$emit("time-update")),
              onAmPmChange: Pe[9] || (Pe[9] = (Fe) => ne.$emit("am-pm-change", Fe)),
              onTimePickerOpen: Pe[10] || (Pe[10] = (Fe) => ne.$emit("time-picker-open", Fe)),
              onTimePickerClose: ke,
              onRecalculatePosition: Oe,
              onUpdateMonthYear: Pe[11] || (Pe[11] = (Fe) => ne.$emit("update-month-year", Fe)),
              onAutoApplyInvalid: Pe[12] || (Pe[12] = (Fe) => ne.$emit("auto-apply-invalid", Fe)),
              onInvalidDate: Pe[13] || (Pe[13] = (Fe) => ne.$emit("invalid-date", Fe)),
              onOverlayToggle: Pe[14] || (Pe[14] = (Fe) => ne.$emit("overlay-toggle", Fe)),
              "onUpdate:internalModelValue": Pe[15] || (Pe[15] = (Fe) => ne.$emit("update:internal-model-value", Fe))
            }), Lt({ _: 2 }, [
              tt($.value, (Fe, Ba) => ({
                name: Fe,
                fn: ue((yn) => [
                  fe(ne.$slots, Fe, fn(Xn({ ...yn })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          ne.$slots["right-sidebar"] ? (f(), y("div", rE, [
            fe(ne.$slots, "right-sidebar", fn(Xn(oe.value)))
          ])) : Y("", !0),
          ne.$slots["action-extra"] ? (f(), y("div", lE, [
            ne.$slots["action-extra"] ? fe(ne.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: Te
            }) : Y("", !0)
          ])) : Y("", !0)
        ], 6),
        !ne.autoApply || b(w).keepActionRow ? (f(), ce(uI, Xt({
          key: 3,
          "menu-mount": N.value
        }, u.value, {
          "calendar-width": L.value,
          onClosePicker: Pe[16] || (Pe[16] = (Fe) => ne.$emit("close-picker")),
          onSelectDate: Pe[17] || (Pe[17] = (Fe) => ne.$emit("select-date")),
          onInvalidSelect: Pe[18] || (Pe[18] = (Fe) => ne.$emit("invalid-select")),
          onSelectNow: Te
        }), Lt({ _: 2 }, [
          tt(b(pe), (Fe, Ba) => ({
            name: Fe,
            fn: ue((yn) => [
              fe(ne.$slots, Fe, fn(Xn({ ...yn })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : Y("", !0)
      ], 46, $I);
    };
  }
});
var xl = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(xl || {});
const iE = ({
  menuRef: e,
  menuRefInner: a,
  inputRef: t,
  pickerWrapperRef: r,
  inline: i,
  emit: s,
  props: u,
  slots: A
}) => {
  const { defaultedConfig: c } = Nt(u), g = U({}), p = U(!1), v = U({
    top: "0",
    left: "0"
  }), m = U(!1), w = zl(u, "teleportCenter");
  st(w, () => {
    v.value = JSON.parse(JSON.stringify({})), S();
  });
  const B = (G) => {
    if (u.teleport) {
      const oe = G.getBoundingClientRect();
      return {
        left: oe.left + window.scrollX,
        top: oe.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, T = (G, oe) => {
    v.value.left = `${G + oe - g.value.width}px`;
  }, L = (G) => {
    v.value.left = `${G}px`;
  }, E = (G, oe) => {
    u.position === xl.left && L(G), u.position === xl.right && T(G, oe), u.position === xl.center && (v.value.left = `${G + oe / 2 - g.value.width / 2}px`);
  }, N = (G) => {
    const { width: oe, height: Oe } = G.getBoundingClientRect(), { top: pe, left: $ } = u.altPosition ? u.altPosition(G) : B(G);
    return { top: +pe, left: +$, width: oe, height: Oe };
  }, k = () => {
    v.value.left = "50%", v.value.top = "50%", v.value.transform = "translate(-50%, -50%)", v.value.position = "fixed", delete v.value.opacity;
  }, F = () => {
    const G = on(t), { top: oe, left: Oe, transform: pe } = u.altPosition(G);
    v.value = { top: `${oe}px`, left: `${Oe}px`, transform: pe ?? "" };
  }, S = (G = !0) => {
    var oe;
    if (!i.value.enabled) {
      if (w.value)
        return k();
      if (u.altPosition !== null)
        return F();
      if (G) {
        const Oe = u.teleport ? (oe = a.value) == null ? void 0 : oe.$el : e.value;
        Oe && (g.value = Oe.getBoundingClientRect()), s("recalculate-position");
      }
      return le();
    }
  }, Q = ({ inputEl: G, left: oe, width: Oe }) => {
    window.screen.width > 768 && !p.value && E(oe, Oe), z(G);
  }, x = (G) => {
    const { top: oe, left: Oe, height: pe, width: $ } = N(G);
    v.value.top = `${pe + oe + +u.offset}px`, m.value = !1, p.value || (v.value.left = `${Oe + $ / 2 - g.value.width / 2}px`), Q({ inputEl: G, left: Oe, width: $ });
  }, W = (G) => {
    const { top: oe, left: Oe, width: pe } = N(G);
    v.value.top = `${oe - +u.offset - g.value.height}px`, m.value = !0, Q({ inputEl: G, left: Oe, width: pe });
  }, z = (G) => {
    if (u.autoPosition) {
      const { left: oe, width: Oe } = N(G), { left: pe, right: $ } = g.value;
      if (!p.value) {
        if (Math.abs(pe) !== Math.abs($)) {
          if (pe <= 0)
            return p.value = !0, L(oe);
          if ($ >= document.documentElement.clientWidth)
            return p.value = !0, T(oe, Oe);
        }
        return E(oe, Oe);
      }
    }
  }, q = () => {
    const G = on(t);
    if (G) {
      const { height: oe } = g.value, { top: Oe, height: pe } = G.getBoundingClientRect(), $ = window.innerHeight - Oe - pe, Me = Oe;
      return oe <= $ ? jr.bottom : oe > $ && oe <= Me ? jr.top : $ >= Me ? jr.bottom : jr.top;
    }
    return jr.bottom;
  }, J = (G) => q() === jr.bottom ? x(G) : W(G), le = () => {
    const G = on(t);
    if (G)
      return u.autoPosition ? J(G) : x(G);
  }, ve = function(G) {
    if (G) {
      const oe = G.scrollHeight > G.clientHeight, Oe = window.getComputedStyle(G).overflowY.indexOf("hidden") !== -1;
      return oe && !Oe;
    }
    return !0;
  }, R = function(G) {
    return !G || G === document.body || G.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : ve(G) ? G : R(
      G.assignedSlot && c.value.shadowDom ? G.assignedSlot.parentNode : G.parentNode
    );
  }, _ = (G) => {
    if (G)
      switch (u.position) {
        case xl.left:
          return { left: 0, transform: "translateX(0)" };
        case xl.right:
          return { left: `${G.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${G.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: m,
    menuStyle: v,
    xCorrect: p,
    setMenuPosition: S,
    getScrollableParent: R,
    shadowRender: (G, oe) => {
      var Oe, pe, $;
      const Me = document.createElement("div"), me = (Oe = on(t)) == null ? void 0 : Oe.getBoundingClientRect();
      Me.setAttribute("id", "dp--temp-container");
      const te = (pe = r.value) != null && pe.clientWidth ? r.value : document.body;
      te.append(Me);
      const P = _(me), Z = c.value.shadowDom ? Object.keys(A).filter(
        (O) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(O)
      ) : Object.keys(A), ae = bw(
        G,
        {
          ...oe,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...P }
        },
        Object.fromEntries(Z.map((O) => [O, A[O]]))
      );
      Cf(ae, Me), g.value = ($ = ae.el) == null ? void 0 : $.getBoundingClientRect(), Cf(null, Me), te.removeChild(Me);
    }
  };
}, vr = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], oE = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], sE = {
  all: () => vr,
  monthYear: () => vr.filter((e) => e.use.includes("month-year")),
  input: () => oE,
  timePicker: () => vr.filter((e) => e.use.includes("time")),
  action: () => vr.filter((e) => e.use.includes("action")),
  calendar: () => vr.filter((e) => e.use.includes("calendar")),
  menu: () => vr.filter((e) => e.use.includes("menu")),
  shared: () => vr.filter((e) => e.use.includes("shared")),
  yearMode: () => vr.filter((e) => e.use.includes("year-mode"))
}, Kn = (e, a, t) => {
  const r = [];
  return sE[a]().forEach((i) => {
    e[i.name] && r.push(i.name);
  }), t != null && t.length && t.forEach((i) => {
    i.slot && r.push(i.slot);
  }), r;
}, Yi = (e) => {
  const a = V(() => (r) => e.value ? r ? e.value.open : e.value.close : ""), t = V(() => (r) => e.value ? r ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: a, showTransition: !!e.value, menuTransition: t };
}, Si = (e, a, t) => {
  const { defaultedRange: r, defaultedTz: i } = Nt(e), s = Be(Qn(Be(), i.value.timezone)), u = U([{ month: At(s), year: et(s) }]), A = (m) => {
    const w = {
      hours: $a(s),
      minutes: Dr(s),
      seconds: 0
    };
    return r.value.enabled ? [w[m], w[m]] : w[m];
  }, c = Ja({
    hours: A("hours"),
    minutes: A("minutes"),
    seconds: A("seconds")
  });
  st(
    r,
    (m, w) => {
      m.enabled !== w.enabled && (c.hours = A("hours"), c.minutes = A("minutes"), c.seconds = A("seconds"));
    },
    { deep: !0 }
  );
  const g = V({
    get: () => e.internalModelValue,
    set: (m) => {
      !e.readonly && !e.disabled && a("update:internal-model-value", m);
    }
  }), p = V(
    () => (m) => u.value[m] ? u.value[m].month : 0
  ), v = V(
    () => (m) => u.value[m] ? u.value[m].year : 0
  );
  return st(
    g,
    (m, w) => {
      t && JSON.stringify(m ?? {}) !== JSON.stringify(w ?? {}) && t();
    },
    { deep: !0 }
  ), {
    calendars: u,
    time: c,
    modelValue: g,
    month: p,
    year: v,
    today: s
  };
}, uE = (e, a) => {
  const {
    defaultedMultiCalendars: t,
    defaultedMultiDates: r,
    defaultedUI: i,
    defaultedHighlight: s,
    defaultedTz: u,
    propDates: A,
    defaultedRange: c
  } = Nt(a), { isDisabled: g } = xr(a), p = U(null), v = U(Qn(/* @__PURE__ */ new Date(), u.value.timezone)), m = (P) => {
    !P.current && a.hideOffsetDates || (p.value = P.value);
  }, w = () => {
    p.value = null;
  }, B = (P) => Array.isArray(e.value) && c.value.enabled && e.value[0] && p.value ? P ? jt(p.value, e.value[0]) : qt(p.value, e.value[0]) : !0, T = (P, Z) => {
    const ae = () => e.value ? Z ? e.value[0] || null : e.value[1] : null, O = e.value && Array.isArray(e.value) ? ae() : null;
    return ft(Be(P.value), O);
  }, L = (P) => {
    const Z = Array.isArray(e.value) ? e.value[0] : null;
    return P ? !qt(p.value ?? null, Z) : !0;
  }, E = (P, Z = !0) => (c.value.enabled || a.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? a.hideOffsetDates && !P.current ? !1 : ft(Be(P.value), e.value[Z ? 0 : 1]) : c.value.enabled ? T(P, Z) && L(Z) || ft(P.value, Array.isArray(e.value) ? e.value[0] : null) && B(Z) : !1, N = (P, Z) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const ae = ft(P.value, p.value);
      return Z ? jt(e.value[0], P.value) && ae : qt(e.value[0], P.value) && ae;
    }
    return !1;
  }, k = (P) => !e.value || a.hideOffsetDates && !P.current ? !1 : c.value.enabled ? a.modelAuto && Array.isArray(e.value) ? ft(P.value, e.value[0] ? e.value[0] : v.value) : !1 : r.value.enabled && Array.isArray(e.value) ? e.value.some((Z) => ft(Z, P.value)) : ft(P.value, e.value ? e.value : v.value), F = (P) => {
    if (c.value.autoRange || a.weekPicker) {
      if (p.value) {
        if (a.hideOffsetDates && !P.current)
          return !1;
        const Z = ma(p.value, +c.value.autoRange), ae = Za(Be(p.value), a.weekStart);
        return a.weekPicker ? ft(ae[1], Be(P.value)) : ft(Z, Be(P.value));
      }
      return !1;
    }
    return !1;
  }, S = (P) => {
    if (c.value.autoRange || a.weekPicker) {
      if (p.value) {
        const Z = ma(p.value, +c.value.autoRange);
        if (a.hideOffsetDates && !P.current)
          return !1;
        const ae = Za(Be(p.value), a.weekStart);
        return a.weekPicker ? jt(P.value, ae[0]) && qt(P.value, ae[1]) : jt(P.value, p.value) && qt(P.value, Z);
      }
      return !1;
    }
    return !1;
  }, Q = (P) => {
    if (c.value.autoRange || a.weekPicker) {
      if (p.value) {
        if (a.hideOffsetDates && !P.current)
          return !1;
        const Z = Za(Be(p.value), a.weekStart);
        return a.weekPicker ? ft(Z[0], P.value) : ft(p.value, P.value);
      }
      return !1;
    }
    return !1;
  }, x = (P) => ss(e.value, p.value, P.value), W = () => a.modelAuto && Array.isArray(a.internalModelValue) ? !!a.internalModelValue[0] : !1, z = () => a.modelAuto ? xp(a.internalModelValue) : !0, q = (P) => {
    if (a.weekPicker)
      return !1;
    const Z = c.value.enabled ? !E(P) && !E(P, !1) : !0;
    return !g(P.value) && !k(P) && !(!P.current && a.hideOffsetDates) && Z;
  }, J = (P) => c.value.enabled ? a.modelAuto ? W() && k(P) : !1 : k(P), le = (P) => s.value ? Lz(P.value, A.value.highlight) : !1, ve = (P) => {
    const Z = g(P.value);
    return Z && (typeof s.value == "function" ? !s.value(P.value, Z) : !s.value.options.highlightDisabled);
  }, R = (P) => {
    var Z;
    return typeof s.value == "function" ? s.value(P.value) : (Z = s.value.weekdays) == null ? void 0 : Z.includes(P.value.getDay());
  }, _ = (P) => (c.value.enabled || a.weekPicker) && (!(t.value.count > 0) || P.current) && z() && !(!P.current && a.hideOffsetDates) && !k(P) ? x(P) : !1, G = (P) => {
    const { isRangeStart: Z, isRangeEnd: ae } = $(P), O = c.value.enabled ? Z || ae : !1;
    return {
      dp__cell_offset: !P.current,
      dp__pointer: !a.disabled && !(!P.current && a.hideOffsetDates) && !g(P.value),
      dp__cell_disabled: g(P.value),
      dp__cell_highlight: !ve(P) && (le(P) || R(P)) && !J(P) && !O && !Q(P) && !(_(P) && a.weekPicker) && !ae,
      dp__cell_highlight_active: !ve(P) && (le(P) || R(P)) && J(P),
      dp__today: !a.noToday && ft(P.value, v.value) && P.current,
      "dp--past": qt(P.value, v.value),
      "dp--future": jt(P.value, v.value)
    };
  }, oe = (P) => ({
    dp__active_date: J(P),
    dp__date_hover: q(P)
  }), Oe = (P) => {
    if (e.value && !Array.isArray(e.value)) {
      const Z = Za(e.value, a.weekStart);
      return {
        ...me(P),
        dp__range_start: ft(Z[0], P.value),
        dp__range_end: ft(Z[1], P.value),
        dp__range_between_week: jt(P.value, Z[0]) && qt(P.value, Z[1])
      };
    }
    return {
      ...me(P)
    };
  }, pe = (P) => {
    if (e.value && Array.isArray(e.value)) {
      const Z = Za(e.value[0], a.weekStart), ae = e.value[1] ? Za(e.value[1], a.weekStart) : [];
      return {
        ...me(P),
        dp__range_start: ft(Z[0], P.value) || ft(ae[0], P.value),
        dp__range_end: ft(Z[1], P.value) || ft(ae[1], P.value),
        dp__range_between_week: jt(P.value, Z[0]) && qt(P.value, Z[1]) || jt(P.value, ae[0]) && qt(P.value, ae[1]),
        dp__range_between: jt(P.value, Z[1]) && qt(P.value, ae[0])
      };
    }
    return {
      ...me(P)
    };
  }, $ = (P) => {
    const Z = t.value.count > 0 ? P.current && E(P) && z() : E(P) && z(), ae = t.value.count > 0 ? P.current && E(P, !1) && z() : E(P, !1) && z();
    return { isRangeStart: Z, isRangeEnd: ae };
  }, Me = (P) => {
    const { isRangeStart: Z, isRangeEnd: ae } = $(P);
    return {
      dp__range_start: Z,
      dp__range_end: ae,
      dp__range_between: _(P),
      dp__date_hover: ft(P.value, p.value) && !Z && !ae && !a.weekPicker,
      dp__date_hover_start: N(P, !0),
      dp__date_hover_end: N(P, !1)
    };
  }, me = (P) => ({
    ...Me(P),
    dp__cell_auto_range: S(P),
    dp__cell_auto_range_start: Q(P),
    dp__cell_auto_range_end: F(P)
  }), te = (P) => c.value.enabled ? c.value.autoRange ? me(P) : a.modelAuto ? { ...oe(P), ...Me(P) } : a.weekPicker ? pe(P) : Me(P) : a.weekPicker ? Oe(P) : oe(P);
  return {
    setHoverDate: m,
    clearHoverDate: w,
    getDayClassData: (P) => a.hideOffsetDates && !P.current ? {} : {
      ...G(P),
      ...te(P),
      [a.dayClass ? a.dayClass(P.value, a.internalModelValue) : ""]: !0,
      ...i.value.calendarCell ?? {}
    }
  };
}, xr = (e) => {
  const { defaultedFilters: a, defaultedRange: t, propDates: r, defaultedMultiDates: i } = Nt(e), s = (R) => r.value.disabledDates ? typeof r.value.disabledDates == "function" ? r.value.disabledDates(Be(R)) : !!ns(R, r.value.disabledDates) : !1, u = (R) => r.value.maxDate ? e.yearPicker ? et(R) > et(r.value.maxDate) : jt(R, r.value.maxDate) : !1, A = (R) => r.value.minDate ? e.yearPicker ? et(R) < et(r.value.minDate) : qt(R, r.value.minDate) : !1, c = (R) => {
    const _ = u(R), G = A(R), oe = s(R), Oe = a.value.months.map((te) => +te).includes(At(R)), pe = e.disabledWeekDays.length ? e.disabledWeekDays.some((te) => +te === DM(R)) : !1, $ = w(R), Me = et(R), me = Me < +e.yearRange[0] || Me > +e.yearRange[1];
    return !(_ || G || oe || Oe || me || pe || $);
  }, g = (R, _) => qt(...mr(r.value.minDate, R, _)) || ft(...mr(r.value.minDate, R, _)), p = (R, _) => jt(...mr(r.value.maxDate, R, _)) || ft(...mr(r.value.maxDate, R, _)), v = (R, _, G) => {
    let oe = !1;
    return r.value.maxDate && G && p(R, _) && (oe = !0), r.value.minDate && !G && g(R, _) && (oe = !0), oe;
  }, m = (R, _, G, oe) => {
    let Oe = !1;
    return oe && (r.value.minDate || r.value.maxDate) ? r.value.minDate && r.value.maxDate ? Oe = v(R, _, G) : (r.value.minDate && g(R, _) || r.value.maxDate && p(R, _)) && (Oe = !0) : Oe = !0, Oe;
  }, w = (R) => Array.isArray(r.value.allowedDates) && !r.value.allowedDates.length ? !0 : r.value.allowedDates ? !ns(R, r.value.allowedDates) : !1, B = (R) => !c(R), T = (R) => t.value.noDisabledRange ? !Ap({ start: R[0], end: R[1] }).some((_) => B(_)) : !0, L = (R) => {
    if (R) {
      const _ = et(R);
      return _ >= +e.yearRange[0] && _ <= e.yearRange[1];
    }
    return !0;
  }, E = (R, _) => !!(Array.isArray(R) && R[_] && (t.value.maxRange || t.value.minRange) && L(R[_])), N = (R, _, G = 0) => {
    if (E(_, G) && L(R)) {
      const oe = sp(R, _[G]), Oe = zp(_[G], R), pe = Oe.length === 1 ? 0 : Oe.filter((Me) => B(Me)).length, $ = Math.abs(oe) - (t.value.minMaxRawRange ? 0 : pe);
      if (t.value.minRange && t.value.maxRange)
        return $ >= +t.value.minRange && $ <= +t.value.maxRange;
      if (t.value.minRange)
        return $ >= +t.value.minRange;
      if (t.value.maxRange)
        return $ <= +t.value.maxRange;
    }
    return !0;
  }, k = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, F = (R) => Array.isArray(R) ? [R[0] ? ju(R[0]) : null, R[1] ? ju(R[1]) : null] : ju(R), S = (R, _, G) => R.find(
    (oe) => +oe.hours === $a(_) && oe.minutes === "*" ? !0 : +oe.minutes === Dr(_) && +oe.hours === $a(_)
  ) && G, Q = (R, _, G) => {
    const [oe, Oe] = R, [pe, $] = _;
    return !S(oe, pe, G) && !S(Oe, $, G) && G;
  }, x = (R, _) => {
    const G = Array.isArray(_) ? _ : [_];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? Q(e.disabledTimes, G, R) : !G.some((oe) => S(e.disabledTimes, oe, R)) : R;
  }, W = (R, _) => {
    const G = Array.isArray(_) ? [el(_[0]), _[1] ? el(_[1]) : void 0] : el(_), oe = !e.disabledTimes(G);
    return R && oe;
  }, z = (R, _) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? x(_, R) : W(_, R) : _, q = (R) => {
    let _ = !0;
    if (!R || k())
      return !0;
    const G = !r.value.minDate && !r.value.maxDate ? F(R) : R;
    return (e.maxTime || r.value.maxDate) && (_ = ov(
      e.maxTime,
      r.value.maxDate,
      "max",
      dn(G),
      _
    )), (e.minTime || r.value.minDate) && (_ = ov(
      e.minTime,
      r.value.minDate,
      "min",
      dn(G),
      _
    )), z(R, _);
  }, J = (R) => {
    if (!e.monthPicker)
      return !0;
    let _ = !0;
    const G = Be(ya(R));
    if (r.value.minDate && r.value.maxDate) {
      const oe = Be(ya(r.value.minDate)), Oe = Be(ya(r.value.maxDate));
      return jt(G, oe) && qt(G, Oe) || ft(G, oe) || ft(G, Oe);
    }
    if (r.value.minDate) {
      const oe = Be(ya(r.value.minDate));
      _ = jt(G, oe) || ft(G, oe);
    }
    if (r.value.maxDate) {
      const oe = Be(ya(r.value.maxDate));
      _ = qt(G, oe) || ft(G, oe);
    }
    return _;
  }, le = V(() => (R) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : q(R)), ve = V(() => (R) => e.monthPicker ? Array.isArray(R) && (t.value.enabled || i.value.enabled) ? !R.filter((_) => !J(_)).length : J(R) : !0);
  return {
    isDisabled: B,
    validateDate: c,
    validateMonthYearInRange: m,
    isDateRangeAllowed: T,
    checkMinMaxRange: N,
    isValidTime: q,
    isTimeValid: le,
    isMonthValid: ve
  };
}, cs = () => {
  const e = V(() => (r, i) => r == null ? void 0 : r.includes(i)), a = V(() => (r, i) => r.count ? r.solo ? !0 : i === 0 : !0), t = V(() => (r, i) => r.count ? r.solo ? !0 : i === r.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: a, showRightIcon: t };
}, AE = (e, a, t) => {
  const r = U(0), i = Ja({
    [$r.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [$r.calendar]: !1,
    [$r.header]: !1
  }), s = V(() => e.monthPicker || e.timePicker), u = (v) => {
    var m;
    if ((m = e.flow) != null && m.length) {
      if (!v && s.value)
        return p();
      i[v] = !0, Object.keys(i).filter((w) => !i[w]).length || p();
    }
  }, A = () => {
    var v, m;
    (v = e.flow) != null && v.length && r.value !== -1 && (r.value += 1, a("flow-step", r.value), p()), ((m = e.flow) == null ? void 0 : m.length) === r.value && Bt().then(() => c());
  }, c = () => {
    r.value = -1;
  }, g = (v, m, ...w) => {
    var B, T;
    e.flow[r.value] === v && t.value && ((T = (B = t.value)[m]) == null || T.call(B, ...w));
  }, p = (v = 0) => {
    v && (r.value += v), g(Bn.month, "toggleMonthPicker", !0), g(Bn.year, "toggleYearPicker", !0), g(Bn.calendar, "toggleTimePicker", !1, !0), g(Bn.time, "toggleTimePicker", !0, !0);
    const m = e.flow[r.value];
    (m === Bn.hours || m === Bn.minutes || m === Bn.seconds) && g(m, "toggleTimePicker", !0, !0, m);
  };
  return { childMount: u, updateFlowStep: A, resetFlow: c, handleFlow: p, flowStep: r };
}, dE = {
  key: 1,
  class: "dp__input_wrap"
}, cE = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], fE = {
  key: 2,
  class: "dp--clear-btn"
}, vE = ["aria-label"], pE = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...us
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, {
      defaultedTextInput: s,
      defaultedAriaLabels: u,
      defaultedInline: A,
      defaultedConfig: c,
      defaultedRange: g,
      defaultedMultiDates: p,
      defaultedUI: v,
      getDefaultPattern: m,
      getDefaultStartTime: w
    } = Nt(i), { checkMinMaxRange: B } = xr(i), T = U(), L = U(null), E = U(!1), N = U(!1), k = V(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !s.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !s.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !i.hideInputIcon,
        dp__input_valid: typeof i.state == "boolean" ? i.state : !1,
        dp__input_invalid: typeof i.state == "boolean" ? !i.state : !1,
        dp__input_focus: E.value || i.isMenuOpen,
        dp__input_reg: !s.value.enabled,
        ...v.value.input ?? {}
      })
    ), F = () => {
      r("set-input-date", null), i.clearable && i.autoApply && (r("set-empty-date"), T.value = null);
    }, S = ($) => {
      const Me = w();
      return Nz(
        $,
        s.value.format ?? m(),
        Me ?? Ip({}, i.enableSeconds),
        i.inputValue,
        N.value,
        i.formatLocale
      );
    }, Q = ($) => {
      const { rangeSeparator: Me } = s.value, [me, te] = $.split(`${Me}`);
      if (me) {
        const P = S(me.trim()), Z = te ? S(te.trim()) : null;
        if (Sl(P, Z))
          return;
        const ae = P && Z ? [P, Z] : [P];
        B(Z, ae, 0) && (T.value = P ? ae : null);
      }
    }, x = () => {
      N.value = !0;
    }, W = ($) => {
      if (g.value.enabled)
        Q($);
      else if (p.value.enabled) {
        const Me = $.split(";");
        T.value = Me.map((me) => S(me.trim())).filter((me) => me);
      } else
        T.value = S($);
    }, z = ($) => {
      var Me;
      const me = typeof $ == "string" ? $ : (Me = $.target) == null ? void 0 : Me.value;
      me !== "" ? (s.value.openMenu && !i.isMenuOpen && r("open"), W(me), r("set-input-date", T.value)) : F(), N.value = !1, r("update:input-value", me), r("text-input", $, T.value);
    }, q = ($) => {
      s.value.enabled ? (W($.target.value), s.value.enterSubmit && mA(T.value) && i.inputValue !== "" ? (r("set-input-date", T.value, !0), T.value = null) : s.value.enterSubmit && i.inputValue === "" && (T.value = null, r("clear"))) : ve($);
    }, J = ($, Me) => {
      s.value.enabled && s.value.tabSubmit && !Me && W($.target.value), s.value.tabSubmit && mA(T.value) && i.inputValue !== "" ? (r("set-input-date", T.value, !0, !0), T.value = null) : s.value.tabSubmit && i.inputValue === "" && (T.value = null, r("clear", !0));
    }, le = () => {
      E.value = !0, r("focus"), Bt().then(() => {
        var $;
        s.value.enabled && s.value.selectOnFocus && (($ = L.value) == null || $.select());
      });
    }, ve = ($) => {
      if (br($, c.value, !0), s.value.enabled && s.value.openMenu && !A.value.input) {
        if (s.value.openMenu === "open" && !i.isMenuOpen)
          return r("open");
        if (s.value.openMenu === "toggle")
          return r("toggle");
      } else
        s.value.enabled || r("toggle");
    }, R = () => {
      r("real-blur"), E.value = !1, (!i.isMenuOpen || A.value.enabled && A.value.input) && r("blur"), i.autoApply && s.value.enabled && T.value && !i.isMenuOpen && (r("set-input-date", T.value), r("select-date"), T.value = null);
    }, _ = ($) => {
      br($, c.value, !0), r("clear");
    }, G = ($) => {
      if ($.key === "Tab" && J($), $.key === "Enter" && q($), !s.value.enabled) {
        if ($.code === "Tab")
          return;
        $.preventDefault();
      }
    }, oe = () => {
      var $;
      ($ = L.value) == null || $.focus({ preventScroll: !0 });
    }, Oe = ($) => {
      T.value = $;
    }, pe = ($) => {
      $.key === zt.tab && J($, !0);
    };
    return a({
      focusInput: oe,
      setParsedDate: Oe
    }), ($, Me) => {
      var me, te, P;
      return f(), y("div", { onClick: ve }, [
        $.$slots.trigger && !$.$slots["dp-input"] && !b(A).enabled ? fe($.$slots, "trigger", { key: 0 }) : Y("", !0),
        !$.$slots.trigger && (!b(A).enabled || b(A).input) ? (f(), y("div", dE, [
          $.$slots["dp-input"] && !$.$slots.trigger && (!b(A).enabled || b(A).enabled && b(A).input) ? fe($.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: z,
            onEnter: q,
            onTab: J,
            onClear: _,
            onBlur: R,
            onKeypress: G,
            onPaste: x,
            onFocus: le,
            openMenu: () => $.$emit("open"),
            closeMenu: () => $.$emit("close"),
            toggleMenu: () => $.$emit("toggle")
          }) : Y("", !0),
          $.$slots["dp-input"] ? Y("", !0) : (f(), y("input", {
            key: 1,
            id: $.uid ? `dp-input-${$.uid}` : void 0,
            ref_key: "inputRef",
            ref: L,
            "data-test": "dp-input",
            name: $.name,
            class: he(k.value),
            inputmode: b(s).enabled ? "text" : "none",
            placeholder: $.placeholder,
            disabled: $.disabled,
            readonly: $.readonly,
            required: $.required,
            value: e.inputValue,
            autocomplete: $.autocomplete,
            "aria-label": (me = b(u)) == null ? void 0 : me.input,
            "aria-disabled": $.disabled || void 0,
            "aria-invalid": $.state === !1 ? !0 : void 0,
            onInput: z,
            onBlur: R,
            onFocus: le,
            onKeypress: G,
            onKeydown: Me[0] || (Me[0] = (Z) => G(Z)),
            onPaste: x
          }, null, 42, cE)),
          X("div", {
            onClick: Me[3] || (Me[3] = (Z) => r("toggle"))
          }, [
            $.$slots["input-icon"] && !$.hideInputIcon ? (f(), y("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: Me[1] || (Me[1] = (Z) => r("toggle"))
            }, [
              fe($.$slots, "input-icon")
            ])) : Y("", !0),
            !$.$slots["input-icon"] && !$.hideInputIcon && !$.$slots["dp-input"] ? (f(), ce(b(Hl), {
              key: 1,
              "aria-label": (te = b(u)) == null ? void 0 : te.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: Me[2] || (Me[2] = (Z) => r("toggle"))
            }, null, 8, ["aria-label"])) : Y("", !0)
          ]),
          $.$slots["clear-icon"] && e.inputValue && $.clearable && !$.disabled && !$.readonly ? (f(), y("span", fE, [
            fe($.$slots, "clear-icon", { clear: _ })
          ])) : Y("", !0),
          $.clearable && !$.$slots["clear-icon"] && e.inputValue && !$.disabled && !$.readonly ? (f(), y("button", {
            key: 3,
            "aria-label": (P = b(u)) == null ? void 0 : P.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: Me[4] || (Me[4] = (Z) => b(zn)(Z, () => _(Z), !0, pe)),
            onClick: Me[5] || (Me[5] = _t((Z) => _(Z), ["prevent"]))
          }, [
            Ce(b(Bp), {
              class: "dp__input_icons",
              "data-test": "clear-icon"
            })
          ], 40, vE)) : Y("", !0)
        ])) : Y("", !0)
      ]);
    };
  }
}), gE = typeof window < "u" ? window : void 0, tA = () => {
}, hE = (e) => fv() ? (vv(e), !0) : !1, mE = (e, a, t, r) => {
  if (!e)
    return tA;
  let i = tA;
  const s = st(
    () => b(e),
    (A) => {
      i(), A && (A.addEventListener(a, t, r), i = () => {
        A.removeEventListener(a, t, r), i = tA;
      });
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), i();
  };
  return hE(u), u;
}, yE = (e, a, t, r = {}) => {
  const { window: i = gE, event: s = "pointerdown" } = r;
  return i ? mE(i, s, (u) => {
    const A = on(e), c = on(a);
    !A || !c || A === u.target || u.composedPath().includes(A) || u.composedPath().includes(c) || t(u);
  }, { passive: !0 }) : void 0;
}, bE = /* @__PURE__ */ We({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...us
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(e, { expose: a, emit: t }) {
    const r = t, i = e, s = mn(), u = U(!1), A = zl(i, "modelValue"), c = zl(i, "timezone"), g = U(null), p = U(null), v = U(null), m = U(!1), w = U(null), B = U(!1), T = U(!1), L = U(!1), E = U(!1), { setMenuFocused: N, setShiftKey: k } = Sp(), { clearArrowNav: F } = Tr(), { validateDate: S, isValidTime: Q } = xr(i), {
      defaultedTransitions: x,
      defaultedTextInput: W,
      defaultedInline: z,
      defaultedConfig: q,
      defaultedRange: J,
      defaultedMultiDates: le
    } = Nt(i), { menuTransition: ve, showTransition: R } = Yi(x);
    bt(() => {
      Z(i.modelValue), Bt().then(() => {
        if (!z.value.enabled) {
          const se = Me(w.value);
          se == null || se.addEventListener("scroll", xe), window == null || window.addEventListener("resize", de);
        }
      }), z.value.enabled && (u.value = !0), window == null || window.addEventListener("keyup", Re), window == null || window.addEventListener("keydown", ne);
    }), al(() => {
      if (!z.value.enabled) {
        const se = Me(w.value);
        se == null || se.removeEventListener("scroll", xe), window == null || window.removeEventListener("resize", de);
      }
      window == null || window.removeEventListener("keyup", Re), window == null || window.removeEventListener("keydown", ne);
    });
    const _ = Kn(s, "all", i.presetDates), G = Kn(s, "input");
    st(
      [A, c],
      () => {
        Z(A.value);
      },
      { deep: !0 }
    );
    const { openOnTop: oe, menuStyle: Oe, xCorrect: pe, setMenuPosition: $, getScrollableParent: Me, shadowRender: me } = iE({
      menuRef: g,
      menuRefInner: p,
      inputRef: v,
      pickerWrapperRef: w,
      inline: z,
      emit: r,
      props: i,
      slots: s
    }), {
      inputValue: te,
      internalModelValue: P,
      parseExternalModelValue: Z,
      emitModelValue: ae,
      formatInputValue: O,
      checkBeforeEmit: ke
    } = lI(r, i, m), Ue = V(
      () => ({
        dp__main: !0,
        dp__theme_dark: i.dark,
        dp__theme_light: !i.dark,
        dp__flex_display: z.value.enabled,
        "dp--flex-display-collapsed": L.value,
        dp__flex_display_with_input: z.value.input
      })
    ), Qt = V(() => i.dark ? "dp__theme_dark" : "dp__theme_light"), ie = V(() => i.teleport ? {
      to: typeof i.teleport == "boolean" ? "body" : i.teleport,
      disabled: !i.teleport || z.value.enabled
    } : {}), Te = V(() => ({ class: "dp__outer_menu_wrap" })), M = V(() => z.value.enabled && (i.timePicker || i.monthPicker || i.yearPicker || i.quarterPicker)), Ae = () => {
      var se, ze;
      return (ze = (se = v.value) == null ? void 0 : se.$el) == null ? void 0 : ze.getBoundingClientRect();
    }, xe = () => {
      u.value && (q.value.closeOnScroll ? an() : $());
    }, de = () => {
      var se;
      u.value && $();
      const ze = (se = p.value) == null ? void 0 : se.$el.getBoundingClientRect().width;
      L.value = document.body.offsetWidth <= ze;
    }, Re = (se) => {
      se.key === "Tab" && !z.value.enabled && !i.teleport && q.value.tabOutClosesMenu && (w.value.contains(document.activeElement) || an()), T.value = se.shiftKey;
    }, ne = (se) => {
      T.value = se.shiftKey;
    }, Pe = () => {
      !i.disabled && !i.readonly && (me(dv, i), $(!1), u.value = !0, u.value && r("open"), u.value || Pr(), Z(i.modelValue));
    }, Ve = () => {
      var se;
      te.value = "", Pr(), (se = v.value) == null || se.setParsedDate(null), r("update:model-value", null), r("update:model-timezone-value", null), r("cleared"), q.value.closeOnClearValue && an();
    }, Ze = () => {
      const se = P.value;
      return !se || !Array.isArray(se) && S(se) ? !0 : Array.isArray(se) ? le.value.enabled || se.length === 2 && S(se[0]) && S(se[1]) ? !0 : J.value.partialRange && !i.timePicker ? S(se[0]) : !1 : !1;
    }, sn = () => {
      ke() && Ze() ? (ae(), an()) : r("invalid-select", P.value);
    }, Fe = (se) => {
      Ba(), ae(), q.value.closeOnAutoApply && !se && an();
    }, Ba = () => {
      v.value && W.value.enabled && v.value.setParsedDate(P.value);
    }, yn = (se = !1) => {
      i.autoApply && Q(P.value) && Ze() && (J.value.enabled && Array.isArray(P.value) ? (J.value.partialRange || P.value.length === 2) && Fe(se) : Fe(se));
    }, Pr = () => {
      W.value.enabled || (P.value = null);
    }, an = () => {
      z.value.enabled || (u.value && (u.value = !1, pe.value = !1, N(!1), k(!1), F(), r("closed"), te.value && Z(A.value)), Pr(), r("blur"));
    }, _n = (se, ze, Ye = !1) => {
      if (!se) {
        P.value = null;
        return;
      }
      const un = Array.isArray(se) ? !se.some((Sa) => !S(Sa)) : S(se), En = Q(se);
      un && En ? (E.value = !0, P.value = se, ze && (B.value = Ye, sn(), r("text-submit")), Bt().then(() => {
        E.value = !1;
      })) : r("invalid-date", se);
    }, kr = () => {
      i.autoApply && Q(P.value) && ae(), Ba();
    }, ar = () => u.value ? an() : Pe(), Or = (se) => {
      P.value = se;
    }, Mr = () => {
      W.value.enabled && (m.value = !0, O()), r("focus");
    }, zr = () => {
      if (W.value.enabled && (m.value = !1, Z(i.modelValue), B.value)) {
        const se = Ez(w.value, T.value);
        se == null || se.focus();
      }
      r("blur");
    }, Ir = (se) => {
      p.value && p.value.updateMonthYear(0, {
        month: av(se.month),
        year: av(se.year)
      });
    }, Er = (se) => {
      Z(se ?? i.modelValue);
    }, Lr = (se, ze) => {
      var Ye;
      (Ye = p.value) == null || Ye.switchView(se, ze);
    }, ee = (se) => q.value.onClickOutside ? q.value.onClickOutside(se) : an(), Ie = (se = 0) => {
      var ze;
      (ze = p.value) == null || ze.handleFlow(se);
    };
    return yE(g, v, () => ee(Ze)), a({
      closeMenu: an,
      selectDate: sn,
      clearValue: Ve,
      openMenu: Pe,
      onScroll: xe,
      formatInputValue: O,
      // exposed for testing purposes
      updateInternalModelValue: Or,
      // modify internal modelValue
      setMonthYear: Ir,
      parseModel: Er,
      switchView: Lr,
      toggleMenu: ar,
      handleFlow: Ie,
      dpWrapMenuRef: g
    }), (se, ze) => (f(), y("div", {
      ref_key: "pickerWrapperRef",
      ref: w,
      class: he(Ue.value),
      "data-datepicker-instance": ""
    }, [
      Ce(pE, Xt({
        ref_key: "inputRef",
        ref: v,
        "input-value": b(te),
        "onUpdate:inputValue": ze[0] || (ze[0] = (Ye) => Cr(te) ? te.value = Ye : null),
        "is-menu-open": u.value
      }, se.$props, {
        onClear: Ve,
        onOpen: Pe,
        onSetInputDate: _n,
        onSetEmptyDate: b(ae),
        onSelectDate: sn,
        onToggle: ar,
        onClose: an,
        onFocus: Mr,
        onBlur: zr,
        onRealBlur: ze[1] || (ze[1] = (Ye) => m.value = !1),
        onTextInput: ze[2] || (ze[2] = (Ye) => se.$emit("text-input", Ye))
      }), Lt({ _: 2 }, [
        tt(b(G), (Ye, un) => ({
          name: Ye,
          fn: ue((En) => [
            fe(se.$slots, Ye, fn(Xn(En)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (f(), ce(Dt(se.teleport ? rl : "div"), fn(Xn(ie.value)), {
        default: ue(() => [
          Ce(Jn, {
            name: b(ve)(b(oe)),
            css: b(R) && !b(z).enabled
          }, {
            default: ue(() => [
              u.value ? (f(), y("div", Xt({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: g
              }, Te.value, {
                class: { "dp--menu-wrapper": !b(z).enabled },
                style: b(z).enabled ? void 0 : b(Oe)
              }), [
                Ce(dv, Xt({
                  ref_key: "dpMenuRef",
                  ref: p
                }, se.$props, {
                  "internal-model-value": b(P),
                  "onUpdate:internalModelValue": ze[3] || (ze[3] = (Ye) => Cr(P) ? P.value = Ye : null),
                  class: { [Qt.value]: !0, "dp--menu-wrapper": se.teleport },
                  "open-on-top": b(oe),
                  "no-overlay-focus": M.value,
                  collapse: L.value,
                  "get-input-rect": Ae,
                  "is-text-input-date": E.value,
                  onClosePicker: an,
                  onSelectDate: sn,
                  onAutoApply: yn,
                  onTimeUpdate: kr,
                  onFlowStep: ze[4] || (ze[4] = (Ye) => se.$emit("flow-step", Ye)),
                  onUpdateMonthYear: ze[5] || (ze[5] = (Ye) => se.$emit("update-month-year", Ye)),
                  onInvalidSelect: ze[6] || (ze[6] = (Ye) => se.$emit("invalid-select", b(P))),
                  onAutoApplyInvalid: ze[7] || (ze[7] = (Ye) => se.$emit("invalid-select", Ye)),
                  onInvalidFixedRange: ze[8] || (ze[8] = (Ye) => se.$emit("invalid-fixed-range", Ye)),
                  onRecalculatePosition: b($),
                  onTooltipOpen: ze[9] || (ze[9] = (Ye) => se.$emit("tooltip-open", Ye)),
                  onTooltipClose: ze[10] || (ze[10] = (Ye) => se.$emit("tooltip-close", Ye)),
                  onTimePickerOpen: ze[11] || (ze[11] = (Ye) => se.$emit("time-picker-open", Ye)),
                  onTimePickerClose: ze[12] || (ze[12] = (Ye) => se.$emit("time-picker-close", Ye)),
                  onAmPmChange: ze[13] || (ze[13] = (Ye) => se.$emit("am-pm-change", Ye)),
                  onRangeStart: ze[14] || (ze[14] = (Ye) => se.$emit("range-start", Ye)),
                  onRangeEnd: ze[15] || (ze[15] = (Ye) => se.$emit("range-end", Ye)),
                  onDateUpdate: ze[16] || (ze[16] = (Ye) => se.$emit("date-update", Ye)),
                  onInvalidDate: ze[17] || (ze[17] = (Ye) => se.$emit("invalid-date", Ye)),
                  onOverlayToggle: ze[18] || (ze[18] = (Ye) => se.$emit("overlay-toggle", Ye))
                }), Lt({ _: 2 }, [
                  tt(b(_), (Ye, un) => ({
                    name: Ye,
                    fn: ue((En) => [
                      fe(se.$slots, Ye, fn(Xn({ ...En })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : Y("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), fs = /* @__PURE__ */ (() => {
  const e = bE;
  return e.install = (a) => {
    a.component("Vue3DatePicker", e);
  }, e;
})(), wE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fs
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(wE).forEach(([e, a]) => {
  e !== "default" && (fs[e] = a);
});
function as(e) {
  return e.length >= 3 ? e.substring(0, 3) : e;
}
function CE() {
  const e = /* @__PURE__ */ new Date();
  return [
    { label: "Сегодня", value: [Kr(e), ii(e)] },
    {
      label: "Вчера",
      value: [Kr(vi(e, 1)), ii(vi(e, 1))]
    },
    {
      label: "Последние 7 дней",
      value: [Kr(vi(e, 7)), ii(e)]
    },
    {
      label: "Последние 30 дней",
      value: [Kr(vi(e, 30)), ii(e)]
    },
    {
      label: "Последний год",
      value: [Kr(YA(e, 1)), ii(e)]
    }
  ];
}
function DE(e) {
  if (!e)
    return "";
  const a = (r) => {
    const i = String(r.getDate()).padStart(2, "0"), s = String(r.getMonth() + 1).padStart(2, "0"), u = r.getFullYear();
    return `${i}.${s}.${u}`;
  }, t = (r) => r instanceof Date ? r : new Date(r);
  if (Array.isArray(e)) {
    const [r, i] = e.map(t);
    return `${a(r)} - ${a(i)}`;
  }
  return a(t(e));
}
function BE(e) {
  const a = e.split(".").map(Number).slice(0, 3);
  if (a.some((s) => !s))
    return null;
  const [t, r, i] = a;
  return new Date(i, r - 1, t);
}
function TE(e, a) {
  return e + a;
}
function qp(e, a) {
  const t = U(null), r = U(CE()), i = U((/* @__PURE__ */ new Date()).getFullYear()), s = U(null), u = U(null), A = U(""), c = V(() => {
    if (e.range && Array.isArray(e.modelValue)) {
      const S = e.modelValue[0];
      if (S instanceof Date)
        return S.getFullYear();
    }
    return i.value;
  }), g = () => {
    if (!s.value || !t.value)
      return;
    s.value.selectDate();
    const S = p(t.value);
    a("update:modelValue", S), k();
  };
  function p(S) {
    return Array.isArray(S) ? S.map(v) : v(S);
  }
  function v(S) {
    return S instanceof Date ? S.toISOString() : String(S);
  }
  const m = () => {
    s.value && s.value.switchView("year");
  }, w = (S) => {
    t.value = S, k();
  }, B = V(() => e.placeholder || (e.range ? "дд.мм.гггг - дд.мм.гггг" : "дд.мм.гггг")), T = V(() => e.range ? "##.##.#### - ##.##.####" : "##.##.####"), L = () => {
    var S;
    (S = s == null ? void 0 : s.value) == null || S.closeMenu();
  }, E = (S) => {
    const Q = TE(c.value, S);
    s.value && (s.value.setMonthYear({ year: Q }), i.value = Q);
  }, N = (S, Q) => {
    t.value = S, u.value = Q;
  }, k = () => {
    A.value = DE(t.value);
  }, F = () => {
    t.value === "" && (t.value = BE(A.value));
  };
  return bt(() => {
    (e.range && Array.isArray(e.modelValue) || e.modelValue) && (t.value = e.modelValue), k();
  }), {
    date: t,
    presetDates: r,
    currentYear: i,
    selectedYear: c,
    datePickerRef: s,
    selectDate: g,
    toggleYearPicker: m,
    inputPlaceholder: B,
    formattedDateMask: T,
    close: L,
    inputDate: A,
    toggleYear: E,
    activePresetIndex: u,
    applyPreset: N,
    handleDate: k,
    updateDate: w,
    convertToLongDate: F
  };
}
const xE = { class: "ui-date-picker-navigation__wrapper" }, PE = {
  key: 0,
  class: "ui-date-picker-navigation"
}, kE = { class: "ui-date-picker-navigation__list" }, OE = { class: "ui-date-picker" }, ME = { class: "ui-date-picker-year dp__month_year_wrap" }, zE = { class: "dp__inner_nav" }, IE = { class: "dp__inner_nav" }, EE = {
  type: "button",
  class: "ui-date-picker-header__button"
}, LE = {
  type: "button",
  class: "ui-date-picker-header__button"
}, NE = /* @__PURE__ */ We({
  __name: "MobileDatePicker",
  props: {
    modelValue: {
      type: [Date, Array, String],
      default: /* @__PURE__ */ new Date()
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputLabel: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    error: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, {
      date: i,
      presetDates: s,
      selectedYear: u,
      datePickerRef: A,
      toggleYearPicker: c,
      inputPlaceholder: g,
      formattedDateMask: p,
      inputDate: v,
      toggleYear: m,
      handleDate: w,
      activePresetIndex: B,
      applyPreset: T,
      convertToLongDate: L
    } = qp(t, r), E = U(!1), N = (F) => {
      E.value = F ?? !E.value;
    }, k = () => {
      A.value && (A.value.selectDate(), r("update:modelValue", i.value), w(), N(!1));
    };
    return (F, S) => (f(), y("div", Xt(F.$attrs, { class: "ui-date-picker-mobile" }), [
      Ce(yr, {
        modelValue: b(v),
        "onUpdate:modelValue": [
          S[0] || (S[0] = (Q) => Cr(v) ? v.value = Q : null),
          b(L)
        ],
        size: e.size,
        disabled: e.disabled,
        error: e.error,
        mask: b(p),
        label: e.inputLabel,
        required: e.required,
        "error-message": e.errorMessage,
        "label-tooltip": e.labelTooltip,
        "hint-message": e.hintMessage,
        "reset-button": "",
        placeholder: b(g),
        onClick: S[1] || (S[1] = (Q) => N(!0))
      }, {
        "icon-left": ue(() => [
          Ce(b(rA))
        ]),
        _: 1
      }, 8, ["modelValue", "size", "disabled", "error", "mask", "label", "required", "error-message", "label-tooltip", "hint-message", "placeholder", "onUpdate:modelValue"]),
      E.value ? (f(), ce(is, {
        key: 0,
        title: e.inputLabel,
        subtitle: e.hintMessage,
        onClose: S[7] || (S[7] = (Q) => N(!1))
      }, {
        content: ue(() => [
          X("div", xE, [
            e.range ? (f(), y("div", PE, [
              X("ul", kE, [
                (f(!0), y(Qe, null, tt(b(s), (Q, x) => (f(), y("li", {
                  key: x,
                  class: "ui-date-picker-navigation__item"
                }, [
                  Ce(xv, {
                    active: b(B) === x,
                    label: Q.label,
                    size: "s",
                    onClick: (W) => b(T)(Q.value, x)
                  }, null, 8, ["active", "label", "onClick"])
                ]))), 128))
              ])
            ])) : Y("", !0)
          ]),
          X("div", OE, [
            Ce(b(fs), {
              ref_key: "datePickerRef",
              ref: A,
              modelValue: b(i),
              "onUpdate:modelValue": S[5] || (S[5] = (Q) => Cr(i) ? i.value = Q : null),
              "enable-time-picker": "",
              "month-change-on-scroll": !1,
              range: e.range,
              format: "dd.MM.yyyy",
              locale: "ru",
              class: "ui-date-picker-calendar",
              inline: "",
              "select-year": ""
            }, {
              month: ue(({ text: Q }) => [
                $t(we(b(as)(Q)), 1)
              ]),
              "month-overlay-value": ue(({ text: Q }) => [
                $t(we(b(as)(Q)), 1)
              ]),
              "month-overlay-header": ue(() => [
                X("div", ME, [
                  X("div", zE, [
                    X("button", {
                      type: "button",
                      class: "ui-date-picker-header__button",
                      onClick: S[2] || (S[2] = (Q) => b(m)(-1))
                    }, [
                      Ce(b(qo), { class: "ui-date-picker-header__icon" })
                    ])
                  ]),
                  X("button", {
                    type: "button",
                    class: "dp__btn dp__month_year_select",
                    onClick: S[3] || (S[3] = //@ts-ignore
                    (...Q) => b(c) && b(c)(...Q))
                  }, we(b(u)), 1),
                  X("div", IE, [
                    X("button", {
                      type: "button",
                      class: "ui-date-picker-header__button",
                      onClick: S[4] || (S[4] = (Q) => b(m)(1))
                    }, [
                      Ce(b(Uo), { class: "ui-date-picker-header__icon" })
                    ])
                  ])
                ])
              ]),
              "input-icon": ue(() => [
                Ce(b(rA), { class: "ui-date-picker-input__icon" })
              ]),
              "calendar-icon": ue(() => [
                Ce(b(bv), { class: "ui-date-picker-month__icon" })
              ]),
              "arrow-left": ue(() => [
                X("button", EE, [
                  Ce(b(qo), { class: "ui-date-picker-header__icon" })
                ])
              ]),
              "arrow-right": ue(() => [
                X("button", LE, [
                  Ce(b(Uo), { class: "ui-date-picker-header__icon" })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "range"])
          ])
        ]),
        footer: ue(() => [
          Ce(nl, {
            label: "Применить",
            size: "m",
            style: { width: "100%", "margin-bottom": "8px" },
            onClick: k
          }),
          Ce(nl, {
            label: "Отменить",
            size: "m",
            color: "secondary",
            style: { width: "100%" },
            onClick: S[6] || (S[6] = (Q) => N(!1))
          })
        ]),
        _: 1
      }, 8, ["title", "subtitle"])) : Y("", !0)
    ], 16));
  }
});
const YE = /* @__PURE__ */ je(NE, [["__scopeId", "data-v-d38e452b"]]), nA = ".dp--menu-wrapper", SE = { class: "ui-date-picker-navigation" }, VE = { class: "ui-date-picker-navigation__list" }, WE = { class: "ui-date-picker-year dp__month_year_wrap" }, XE = { class: "dp__inner_nav" }, QE = { class: "dp__inner_nav" }, HE = {
  type: "button",
  class: "ui-date-picker-header__button"
}, FE = {
  type: "button",
  class: "ui-date-picker-header__button"
}, qE = ["onClick", "onKeyup"], UE = { class: "ui-date-picker-buttons" }, RE = /* @__PURE__ */ We({
  __name: "DasktopDatePicker",
  props: {
    modelValue: {
      type: [Date, Array, String],
      default: /* @__PURE__ */ new Date()
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputLabel: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    error: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, {
      date: i,
      presetDates: s,
      selectedYear: u,
      datePickerRef: A,
      selectDate: c,
      toggleYearPicker: g,
      inputPlaceholder: p,
      formattedDateMask: v,
      close: m,
      inputDate: w,
      toggleYear: B,
      updateDate: T,
      activePresetIndex: L,
      applyPreset: E,
      convertToLongDate: N
    } = qp(t, r), k = (x) => {
      t.disabled && x && x.stopPropagation();
      const W = document.querySelector(nA);
      W && W.classList.add("elevation-shadow-low");
    }, F = new MutationObserver((x) => {
      for (const W of x)
        if (W.type === "childList" && document.querySelector(nA)) {
          k(), Q();
          break;
        }
    }), S = () => {
      const x = document.querySelector(nA);
      x && x.parentNode && F.observe(x.parentNode, {
        childList: !0,
        subtree: !1
      });
    }, Q = () => {
      F.disconnect();
    };
    return bt(() => {
      S();
    }), gv(() => {
      Q();
    }), (x, W) => (f(), y("div", {
      class: he(["ui-date-picker", { "ui-date-picker_disabled": e.disabled }])
    }, [
      Ce(b(fs), {
        ref_key: "datePickerRef",
        ref: A,
        modelValue: b(i),
        "onUpdate:modelValue": [
          W[4] || (W[4] = (z) => Cr(i) ? i.value = z : null),
          b(T)
        ],
        format: "dd.MM.yyyy",
        locale: "ru",
        "text-input": "",
        "enable-time-picker": "",
        "month-change-on-scroll": !1,
        range: e.range
      }, Lt({
        "action-preview": ue(() => []),
        month: ue(({ text: z }) => [
          $t(we(b(as)(z)), 1)
        ]),
        "month-overlay-value": ue(({ text: z }) => [
          $t(we(b(as)(z)), 1)
        ]),
        day: ue(({ day: z }) => [
          X("span", null, we(z), 1)
        ]),
        "dp-input": ue(({ onBlur: z, onInput: q }) => [
          Ce(yr, {
            modelValue: b(w),
            "onUpdate:modelValue": [
              W[0] || (W[0] = (J) => Cr(w) ? w.value = J : null),
              b(N)
            ],
            "reset-button": !e.disabled,
            mask: b(v),
            placeholder: b(p),
            label: e.inputLabel,
            disabled: e.disabled,
            error: e.error,
            required: e.required,
            "error-message": e.errorMessage,
            "label-tooltip": e.labelTooltip,
            "hint-message": e.hintMessage,
            size: e.size,
            onClick: k,
            onInputDebounced: q,
            onBlur: z
          }, {
            "icon-left": ue(() => [
              Ce(b(rA))
            ]),
            _: 2
          }, 1032, ["modelValue", "reset-button", "mask", "placeholder", "label", "disabled", "error", "required", "error-message", "label-tooltip", "hint-message", "size", "onInputDebounced", "onBlur", "onUpdate:modelValue"])
        ]),
        "month-overlay-header": ue(() => [
          X("div", WE, [
            X("div", XE, [
              X("button", {
                type: "button",
                class: "ui-date-picker-header__button",
                onClick: W[1] || (W[1] = (z) => b(B)(-1))
              }, [
                Ce(b(qo), { class: "ui-date-picker-header__icon" })
              ])
            ]),
            X("button", {
              type: "button",
              class: "dp__btn dp__month_year_select",
              onClick: W[2] || (W[2] = //@ts-ignore
              (...z) => b(g) && b(g)(...z))
            }, we(b(u)), 1),
            X("div", QE, [
              X("button", {
                type: "button",
                class: "ui-date-picker-header__button",
                onClick: W[3] || (W[3] = (z) => b(B)(1))
              }, [
                Ce(b(Uo), { class: "ui-date-picker-header__icon" })
              ])
            ])
          ])
        ]),
        "calendar-icon": ue(() => [
          Ce(b(bv), { class: "ui-date-picker-month__icon" })
        ]),
        "arrow-left": ue(() => [
          X("button", HE, [
            Ce(b(qo), { class: "ui-date-picker-header__icon" })
          ])
        ]),
        "arrow-right": ue(() => [
          X("button", FE, [
            Ce(b(Uo), { class: "ui-date-picker-header__icon" })
          ])
        ]),
        "action-buttons": ue(() => [
          X("div", UE, [
            Ce(nl, {
              color: "secondary",
              label: "Отмена",
              size: "s",
              onClick: b(m)
            }, null, 8, ["onClick"]),
            Ce(nl, {
              label: "Применить",
              size: "s",
              onClick: b(c)
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 2
      }, [
        e.range ? {
          name: "left-sidebar",
          fn: ue(() => [
            X("div", SE, [
              X("ul", VE, [
                (f(!0), y(Qe, null, tt(b(s), (z, q) => (f(), y("li", {
                  key: q,
                  class: "ui-date-picker-navigation__item"
                }, [
                  Ce(xv, {
                    label: z.label,
                    size: "m",
                    active: b(L) === q,
                    onClick: (J) => b(E)(z.value, q)
                  }, null, 8, ["label", "active", "onClick"])
                ]))), 128))
              ])
            ])
          ]),
          key: "0"
        } : void 0,
        e.range ? {
          name: "preset-date-range-button",
          fn: ue(({ label: z, value: q, presetDate: J }) => [
            X("button", {
              type: "button",
              tabindex: "0",
              role: "button",
              onClick: (le) => J(q),
              onKeyup: [
                aA(_t((le) => J(q), ["prevent"]), ["enter"]),
                aA(_t((le) => J(q), ["prevent"]), ["space"])
              ]
            }, we(z), 41, qE)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "range", "onUpdate:modelValue"])
    ], 2));
  }
});
const ZE = /* @__PURE__ */ je(RE, [["__scopeId", "data-v-757e3dd0"]]), x6 = /* @__PURE__ */ We({
  name: "UiDatePicker",
  __name: "UiDatePicker",
  props: {
    modelValue: {
      type: [Date, Array, String],
      default: /* @__PURE__ */ new Date()
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, r = a, { width: i } = sa(), s = V(() => i.value >= 768 ? ZE : YE), u = V({
      get: () => t.modelValue,
      set: (A) => r("update:modelValue", A)
    });
    return (A, c) => (f(), ce(Dt(s.value), Xt({
      modelValue: u.value,
      "onUpdate:modelValue": c[0] || (c[0] = (g) => u.value = g),
      range: e.range,
      size: e.size,
      "input-label": e.label,
      placeholder: e.placeholder,
      required: e.required,
      "error-message": e.errorMessage,
      "label-tooltip": e.labelTooltip,
      "hint-message": e.hintMessage,
      error: e.error,
      disabled: e.disabled
    }, A.$attrs), null, 16, ["modelValue", "range", "size", "input-label", "placeholder", "required", "error-message", "label-tooltip", "hint-message", "error", "disabled"]));
  }
});
export {
  T6 as UiAccordion,
  KE as UiAppButton,
  A6 as UiAvatar,
  j7 as UiBadge,
  is as UiBottomSheet,
  nl as UiButton,
  JE as UiButtonRedirect,
  _E as UiCheckbox,
  xv as UiChip,
  $E as UiCounter,
  x6 as UiDatePicker,
  w6 as UiDrawer,
  Ii as UiDropdown,
  Lu as UiDropdownItem,
  C6 as UiDropzone,
  D6 as UiFile,
  p6 as UiFileCard,
  ls as UiHint,
  Pf as UiIconButton,
  B6 as UiImageUploader,
  yr as UiInput,
  d6 as UiInputPhone,
  c6 as UiInputSearch,
  e6 as UiLink,
  b6 as UiList,
  h6 as UiModal,
  l6 as UiMultipleSelect,
  y6 as UiNotFoundPage,
  t6 as UiNotification,
  f6 as UiPagination,
  nP as UiProgressBar,
  n6 as UiRadioButton,
  a6 as UiSegmentedControl,
  r6 as UiSelect,
  g6 as UiSkeleton,
  u6 as UiSlider,
  _x as UiSnackbar,
  v6 as UiSnackbarGroup,
  m6 as UiStepper,
  i6 as UiSwitch,
  RT as UiTab,
  o6 as UiTabs,
  Zo as UiTextButton,
  s6 as UiTextarea,
  zi as UiTooltip
};
